import { defineStore as Oe } from "pinia";
import { defineComponent as T, openBlock as p, createElementBlock as h, normalizeClass as _, normalizeStyle as b, renderSlot as J, createElementVNode as l, Fragment as H, renderList as de, toDisplayString as $, resolveComponent as L, createBlock as V, createVNode as M, Transition as ks, withCtx as F, createCommentVNode as w, createTextVNode as K, withDirectives as Ae, vShow as Ze, withModifiers as A, vModelText as Bn, createStaticVNode as is, resolveDirective as Pn } from "vue";
const Dn = () => ({
  showOverlay: !1
}), Ln = Oe("blackOverlay", {
  state: Dn
}), On = () => ({
  errorText: "",
  errorArray: [],
  isConnectionError: !1,
  headerText: "ERROR"
}), yi = Oe("errorState", {
  state: On,
  actions: {
    addError(e) {
      this.errorArray.push(e);
    }
  }
}), In = () => ({
  averageFps: 0,
  actualFps: 0,
  actualAverageFps: 0,
  isStarted: !1
}), ss = Oe("fpsLookerState", {
  state: In
}), Mn = () => ({
  graphicsSettings: 1,
  graphicsAuto: !1,
  volume: !1,
  isLeft: !1,
  controlsType: 1,
  aimSensitivity: 0,
  vibrations: !0,
  oneFinger: !1
}), Gt = Oe("gameSettingsState", {
  state: Mn
}), Nn = () => ({
  isPrematureEnd: !1
}), X1 = Oe("gameState", {
  state: Nn
}), An = () => ({
  isActive: !1
}), Rn = Oe("loadingCircleState", {
  state: An
}), En = () => ({
  loadingProgress: 0,
  showLoading: !0,
  crossConfig: {
    isActive: !0,
    imgSrc: "",
    imgHref: "",
    fullsized: !1
  },
  hintText: "",
  tutorial: {
    isEnabled: !1,
    text: ""
  }
}), _s = Oe("loadingState", {
  state: En
}), Fn = () => ({
  isMobile: !1
}), Vn = Oe("mobileState", {
  state: Fn
}), qn = () => ({
  text: "1",
  duration: 1,
  showSmall: !0,
  showBig: !0,
  leftStart: -0.2,
  showHeader: !0
}), G1 = Oe("testCountdownState", {
  state: qn
}), Wn = () => ({
  typeWriter: !0
}), Y1 = Oe("tutorialCoreState", {
  state: Wn
}), Un = () => ({
  isWaiting: !1,
  trainingButtonsDisabled: !0
}), mt = Oe("waitingState", {
  state: Un
}), P = T({
  data: () => ({
    coef: 0
  }),
  computed: {
    scaleCoef() {
      return this.coef;
    }
  },
  mounted() {
    this.getAspectRatio();
  },
  methods: {
    isIOS() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent);
    },
    isTablet() {
      return window.innerWidth / window.innerHeight <= 1.7;
    },
    isMobile() {
      return Vn().isMobile || !!navigator.userAgent.match(/Android/i) || !!navigator.userAgent.match(/webOS/i) || !!navigator.userAgent.match(/iPhone/i) || !!navigator.userAgent.match(/iPad/i) || !!navigator.userAgent.match(/iPod/i) || !!navigator.userAgent.match(/BlackBerry/i) || !!navigator.userAgent.match(/Windows Phone/i);
    },
    getAspectRatio() {
      this.$nextTick(() => {
        const e = window.minigameScaleCoef;
        if (e !== void 0) {
          this.coef = e;
          return;
        }
        let t = window.innerWidth, i = window.innerHeight;
        this.isMobile() || (t = 1280, i = 720), t / i <= 1.6 ? this.coef = t / 1920 : this.coef = i / 1080, window.minigameScaleCoef = this.coef;
      });
    }
  }
}), Hn = T({
  name: "ArrowAnimation",
  mixins: [P],
  props: {
    position: {
      type: String,
      default: "left"
    },
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    tutorial: {
      type: Boolean,
      default: !0
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    translateX: {
      type: String,
      default: "0"
    },
    translateY: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.isScaled ? this.scaleCoef : 1}) translate(${this.translateX}, ${this.translateY})`
      };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), S = (e, t) => {
  const i = e.__vccOpts || e;
  for (const [s, n] of t)
    i[s] = n;
  return i;
};
function Xn(e, t, i, s, n, o) {
  return e.tutorial ? (p(), h("div", {
    key: 0,
    class: _(["arrow-wrapper", { "arrow-wrapper-ssm": e.isSsm }]),
    style: b([e.style, e.transformCoef])
  }, [
    J(e.$slots, "default", {}, void 0, !0),
    l("div", {
      class: _(["arrows-group-animation", `arrow-anim-${e.position}`])
    }, null, 2)
  ], 6)) : J(e.$slots, "default", { key: 1 }, void 0, !0);
}
const Gn = /* @__PURE__ */ S(Hn, [["render", Xn], ["__scopeId", "data-v-58a8fac3"]]), Yn = T({
  name: "ArrowStatic",
  mixins: [P],
  props: {
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.isScaled ? this.scaleCoef : 1}) translate(0, 0)`
      };
    }
  }
});
function Kn(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "arrow-static",
    style: b(e.transformCoef)
  }, [
    (p(), h(H, null, de([1, 2, 3], (r) => l("div", {
      key: r,
      class: _(["arrow", `arrow-${r}`])
    }, null, 2)), 64))
  ], 4);
}
const Zn = /* @__PURE__ */ S(Yn, [["render", Kn]]), Jn = T({
  name: "TypeWriterComponent",
  props: {
    text: {
      type: String,
      required: !0
    },
    fontSize: {
      type: String,
      default: ""
    },
    typeSpeed: {
      type: Number,
      default: 30
    },
    startDelay: {
      type: Number,
      default: 0
    }
  },
  emits: ["showFullText", "shrinkText"],
  data() {
    return {
      showText: "",
      charIndex: 0,
      timeout: 0
    };
  },
  created() {
    setTimeout(this.typewriter, this.startDelay);
  },
  beforeUnmount() {
    clearTimeout(this.timeout);
  },
  methods: {
    typewriter() {
      this.charIndex < this.text.length ? (this.showText += this.text.charAt(this.charIndex), this.charIndex += 1, this.timeout = setTimeout(this.typewriter, this.typeSpeed), this.charIndex % 5 === 0 && this.$emit("shrinkText")) : (this.$emit("showFullText"), this.$emit("shrinkText"));
    }
  }
}), Qn = { class: "typewriter-text" };
function eo(e, t, i, s, n, o) {
  return p(), h("span", Qn, $(e.showText), 1);
}
const ws = /* @__PURE__ */ S(Jn, [["render", eo]]), to = T({
  name: "ShrinkingTextBox",
  components: {
    TypeWriterComponent: ws
  },
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    useTypeWriter: {
      type: Boolean,
      default: !1
    },
    text: {
      type: String,
      default: ""
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    fontSize: {
      type: Number,
      default: 0
    }
  },
  emits: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shrinkingFontSize: (e) => !0,
    showFullText: () => !0
  },
  data() {
    return {
      shrinkedFontSize: `${this.fontSize}px`
    };
  },
  watch: {
    useTypeWriter: {
      handler(e) {
        if (e === !1) {
          const t = this.$refs.shrinkingText;
          setTimeout(() => {
            this.shrinkText(t);
          }, 0);
        }
      }
    }
  },
  mounted() {
    const e = this.$refs.shrinkingText;
    e.style.maxWidth = `${this.width}px`, e.style.height = `${this.height}px`, e.style.fontSize = `${this.fontSize}px`, this.shrinkText(e);
  },
  methods: {
    shrinkText(e) {
      if (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) {
        e.style.fontSize = `${parseInt(e.style.fontSize) - 1}px`, this.shrinkText(e);
        return;
      }
      this.shrinkedFontSize = e.style.fontSize, this.$emit("shrinkingFontSize", e.style.fontSize);
    }
  }
}), io = {
  ref: "shrinkingText",
  class: "shrinking-text"
}, so = { key: 1 };
function no(e, t, i, s, n, o) {
  const r = L("type-writer-component");
  return p(), h("div", io, [
    e.useTypeWriter ? (p(), V(r, {
      key: 0,
      text: e.text,
      "font-size": e.shrinkedFontSize,
      onShowFullText: t[0] || (t[0] = (a) => e.$emit("showFullText")),
      onShrinkText: t[1] || (t[1] = (a) => e.shrinkText(e.$refs.shrinkingText))
    }, null, 8, ["text", "font-size"])) : (p(), h("span", so, $(e.text), 1))
  ]);
}
const pe = /* @__PURE__ */ S(to, [["render", no]]), oo = T({
  name: "BiathlonSplitTimes",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    rowData: {
      type: Array,
      required: !0
    },
    showPlayerTime: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  data() {
    return {
      isPlayerFirst: !1
    };
  },
  computed: {
    basicStyle() {
      return {
        transform: `scale(${this.scaleCoef})`,
        "transform-origin": "0 0"
      };
    }
  },
  methods: {
    isFirstElement(e) {
      return e === 0;
    },
    getClass(e, t) {
      let i = "";
      return t && (i += " isPlayer", e && (this.isPlayerFirst = !0)), e && (i += " isFirst"), i;
    },
    getText(e, t, i) {
      return this.showPlayerTime && i ? t.time : e < 2 && !this.showPlayerTime ? this.doXor(e, t) : t.timeDiff;
    },
    doXor(e, t) {
      return (this.isFirstElement(e) ? !this.isPlayerFirst : this.isPlayerFirst) ? t.time : t.timeDiff;
    }
  }
}), ro = { class: "position" }, ao = { class: "pos-number" }, lo = { class: "row-i" }, uo = { class: "sider" }, co = { class: "country" }, po = ["src", "alt"], ho = { class: "country-name" };
function fo(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: "left-table-rows",
    style: b([e.style, e.basicStyle])
  }, [
    (p(!0), h(H, null, de(e.rowData, (a, u) => {
      var d;
      return p(), h("div", {
        key: u,
        class: _(["table-row", e.getClass(e.isFirstElement(u), ((d = a.player) == null ? void 0 : d.isPlayer) ?? !1)])
      }, [
        l("div", ro, [
          l("span", ao, $(a.position), 1)
        ]),
        l("div", lo, [
          l("div", uo, [
            l("div", co, [
              l("img", {
                class: "image",
                src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${a.country.toLowerCase()}.png`,
                alt: a.country
              }, null, 8, po),
              M(r, {
                text: a.player.name,
                "font-size": 34,
                width: 270,
                height: 40,
                class: "player-name"
              }, null, 8, ["text"]),
              l("div", ho, " (" + $(a.countryString) + ") ", 1)
            ])
          ])
        ]),
        l("div", {
          class: _(["time", a.color])
        }, $(e.getText(u, a, a.player.isPlayer ?? !1)), 3)
      ], 2);
    }), 128))
  ], 4);
}
const K1 = /* @__PURE__ */ S(oo, [["render", fo], ["__scopeId", "data-v-9531ce5d"]]), E = "https://appspowerplaymanager.vshcdn.net/images/winter-sports/minigame/core-ui", mo = "https://appspowerplaymanager.vshcdn.net/images/winter-sports/avatars", go = "https://appspowerplaymanager.vshcdn.net/images/winter-sports/events", yo = T({
  name: "BlackOverlay",
  mixins: [P],
  props: {},
  data() {
    return {
      pathImages: E,
      blackOverlay: Ln()
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef})`,
        "transform-origin": "0% 0%",
        width: `calc(100% / ${this.scaleCoef})`,
        height: `calc(100% / ${this.scaleCoef})`
      };
    }
  }
}), vo = ["src"];
function bo(e, t, i, s, n, o) {
  return p(), V(ks, { name: "fade" }, {
    default: F(() => [
      e.blackOverlay.showOverlay ? (p(), h("section", {
        key: 0,
        ref: "black-overlay-container",
        class: _(["game-in-black", e.isMobile() ? "mobile-overlay" : ""]),
        style: b([e.transformCoef])
      }, [
        l("img", {
          src: `${e.pathImages}/black-overlay/WINTER-SPORTS-LOGO.png`,
          alt: "logo"
        }, null, 8, vo)
      ], 6)) : w("", !0)
    ]),
    _: 1
  });
}
const Z1 = /* @__PURE__ */ S(yo, [["render", bo], ["__scopeId", "data-v-b6daf1d2"]]), $o = T({
  name: "BlueBoxSolid",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    cutCornerBottomRight: {
      type: Boolean,
      required: !1,
      default: !1
    },
    highlight: {
      type: Boolean,
      default: !1
    },
    showShadowBox: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {},
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), ko = {
  key: 0,
  class: "corner-box corner-box-top-right"
}, _o = {
  key: 1,
  class: "corner-box corner-box-bottom-left"
}, wo = {
  key: 2,
  class: "cutting-box"
}, To = {
  key: 3,
  class: "shadow-box"
};
function So(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["blue-box-solid-container", [e.highlight ? "highlight" : "", { "blue-box-solid-container-ssm": e.isSsm }]]),
    style: b([e.style])
  }, [
    e.isSsm ? w("", !0) : (p(), h("div", ko)),
    e.isSsm ? w("", !0) : (p(), h("div", _o)),
    e.cutCornerBottomRight ? (p(), h("div", wo)) : w("", !0),
    J(e.$slots, "default"),
    e.showShadowBox ? (p(), h("div", To)) : w("", !0)
  ], 6);
}
const Ts = /* @__PURE__ */ S($o, [["render", So]]), xo = T({
  name: "BlueBox",
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({
        width: "950px",
        height: "70px"
      })
    },
    yellowBorder: {
      type: Boolean,
      required: !1,
      default: !1
    },
    showBorder: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** colours: yellow, white */
    borderColor: {
      type: String,
      required: !1,
      default: "yellow"
    },
    side: {
      type: String,
      default: ""
    },
    isPink: {
      type: Boolean,
      default: !1
    },
    moreGradient: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    transformCoef() {
      let e = "-50%, 0", t = "0 0";
      this.side === "left" ? e = "0" : this.side === "right" ? (e = "0", t = "100% 0") : this.side === "bottom" && (e = "0", t = "center bottom");
      let i = 1;
      return this.isScaled && (i = this.scaleCoef), {
        transform: `scale( ${i} ) translate(${e})`,
        "transform-origin": t
      };
    }
  }
});
function Co(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["blue-box", [`blue-box-${e.side}`, { "pink-box": e.isPink }, { "more-gradient": e.moreGradient }]]),
    style: b([e.transformCoef, e.style])
  }, [
    e.showBorder ? (p(), h("div", {
      key: 0,
      class: _(["border-top", e.borderColor, { "more-gradient": e.moreGradient }])
    }, null, 2)) : w("", !0),
    J(e.$slots, "default"),
    e.showBorder ? (p(), h("div", {
      key: 1,
      class: _(["border-bottom", e.borderColor, { "more-gradient": e.moreGradient }])
    }, null, 2)) : w("", !0)
  ], 6);
}
const Mi = /* @__PURE__ */ S(xo, [["render", Co]]), zo = T({
  name: "BlueBoxSegmented",
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({
        width: "",
        height: "67px"
      })
    },
    yellowBorder: {
      type: Boolean,
      required: !1,
      default: !1
    },
    showBorder: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /** colours: yellow, white */
    borderColor: {
      type: String,
      required: !1,
      default: "yellow"
    },
    side: {
      type: String,
      default: ""
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    transformCoef() {
      let e = 1;
      return this.isScaled && (e = this.scaleCoef), {
        transform: `scale( ${e} )`
      };
    }
  }
}), jo = {
  key: 1,
  class: "left-gradient"
}, Bo = { class: "content" }, Po = {
  key: 2,
  class: "right-gradient"
};
function Do(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "blue-box-segmented-positioner",
    style: b(e.transformCoef)
  }, [
    l("div", {
      class: "blue-box-segmented",
      style: b([e.style])
    }, [
      e.showBorder ? (p(), h("div", {
        key: 0,
        class: _(["border-top", e.borderColor])
      }, null, 2)) : w("", !0),
      e.side !== "right" ? (p(), h("div", jo)) : w("", !0),
      l("div", Bo, [
        J(e.$slots, "default")
      ]),
      e.side !== "left" ? (p(), h("div", Po)) : w("", !0),
      e.showBorder ? (p(), h("div", {
        key: 3,
        class: _(["border-bottom", e.borderColor])
      }, null, 2)) : w("", !0)
    ], 4)
  ], 4);
}
const J1 = /* @__PURE__ */ S(zo, [["render", Do]]), Lo = T({
  name: "BulletsTargetsBox",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    bullets: {
      type: Number,
      default: 0
    },
    targets: {
      type: Array,
      default: () => [
        !1,
        !0,
        !1,
        !0,
        !1
      ]
    },
    targetsType: {
      type: String,
      required: !1,
      default: "Standing"
    }
  },
  emits: ["close"],
  computed: {
    defaultTarget() {
      return `target-${this.targetsType.toLowerCase()}`;
    }
  }
}), Oo = { class: "bullets-targets-box" }, Io = { class: "bullets" }, Mo = { class: "targets" };
function No(e, t, i, s, n, o) {
  return p(), h("div", Oo, [
    l("div", Io, [
      K($(e.bullets) + " ", 1),
      t[0] || (t[0] = l("span", { class: "icon-bullet" }, null, -1))
    ]),
    l("div", Mo, [
      (p(!0), h(H, null, de(e.targets, (r, a) => (p(), h("div", {
        key: a,
        class: _(["target", [r ? "target-hit" : e.defaultTarget]])
      }, null, 2))), 128))
    ])
  ]);
}
const Q1 = /* @__PURE__ */ S(Lo, [["render", No]]), Ao = T({
  name: "PowerCircleBalance",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    positions: {
      type: Object,
      required: !0
    },
    isHeightEnabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    heightPercent: {
      type: Number,
      required: !1,
      default: 0
    },
    glow: {
      type: Boolean,
      default: !1
    },
    glowStyle: {
      type: Object,
      default: () => ({})
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      pathImages: E
    };
  },
  computed: {
    transformCoef() {
      return `scale(${this.isScaled ? this.scaleCoef : 1})`;
    },
    heightPercentStyle() {
      return `scale(${this.heightPercent})`;
    }
  }
}), Ro = ["src"], Eo = ["src"];
function Fo(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["power-circle-balance", { disabled: e.disabled }]),
    style: b([e.style, { transform: e.transformCoef }])
  }, [
    e.glow ? (p(), h("div", {
      key: 0,
      class: "yellow-glow",
      style: b([e.glowStyle])
    }, null, 4)) : w("", !0),
    l("img", {
      class: "dot",
      src: `${e.pathImages}/balance-circle/DOT-SYMBOL.png`,
      alt: "dot-symbol",
      style: b({
        left: Number(e.positions.x) + "%",
        top: Number(e.positions.y) + "%"
      })
    }, null, 12, Ro),
    e.isHeightEnabled ? (p(), h("img", {
      key: 1,
      class: "height",
      src: `${e.pathImages}/balance-circle/HEIGHT-INDICATOR.png`,
      alt: "height-indicator",
      style: b({ transform: e.heightPercentStyle })
    }, null, 12, Eo)) : w("", !0)
  ], 6);
}
const e0 = /* @__PURE__ */ S(Ao, [["render", Fo]]), Vo = T({
  name: "ColorOverlayComponent",
  mixins: [P],
  props: {
    color: {
      type: String,
      required: !1,
      default: "#000000"
    },
    imgSource: {
      // TODO toto vyhod a namiesto tohto pouzi slot aby sa aj texty dali vkladat
      type: String,
      default: ""
    },
    opacity: {
      type: Number,
      required: !1,
      default: 0.5
    }
  },
  data() {
    return {
      pathImages: E
    };
  },
  computed: {
    getColourAndOpacity() {
      return `background-color: ${this.color};opacity: ${this.opacity}`;
    }
  }
}), qo = ["src"];
function Wo(e, t, i, s, n, o) {
  return p(), h("section", {
    class: _(["color-overlay-container", e.isMobile() ? "mobile-color-overlay-container" : ""]),
    style: b(e.getColourAndOpacity)
  }, [
    e.imgSource ? (p(), h("img", {
      key: 0,
      src: e.imgSource,
      alt: "logo"
    }, null, 8, qo)) : w("", !0)
  ], 6);
}
const t0 = /* @__PURE__ */ S(Vo, [["render", Wo]]);
function Ve(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ss(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
/*!
 * GSAP 3.11.5
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var Te = {
  autoSleep: 120,
  force3D: "auto",
  nullTargetWarn: 1,
  units: {
    lineHeight: ""
  }
}, kt = {
  duration: 0.5,
  overwrite: !1,
  delay: 0
}, Ni, fe, re, je = 1e8, Y = 1 / je, vi = Math.PI * 2, Uo = vi / 4, Ho = 0, xs = Math.sqrt, Xo = Math.cos, Go = Math.sin, ue = function(t) {
  return typeof t == "string";
}, se = function(t) {
  return typeof t == "function";
}, We = function(t) {
  return typeof t == "number";
}, Ai = function(t) {
  return typeof t > "u";
}, Re = function(t) {
  return typeof t == "object";
}, ve = function(t) {
  return t !== !1;
}, Ri = function() {
  return typeof window < "u";
}, Wt = function(t) {
  return se(t) || ue(t);
}, Cs = typeof ArrayBuffer == "function" && ArrayBuffer.isView || function() {
}, me = Array.isArray, bi = /(?:-?\.?\d|\.)+/gi, zs = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, gt = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, li = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, js = /[+-]=-?[.\d]+/, Bs = /[^,'"\[\]\s]+/gi, Yo = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, te, Ce, $i, Ei, Se = {}, Yt = {}, Ps, Ds = function(t) {
  return (Yt = pt(t, Se)) && ke;
}, Fi = function(t, i) {
  return console.warn("Invalid property", t, "set to", i, "Missing plugin? gsap.registerPlugin()");
}, Kt = function(t, i) {
  return !i && console.warn(t);
}, Ls = function(t, i) {
  return t && (Se[t] = i) && Yt && (Yt[t] = i) || Se;
}, Mt = function() {
  return 0;
}, Ko = {
  suppressEvents: !0,
  isStart: !0,
  kill: !1
}, Ut = {
  suppressEvents: !0,
  kill: !1
}, Zo = {
  suppressEvents: !0
}, Vi = {}, Ye = [], ki = {}, Os, _e = {}, di = {}, ns = 30, Ht = [], qi = "", Wi = function(t) {
  var i = t[0], s, n;
  if (Re(i) || se(i) || (t = [t]), !(s = (i._gsap || {}).harness)) {
    for (n = Ht.length; n-- && !Ht[n].targetTest(i); )
      ;
    s = Ht[n];
  }
  for (n = t.length; n--; )
    t[n] && (t[n]._gsap || (t[n]._gsap = new on(t[n], s))) || t.splice(n, 1);
  return t;
}, dt = function(t) {
  return t._gsap || Wi(Be(t))[0]._gsap;
}, Is = function(t, i, s) {
  return (s = t[i]) && se(s) ? t[i]() : Ai(s) && t.getAttribute && t.getAttribute(i) || s;
}, be = function(t, i) {
  return (t = t.split(",")).forEach(i) || t;
}, ne = function(t) {
  return Math.round(t * 1e5) / 1e5 || 0;
}, ce = function(t) {
  return Math.round(t * 1e7) / 1e7 || 0;
}, vt = function(t, i) {
  var s = i.charAt(0), n = parseFloat(i.substr(2));
  return t = parseFloat(t), s === "+" ? t + n : s === "-" ? t - n : s === "*" ? t * n : t / n;
}, Jo = function(t, i) {
  for (var s = i.length, n = 0; t.indexOf(i[n]) < 0 && ++n < s; )
    ;
  return n < s;
}, Zt = function() {
  var t = Ye.length, i = Ye.slice(0), s, n;
  for (ki = {}, Ye.length = 0, s = 0; s < t; s++)
    n = i[s], n && n._lazy && (n.render(n._lazy[0], n._lazy[1], !0)._lazy = 0);
}, Ms = function(t, i, s, n) {
  Ye.length && !fe && Zt(), t.render(i, s, fe && i < 0 && (t._initted || t._startAt)), Ye.length && !fe && Zt();
}, Ns = function(t) {
  var i = parseFloat(t);
  return (i || i === 0) && (t + "").match(Bs).length < 2 ? i : ue(t) ? t.trim() : t;
}, As = function(t) {
  return t;
}, De = function(t, i) {
  for (var s in i)
    s in t || (t[s] = i[s]);
  return t;
}, Qo = function(t) {
  return function(i, s) {
    for (var n in s)
      n in i || n === "duration" && t || n === "ease" || (i[n] = s[n]);
  };
}, pt = function(t, i) {
  for (var s in i)
    t[s] = i[s];
  return t;
}, os = function e(t, i) {
  for (var s in i)
    s !== "__proto__" && s !== "constructor" && s !== "prototype" && (t[s] = Re(i[s]) ? e(t[s] || (t[s] = {}), i[s]) : i[s]);
  return t;
}, Jt = function(t, i) {
  var s = {}, n;
  for (n in t)
    n in i || (s[n] = t[n]);
  return s;
}, Lt = function(t) {
  var i = t.parent || te, s = t.keyframes ? Qo(me(t.keyframes)) : De;
  if (ve(t.inherit))
    for (; i; )
      s(t, i.vars.defaults), i = i.parent || i._dp;
  return t;
}, er = function(t, i) {
  for (var s = t.length, n = s === i.length; n && s-- && t[s] === i[s]; )
    ;
  return s < 0;
}, Rs = function(t, i, s, n, o) {
  var r = t[n], a;
  if (o)
    for (a = i[o]; r && r[o] > a; )
      r = r._prev;
  return r ? (i._next = r._next, r._next = i) : (i._next = t[s], t[s] = i), i._next ? i._next._prev = i : t[n] = i, i._prev = r, i.parent = i._dp = t, i;
}, si = function(t, i, s, n) {
  s === void 0 && (s = "_first"), n === void 0 && (n = "_last");
  var o = i._prev, r = i._next;
  o ? o._next = r : t[s] === i && (t[s] = r), r ? r._prev = o : t[n] === i && (t[n] = o), i._next = i._prev = i.parent = null;
}, Je = function(t, i) {
  t.parent && (!i || t.parent.autoRemoveChildren) && t.parent.remove(t), t._act = 0;
}, ut = function(t, i) {
  if (t && (!i || i._end > t._dur || i._start < 0))
    for (var s = t; s; )
      s._dirty = 1, s = s.parent;
  return t;
}, tr = function(t) {
  for (var i = t.parent; i && i.parent; )
    i._dirty = 1, i.totalDuration(), i = i.parent;
  return t;
}, _i = function(t, i, s, n) {
  return t._startAt && (fe ? t._startAt.revert(Ut) : t.vars.immediateRender && !t.vars.autoRevert || t._startAt.render(i, !0, n));
}, ir = function e(t) {
  return !t || t._ts && e(t.parent);
}, rs = function(t) {
  return t._repeat ? _t(t._tTime, t = t.duration() + t._rDelay) * t : 0;
}, _t = function(t, i) {
  var s = Math.floor(t /= i);
  return t && s === t ? s - 1 : s;
}, Qt = function(t, i) {
  return (t - i._start) * i._ts + (i._ts >= 0 ? 0 : i._dirty ? i.totalDuration() : i._tDur);
}, ni = function(t) {
  return t._end = ce(t._start + (t._tDur / Math.abs(t._ts || t._rts || Y) || 0));
}, oi = function(t, i) {
  var s = t._dp;
  return s && s.smoothChildTiming && t._ts && (t._start = ce(s._time - (t._ts > 0 ? i / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - i) / -t._ts)), ni(t), s._dirty || ut(s, t)), t;
}, Es = function(t, i) {
  var s;
  if ((i._time || i._initted && !i._dur) && (s = Qt(t.rawTime(), i), (!i._dur || Vt(0, i.totalDuration(), s) - i._tTime > Y) && i.render(s, !0)), ut(t, i)._dp && t._initted && t._time >= t._dur && t._ts) {
    if (t._dur < t.duration())
      for (s = t; s._dp; )
        s.rawTime() >= 0 && s.totalTime(s._tTime), s = s._dp;
    t._zTime = -Y;
  }
}, Ie = function(t, i, s, n) {
  return i.parent && Je(i), i._start = ce((We(s) ? s : s || t !== te ? xe(t, s, i) : t._time) + i._delay), i._end = ce(i._start + (i.totalDuration() / Math.abs(i.timeScale()) || 0)), Rs(t, i, "_first", "_last", t._sort ? "_start" : 0), wi(i) || (t._recent = i), n || Es(t, i), t._ts < 0 && oi(t, t._tTime), t;
}, Fs = function(t, i) {
  return (Se.ScrollTrigger || Fi("scrollTrigger", i)) && Se.ScrollTrigger.create(i, t);
}, Vs = function(t, i, s, n, o) {
  if (Hi(t, i, o), !t._initted)
    return 1;
  if (!s && t._pt && !fe && (t._dur && t.vars.lazy !== !1 || !t._dur && t.vars.lazy) && Os !== we.frame)
    return Ye.push(t), t._lazy = [o, n], 1;
}, sr = function e(t) {
  var i = t.parent;
  return i && i._ts && i._initted && !i._lock && (i.rawTime() < 0 || e(i));
}, wi = function(t) {
  var i = t.data;
  return i === "isFromStart" || i === "isStart";
}, nr = function(t, i, s, n) {
  var o = t.ratio, r = i < 0 || !i && (!t._start && sr(t) && !(!t._initted && wi(t)) || (t._ts < 0 || t._dp._ts < 0) && !wi(t)) ? 0 : 1, a = t._rDelay, u = 0, d, c, g;
  if (a && t._repeat && (u = Vt(0, t._tDur, i), c = _t(u, a), t._yoyo && c & 1 && (r = 1 - r), c !== _t(t._tTime, a) && (o = 1 - r, t.vars.repeatRefresh && t._initted && t.invalidate())), r !== o || fe || n || t._zTime === Y || !i && t._zTime) {
    if (!t._initted && Vs(t, i, n, s, u))
      return;
    for (g = t._zTime, t._zTime = i || (s ? Y : 0), s || (s = i && !g), t.ratio = r, t._from && (r = 1 - r), t._time = 0, t._tTime = u, d = t._pt; d; )
      d.r(r, d.d), d = d._next;
    i < 0 && _i(t, i, s, !0), t._onUpdate && !s && Pe(t, "onUpdate"), u && t._repeat && !s && t.parent && Pe(t, "onRepeat"), (i >= t._tDur || i < 0) && t.ratio === r && (r && Je(t, 1), !s && !fe && (Pe(t, r ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
  } else t._zTime || (t._zTime = i);
}, or = function(t, i, s) {
  var n;
  if (s > i)
    for (n = t._first; n && n._start <= s; ) {
      if (n.data === "isPause" && n._start > i)
        return n;
      n = n._next;
    }
  else
    for (n = t._last; n && n._start >= s; ) {
      if (n.data === "isPause" && n._start < i)
        return n;
      n = n._prev;
    }
}, wt = function(t, i, s, n) {
  var o = t._repeat, r = ce(i) || 0, a = t._tTime / t._tDur;
  return a && !n && (t._time *= r / t._dur), t._dur = r, t._tDur = o ? o < 0 ? 1e10 : ce(r * (o + 1) + t._rDelay * o) : r, a > 0 && !n && oi(t, t._tTime = t._tDur * a), t.parent && ni(t), s || ut(t.parent, t), t;
}, as = function(t) {
  return t instanceof ye ? ut(t) : wt(t, t._dur);
}, rr = {
  _start: 0,
  endTime: Mt,
  totalDuration: Mt
}, xe = function e(t, i, s) {
  var n = t.labels, o = t._recent || rr, r = t.duration() >= je ? o.endTime(!1) : t._dur, a, u, d;
  return ue(i) && (isNaN(i) || i in n) ? (u = i.charAt(0), d = i.substr(-1) === "%", a = i.indexOf("="), u === "<" || u === ">" ? (a >= 0 && (i = i.replace(/=/, "")), (u === "<" ? o._start : o.endTime(o._repeat >= 0)) + (parseFloat(i.substr(1)) || 0) * (d ? (a < 0 ? o : s).totalDuration() / 100 : 1)) : a < 0 ? (i in n || (n[i] = r), n[i]) : (u = parseFloat(i.charAt(a - 1) + i.substr(a + 1)), d && s && (u = u / 100 * (me(s) ? s[0] : s).totalDuration()), a > 1 ? e(t, i.substr(0, a - 1), s) + u : r + u)) : i == null ? r : +i;
}, Ot = function(t, i, s) {
  var n = We(i[1]), o = (n ? 2 : 1) + (t < 2 ? 0 : 1), r = i[o], a, u;
  if (n && (r.duration = i[1]), r.parent = s, t) {
    for (a = r, u = s; u && !("immediateRender" in a); )
      a = u.vars.defaults || {}, u = ve(u.vars.inherit) && u.parent;
    r.immediateRender = ve(a.immediateRender), t < 2 ? r.runBackwards = 1 : r.startAt = i[o - 1];
  }
  return new le(i[0], r, i[o + 1]);
}, et = function(t, i) {
  return t || t === 0 ? i(t) : i;
}, Vt = function(t, i, s) {
  return s < t ? t : s > i ? i : s;
}, he = function(t, i) {
  return !ue(t) || !(i = Yo.exec(t)) ? "" : i[1];
}, ar = function(t, i, s) {
  return et(s, function(n) {
    return Vt(t, i, n);
  });
}, Ti = [].slice, qs = function(t, i) {
  return t && Re(t) && "length" in t && (!i && !t.length || t.length - 1 in t && Re(t[0])) && !t.nodeType && t !== Ce;
}, lr = function(t, i, s) {
  return s === void 0 && (s = []), t.forEach(function(n) {
    var o;
    return ue(n) && !i || qs(n, 1) ? (o = s).push.apply(o, Be(n)) : s.push(n);
  }) || s;
}, Be = function(t, i, s) {
  return re && !i && re.selector ? re.selector(t) : ue(t) && !s && ($i || !Tt()) ? Ti.call((i || Ei).querySelectorAll(t), 0) : me(t) ? lr(t, s) : qs(t) ? Ti.call(t, 0) : t ? [t] : [];
}, Si = function(t) {
  return t = Be(t)[0] || Kt("Invalid scope") || {}, function(i) {
    var s = t.current || t.nativeElement || t;
    return Be(i, s.querySelectorAll ? s : s === t ? Kt("Invalid scope") || Ei.createElement("div") : t);
  };
}, Ws = function(t) {
  return t.sort(function() {
    return 0.5 - Math.random();
  });
}, Us = function(t) {
  if (se(t))
    return t;
  var i = Re(t) ? t : {
    each: t
  }, s = ct(i.ease), n = i.from || 0, o = parseFloat(i.base) || 0, r = {}, a = n > 0 && n < 1, u = isNaN(n) || a, d = i.axis, c = n, g = n;
  return ue(n) ? c = g = {
    center: 0.5,
    edges: 0.5,
    end: 1
  }[n] || 0 : !a && u && (c = n[0], g = n[1]), function(f, m, v) {
    var y = (v || i).length, k = r[y], C, x, j, D, z, N, I, O, B;
    if (!k) {
      if (B = i.grid === "auto" ? 0 : (i.grid || [1, je])[1], !B) {
        for (I = -je; I < (I = v[B++].getBoundingClientRect().left) && B < y; )
          ;
        B--;
      }
      for (k = r[y] = [], C = u ? Math.min(B, y) * c - 0.5 : n % B, x = B === je ? 0 : u ? y * g / B - 0.5 : n / B | 0, I = 0, O = je, N = 0; N < y; N++)
        j = N % B - C, D = x - (N / B | 0), k[N] = z = d ? Math.abs(d === "y" ? D : j) : xs(j * j + D * D), z > I && (I = z), z < O && (O = z);
      n === "random" && Ws(k), k.max = I - O, k.min = O, k.v = y = (parseFloat(i.amount) || parseFloat(i.each) * (B > y ? y - 1 : d ? d === "y" ? y / B : B : Math.max(B, y / B)) || 0) * (n === "edges" ? -1 : 1), k.b = y < 0 ? o - y : o, k.u = he(i.amount || i.each) || 0, s = s && y < 0 ? tn(s) : s;
    }
    return y = (k[f] - k.min) / k.max || 0, ce(k.b + (s ? s(y) : y) * k.v) + k.u;
  };
}, xi = function(t) {
  var i = Math.pow(10, ((t + "").split(".")[1] || "").length);
  return function(s) {
    var n = ce(Math.round(parseFloat(s) / t) * t * i);
    return (n - n % 1) / i + (We(s) ? 0 : he(s));
  };
}, Hs = function(t, i) {
  var s = me(t), n, o;
  return !s && Re(t) && (n = s = t.radius || je, t.values ? (t = Be(t.values), (o = !We(t[0])) && (n *= n)) : t = xi(t.increment)), et(i, s ? se(t) ? function(r) {
    return o = t(r), Math.abs(o - r) <= n ? o : r;
  } : function(r) {
    for (var a = parseFloat(o ? r.x : r), u = parseFloat(o ? r.y : 0), d = je, c = 0, g = t.length, f, m; g--; )
      o ? (f = t[g].x - a, m = t[g].y - u, f = f * f + m * m) : f = Math.abs(t[g] - a), f < d && (d = f, c = g);
    return c = !n || d <= n ? t[c] : r, o || c === r || We(r) ? c : c + he(r);
  } : xi(t));
}, Xs = function(t, i, s, n) {
  return et(me(t) ? !i : s === !0 ? !!(s = 0) : !n, function() {
    return me(t) ? t[~~(Math.random() * t.length)] : (s = s || 1e-5) && (n = s < 1 ? Math.pow(10, (s + "").length - 2) : 1) && Math.floor(Math.round((t - s / 2 + Math.random() * (i - t + s * 0.99)) / s) * s * n) / n;
  });
}, dr = function() {
  for (var t = arguments.length, i = new Array(t), s = 0; s < t; s++)
    i[s] = arguments[s];
  return function(n) {
    return i.reduce(function(o, r) {
      return r(o);
    }, n);
  };
}, ur = function(t, i) {
  return function(s) {
    return t(parseFloat(s)) + (i || he(s));
  };
}, cr = function(t, i, s) {
  return Ys(t, i, 0, 1, s);
}, Gs = function(t, i, s) {
  return et(s, function(n) {
    return t[~~i(n)];
  });
}, pr = function e(t, i, s) {
  var n = i - t;
  return me(t) ? Gs(t, e(0, t.length), i) : et(s, function(o) {
    return (n + (o - t) % n) % n + t;
  });
}, hr = function e(t, i, s) {
  var n = i - t, o = n * 2;
  return me(t) ? Gs(t, e(0, t.length - 1), i) : et(s, function(r) {
    return r = (o + (r - t) % o) % o || 0, t + (r > n ? o - r : r);
  });
}, Nt = function(t) {
  for (var i = 0, s = "", n, o, r, a; ~(n = t.indexOf("random(", i)); )
    r = t.indexOf(")", n), a = t.charAt(n + 7) === "[", o = t.substr(n + 7, r - n - 7).match(a ? Bs : bi), s += t.substr(i, n - i) + Xs(a ? o : +o[0], a ? 0 : +o[1], +o[2] || 1e-5), i = r + 1;
  return s + t.substr(i, t.length - i);
}, Ys = function(t, i, s, n, o) {
  var r = i - t, a = n - s;
  return et(o, function(u) {
    return s + ((u - t) / r * a || 0);
  });
}, fr = function e(t, i, s, n) {
  var o = isNaN(t + i) ? 0 : function(m) {
    return (1 - m) * t + m * i;
  };
  if (!o) {
    var r = ue(t), a = {}, u, d, c, g, f;
    if (s === !0 && (n = 1) && (s = null), r)
      t = {
        p: t
      }, i = {
        p: i
      };
    else if (me(t) && !me(i)) {
      for (c = [], g = t.length, f = g - 2, d = 1; d < g; d++)
        c.push(e(t[d - 1], t[d]));
      g--, o = function(v) {
        v *= g;
        var y = Math.min(f, ~~v);
        return c[y](v - y);
      }, s = i;
    } else n || (t = pt(me(t) ? [] : {}, t));
    if (!c) {
      for (u in i)
        Ui.call(a, t, u, "get", i[u]);
      o = function(v) {
        return Yi(v, a) || (r ? t.p : t);
      };
    }
  }
  return et(s, o);
}, ls = function(t, i, s) {
  var n = t.labels, o = je, r, a, u;
  for (r in n)
    a = n[r] - i, a < 0 == !!s && a && o > (a = Math.abs(a)) && (u = r, o = a);
  return u;
}, Pe = function(t, i, s) {
  var n = t.vars, o = n[i], r = re, a = t._ctx, u, d, c;
  if (o)
    return u = n[i + "Params"], d = n.callbackScope || t, s && Ye.length && Zt(), a && (re = a), c = u ? o.apply(d, u) : o.call(d), re = r, c;
}, Pt = function(t) {
  return Je(t), t.scrollTrigger && t.scrollTrigger.kill(!!fe), t.progress() < 1 && Pe(t, "onInterrupt"), t;
}, yt, Ks = [], Zs = function(t) {
  if (!Ri()) {
    Ks.push(t);
    return;
  }
  t = !t.name && t.default || t;
  var i = t.name, s = se(t), n = i && !s && t.init ? function() {
    this._props = [];
  } : t, o = {
    init: Mt,
    render: Yi,
    add: Ui,
    kill: Br,
    modifier: jr,
    rawVars: 0
  }, r = {
    targetTest: 0,
    get: 0,
    getSetter: Gi,
    aliases: {},
    register: 0
  };
  if (Tt(), t !== n) {
    if (_e[i])
      return;
    De(n, De(Jt(t, o), r)), pt(n.prototype, pt(o, Jt(t, r))), _e[n.prop = i] = n, t.targetTest && (Ht.push(n), Vi[i] = 1), i = (i === "css" ? "CSS" : i.charAt(0).toUpperCase() + i.substr(1)) + "Plugin";
  }
  Ls(i, n), t.register && t.register(ke, n, $e);
}, G = 255, Dt = {
  aqua: [0, G, G],
  lime: [0, G, 0],
  silver: [192, 192, 192],
  black: [0, 0, 0],
  maroon: [128, 0, 0],
  teal: [0, 128, 128],
  blue: [0, 0, G],
  navy: [0, 0, 128],
  white: [G, G, G],
  olive: [128, 128, 0],
  yellow: [G, G, 0],
  orange: [G, 165, 0],
  gray: [128, 128, 128],
  purple: [128, 0, 128],
  green: [0, 128, 0],
  red: [G, 0, 0],
  pink: [G, 192, 203],
  cyan: [0, G, G],
  transparent: [G, G, G, 0]
}, ui = function(t, i, s) {
  return t += t < 0 ? 1 : t > 1 ? -1 : 0, (t * 6 < 1 ? i + (s - i) * t * 6 : t < 0.5 ? s : t * 3 < 2 ? i + (s - i) * (2 / 3 - t) * 6 : i) * G + 0.5 | 0;
}, Js = function(t, i, s) {
  var n = t ? We(t) ? [t >> 16, t >> 8 & G, t & G] : 0 : Dt.black, o, r, a, u, d, c, g, f, m, v;
  if (!n) {
    if (t.substr(-1) === "," && (t = t.substr(0, t.length - 1)), Dt[t])
      n = Dt[t];
    else if (t.charAt(0) === "#") {
      if (t.length < 6 && (o = t.charAt(1), r = t.charAt(2), a = t.charAt(3), t = "#" + o + o + r + r + a + a + (t.length === 5 ? t.charAt(4) + t.charAt(4) : "")), t.length === 9)
        return n = parseInt(t.substr(1, 6), 16), [n >> 16, n >> 8 & G, n & G, parseInt(t.substr(7), 16) / 255];
      t = parseInt(t.substr(1), 16), n = [t >> 16, t >> 8 & G, t & G];
    } else if (t.substr(0, 3) === "hsl") {
      if (n = v = t.match(bi), !i)
        u = +n[0] % 360 / 360, d = +n[1] / 100, c = +n[2] / 100, r = c <= 0.5 ? c * (d + 1) : c + d - c * d, o = c * 2 - r, n.length > 3 && (n[3] *= 1), n[0] = ui(u + 1 / 3, o, r), n[1] = ui(u, o, r), n[2] = ui(u - 1 / 3, o, r);
      else if (~t.indexOf("="))
        return n = t.match(zs), s && n.length < 4 && (n[3] = 1), n;
    } else
      n = t.match(bi) || Dt.transparent;
    n = n.map(Number);
  }
  return i && !v && (o = n[0] / G, r = n[1] / G, a = n[2] / G, g = Math.max(o, r, a), f = Math.min(o, r, a), c = (g + f) / 2, g === f ? u = d = 0 : (m = g - f, d = c > 0.5 ? m / (2 - g - f) : m / (g + f), u = g === o ? (r - a) / m + (r < a ? 6 : 0) : g === r ? (a - o) / m + 2 : (o - r) / m + 4, u *= 60), n[0] = ~~(u + 0.5), n[1] = ~~(d * 100 + 0.5), n[2] = ~~(c * 100 + 0.5)), s && n.length < 4 && (n[3] = 1), n;
}, Qs = function(t) {
  var i = [], s = [], n = -1;
  return t.split(Ke).forEach(function(o) {
    var r = o.match(gt) || [];
    i.push.apply(i, r), s.push(n += r.length + 1);
  }), i.c = s, i;
}, ds = function(t, i, s) {
  var n = "", o = (t + n).match(Ke), r = i ? "hsla(" : "rgba(", a = 0, u, d, c, g;
  if (!o)
    return t;
  if (o = o.map(function(f) {
    return (f = Js(f, i, 1)) && r + (i ? f[0] + "," + f[1] + "%," + f[2] + "%," + f[3] : f.join(",")) + ")";
  }), s && (c = Qs(t), u = s.c, u.join(n) !== c.c.join(n)))
    for (d = t.replace(Ke, "1").split(gt), g = d.length - 1; a < g; a++)
      n += d[a] + (~u.indexOf(a) ? o.shift() || r + "0,0,0,0)" : (c.length ? c : o.length ? o : s).shift());
  if (!d)
    for (d = t.split(Ke), g = d.length - 1; a < g; a++)
      n += d[a] + o[a];
  return n + d[g];
}, Ke = function() {
  var e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", t;
  for (t in Dt)
    e += "|" + t + "\\b";
  return new RegExp(e + ")", "gi");
}(), mr = /hsl[a]?\(/, en = function(t) {
  var i = t.join(" "), s;
  if (Ke.lastIndex = 0, Ke.test(i))
    return s = mr.test(i), t[1] = ds(t[1], s), t[0] = ds(t[0], s, Qs(t[1])), !0;
}, At, we = function() {
  var e = Date.now, t = 500, i = 33, s = e(), n = s, o = 1e3 / 240, r = o, a = [], u, d, c, g, f, m, v = function y(k) {
    var C = e() - n, x = k === !0, j, D, z, N;
    if (C > t && (s += C - i), n += C, z = n - s, j = z - r, (j > 0 || x) && (N = ++g.frame, f = z - g.time * 1e3, g.time = z = z / 1e3, r += j + (j >= o ? 4 : o - j), D = 1), x || (u = d(y)), D)
      for (m = 0; m < a.length; m++)
        a[m](z, f, N, k);
  };
  return g = {
    time: 0,
    frame: 0,
    tick: function() {
      v(!0);
    },
    deltaRatio: function(k) {
      return f / (1e3 / (k || 60));
    },
    wake: function() {
      Ps && (!$i && Ri() && (Ce = $i = window, Ei = Ce.document || {}, Se.gsap = ke, (Ce.gsapVersions || (Ce.gsapVersions = [])).push(ke.version), Ds(Yt || Ce.GreenSockGlobals || !Ce.gsap && Ce || {}), c = Ce.requestAnimationFrame, Ks.forEach(Zs)), u && g.sleep(), d = c || function(k) {
        return setTimeout(k, r - g.time * 1e3 + 1 | 0);
      }, At = 1, v(2));
    },
    sleep: function() {
      (c ? Ce.cancelAnimationFrame : clearTimeout)(u), At = 0, d = Mt;
    },
    lagSmoothing: function(k, C) {
      t = k || 1 / 0, i = Math.min(C || 33, t);
    },
    fps: function(k) {
      o = 1e3 / (k || 240), r = g.time * 1e3 + o;
    },
    add: function(k, C, x) {
      var j = C ? function(D, z, N, I) {
        k(D, z, N, I), g.remove(j);
      } : k;
      return g.remove(k), a[x ? "unshift" : "push"](j), Tt(), j;
    },
    remove: function(k, C) {
      ~(C = a.indexOf(k)) && a.splice(C, 1) && m >= C && m--;
    },
    _listeners: a
  }, g;
}(), Tt = function() {
  return !At && we.wake();
}, q = {}, gr = /^[\d.\-M][\d.\-,\s]/, yr = /["']/g, vr = function(t) {
  for (var i = {}, s = t.substr(1, t.length - 3).split(":"), n = s[0], o = 1, r = s.length, a, u, d; o < r; o++)
    u = s[o], a = o !== r - 1 ? u.lastIndexOf(",") : u.length, d = u.substr(0, a), i[n] = isNaN(d) ? d.replace(yr, "").trim() : +d, n = u.substr(a + 1).trim();
  return i;
}, br = function(t) {
  var i = t.indexOf("(") + 1, s = t.indexOf(")"), n = t.indexOf("(", i);
  return t.substring(i, ~n && n < s ? t.indexOf(")", s + 1) : s);
}, $r = function(t) {
  var i = (t + "").split("("), s = q[i[0]];
  return s && i.length > 1 && s.config ? s.config.apply(null, ~t.indexOf("{") ? [vr(i[1])] : br(t).split(",").map(Ns)) : q._CE && gr.test(t) ? q._CE("", t) : s;
}, tn = function(t) {
  return function(i) {
    return 1 - t(1 - i);
  };
}, sn = function e(t, i) {
  for (var s = t._first, n; s; )
    s instanceof ye ? e(s, i) : s.vars.yoyoEase && (!s._yoyo || !s._repeat) && s._yoyo !== i && (s.timeline ? e(s.timeline, i) : (n = s._ease, s._ease = s._yEase, s._yEase = n, s._yoyo = i)), s = s._next;
}, ct = function(t, i) {
  return t && (se(t) ? t : q[t] || $r(t)) || i;
}, ht = function(t, i, s, n) {
  s === void 0 && (s = function(u) {
    return 1 - i(1 - u);
  }), n === void 0 && (n = function(u) {
    return u < 0.5 ? i(u * 2) / 2 : 1 - i((1 - u) * 2) / 2;
  });
  var o = {
    easeIn: i,
    easeOut: s,
    easeInOut: n
  }, r;
  return be(t, function(a) {
    q[a] = Se[a] = o, q[r = a.toLowerCase()] = s;
    for (var u in o)
      q[r + (u === "easeIn" ? ".in" : u === "easeOut" ? ".out" : ".inOut")] = q[a + "." + u] = o[u];
  }), o;
}, nn = function(t) {
  return function(i) {
    return i < 0.5 ? (1 - t(1 - i * 2)) / 2 : 0.5 + t((i - 0.5) * 2) / 2;
  };
}, ci = function e(t, i, s) {
  var n = i >= 1 ? i : 1, o = (s || (t ? 0.3 : 0.45)) / (i < 1 ? i : 1), r = o / vi * (Math.asin(1 / n) || 0), a = function(c) {
    return c === 1 ? 1 : n * Math.pow(2, -10 * c) * Go((c - r) * o) + 1;
  }, u = t === "out" ? a : t === "in" ? function(d) {
    return 1 - a(1 - d);
  } : nn(a);
  return o = vi / o, u.config = function(d, c) {
    return e(t, d, c);
  }, u;
}, pi = function e(t, i) {
  i === void 0 && (i = 1.70158);
  var s = function(r) {
    return r ? --r * r * ((i + 1) * r + i) + 1 : 0;
  }, n = t === "out" ? s : t === "in" ? function(o) {
    return 1 - s(1 - o);
  } : nn(s);
  return n.config = function(o) {
    return e(t, o);
  }, n;
};
be("Linear,Quad,Cubic,Quart,Quint,Strong", function(e, t) {
  var i = t < 5 ? t + 1 : t;
  ht(e + ",Power" + (i - 1), t ? function(s) {
    return Math.pow(s, i);
  } : function(s) {
    return s;
  }, function(s) {
    return 1 - Math.pow(1 - s, i);
  }, function(s) {
    return s < 0.5 ? Math.pow(s * 2, i) / 2 : 1 - Math.pow((1 - s) * 2, i) / 2;
  });
});
q.Linear.easeNone = q.none = q.Linear.easeIn;
ht("Elastic", ci("in"), ci("out"), ci());
(function(e, t) {
  var i = 1 / t, s = 2 * i, n = 2.5 * i, o = function(a) {
    return a < i ? e * a * a : a < s ? e * Math.pow(a - 1.5 / t, 2) + 0.75 : a < n ? e * (a -= 2.25 / t) * a + 0.9375 : e * Math.pow(a - 2.625 / t, 2) + 0.984375;
  };
  ht("Bounce", function(r) {
    return 1 - o(1 - r);
  }, o);
})(7.5625, 2.75);
ht("Expo", function(e) {
  return e ? Math.pow(2, 10 * (e - 1)) : 0;
});
ht("Circ", function(e) {
  return -(xs(1 - e * e) - 1);
});
ht("Sine", function(e) {
  return e === 1 ? 1 : -Xo(e * Uo) + 1;
});
ht("Back", pi("in"), pi("out"), pi());
q.SteppedEase = q.steps = Se.SteppedEase = {
  config: function(t, i) {
    t === void 0 && (t = 1);
    var s = 1 / t, n = t + (i ? 0 : 1), o = i ? 1 : 0, r = 1 - Y;
    return function(a) {
      return ((n * Vt(0, r, a) | 0) + o) * s;
    };
  }
};
kt.ease = q["quad.out"];
be("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(e) {
  return qi += e + "," + e + "Params,";
});
var on = function(t, i) {
  this.id = Ho++, t._gsap = this, this.target = t, this.harness = i, this.get = i ? i.get : Is, this.set = i ? i.getSetter : Gi;
}, St = /* @__PURE__ */ function() {
  function e(i) {
    this.vars = i, this._delay = +i.delay || 0, (this._repeat = i.repeat === 1 / 0 ? -2 : i.repeat || 0) && (this._rDelay = i.repeatDelay || 0, this._yoyo = !!i.yoyo || !!i.yoyoEase), this._ts = 1, wt(this, +i.duration, 1, 1), this.data = i.data, re && (this._ctx = re, re.data.push(this)), At || we.wake();
  }
  var t = e.prototype;
  return t.delay = function(s) {
    return s || s === 0 ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + s - this._delay), this._delay = s, this) : this._delay;
  }, t.duration = function(s) {
    return arguments.length ? this.totalDuration(this._repeat > 0 ? s + (s + this._rDelay) * this._repeat : s) : this.totalDuration() && this._dur;
  }, t.totalDuration = function(s) {
    return arguments.length ? (this._dirty = 0, wt(this, this._repeat < 0 ? s : (s - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
  }, t.totalTime = function(s, n) {
    if (Tt(), !arguments.length)
      return this._tTime;
    var o = this._dp;
    if (o && o.smoothChildTiming && this._ts) {
      for (oi(this, s), !o._dp || o.parent || Es(o, this); o && o.parent; )
        o.parent._time !== o._start + (o._ts >= 0 ? o._tTime / o._ts : (o.totalDuration() - o._tTime) / -o._ts) && o.totalTime(o._tTime, !0), o = o.parent;
      !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && s < this._tDur || this._ts < 0 && s > 0 || !this._tDur && !s) && Ie(this._dp, this, this._start - this._delay);
    }
    return (this._tTime !== s || !this._dur && !n || this._initted && Math.abs(this._zTime) === Y || !s && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = s), Ms(this, s, n)), this;
  }, t.time = function(s, n) {
    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), s + rs(this)) % (this._dur + this._rDelay) || (s ? this._dur : 0), n) : this._time;
  }, t.totalProgress = function(s, n) {
    return arguments.length ? this.totalTime(this.totalDuration() * s, n) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
  }, t.progress = function(s, n) {
    return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - s : s) + rs(this), n) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
  }, t.iteration = function(s, n) {
    var o = this.duration() + this._rDelay;
    return arguments.length ? this.totalTime(this._time + (s - 1) * o, n) : this._repeat ? _t(this._tTime, o) + 1 : 1;
  }, t.timeScale = function(s) {
    if (!arguments.length)
      return this._rts === -Y ? 0 : this._rts;
    if (this._rts === s)
      return this;
    var n = this.parent && this._ts ? Qt(this.parent._time, this) : this._tTime;
    return this._rts = +s || 0, this._ts = this._ps || s === -Y ? 0 : this._rts, this.totalTime(Vt(-Math.abs(this._delay), this._tDur, n), !0), ni(this), tr(this);
  }, t.paused = function(s) {
    return arguments.length ? (this._ps !== s && (this._ps = s, s ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Tt(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== Y && (this._tTime -= Y)))), this) : this._ps;
  }, t.startTime = function(s) {
    if (arguments.length) {
      this._start = s;
      var n = this.parent || this._dp;
      return n && (n._sort || !this.parent) && Ie(n, this, s - this._delay), this;
    }
    return this._start;
  }, t.endTime = function(s) {
    return this._start + (ve(s) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
  }, t.rawTime = function(s) {
    var n = this.parent || this._dp;
    return n ? s && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Qt(n.rawTime(s), this) : this._tTime : this._tTime;
  }, t.revert = function(s) {
    s === void 0 && (s = Zo);
    var n = fe;
    return fe = s, (this._initted || this._startAt) && (this.timeline && this.timeline.revert(s), this.totalTime(-0.01, s.suppressEvents)), this.data !== "nested" && s.kill !== !1 && this.kill(), fe = n, this;
  }, t.globalTime = function(s) {
    for (var n = this, o = arguments.length ? s : n.rawTime(); n; )
      o = n._start + o / (n._ts || 1), n = n._dp;
    return !this.parent && this._sat ? this._sat.vars.immediateRender ? -1 : this._sat.globalTime(s) : o;
  }, t.repeat = function(s) {
    return arguments.length ? (this._repeat = s === 1 / 0 ? -2 : s, as(this)) : this._repeat === -2 ? 1 / 0 : this._repeat;
  }, t.repeatDelay = function(s) {
    if (arguments.length) {
      var n = this._time;
      return this._rDelay = s, as(this), n ? this.time(n) : this;
    }
    return this._rDelay;
  }, t.yoyo = function(s) {
    return arguments.length ? (this._yoyo = s, this) : this._yoyo;
  }, t.seek = function(s, n) {
    return this.totalTime(xe(this, s), ve(n));
  }, t.restart = function(s, n) {
    return this.play().totalTime(s ? -this._delay : 0, ve(n));
  }, t.play = function(s, n) {
    return s != null && this.seek(s, n), this.reversed(!1).paused(!1);
  }, t.reverse = function(s, n) {
    return s != null && this.seek(s || this.totalDuration(), n), this.reversed(!0).paused(!1);
  }, t.pause = function(s, n) {
    return s != null && this.seek(s, n), this.paused(!0);
  }, t.resume = function() {
    return this.paused(!1);
  }, t.reversed = function(s) {
    return arguments.length ? (!!s !== this.reversed() && this.timeScale(-this._rts || (s ? -Y : 0)), this) : this._rts < 0;
  }, t.invalidate = function() {
    return this._initted = this._act = 0, this._zTime = -Y, this;
  }, t.isActive = function() {
    var s = this.parent || this._dp, n = this._start, o;
    return !!(!s || this._ts && this._initted && s.isActive() && (o = s.rawTime(!0)) >= n && o < this.endTime(!0) - Y);
  }, t.eventCallback = function(s, n, o) {
    var r = this.vars;
    return arguments.length > 1 ? (n ? (r[s] = n, o && (r[s + "Params"] = o), s === "onUpdate" && (this._onUpdate = n)) : delete r[s], this) : r[s];
  }, t.then = function(s) {
    var n = this;
    return new Promise(function(o) {
      var r = se(s) ? s : As, a = function() {
        var d = n.then;
        n.then = null, se(r) && (r = r(n)) && (r.then || r === n) && (n.then = d), o(r), n.then = d;
      };
      n._initted && n.totalProgress() === 1 && n._ts >= 0 || !n._tTime && n._ts < 0 ? a() : n._prom = a;
    });
  }, t.kill = function() {
    Pt(this);
  }, e;
}();
De(St.prototype, {
  _time: 0,
  _start: 0,
  _end: 0,
  _tTime: 0,
  _tDur: 0,
  _dirty: 0,
  _repeat: 0,
  _yoyo: !1,
  parent: null,
  _initted: !1,
  _rDelay: 0,
  _ts: 1,
  _dp: 0,
  ratio: 0,
  _zTime: -Y,
  _prom: 0,
  _ps: !1,
  _rts: 1
});
var ye = /* @__PURE__ */ function(e) {
  Ss(t, e);
  function t(s, n) {
    var o;
    return s === void 0 && (s = {}), o = e.call(this, s) || this, o.labels = {}, o.smoothChildTiming = !!s.smoothChildTiming, o.autoRemoveChildren = !!s.autoRemoveChildren, o._sort = ve(s.sortChildren), te && Ie(s.parent || te, Ve(o), n), s.reversed && o.reverse(), s.paused && o.paused(!0), s.scrollTrigger && Fs(Ve(o), s.scrollTrigger), o;
  }
  var i = t.prototype;
  return i.to = function(n, o, r) {
    return Ot(0, arguments, this), this;
  }, i.from = function(n, o, r) {
    return Ot(1, arguments, this), this;
  }, i.fromTo = function(n, o, r, a) {
    return Ot(2, arguments, this), this;
  }, i.set = function(n, o, r) {
    return o.duration = 0, o.parent = this, Lt(o).repeatDelay || (o.repeat = 0), o.immediateRender = !!o.immediateRender, new le(n, o, xe(this, r), 1), this;
  }, i.call = function(n, o, r) {
    return Ie(this, le.delayedCall(0, n, o), r);
  }, i.staggerTo = function(n, o, r, a, u, d, c) {
    return r.duration = o, r.stagger = r.stagger || a, r.onComplete = d, r.onCompleteParams = c, r.parent = this, new le(n, r, xe(this, u)), this;
  }, i.staggerFrom = function(n, o, r, a, u, d, c) {
    return r.runBackwards = 1, Lt(r).immediateRender = ve(r.immediateRender), this.staggerTo(n, o, r, a, u, d, c);
  }, i.staggerFromTo = function(n, o, r, a, u, d, c, g) {
    return a.startAt = r, Lt(a).immediateRender = ve(a.immediateRender), this.staggerTo(n, o, a, u, d, c, g);
  }, i.render = function(n, o, r) {
    var a = this._time, u = this._dirty ? this.totalDuration() : this._tDur, d = this._dur, c = n <= 0 ? 0 : ce(n), g = this._zTime < 0 != n < 0 && (this._initted || !d), f, m, v, y, k, C, x, j, D, z, N, I;
    if (this !== te && c > u && n >= 0 && (c = u), c !== this._tTime || r || g) {
      if (a !== this._time && d && (c += this._time - a, n += this._time - a), f = c, D = this._start, j = this._ts, C = !j, g && (d || (a = this._zTime), (n || !o) && (this._zTime = n)), this._repeat) {
        if (N = this._yoyo, k = d + this._rDelay, this._repeat < -1 && n < 0)
          return this.totalTime(k * 100 + n, o, r);
        if (f = ce(c % k), c === u ? (y = this._repeat, f = d) : (y = ~~(c / k), y && y === c / k && (f = d, y--), f > d && (f = d)), z = _t(this._tTime, k), !a && this._tTime && z !== y && this._tTime - z * k - this._dur <= 0 && (z = y), N && y & 1 && (f = d - f, I = 1), y !== z && !this._lock) {
          var O = N && z & 1, B = O === (N && y & 1);
          if (y < z && (O = !O), a = O ? 0 : d, this._lock = 1, this.render(a || (I ? 0 : ce(y * k)), o, !d)._lock = 0, this._tTime = c, !o && this.parent && Pe(this, "onRepeat"), this.vars.repeatRefresh && !I && (this.invalidate()._lock = 1), a && a !== this._time || C !== !this._ts || this.vars.onRepeat && !this.parent && !this._act)
            return this;
          if (d = this._dur, u = this._tDur, B && (this._lock = 2, a = O ? d : -1e-4, this.render(a, !0), this.vars.repeatRefresh && !I && this.invalidate()), this._lock = 0, !this._ts && !C)
            return this;
          sn(this, I);
        }
      }
      if (this._hasPause && !this._forcing && this._lock < 2 && (x = or(this, ce(a), ce(f)), x && (c -= f - (f = x._start))), this._tTime = c, this._time = f, this._act = !j, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = n, a = 0), !a && f && !o && !y && (Pe(this, "onStart"), this._tTime !== c))
        return this;
      if (f >= a && n >= 0)
        for (m = this._first; m; ) {
          if (v = m._next, (m._act || f >= m._start) && m._ts && x !== m) {
            if (m.parent !== this)
              return this.render(n, o, r);
            if (m.render(m._ts > 0 ? (f - m._start) * m._ts : (m._dirty ? m.totalDuration() : m._tDur) + (f - m._start) * m._ts, o, r), f !== this._time || !this._ts && !C) {
              x = 0, v && (c += this._zTime = -Y);
              break;
            }
          }
          m = v;
        }
      else {
        m = this._last;
        for (var R = n < 0 ? n : f; m; ) {
          if (v = m._prev, (m._act || R <= m._end) && m._ts && x !== m) {
            if (m.parent !== this)
              return this.render(n, o, r);
            if (m.render(m._ts > 0 ? (R - m._start) * m._ts : (m._dirty ? m.totalDuration() : m._tDur) + (R - m._start) * m._ts, o, r || fe && (m._initted || m._startAt)), f !== this._time || !this._ts && !C) {
              x = 0, v && (c += this._zTime = R ? -Y : Y);
              break;
            }
          }
          m = v;
        }
      }
      if (x && !o && (this.pause(), x.render(f >= a ? 0 : -Y)._zTime = f >= a ? 1 : -1, this._ts))
        return this._start = D, ni(this), this.render(n, o, r);
      this._onUpdate && !o && Pe(this, "onUpdate", !0), (c === u && this._tTime >= this.totalDuration() || !c && a) && (D === this._start || Math.abs(j) !== Math.abs(this._ts)) && (this._lock || ((n || !d) && (c === u && this._ts > 0 || !c && this._ts < 0) && Je(this, 1), !o && !(n < 0 && !a) && (c || a || !u) && (Pe(this, c === u && n >= 0 ? "onComplete" : "onReverseComplete", !0), this._prom && !(c < u && this.timeScale() > 0) && this._prom())));
    }
    return this;
  }, i.add = function(n, o) {
    var r = this;
    if (We(o) || (o = xe(this, o, n)), !(n instanceof St)) {
      if (me(n))
        return n.forEach(function(a) {
          return r.add(a, o);
        }), this;
      if (ue(n))
        return this.addLabel(n, o);
      if (se(n))
        n = le.delayedCall(0, n);
      else
        return this;
    }
    return this !== n ? Ie(this, n, o) : this;
  }, i.getChildren = function(n, o, r, a) {
    n === void 0 && (n = !0), o === void 0 && (o = !0), r === void 0 && (r = !0), a === void 0 && (a = -je);
    for (var u = [], d = this._first; d; )
      d._start >= a && (d instanceof le ? o && u.push(d) : (r && u.push(d), n && u.push.apply(u, d.getChildren(!0, o, r)))), d = d._next;
    return u;
  }, i.getById = function(n) {
    for (var o = this.getChildren(1, 1, 1), r = o.length; r--; )
      if (o[r].vars.id === n)
        return o[r];
  }, i.remove = function(n) {
    return ue(n) ? this.removeLabel(n) : se(n) ? this.killTweensOf(n) : (si(this, n), n === this._recent && (this._recent = this._last), ut(this));
  }, i.totalTime = function(n, o) {
    return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = ce(we.time - (this._ts > 0 ? n / this._ts : (this.totalDuration() - n) / -this._ts))), e.prototype.totalTime.call(this, n, o), this._forcing = 0, this) : this._tTime;
  }, i.addLabel = function(n, o) {
    return this.labels[n] = xe(this, o), this;
  }, i.removeLabel = function(n) {
    return delete this.labels[n], this;
  }, i.addPause = function(n, o, r) {
    var a = le.delayedCall(0, o || Mt, r);
    return a.data = "isPause", this._hasPause = 1, Ie(this, a, xe(this, n));
  }, i.removePause = function(n) {
    var o = this._first;
    for (n = xe(this, n); o; )
      o._start === n && o.data === "isPause" && Je(o), o = o._next;
  }, i.killTweensOf = function(n, o, r) {
    for (var a = this.getTweensOf(n, r), u = a.length; u--; )
      He !== a[u] && a[u].kill(n, o);
    return this;
  }, i.getTweensOf = function(n, o) {
    for (var r = [], a = Be(n), u = this._first, d = We(o), c; u; )
      u instanceof le ? Jo(u._targets, a) && (d ? (!He || u._initted && u._ts) && u.globalTime(0) <= o && u.globalTime(u.totalDuration()) > o : !o || u.isActive()) && r.push(u) : (c = u.getTweensOf(a, o)).length && r.push.apply(r, c), u = u._next;
    return r;
  }, i.tweenTo = function(n, o) {
    o = o || {};
    var r = this, a = xe(r, n), u = o, d = u.startAt, c = u.onStart, g = u.onStartParams, f = u.immediateRender, m, v = le.to(r, De({
      ease: o.ease || "none",
      lazy: !1,
      immediateRender: !1,
      time: a,
      overwrite: "auto",
      duration: o.duration || Math.abs((a - (d && "time" in d ? d.time : r._time)) / r.timeScale()) || Y,
      onStart: function() {
        if (r.pause(), !m) {
          var k = o.duration || Math.abs((a - (d && "time" in d ? d.time : r._time)) / r.timeScale());
          v._dur !== k && wt(v, k, 0, 1).render(v._time, !0, !0), m = 1;
        }
        c && c.apply(v, g || []);
      }
    }, o));
    return f ? v.render(0) : v;
  }, i.tweenFromTo = function(n, o, r) {
    return this.tweenTo(o, De({
      startAt: {
        time: xe(this, n)
      }
    }, r));
  }, i.recent = function() {
    return this._recent;
  }, i.nextLabel = function(n) {
    return n === void 0 && (n = this._time), ls(this, xe(this, n));
  }, i.previousLabel = function(n) {
    return n === void 0 && (n = this._time), ls(this, xe(this, n), 1);
  }, i.currentLabel = function(n) {
    return arguments.length ? this.seek(n, !0) : this.previousLabel(this._time + Y);
  }, i.shiftChildren = function(n, o, r) {
    r === void 0 && (r = 0);
    for (var a = this._first, u = this.labels, d; a; )
      a._start >= r && (a._start += n, a._end += n), a = a._next;
    if (o)
      for (d in u)
        u[d] >= r && (u[d] += n);
    return ut(this);
  }, i.invalidate = function(n) {
    var o = this._first;
    for (this._lock = 0; o; )
      o.invalidate(n), o = o._next;
    return e.prototype.invalidate.call(this, n);
  }, i.clear = function(n) {
    n === void 0 && (n = !0);
    for (var o = this._first, r; o; )
      r = o._next, this.remove(o), o = r;
    return this._dp && (this._time = this._tTime = this._pTime = 0), n && (this.labels = {}), ut(this);
  }, i.totalDuration = function(n) {
    var o = 0, r = this, a = r._last, u = je, d, c, g;
    if (arguments.length)
      return r.timeScale((r._repeat < 0 ? r.duration() : r.totalDuration()) / (r.reversed() ? -n : n));
    if (r._dirty) {
      for (g = r.parent; a; )
        d = a._prev, a._dirty && a.totalDuration(), c = a._start, c > u && r._sort && a._ts && !r._lock ? (r._lock = 1, Ie(r, a, c - a._delay, 1)._lock = 0) : u = c, c < 0 && a._ts && (o -= c, (!g && !r._dp || g && g.smoothChildTiming) && (r._start += c / r._ts, r._time -= c, r._tTime -= c), r.shiftChildren(-c, !1, -1 / 0), u = 0), a._end > o && a._ts && (o = a._end), a = d;
      wt(r, r === te && r._time > o ? r._time : o, 1, 1), r._dirty = 0;
    }
    return r._tDur;
  }, t.updateRoot = function(n) {
    if (te._ts && (Ms(te, Qt(n, te)), Os = we.frame), we.frame >= ns) {
      ns += Te.autoSleep || 120;
      var o = te._first;
      if ((!o || !o._ts) && Te.autoSleep && we._listeners.length < 2) {
        for (; o && !o._ts; )
          o = o._next;
        o || we.sleep();
      }
    }
  }, t;
}(St);
De(ye.prototype, {
  _lock: 0,
  _hasPause: 0,
  _forcing: 0
});
var kr = function(t, i, s, n, o, r, a) {
  var u = new $e(this._pt, t, i, 0, 1, cn, null, o), d = 0, c = 0, g, f, m, v, y, k, C, x;
  for (u.b = s, u.e = n, s += "", n += "", (C = ~n.indexOf("random(")) && (n = Nt(n)), r && (x = [s, n], r(x, t, i), s = x[0], n = x[1]), f = s.match(li) || []; g = li.exec(n); )
    v = g[0], y = n.substring(d, g.index), m ? m = (m + 1) % 5 : y.substr(-5) === "rgba(" && (m = 1), v !== f[c++] && (k = parseFloat(f[c - 1]) || 0, u._pt = {
      _next: u._pt,
      p: y || c === 1 ? y : ",",
      //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
      s: k,
      c: v.charAt(1) === "=" ? vt(k, v) - k : parseFloat(v) - k,
      m: m && m < 4 ? Math.round : 0
    }, d = li.lastIndex);
  return u.c = d < n.length ? n.substring(d, n.length) : "", u.fp = a, (js.test(n) || C) && (u.e = 0), this._pt = u, u;
}, Ui = function(t, i, s, n, o, r, a, u, d, c) {
  se(n) && (n = n(o || 0, t, r));
  var g = t[i], f = s !== "get" ? s : se(g) ? d ? t[i.indexOf("set") || !se(t["get" + i.substr(3)]) ? i : "get" + i.substr(3)](d) : t[i]() : g, m = se(g) ? d ? xr : dn : Xi, v;
  if (ue(n) && (~n.indexOf("random(") && (n = Nt(n)), n.charAt(1) === "=" && (v = vt(f, n) + (he(f) || 0), (v || v === 0) && (n = v))), !c || f !== n || Ci)
    return !isNaN(f * n) && n !== "" ? (v = new $e(this._pt, t, i, +f || 0, n - (f || 0), typeof g == "boolean" ? zr : un, 0, m), d && (v.fp = d), a && v.modifier(a, this, t), this._pt = v) : (!g && !(i in t) && Fi(i, n), kr.call(this, t, i, f, n, m, u || Te.stringFilter, d));
}, _r = function(t, i, s, n, o) {
  if (se(t) && (t = It(t, o, i, s, n)), !Re(t) || t.style && t.nodeType || me(t) || Cs(t))
    return ue(t) ? It(t, o, i, s, n) : t;
  var r = {}, a;
  for (a in t)
    r[a] = It(t[a], o, i, s, n);
  return r;
}, rn = function(t, i, s, n, o, r) {
  var a, u, d, c;
  if (_e[t] && (a = new _e[t]()).init(o, a.rawVars ? i[t] : _r(i[t], n, o, r, s), s, n, r) !== !1 && (s._pt = u = new $e(s._pt, o, t, 0, 1, a.render, a, 0, a.priority), s !== yt))
    for (d = s._ptLookup[s._targets.indexOf(o)], c = a._props.length; c--; )
      d[a._props[c]] = u;
  return a;
}, He, Ci, Hi = function e(t, i, s) {
  var n = t.vars, o = n.ease, r = n.startAt, a = n.immediateRender, u = n.lazy, d = n.onUpdate, c = n.onUpdateParams, g = n.callbackScope, f = n.runBackwards, m = n.yoyoEase, v = n.keyframes, y = n.autoRevert, k = t._dur, C = t._startAt, x = t._targets, j = t.parent, D = j && j.data === "nested" ? j.vars.targets : x, z = t._overwrite === "auto" && !Ni, N = t.timeline, I, O, B, R, W, Z, X, Q, ee, ae, oe, ge, tt;
  if (N && (!v || !o) && (o = "none"), t._ease = ct(o, kt.ease), t._yEase = m ? tn(ct(m === !0 ? o : m, kt.ease)) : 0, m && t._yoyo && !t._repeat && (m = t._yEase, t._yEase = t._ease, t._ease = m), t._from = !N && !!n.runBackwards, !N || v && !n.stagger) {
    if (Q = x[0] ? dt(x[0]).harness : 0, ge = Q && n[Q.prop], I = Jt(n, Vi), C && (C._zTime < 0 && C.progress(1), i < 0 && f && a && !y ? C.render(-1, !0) : C.revert(f && k ? Ut : Ko), C._lazy = 0), r) {
      if (Je(t._startAt = le.set(x, De({
        data: "isStart",
        overwrite: !1,
        parent: j,
        immediateRender: !0,
        lazy: !C && ve(u),
        startAt: null,
        delay: 0,
        onUpdate: d,
        onUpdateParams: c,
        callbackScope: g,
        stagger: 0
      }, r))), t._startAt._dp = 0, t._startAt._sat = t, i < 0 && (fe || !a && !y) && t._startAt.revert(Ut), a && k && i <= 0 && s <= 0) {
        i && (t._zTime = i);
        return;
      }
    } else if (f && k && !C) {
      if (i && (a = !1), B = De({
        overwrite: !1,
        data: "isFromStart",
        //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
        lazy: a && !C && ve(u),
        immediateRender: a,
        //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
        stagger: 0,
        parent: j
        //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y:gsap.utils.wrap([-100,100])})
      }, I), ge && (B[Q.prop] = ge), Je(t._startAt = le.set(x, B)), t._startAt._dp = 0, t._startAt._sat = t, i < 0 && (fe ? t._startAt.revert(Ut) : t._startAt.render(-1, !0)), t._zTime = i, !a)
        e(t._startAt, Y, Y);
      else if (!i)
        return;
    }
    for (t._pt = t._ptCache = 0, u = k && ve(u) || u && !k, O = 0; O < x.length; O++) {
      if (W = x[O], X = W._gsap || Wi(x)[O]._gsap, t._ptLookup[O] = ae = {}, ki[X.id] && Ye.length && Zt(), oe = D === x ? O : D.indexOf(W), Q && (ee = new Q()).init(W, ge || I, t, oe, D) !== !1 && (t._pt = R = new $e(t._pt, W, ee.name, 0, 1, ee.render, ee, 0, ee.priority), ee._props.forEach(function(it) {
        ae[it] = R;
      }), ee.priority && (Z = 1)), !Q || ge)
        for (B in I)
          _e[B] && (ee = rn(B, I, t, oe, W, D)) ? ee.priority && (Z = 1) : ae[B] = R = Ui.call(t, W, B, "get", I[B], oe, D, 0, n.stringFilter);
      t._op && t._op[O] && t.kill(W, t._op[O]), z && t._pt && (He = t, te.killTweensOf(W, ae, t.globalTime(i)), tt = !t.parent, He = 0), t._pt && u && (ki[X.id] = 1);
    }
    Z && pn(t), t._onInit && t._onInit(t);
  }
  t._onUpdate = d, t._initted = (!t._op || t._pt) && !tt, v && i <= 0 && N.render(je, !0, !0);
}, wr = function(t, i, s, n, o, r, a) {
  var u = (t._pt && t._ptCache || (t._ptCache = {}))[i], d, c, g, f;
  if (!u)
    for (u = t._ptCache[i] = [], g = t._ptLookup, f = t._targets.length; f--; ) {
      if (d = g[f][i], d && d.d && d.d._pt)
        for (d = d.d._pt; d && d.p !== i && d.fp !== i; )
          d = d._next;
      if (!d)
        return Ci = 1, t.vars[i] = "+=0", Hi(t, a), Ci = 0, 1;
      u.push(d);
    }
  for (f = u.length; f--; )
    c = u[f], d = c._pt || c, d.s = (n || n === 0) && !o ? n : d.s + (n || 0) + r * d.c, d.c = s - d.s, c.e && (c.e = ne(s) + he(c.e)), c.b && (c.b = d.s + he(c.b));
}, Tr = function(t, i) {
  var s = t[0] ? dt(t[0]).harness : 0, n = s && s.aliases, o, r, a, u;
  if (!n)
    return i;
  o = pt({}, i);
  for (r in n)
    if (r in o)
      for (u = n[r].split(","), a = u.length; a--; )
        o[u[a]] = o[r];
  return o;
}, Sr = function(t, i, s, n) {
  var o = i.ease || n || "power1.inOut", r, a;
  if (me(i))
    a = s[t] || (s[t] = []), i.forEach(function(u, d) {
      return a.push({
        t: d / (i.length - 1) * 100,
        v: u,
        e: o
      });
    });
  else
    for (r in i)
      a = s[r] || (s[r] = []), r === "ease" || a.push({
        t: parseFloat(t),
        v: i[r],
        e: o
      });
}, It = function(t, i, s, n, o) {
  return se(t) ? t.call(i, s, n, o) : ue(t) && ~t.indexOf("random(") ? Nt(t) : t;
}, an = qi + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", ln = {};
be(an + ",id,stagger,delay,duration,paused,scrollTrigger", function(e) {
  return ln[e] = 1;
});
var le = /* @__PURE__ */ function(e) {
  Ss(t, e);
  function t(s, n, o, r) {
    var a;
    typeof n == "number" && (o.duration = n, n = o, o = null), a = e.call(this, r ? n : Lt(n)) || this;
    var u = a.vars, d = u.duration, c = u.delay, g = u.immediateRender, f = u.stagger, m = u.overwrite, v = u.keyframes, y = u.defaults, k = u.scrollTrigger, C = u.yoyoEase, x = n.parent || te, j = (me(s) || Cs(s) ? We(s[0]) : "length" in n) ? [s] : Be(s), D, z, N, I, O, B, R, W;
    if (a._targets = j.length ? Wi(j) : Kt("GSAP target " + s + " not found. https://greensock.com", !Te.nullTargetWarn) || [], a._ptLookup = [], a._overwrite = m, v || f || Wt(d) || Wt(c)) {
      if (n = a.vars, D = a.timeline = new ye({
        data: "nested",
        defaults: y || {},
        targets: x && x.data === "nested" ? x.vars.targets : j
      }), D.kill(), D.parent = D._dp = Ve(a), D._start = 0, f || Wt(d) || Wt(c)) {
        if (I = j.length, R = f && Us(f), Re(f))
          for (O in f)
            ~an.indexOf(O) && (W || (W = {}), W[O] = f[O]);
        for (z = 0; z < I; z++)
          N = Jt(n, ln), N.stagger = 0, C && (N.yoyoEase = C), W && pt(N, W), B = j[z], N.duration = +It(d, Ve(a), z, B, j), N.delay = (+It(c, Ve(a), z, B, j) || 0) - a._delay, !f && I === 1 && N.delay && (a._delay = c = N.delay, a._start += c, N.delay = 0), D.to(B, N, R ? R(z, B, j) : 0), D._ease = q.none;
        D.duration() ? d = c = 0 : a.timeline = 0;
      } else if (v) {
        Lt(De(D.vars.defaults, {
          ease: "none"
        })), D._ease = ct(v.ease || n.ease || "none");
        var Z = 0, X, Q, ee;
        if (me(v))
          v.forEach(function(ae) {
            return D.to(j, ae, ">");
          }), D.duration();
        else {
          N = {};
          for (O in v)
            O === "ease" || O === "easeEach" || Sr(O, v[O], N, v.easeEach);
          for (O in N)
            for (X = N[O].sort(function(ae, oe) {
              return ae.t - oe.t;
            }), Z = 0, z = 0; z < X.length; z++)
              Q = X[z], ee = {
                ease: Q.e,
                duration: (Q.t - (z ? X[z - 1].t : 0)) / 100 * d
              }, ee[O] = Q.v, D.to(j, ee, Z), Z += ee.duration;
          D.duration() < d && D.to({}, {
            duration: d - D.duration()
          });
        }
      }
      d || a.duration(d = D.duration());
    } else
      a.timeline = 0;
    return m === !0 && !Ni && (He = Ve(a), te.killTweensOf(j), He = 0), Ie(x, Ve(a), o), n.reversed && a.reverse(), n.paused && a.paused(!0), (g || !d && !v && a._start === ce(x._time) && ve(g) && ir(Ve(a)) && x.data !== "nested") && (a._tTime = -Y, a.render(Math.max(0, -c) || 0)), k && Fs(Ve(a), k), a;
  }
  var i = t.prototype;
  return i.render = function(n, o, r) {
    var a = this._time, u = this._tDur, d = this._dur, c = n < 0, g = n > u - Y && !c ? u : n < Y ? 0 : n, f, m, v, y, k, C, x, j, D;
    if (!d)
      nr(this, n, o, r);
    else if (g !== this._tTime || !n || r || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== c) {
      if (f = g, j = this.timeline, this._repeat) {
        if (y = d + this._rDelay, this._repeat < -1 && c)
          return this.totalTime(y * 100 + n, o, r);
        if (f = ce(g % y), g === u ? (v = this._repeat, f = d) : (v = ~~(g / y), v && v === g / y && (f = d, v--), f > d && (f = d)), C = this._yoyo && v & 1, C && (D = this._yEase, f = d - f), k = _t(this._tTime, y), f === a && !r && this._initted)
          return this._tTime = g, this;
        v !== k && (j && this._yEase && sn(j, C), this.vars.repeatRefresh && !C && !this._lock && (this._lock = r = 1, this.render(ce(y * v), !0).invalidate()._lock = 0));
      }
      if (!this._initted) {
        if (Vs(this, c ? n : f, r, o, g))
          return this._tTime = 0, this;
        if (a !== this._time)
          return this;
        if (d !== this._dur)
          return this.render(n, o, r);
      }
      if (this._tTime = g, this._time = f, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = x = (D || this._ease)(f / d), this._from && (this.ratio = x = 1 - x), f && !a && !o && !v && (Pe(this, "onStart"), this._tTime !== g))
        return this;
      for (m = this._pt; m; )
        m.r(x, m.d), m = m._next;
      j && j.render(n < 0 ? n : !f && C ? -Y : j._dur * j._ease(f / this._dur), o, r) || this._startAt && (this._zTime = n), this._onUpdate && !o && (c && _i(this, n, o, r), Pe(this, "onUpdate")), this._repeat && v !== k && this.vars.onRepeat && !o && this.parent && Pe(this, "onRepeat"), (g === this._tDur || !g) && this._tTime === g && (c && !this._onUpdate && _i(this, n, !0, !0), (n || !d) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && Je(this, 1), !o && !(c && !a) && (g || a || C) && (Pe(this, g === u ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < u && this.timeScale() > 0) && this._prom()));
    }
    return this;
  }, i.targets = function() {
    return this._targets;
  }, i.invalidate = function(n) {
    return (!n || !this.vars.runBackwards) && (this._startAt = 0), this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(n), e.prototype.invalidate.call(this, n);
  }, i.resetTo = function(n, o, r, a) {
    At || we.wake(), this._ts || this.play();
    var u = Math.min(this._dur, (this._dp._time - this._start) * this._ts), d;
    return this._initted || Hi(this, u), d = this._ease(u / this._dur), wr(this, n, o, r, a, d, u) ? this.resetTo(n, o, r, a) : (oi(this, 0), this.parent || Rs(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0), this.render(0));
  }, i.kill = function(n, o) {
    if (o === void 0 && (o = "all"), !n && (!o || o === "all"))
      return this._lazy = this._pt = 0, this.parent ? Pt(this) : this;
    if (this.timeline) {
      var r = this.timeline.totalDuration();
      return this.timeline.killTweensOf(n, o, He && He.vars.overwrite !== !0)._first || Pt(this), this.parent && r !== this.timeline.totalDuration() && wt(this, this._dur * this.timeline._tDur / r, 0, 1), this;
    }
    var a = this._targets, u = n ? Be(n) : a, d = this._ptLookup, c = this._pt, g, f, m, v, y, k, C;
    if ((!o || o === "all") && er(a, u))
      return o === "all" && (this._pt = 0), Pt(this);
    for (g = this._op = this._op || [], o !== "all" && (ue(o) && (y = {}, be(o, function(x) {
      return y[x] = 1;
    }), o = y), o = Tr(a, o)), C = a.length; C--; )
      if (~u.indexOf(a[C])) {
        f = d[C], o === "all" ? (g[C] = o, v = f, m = {}) : (m = g[C] = g[C] || {}, v = o);
        for (y in v)
          k = f && f[y], k && ((!("kill" in k.d) || k.d.kill(y) === !0) && si(this, k, "_pt"), delete f[y]), m !== "all" && (m[y] = 1);
      }
    return this._initted && !this._pt && c && Pt(this), this;
  }, t.to = function(n, o) {
    return new t(n, o, arguments[2]);
  }, t.from = function(n, o) {
    return Ot(1, arguments);
  }, t.delayedCall = function(n, o, r, a) {
    return new t(o, 0, {
      immediateRender: !1,
      lazy: !1,
      overwrite: !1,
      delay: n,
      onComplete: o,
      onReverseComplete: o,
      onCompleteParams: r,
      onReverseCompleteParams: r,
      callbackScope: a
    });
  }, t.fromTo = function(n, o, r) {
    return Ot(2, arguments);
  }, t.set = function(n, o) {
    return o.duration = 0, o.repeatDelay || (o.repeat = 0), new t(n, o);
  }, t.killTweensOf = function(n, o, r) {
    return te.killTweensOf(n, o, r);
  }, t;
}(St);
De(le.prototype, {
  _targets: [],
  _lazy: 0,
  _startAt: 0,
  _op: 0,
  _onInit: 0
});
be("staggerTo,staggerFrom,staggerFromTo", function(e) {
  le[e] = function() {
    var t = new ye(), i = Ti.call(arguments, 0);
    return i.splice(e === "staggerFromTo" ? 5 : 4, 0, 0), t[e].apply(t, i);
  };
});
var Xi = function(t, i, s) {
  return t[i] = s;
}, dn = function(t, i, s) {
  return t[i](s);
}, xr = function(t, i, s, n) {
  return t[i](n.fp, s);
}, Cr = function(t, i, s) {
  return t.setAttribute(i, s);
}, Gi = function(t, i) {
  return se(t[i]) ? dn : Ai(t[i]) && t.setAttribute ? Cr : Xi;
}, un = function(t, i) {
  return i.set(i.t, i.p, Math.round((i.s + i.c * t) * 1e6) / 1e6, i);
}, zr = function(t, i) {
  return i.set(i.t, i.p, !!(i.s + i.c * t), i);
}, cn = function(t, i) {
  var s = i._pt, n = "";
  if (!t && i.b)
    n = i.b;
  else if (t === 1 && i.e)
    n = i.e;
  else {
    for (; s; )
      n = s.p + (s.m ? s.m(s.s + s.c * t) : Math.round((s.s + s.c * t) * 1e4) / 1e4) + n, s = s._next;
    n += i.c;
  }
  i.set(i.t, i.p, n, i);
}, Yi = function(t, i) {
  for (var s = i._pt; s; )
    s.r(t, s.d), s = s._next;
}, jr = function(t, i, s, n) {
  for (var o = this._pt, r; o; )
    r = o._next, o.p === n && o.modifier(t, i, s), o = r;
}, Br = function(t) {
  for (var i = this._pt, s, n; i; )
    n = i._next, i.p === t && !i.op || i.op === t ? si(this, i, "_pt") : i.dep || (s = 1), i = n;
  return !s;
}, Pr = function(t, i, s, n) {
  n.mSet(t, i, n.m.call(n.tween, s, n.mt), n);
}, pn = function(t) {
  for (var i = t._pt, s, n, o, r; i; ) {
    for (s = i._next, n = o; n && n.pr > i.pr; )
      n = n._next;
    (i._prev = n ? n._prev : r) ? i._prev._next = i : o = i, (i._next = n) ? n._prev = i : r = i, i = s;
  }
  t._pt = o;
}, $e = /* @__PURE__ */ function() {
  function e(i, s, n, o, r, a, u, d, c) {
    this.t = s, this.s = o, this.c = r, this.p = n, this.r = a || un, this.d = u || this, this.set = d || Xi, this.pr = c || 0, this._next = i, i && (i._prev = this);
  }
  var t = e.prototype;
  return t.modifier = function(s, n, o) {
    this.mSet = this.mSet || this.set, this.set = Pr, this.m = s, this.mt = o, this.tween = n;
  }, e;
}();
be(qi + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(e) {
  return Vi[e] = 1;
});
Se.TweenMax = Se.TweenLite = le;
Se.TimelineLite = Se.TimelineMax = ye;
te = new ye({
  sortChildren: !1,
  defaults: kt,
  autoRemoveChildren: !0,
  id: "root",
  smoothChildTiming: !0
});
Te.stringFilter = en;
var xt = [], Xt = {}, Dr = [], us = 0, hi = function(t) {
  return (Xt[t] || Dr).map(function(i) {
    return i();
  });
}, zi = function() {
  var t = Date.now(), i = [];
  t - us > 2 && (hi("matchMediaInit"), xt.forEach(function(s) {
    var n = s.queries, o = s.conditions, r, a, u, d;
    for (a in n)
      r = Ce.matchMedia(n[a]).matches, r && (u = 1), r !== o[a] && (o[a] = r, d = 1);
    d && (s.revert(), u && i.push(s));
  }), hi("matchMediaRevert"), i.forEach(function(s) {
    return s.onMatch(s);
  }), us = t, hi("matchMedia"));
}, hn = /* @__PURE__ */ function() {
  function e(i, s) {
    this.selector = s && Si(s), this.data = [], this._r = [], this.isReverted = !1, i && this.add(i);
  }
  var t = e.prototype;
  return t.add = function(s, n, o) {
    se(s) && (o = n, n = s, s = se);
    var r = this, a = function() {
      var d = re, c = r.selector, g;
      return d && d !== r && d.data.push(r), o && (r.selector = Si(o)), re = r, g = n.apply(r, arguments), se(g) && r._r.push(g), re = d, r.selector = c, r.isReverted = !1, g;
    };
    return r.last = a, s === se ? a(r) : s ? r[s] = a : a;
  }, t.ignore = function(s) {
    var n = re;
    re = null, s(this), re = n;
  }, t.getTweens = function() {
    var s = [];
    return this.data.forEach(function(n) {
      return n instanceof e ? s.push.apply(s, n.getTweens()) : n instanceof le && !(n.parent && n.parent.data === "nested") && s.push(n);
    }), s;
  }, t.clear = function() {
    this._r.length = this.data.length = 0;
  }, t.kill = function(s, n) {
    var o = this;
    if (s) {
      var r = this.getTweens();
      this.data.forEach(function(u) {
        u.data === "isFlip" && (u.revert(), u.getChildren(!0, !0, !1).forEach(function(d) {
          return r.splice(r.indexOf(d), 1);
        }));
      }), r.map(function(u) {
        return {
          g: u.globalTime(0),
          t: u
        };
      }).sort(function(u, d) {
        return d.g - u.g || -1;
      }).forEach(function(u) {
        return u.t.revert(s);
      }), this.data.forEach(function(u) {
        return !(u instanceof St) && u.revert && u.revert(s);
      }), this._r.forEach(function(u) {
        return u(s, o);
      }), this.isReverted = !0;
    } else
      this.data.forEach(function(u) {
        return u.kill && u.kill();
      });
    if (this.clear(), n) {
      var a = xt.indexOf(this);
      ~a && xt.splice(a, 1);
    }
  }, t.revert = function(s) {
    this.kill(s || {});
  }, e;
}(), Lr = /* @__PURE__ */ function() {
  function e(i) {
    this.contexts = [], this.scope = i;
  }
  var t = e.prototype;
  return t.add = function(s, n, o) {
    Re(s) || (s = {
      matches: s
    });
    var r = new hn(0, o || this.scope), a = r.conditions = {}, u, d, c;
    this.contexts.push(r), n = r.add("onMatch", n), r.queries = s;
    for (d in s)
      d === "all" ? c = 1 : (u = Ce.matchMedia(s[d]), u && (xt.indexOf(r) < 0 && xt.push(r), (a[d] = u.matches) && (c = 1), u.addListener ? u.addListener(zi) : u.addEventListener("change", zi)));
    return c && n(r), this;
  }, t.revert = function(s) {
    this.kill(s || {});
  }, t.kill = function(s) {
    this.contexts.forEach(function(n) {
      return n.kill(s, !0);
    });
  }, e;
}(), ei = {
  registerPlugin: function() {
    for (var t = arguments.length, i = new Array(t), s = 0; s < t; s++)
      i[s] = arguments[s];
    i.forEach(function(n) {
      return Zs(n);
    });
  },
  timeline: function(t) {
    return new ye(t);
  },
  getTweensOf: function(t, i) {
    return te.getTweensOf(t, i);
  },
  getProperty: function(t, i, s, n) {
    ue(t) && (t = Be(t)[0]);
    var o = dt(t || {}).get, r = s ? As : Ns;
    return s === "native" && (s = ""), t && (i ? r((_e[i] && _e[i].get || o)(t, i, s, n)) : function(a, u, d) {
      return r((_e[a] && _e[a].get || o)(t, a, u, d));
    });
  },
  quickSetter: function(t, i, s) {
    if (t = Be(t), t.length > 1) {
      var n = t.map(function(c) {
        return ke.quickSetter(c, i, s);
      }), o = n.length;
      return function(c) {
        for (var g = o; g--; )
          n[g](c);
      };
    }
    t = t[0] || {};
    var r = _e[i], a = dt(t), u = a.harness && (a.harness.aliases || {})[i] || i, d = r ? function(c) {
      var g = new r();
      yt._pt = 0, g.init(t, s ? c + s : c, yt, 0, [t]), g.render(1, g), yt._pt && Yi(1, yt);
    } : a.set(t, u);
    return r ? d : function(c) {
      return d(t, u, s ? c + s : c, a, 1);
    };
  },
  quickTo: function(t, i, s) {
    var n, o = ke.to(t, pt((n = {}, n[i] = "+=0.1", n.paused = !0, n), s || {})), r = function(u, d, c) {
      return o.resetTo(i, u, d, c);
    };
    return r.tween = o, r;
  },
  isTweening: function(t) {
    return te.getTweensOf(t, !0).length > 0;
  },
  defaults: function(t) {
    return t && t.ease && (t.ease = ct(t.ease, kt.ease)), os(kt, t || {});
  },
  config: function(t) {
    return os(Te, t || {});
  },
  registerEffect: function(t) {
    var i = t.name, s = t.effect, n = t.plugins, o = t.defaults, r = t.extendTimeline;
    (n || "").split(",").forEach(function(a) {
      return a && !_e[a] && !Se[a] && Kt(i + " effect requires " + a + " plugin.");
    }), di[i] = function(a, u, d) {
      return s(Be(a), De(u || {}, o), d);
    }, r && (ye.prototype[i] = function(a, u, d) {
      return this.add(di[i](a, Re(u) ? u : (d = u) && {}, this), d);
    });
  },
  registerEase: function(t, i) {
    q[t] = ct(i);
  },
  parseEase: function(t, i) {
    return arguments.length ? ct(t, i) : q;
  },
  getById: function(t) {
    return te.getById(t);
  },
  exportRoot: function(t, i) {
    t === void 0 && (t = {});
    var s = new ye(t), n, o;
    for (s.smoothChildTiming = ve(t.smoothChildTiming), te.remove(s), s._dp = 0, s._time = s._tTime = te._time, n = te._first; n; )
      o = n._next, (i || !(!n._dur && n instanceof le && n.vars.onComplete === n._targets[0])) && Ie(s, n, n._start - n._delay), n = o;
    return Ie(te, s, 0), s;
  },
  context: function(t, i) {
    return t ? new hn(t, i) : re;
  },
  matchMedia: function(t) {
    return new Lr(t);
  },
  matchMediaRefresh: function() {
    return xt.forEach(function(t) {
      var i = t.conditions, s, n;
      for (n in i)
        i[n] && (i[n] = !1, s = 1);
      s && t.revert();
    }) || zi();
  },
  addEventListener: function(t, i) {
    var s = Xt[t] || (Xt[t] = []);
    ~s.indexOf(i) || s.push(i);
  },
  removeEventListener: function(t, i) {
    var s = Xt[t], n = s && s.indexOf(i);
    n >= 0 && s.splice(n, 1);
  },
  utils: {
    wrap: pr,
    wrapYoyo: hr,
    distribute: Us,
    random: Xs,
    snap: Hs,
    normalize: cr,
    getUnit: he,
    clamp: ar,
    splitColor: Js,
    toArray: Be,
    selector: Si,
    mapRange: Ys,
    pipe: dr,
    unitize: ur,
    interpolate: fr,
    shuffle: Ws
  },
  install: Ds,
  effects: di,
  ticker: we,
  updateRoot: ye.updateRoot,
  plugins: _e,
  globalTimeline: te,
  core: {
    PropTween: $e,
    globals: Ls,
    Tween: le,
    Timeline: ye,
    Animation: St,
    getCache: dt,
    _removeLinkedListItem: si,
    reverting: function() {
      return fe;
    },
    context: function(t) {
      return t && re && (re.data.push(t), t._ctx = re), re;
    },
    suppressOverwrites: function(t) {
      return Ni = t;
    }
  }
};
be("to,from,fromTo,delayedCall,set,killTweensOf", function(e) {
  return ei[e] = le[e];
});
we.add(ye.updateRoot);
yt = ei.to({}, {
  duration: 0
});
var Or = function(t, i) {
  for (var s = t._pt; s && s.p !== i && s.op !== i && s.fp !== i; )
    s = s._next;
  return s;
}, Ir = function(t, i) {
  var s = t._targets, n, o, r;
  for (n in i)
    for (o = s.length; o--; )
      r = t._ptLookup[o][n], r && (r = r.d) && (r._pt && (r = Or(r, n)), r && r.modifier && r.modifier(i[n], t, s[o], n));
}, fi = function(t, i) {
  return {
    name: t,
    rawVars: 1,
    //don't pre-process function-based values or "random()" strings.
    init: function(n, o, r) {
      r._onInit = function(a) {
        var u, d;
        if (ue(o) && (u = {}, be(o, function(c) {
          return u[c] = 1;
        }), o = u), i) {
          u = {};
          for (d in o)
            u[d] = i(o[d]);
          o = u;
        }
        Ir(a, o);
      };
    }
  };
}, ke = ei.registerPlugin({
  name: "attr",
  init: function(t, i, s, n, o) {
    var r, a, u;
    this.tween = s;
    for (r in i)
      u = t.getAttribute(r) || "", a = this.add(t, "setAttribute", (u || 0) + "", i[r], n, o, 0, 0, r), a.op = r, a.b = u, this._props.push(r);
  },
  render: function(t, i) {
    for (var s = i._pt; s; )
      fe ? s.set(s.t, s.p, s.b, s) : s.r(t, s.d), s = s._next;
  }
}, {
  name: "endArray",
  init: function(t, i) {
    for (var s = i.length; s--; )
      this.add(t, s, t[s] || 0, i[s], 0, 0, 0, 0, 0, 1);
  }
}, fi("roundProps", xi), fi("modifiers"), fi("snap", Hs)) || ei;
le.version = ye.version = ke.version = "3.11.5";
Ps = 1;
Ri() && Tt();
q.Power0;
q.Power1;
q.Power2;
q.Power3;
q.Power4;
q.Linear;
q.Quad;
q.Cubic;
q.Quart;
q.Quint;
q.Strong;
q.Elastic;
q.Back;
q.SteppedEase;
q.Bounce;
q.Sine;
q.Expo;
q.Circ;
/*!
 * CSSPlugin 3.11.5
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var cs, Xe, bt, Ki, lt, ps, Zi, Mr = function() {
  return typeof window < "u";
}, Ue = {}, at = 180 / Math.PI, $t = Math.PI / 180, ft = Math.atan2, hs = 1e8, Ji = /([A-Z])/g, Nr = /(left|right|width|margin|padding|x)/i, Ar = /[\s,\(]\S/, Me = {
  autoAlpha: "opacity,visibility",
  scale: "scaleX,scaleY",
  alpha: "opacity"
}, ji = function(t, i) {
  return i.set(i.t, i.p, Math.round((i.s + i.c * t) * 1e4) / 1e4 + i.u, i);
}, Rr = function(t, i) {
  return i.set(i.t, i.p, t === 1 ? i.e : Math.round((i.s + i.c * t) * 1e4) / 1e4 + i.u, i);
}, Er = function(t, i) {
  return i.set(i.t, i.p, t ? Math.round((i.s + i.c * t) * 1e4) / 1e4 + i.u : i.b, i);
}, Fr = function(t, i) {
  var s = i.s + i.c * t;
  i.set(i.t, i.p, ~~(s + (s < 0 ? -0.5 : 0.5)) + i.u, i);
}, fn = function(t, i) {
  return i.set(i.t, i.p, t ? i.e : i.b, i);
}, mn = function(t, i) {
  return i.set(i.t, i.p, t !== 1 ? i.b : i.e, i);
}, Vr = function(t, i, s) {
  return t.style[i] = s;
}, qr = function(t, i, s) {
  return t.style.setProperty(i, s);
}, Wr = function(t, i, s) {
  return t._gsap[i] = s;
}, Ur = function(t, i, s) {
  return t._gsap.scaleX = t._gsap.scaleY = s;
}, Hr = function(t, i, s, n, o) {
  var r = t._gsap;
  r.scaleX = r.scaleY = s, r.renderTransform(o, r);
}, Xr = function(t, i, s, n, o) {
  var r = t._gsap;
  r[i] = s, r.renderTransform(o, r);
}, ie = "transform", Le = ie + "Origin", Gr = function e(t, i) {
  var s = this, n = this.target, o = n.style;
  if (t in Ue) {
    if (this.tfm = this.tfm || {}, t !== "transform")
      t = Me[t] || t, ~t.indexOf(",") ? t.split(",").forEach(function(r) {
        return s.tfm[r] = qe(n, r);
      }) : this.tfm[t] = n._gsap.x ? n._gsap[t] : qe(n, t);
    else
      return Me.transform.split(",").forEach(function(r) {
        return e.call(s, r, i);
      });
    if (this.props.indexOf(ie) >= 0)
      return;
    n._gsap.svg && (this.svgo = n.getAttribute("data-svg-origin"), this.props.push(Le, i, "")), t = ie;
  }
  (o || i) && this.props.push(t, i, o[t]);
}, gn = function(t) {
  t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, Yr = function() {
  var t = this.props, i = this.target, s = i.style, n = i._gsap, o, r;
  for (o = 0; o < t.length; o += 3)
    t[o + 1] ? i[t[o]] = t[o + 2] : t[o + 2] ? s[t[o]] = t[o + 2] : s.removeProperty(t[o].substr(0, 2) === "--" ? t[o] : t[o].replace(Ji, "-$1").toLowerCase());
  if (this.tfm) {
    for (r in this.tfm)
      n[r] = this.tfm[r];
    n.svg && (n.renderTransform(), i.setAttribute("data-svg-origin", this.svgo || "")), o = Zi(), (!o || !o.isStart) && !s[ie] && (gn(s), n.uncache = 1);
  }
}, yn = function(t, i) {
  var s = {
    target: t,
    props: [],
    revert: Yr,
    save: Gr
  };
  return t._gsap || ke.core.getCache(t), i && i.split(",").forEach(function(n) {
    return s.save(n);
  }), s;
}, vn, Bi = function(t, i) {
  var s = Xe.createElementNS ? Xe.createElementNS((i || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : Xe.createElement(t);
  return s.style ? s : Xe.createElement(t);
}, Ne = function e(t, i, s) {
  var n = getComputedStyle(t);
  return n[i] || n.getPropertyValue(i.replace(Ji, "-$1").toLowerCase()) || n.getPropertyValue(i) || !s && e(t, Ct(i) || i, 1) || "";
}, fs = "O,Moz,ms,Ms,Webkit".split(","), Ct = function(t, i, s) {
  var n = i || lt, o = n.style, r = 5;
  if (t in o && !s)
    return t;
  for (t = t.charAt(0).toUpperCase() + t.substr(1); r-- && !(fs[r] + t in o); )
    ;
  return r < 0 ? null : (r === 3 ? "ms" : r >= 0 ? fs[r] : "") + t;
}, Pi = function() {
  Mr() && window.document && (cs = window, Xe = cs.document, bt = Xe.documentElement, lt = Bi("div") || {
    style: {}
  }, Bi("div"), ie = Ct(ie), Le = ie + "Origin", lt.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", vn = !!Ct("perspective"), Zi = ke.core.reverting, Ki = 1);
}, mi = function e(t) {
  var i = Bi("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), s = this.parentNode, n = this.nextSibling, o = this.style.cssText, r;
  if (bt.appendChild(i), i.appendChild(this), this.style.display = "block", t)
    try {
      r = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = e;
    } catch {
    }
  else this._gsapBBox && (r = this._gsapBBox());
  return s && (n ? s.insertBefore(this, n) : s.appendChild(this)), bt.removeChild(i), this.style.cssText = o, r;
}, ms = function(t, i) {
  for (var s = i.length; s--; )
    if (t.hasAttribute(i[s]))
      return t.getAttribute(i[s]);
}, bn = function(t) {
  var i;
  try {
    i = t.getBBox();
  } catch {
    i = mi.call(t, !0);
  }
  return i && (i.width || i.height) || t.getBBox === mi || (i = mi.call(t, !0)), i && !i.width && !i.x && !i.y ? {
    x: +ms(t, ["x", "cx", "x1"]) || 0,
    y: +ms(t, ["y", "cy", "y1"]) || 0,
    width: 0,
    height: 0
  } : i;
}, $n = function(t) {
  return !!(t.getCTM && (!t.parentNode || t.ownerSVGElement) && bn(t));
}, Rt = function(t, i) {
  if (i) {
    var s = t.style;
    i in Ue && i !== Le && (i = ie), s.removeProperty ? ((i.substr(0, 2) === "ms" || i.substr(0, 6) === "webkit") && (i = "-" + i), s.removeProperty(i.replace(Ji, "-$1").toLowerCase())) : s.removeAttribute(i);
  }
}, Ge = function(t, i, s, n, o, r) {
  var a = new $e(t._pt, i, s, 0, 1, r ? mn : fn);
  return t._pt = a, a.b = n, a.e = o, t._props.push(s), a;
}, gs = {
  deg: 1,
  rad: 1,
  turn: 1
}, Kr = {
  grid: 1,
  flex: 1
}, Qe = function e(t, i, s, n) {
  var o = parseFloat(s) || 0, r = (s + "").trim().substr((o + "").length) || "px", a = lt.style, u = Nr.test(i), d = t.tagName.toLowerCase() === "svg", c = (d ? "client" : "offset") + (u ? "Width" : "Height"), g = 100, f = n === "px", m = n === "%", v, y, k, C;
  return n === r || !o || gs[n] || gs[r] ? o : (r !== "px" && !f && (o = e(t, i, s, "px")), C = t.getCTM && $n(t), (m || r === "%") && (Ue[i] || ~i.indexOf("adius")) ? (v = C ? t.getBBox()[u ? "width" : "height"] : t[c], ne(m ? o / v * g : o / 100 * v)) : (a[u ? "width" : "height"] = g + (f ? r : n), y = ~i.indexOf("adius") || n === "em" && t.appendChild && !d ? t : t.parentNode, C && (y = (t.ownerSVGElement || {}).parentNode), (!y || y === Xe || !y.appendChild) && (y = Xe.body), k = y._gsap, k && m && k.width && u && k.time === we.time && !k.uncache ? ne(o / k.width * g) : ((m || r === "%") && !Kr[Ne(y, "display")] && (a.position = Ne(t, "position")), y === t && (a.position = "static"), y.appendChild(lt), v = lt[c], y.removeChild(lt), a.position = "absolute", u && m && (k = dt(y), k.time = we.time, k.width = y[c]), ne(f ? v * o / g : v && o ? g / v * o : 0))));
}, qe = function(t, i, s, n) {
  var o;
  return Ki || Pi(), i in Me && i !== "transform" && (i = Me[i], ~i.indexOf(",") && (i = i.split(",")[0])), Ue[i] && i !== "transform" ? (o = Ft(t, n), o = i !== "transformOrigin" ? o[i] : o.svg ? o.origin : ii(Ne(t, Le)) + " " + o.zOrigin + "px") : (o = t.style[i], (!o || o === "auto" || n || ~(o + "").indexOf("calc(")) && (o = ti[i] && ti[i](t, i, s) || Ne(t, i) || Is(t, i) || (i === "opacity" ? 1 : 0))), s && !~(o + "").trim().indexOf(" ") ? Qe(t, i, o, s) + s : o;
}, Zr = function(t, i, s, n) {
  if (!s || s === "none") {
    var o = Ct(i, t, 1), r = o && Ne(t, o, 1);
    r && r !== s ? (i = o, s = r) : i === "borderColor" && (s = Ne(t, "borderTopColor"));
  }
  var a = new $e(this._pt, t.style, i, 0, 1, cn), u = 0, d = 0, c, g, f, m, v, y, k, C, x, j, D, z;
  if (a.b = s, a.e = n, s += "", n += "", n === "auto" && (t.style[i] = n, n = Ne(t, i) || n, t.style[i] = s), c = [s, n], en(c), s = c[0], n = c[1], f = s.match(gt) || [], z = n.match(gt) || [], z.length) {
    for (; g = gt.exec(n); )
      k = g[0], x = n.substring(u, g.index), v ? v = (v + 1) % 5 : (x.substr(-5) === "rgba(" || x.substr(-5) === "hsla(") && (v = 1), k !== (y = f[d++] || "") && (m = parseFloat(y) || 0, D = y.substr((m + "").length), k.charAt(1) === "=" && (k = vt(m, k) + D), C = parseFloat(k), j = k.substr((C + "").length), u = gt.lastIndex - j.length, j || (j = j || Te.units[i] || D, u === n.length && (n += j, a.e += j)), D !== j && (m = Qe(t, i, y, j) || 0), a._pt = {
        _next: a._pt,
        p: x || d === 1 ? x : ",",
        //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
        s: m,
        c: C - m,
        m: v && v < 4 || i === "zIndex" ? Math.round : 0
      });
    a.c = u < n.length ? n.substring(u, n.length) : "";
  } else
    a.r = i === "display" && n === "none" ? mn : fn;
  return js.test(n) && (a.e = 0), this._pt = a, a;
}, ys = {
  top: "0%",
  bottom: "100%",
  left: "0%",
  right: "100%",
  center: "50%"
}, Jr = function(t) {
  var i = t.split(" "), s = i[0], n = i[1] || "50%";
  return (s === "top" || s === "bottom" || n === "left" || n === "right") && (t = s, s = n, n = t), i[0] = ys[s] || s, i[1] = ys[n] || n, i.join(" ");
}, Qr = function(t, i) {
  if (i.tween && i.tween._time === i.tween._dur) {
    var s = i.t, n = s.style, o = i.u, r = s._gsap, a, u, d;
    if (o === "all" || o === !0)
      n.cssText = "", u = 1;
    else
      for (o = o.split(","), d = o.length; --d > -1; )
        a = o[d], Ue[a] && (u = 1, a = a === "transformOrigin" ? Le : ie), Rt(s, a);
    u && (Rt(s, ie), r && (r.svg && s.removeAttribute("transform"), Ft(s, 1), r.uncache = 1, gn(n)));
  }
}, ti = {
  clearProps: function(t, i, s, n, o) {
    if (o.data !== "isFromStart") {
      var r = t._pt = new $e(t._pt, i, s, 0, 0, Qr);
      return r.u = n, r.pr = -10, r.tween = o, t._props.push(s), 1;
    }
  }
  /* className feature (about 0.4kb gzipped).
  , className(plugin, target, property, endValue, tween) {
  	let _renderClassName = (ratio, data) => {
  			data.css.render(ratio, data.css);
  			if (!ratio || ratio === 1) {
  				let inline = data.rmv,
  					target = data.t,
  					p;
  				target.setAttribute("class", ratio ? data.e : data.b);
  				for (p in inline) {
  					_removeProperty(target, p);
  				}
  			}
  		},
  		_getAllStyles = (target) => {
  			let styles = {},
  				computed = getComputedStyle(target),
  				p;
  			for (p in computed) {
  				if (isNaN(p) && p !== "cssText" && p !== "length") {
  					styles[p] = computed[p];
  				}
  			}
  			_setDefaults(styles, _parseTransform(target, 1));
  			return styles;
  		},
  		startClassList = target.getAttribute("class"),
  		style = target.style,
  		cssText = style.cssText,
  		cache = target._gsap,
  		classPT = cache.classPT,
  		inlineToRemoveAtEnd = {},
  		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
  		changingVars = {},
  		startVars = _getAllStyles(target),
  		transformRelated = /(transform|perspective)/i,
  		endVars, p;
  	if (classPT) {
  		classPT.r(1, classPT.d);
  		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
  	}
  	target.setAttribute("class", data.e);
  	endVars = _getAllStyles(target, true);
  	target.setAttribute("class", startClassList);
  	for (p in endVars) {
  		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
  			changingVars[p] = endVars[p];
  			if (!style[p] && style[p] !== "0") {
  				inlineToRemoveAtEnd[p] = 1;
  			}
  		}
  	}
  	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
  	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://greensock.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
  		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
  	}
  	_parseTransform(target, true); //to clear the caching of transforms
  	data.css = new gsap.plugins.css();
  	data.css.init(target, changingVars, tween);
  	plugin._props.push(...data.css._props);
  	return 1;
  }
  */
}, Et = [1, 0, 0, 1, 0, 0], kn = {}, _n = function(t) {
  return t === "matrix(1, 0, 0, 1, 0, 0)" || t === "none" || !t;
}, vs = function(t) {
  var i = Ne(t, ie);
  return _n(i) ? Et : i.substr(7).match(zs).map(ne);
}, Qi = function(t, i) {
  var s = t._gsap || dt(t), n = t.style, o = vs(t), r, a, u, d;
  return s.svg && t.getAttribute("transform") ? (u = t.transform.baseVal.consolidate().matrix, o = [u.a, u.b, u.c, u.d, u.e, u.f], o.join(",") === "1,0,0,1,0,0" ? Et : o) : (o === Et && !t.offsetParent && t !== bt && !s.svg && (u = n.display, n.display = "block", r = t.parentNode, (!r || !t.offsetParent) && (d = 1, a = t.nextElementSibling, bt.appendChild(t)), o = vs(t), u ? n.display = u : Rt(t, "display"), d && (a ? r.insertBefore(t, a) : r ? r.appendChild(t) : bt.removeChild(t))), i && o.length > 6 ? [o[0], o[1], o[4], o[5], o[12], o[13]] : o);
}, Di = function(t, i, s, n, o, r) {
  var a = t._gsap, u = o || Qi(t, !0), d = a.xOrigin || 0, c = a.yOrigin || 0, g = a.xOffset || 0, f = a.yOffset || 0, m = u[0], v = u[1], y = u[2], k = u[3], C = u[4], x = u[5], j = i.split(" "), D = parseFloat(j[0]) || 0, z = parseFloat(j[1]) || 0, N, I, O, B;
  s ? u !== Et && (I = m * k - v * y) && (O = D * (k / I) + z * (-y / I) + (y * x - k * C) / I, B = D * (-v / I) + z * (m / I) - (m * x - v * C) / I, D = O, z = B) : (N = bn(t), D = N.x + (~j[0].indexOf("%") ? D / 100 * N.width : D), z = N.y + (~(j[1] || j[0]).indexOf("%") ? z / 100 * N.height : z)), n || n !== !1 && a.smooth ? (C = D - d, x = z - c, a.xOffset = g + (C * m + x * y) - C, a.yOffset = f + (C * v + x * k) - x) : a.xOffset = a.yOffset = 0, a.xOrigin = D, a.yOrigin = z, a.smooth = !!n, a.origin = i, a.originIsAbsolute = !!s, t.style[Le] = "0px 0px", r && (Ge(r, a, "xOrigin", d, D), Ge(r, a, "yOrigin", c, z), Ge(r, a, "xOffset", g, a.xOffset), Ge(r, a, "yOffset", f, a.yOffset)), t.setAttribute("data-svg-origin", D + " " + z);
}, Ft = function(t, i) {
  var s = t._gsap || new on(t);
  if ("x" in s && !i && !s.uncache)
    return s;
  var n = t.style, o = s.scaleX < 0, r = "px", a = "deg", u = getComputedStyle(t), d = Ne(t, Le) || "0", c, g, f, m, v, y, k, C, x, j, D, z, N, I, O, B, R, W, Z, X, Q, ee, ae, oe, ge, tt, it, jt, st, ts, Fe, nt;
  return c = g = f = y = k = C = x = j = D = 0, m = v = 1, s.svg = !!(t.getCTM && $n(t)), u.translate && ((u.translate !== "none" || u.scale !== "none" || u.rotate !== "none") && (n[ie] = (u.translate !== "none" ? "translate3d(" + (u.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (u.rotate !== "none" ? "rotate(" + u.rotate + ") " : "") + (u.scale !== "none" ? "scale(" + u.scale.split(" ").join(",") + ") " : "") + (u[ie] !== "none" ? u[ie] : "")), n.scale = n.rotate = n.translate = "none"), I = Qi(t, s.svg), s.svg && (s.uncache ? (ge = t.getBBox(), d = s.xOrigin - ge.x + "px " + (s.yOrigin - ge.y) + "px", oe = "") : oe = !i && t.getAttribute("data-svg-origin"), Di(t, oe || d, !!oe || s.originIsAbsolute, s.smooth !== !1, I)), z = s.xOrigin || 0, N = s.yOrigin || 0, I !== Et && (W = I[0], Z = I[1], X = I[2], Q = I[3], c = ee = I[4], g = ae = I[5], I.length === 6 ? (m = Math.sqrt(W * W + Z * Z), v = Math.sqrt(Q * Q + X * X), y = W || Z ? ft(Z, W) * at : 0, x = X || Q ? ft(X, Q) * at + y : 0, x && (v *= Math.abs(Math.cos(x * $t))), s.svg && (c -= z - (z * W + N * X), g -= N - (z * Z + N * Q))) : (nt = I[6], ts = I[7], it = I[8], jt = I[9], st = I[10], Fe = I[11], c = I[12], g = I[13], f = I[14], O = ft(nt, st), k = O * at, O && (B = Math.cos(-O), R = Math.sin(-O), oe = ee * B + it * R, ge = ae * B + jt * R, tt = nt * B + st * R, it = ee * -R + it * B, jt = ae * -R + jt * B, st = nt * -R + st * B, Fe = ts * -R + Fe * B, ee = oe, ae = ge, nt = tt), O = ft(-X, st), C = O * at, O && (B = Math.cos(-O), R = Math.sin(-O), oe = W * B - it * R, ge = Z * B - jt * R, tt = X * B - st * R, Fe = Q * R + Fe * B, W = oe, Z = ge, X = tt), O = ft(Z, W), y = O * at, O && (B = Math.cos(O), R = Math.sin(O), oe = W * B + Z * R, ge = ee * B + ae * R, Z = Z * B - W * R, ae = ae * B - ee * R, W = oe, ee = ge), k && Math.abs(k) + Math.abs(y) > 359.9 && (k = y = 0, C = 180 - C), m = ne(Math.sqrt(W * W + Z * Z + X * X)), v = ne(Math.sqrt(ae * ae + nt * nt)), O = ft(ee, ae), x = Math.abs(O) > 2e-4 ? O * at : 0, D = Fe ? 1 / (Fe < 0 ? -Fe : Fe) : 0), s.svg && (oe = t.getAttribute("transform"), s.forceCSS = t.setAttribute("transform", "") || !_n(Ne(t, ie)), oe && t.setAttribute("transform", oe))), Math.abs(x) > 90 && Math.abs(x) < 270 && (o ? (m *= -1, x += y <= 0 ? 180 : -180, y += y <= 0 ? 180 : -180) : (v *= -1, x += x <= 0 ? 180 : -180)), i = i || s.uncache, s.x = c - ((s.xPercent = c && (!i && s.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-c) ? -50 : 0))) ? t.offsetWidth * s.xPercent / 100 : 0) + r, s.y = g - ((s.yPercent = g && (!i && s.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-g) ? -50 : 0))) ? t.offsetHeight * s.yPercent / 100 : 0) + r, s.z = f + r, s.scaleX = ne(m), s.scaleY = ne(v), s.rotation = ne(y) + a, s.rotationX = ne(k) + a, s.rotationY = ne(C) + a, s.skewX = x + a, s.skewY = j + a, s.transformPerspective = D + r, (s.zOrigin = parseFloat(d.split(" ")[2]) || 0) && (n[Le] = ii(d)), s.xOffset = s.yOffset = 0, s.force3D = Te.force3D, s.renderTransform = s.svg ? ta : vn ? wn : ea, s.uncache = 0, s;
}, ii = function(t) {
  return (t = t.split(" "))[0] + " " + t[1];
}, gi = function(t, i, s) {
  var n = he(i);
  return ne(parseFloat(i) + parseFloat(Qe(t, "x", s + "px", n))) + n;
}, ea = function(t, i) {
  i.z = "0px", i.rotationY = i.rotationX = "0deg", i.force3D = 0, wn(t, i);
}, ot = "0deg", Bt = "0px", rt = ") ", wn = function(t, i) {
  var s = i || this, n = s.xPercent, o = s.yPercent, r = s.x, a = s.y, u = s.z, d = s.rotation, c = s.rotationY, g = s.rotationX, f = s.skewX, m = s.skewY, v = s.scaleX, y = s.scaleY, k = s.transformPerspective, C = s.force3D, x = s.target, j = s.zOrigin, D = "", z = C === "auto" && t && t !== 1 || C === !0;
  if (j && (g !== ot || c !== ot)) {
    var N = parseFloat(c) * $t, I = Math.sin(N), O = Math.cos(N), B;
    N = parseFloat(g) * $t, B = Math.cos(N), r = gi(x, r, I * B * -j), a = gi(x, a, -Math.sin(N) * -j), u = gi(x, u, O * B * -j + j);
  }
  k !== Bt && (D += "perspective(" + k + rt), (n || o) && (D += "translate(" + n + "%, " + o + "%) "), (z || r !== Bt || a !== Bt || u !== Bt) && (D += u !== Bt || z ? "translate3d(" + r + ", " + a + ", " + u + ") " : "translate(" + r + ", " + a + rt), d !== ot && (D += "rotate(" + d + rt), c !== ot && (D += "rotateY(" + c + rt), g !== ot && (D += "rotateX(" + g + rt), (f !== ot || m !== ot) && (D += "skew(" + f + ", " + m + rt), (v !== 1 || y !== 1) && (D += "scale(" + v + ", " + y + rt), x.style[ie] = D || "translate(0, 0)";
}, ta = function(t, i) {
  var s = i || this, n = s.xPercent, o = s.yPercent, r = s.x, a = s.y, u = s.rotation, d = s.skewX, c = s.skewY, g = s.scaleX, f = s.scaleY, m = s.target, v = s.xOrigin, y = s.yOrigin, k = s.xOffset, C = s.yOffset, x = s.forceCSS, j = parseFloat(r), D = parseFloat(a), z, N, I, O, B;
  u = parseFloat(u), d = parseFloat(d), c = parseFloat(c), c && (c = parseFloat(c), d += c, u += c), u || d ? (u *= $t, d *= $t, z = Math.cos(u) * g, N = Math.sin(u) * g, I = Math.sin(u - d) * -f, O = Math.cos(u - d) * f, d && (c *= $t, B = Math.tan(d - c), B = Math.sqrt(1 + B * B), I *= B, O *= B, c && (B = Math.tan(c), B = Math.sqrt(1 + B * B), z *= B, N *= B)), z = ne(z), N = ne(N), I = ne(I), O = ne(O)) : (z = g, O = f, N = I = 0), (j && !~(r + "").indexOf("px") || D && !~(a + "").indexOf("px")) && (j = Qe(m, "x", r, "px"), D = Qe(m, "y", a, "px")), (v || y || k || C) && (j = ne(j + v - (v * z + y * I) + k), D = ne(D + y - (v * N + y * O) + C)), (n || o) && (B = m.getBBox(), j = ne(j + n / 100 * B.width), D = ne(D + o / 100 * B.height)), B = "matrix(" + z + "," + N + "," + I + "," + O + "," + j + "," + D + ")", m.setAttribute("transform", B), x && (m.style[ie] = B);
}, ia = function(t, i, s, n, o) {
  var r = 360, a = ue(o), u = parseFloat(o) * (a && ~o.indexOf("rad") ? at : 1), d = u - n, c = n + d + "deg", g, f;
  return a && (g = o.split("_")[1], g === "short" && (d %= r, d !== d % (r / 2) && (d += d < 0 ? r : -r)), g === "cw" && d < 0 ? d = (d + r * hs) % r - ~~(d / r) * r : g === "ccw" && d > 0 && (d = (d - r * hs) % r - ~~(d / r) * r)), t._pt = f = new $e(t._pt, i, s, n, d, Rr), f.e = c, f.u = "deg", t._props.push(s), f;
}, bs = function(t, i) {
  for (var s in i)
    t[s] = i[s];
  return t;
}, sa = function(t, i, s) {
  var n = bs({}, s._gsap), o = "perspective,force3D,transformOrigin,svgOrigin", r = s.style, a, u, d, c, g, f, m, v;
  n.svg ? (d = s.getAttribute("transform"), s.setAttribute("transform", ""), r[ie] = i, a = Ft(s, 1), Rt(s, ie), s.setAttribute("transform", d)) : (d = getComputedStyle(s)[ie], r[ie] = i, a = Ft(s, 1), r[ie] = d);
  for (u in Ue)
    d = n[u], c = a[u], d !== c && o.indexOf(u) < 0 && (m = he(d), v = he(c), g = m !== v ? Qe(s, u, d, v) : parseFloat(d), f = parseFloat(c), t._pt = new $e(t._pt, a, u, g, f - g, ji), t._pt.u = v || 0, t._props.push(u));
  bs(a, n);
};
be("padding,margin,Width,Radius", function(e, t) {
  var i = "Top", s = "Right", n = "Bottom", o = "Left", r = (t < 3 ? [i, s, n, o] : [i + o, i + s, n + s, n + o]).map(function(a) {
    return t < 2 ? e + a : "border" + a + e;
  });
  ti[t > 1 ? "border" + e : e] = function(a, u, d, c, g) {
    var f, m;
    if (arguments.length < 4)
      return f = r.map(function(v) {
        return qe(a, v, d);
      }), m = f.join(" "), m.split(f[0]).length === 5 ? f[0] : m;
    f = (c + "").split(" "), m = {}, r.forEach(function(v, y) {
      return m[v] = f[y] = f[y] || f[(y - 1) / 2 | 0];
    }), a.init(u, m, g);
  };
});
var Tn = {
  name: "css",
  register: Pi,
  targetTest: function(t) {
    return t.style && t.nodeType;
  },
  init: function(t, i, s, n, o) {
    var r = this._props, a = t.style, u = s.vars.startAt, d, c, g, f, m, v, y, k, C, x, j, D, z, N, I, O;
    Ki || Pi(), this.styles = this.styles || yn(t), O = this.styles.props, this.tween = s;
    for (y in i)
      if (y !== "autoRound" && (c = i[y], !(_e[y] && rn(y, i, s, n, t, o)))) {
        if (m = typeof c, v = ti[y], m === "function" && (c = c.call(s, n, t, o), m = typeof c), m === "string" && ~c.indexOf("random(") && (c = Nt(c)), v)
          v(this, t, y, c, s) && (I = 1);
        else if (y.substr(0, 2) === "--")
          d = (getComputedStyle(t).getPropertyValue(y) + "").trim(), c += "", Ke.lastIndex = 0, Ke.test(d) || (k = he(d), C = he(c)), C ? k !== C && (d = Qe(t, y, d, C) + C) : k && (c += k), this.add(a, "setProperty", d, c, n, o, 0, 0, y), r.push(y), O.push(y, 0, a[y]);
        else if (m !== "undefined") {
          if (u && y in u ? (d = typeof u[y] == "function" ? u[y].call(s, n, t, o) : u[y], ue(d) && ~d.indexOf("random(") && (d = Nt(d)), he(d + "") || (d += Te.units[y] || he(qe(t, y)) || ""), (d + "").charAt(1) === "=" && (d = qe(t, y))) : d = qe(t, y), f = parseFloat(d), x = m === "string" && c.charAt(1) === "=" && c.substr(0, 2), x && (c = c.substr(2)), g = parseFloat(c), y in Me && (y === "autoAlpha" && (f === 1 && qe(t, "visibility") === "hidden" && g && (f = 0), O.push("visibility", 0, a.visibility), Ge(this, a, "visibility", f ? "inherit" : "hidden", g ? "inherit" : "hidden", !g)), y !== "scale" && y !== "transform" && (y = Me[y], ~y.indexOf(",") && (y = y.split(",")[0]))), j = y in Ue, j) {
            if (this.styles.save(y), D || (z = t._gsap, z.renderTransform && !i.parseTransform || Ft(t, i.parseTransform), N = i.smoothOrigin !== !1 && z.smooth, D = this._pt = new $e(this._pt, a, ie, 0, 1, z.renderTransform, z, 0, -1), D.dep = 1), y === "scale")
              this._pt = new $e(this._pt, z, "scaleY", z.scaleY, (x ? vt(z.scaleY, x + g) : g) - z.scaleY || 0, ji), this._pt.u = 0, r.push("scaleY", y), y += "X";
            else if (y === "transformOrigin") {
              O.push(Le, 0, a[Le]), c = Jr(c), z.svg ? Di(t, c, 0, N, 0, this) : (C = parseFloat(c.split(" ")[2]) || 0, C !== z.zOrigin && Ge(this, z, "zOrigin", z.zOrigin, C), Ge(this, a, y, ii(d), ii(c)));
              continue;
            } else if (y === "svgOrigin") {
              Di(t, c, 1, N, 0, this);
              continue;
            } else if (y in kn) {
              ia(this, z, y, f, x ? vt(f, x + c) : c);
              continue;
            } else if (y === "smoothOrigin") {
              Ge(this, z, "smooth", z.smooth, c);
              continue;
            } else if (y === "force3D") {
              z[y] = c;
              continue;
            } else if (y === "transform") {
              sa(this, c, t);
              continue;
            }
          } else y in a || (y = Ct(y) || y);
          if (j || (g || g === 0) && (f || f === 0) && !Ar.test(c) && y in a)
            k = (d + "").substr((f + "").length), g || (g = 0), C = he(c) || (y in Te.units ? Te.units[y] : k), k !== C && (f = Qe(t, y, d, C)), this._pt = new $e(this._pt, j ? z : a, y, f, (x ? vt(f, x + g) : g) - f, !j && (C === "px" || y === "zIndex") && i.autoRound !== !1 ? Fr : ji), this._pt.u = C || 0, k !== C && C !== "%" && (this._pt.b = d, this._pt.r = Er);
          else if (y in a)
            Zr.call(this, t, y, d, x ? x + c : c);
          else if (y in t)
            this.add(t, y, d || t[y], x ? x + c : c, n, o);
          else if (y !== "parseTransform") {
            Fi(y, c);
            continue;
          }
          j || (y in a ? O.push(y, 0, a[y]) : O.push(y, 1, d || t[y])), r.push(y);
        }
      }
    I && pn(this);
  },
  render: function(t, i) {
    if (i.tween._time || !Zi())
      for (var s = i._pt; s; )
        s.r(t, s.d), s = s._next;
    else
      i.styles.revert();
  },
  get: qe,
  aliases: Me,
  getSetter: function(t, i, s) {
    var n = Me[i];
    return n && n.indexOf(",") < 0 && (i = n), i in Ue && i !== Le && (t._gsap.x || qe(t, "x")) ? s && ps === s ? i === "scale" ? Ur : Wr : (ps = s || {}) && (i === "scale" ? Hr : Xr) : t.style && !Ai(t.style[i]) ? Vr : ~i.indexOf("-") ? qr : Gi(t, i);
  },
  core: {
    _removeProperty: Rt,
    _getMatrix: Qi
  }
};
ke.utils.checkPrefix = Ct;
ke.core.getStyleSaver = yn;
(function(e, t, i, s) {
  var n = be(e + "," + t + "," + i, function(o) {
    Ue[o] = 1;
  });
  be(t, function(o) {
    Te.units[o] = "deg", kn[o] = 1;
  }), Me[n[13]] = e + "," + t, be(s, function(o) {
    var r = o.split(":");
    Me[r[1]] = n[r[0]];
  });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
be("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(e) {
  Te.units[e] = "px";
});
ke.registerPlugin(Tn);
var U = ke.registerPlugin(Tn) || ke;
U.core.Tween;
const na = T({
  name: "CountdownComponent",
  components: {
    BlueBox: Mi
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    /**
     * aky text chceme animovat
     */
    toAnimate: {
      type: String,
      required: !0
    },
    /**
     * ako dlho ma cela animacia trvat
     */
    duration: {
      type: Number,
      required: !0
    },
    /**
     * nadpis
     */
    headerText: {
      type: String,
      required: !0
    },
    /**
     * ci zobrazujeme velky text
     */
    showBig: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * ci zobrazujeme maly text
     */
    showSmall: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * ci zobrazujeme nadpis
     */
    showHeader: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /**
     * callback je len na malom texte
     */
    callback: {
      type: Function,
      required: !1,
      default: null
    },
    /**
     * z akej pozicie zaciname
     */
    leftStart: {
      type: Number,
      required: !1,
      default: -0.2
    }
  },
  data() {
    return {
      bigTween: null,
      smallTween: null
    };
  },
  computed: {
    transformCoef() {
      return `transform: scale(${this.scaleCoef}) translate(-50%, -50%)`;
    },
    fullWidthPercent() {
      return `width:${100 / this.scaleCoef}%`;
    },
    fullHeightPercent() {
      return `height:${100 / this.scaleCoef}%`;
    },
    textClass() {
      return `text-${this.toAnimate.toLowerCase()}`;
    }
  },
  watch: {
    toAnimate: {
      handler(e) {
        var t, i, s, n;
        if (e) {
          const o = document.body.clientWidth / this.scaleCoef, r = this.leftStart * o;
          if (this.showBig) {
            const a = this.$refs.bigTextRef;
            a.style.left = `${r}px`, (t = this.bigTween) == null || t.progress(0), (i = this.bigTween) == null || i.play();
          }
          if (this.showSmall) {
            const a = this.$refs.smallTextRef;
            a.style.left = `${r}px`, (s = this.smallTween) == null || s.progress(0), (n = this.smallTween) == null || n.play();
          }
        }
      }
    }
  },
  mounted() {
    this.setUpTweens();
  },
  methods: {
    setUpTweens() {
      this.$nextTick(() => {
        const e = this.duration * 0.2, t = this.duration * 0.7, i = this.duration * 0.1, s = document.body.clientWidth / this.scaleCoef, n = this.leftStart * s;
        this.setBigTween(e, t, i, s, n), this.setSmallTween(e, t, i, s, n);
      });
    },
    setBigTween(e, t, i, s, n) {
      this.bigTween && this.bigTween.kill();
      const o = this.$refs.bigTextRef, r = o.clientWidth, a = s * 0.4 - r / 2, u = s * 0.5 - r / 2;
      o.style.left = `${n}px`, this.bigTween = U.timeline({ paused: !0 }).to(".big-text", {
        duration: e,
        ease: "none",
        left: `${a}px`
      }).to(".big-text", {
        duration: t,
        ease: "none",
        left: `${u}px`
      }).to(".big-text", {
        duration: i,
        ease: "none",
        left: `${s}px`
      });
    },
    setSmallTween(e, t, i, s, n) {
      this.smallTween && this.smallTween.kill();
      const o = this.$refs.smallTextRef, r = o.clientWidth, a = s * 0.45 - r / 2, u = s * 0.5 - r / 2;
      o.style.left = `${n}px`, this.smallTween = U.timeline({ paused: !0 }).to(".small-text", {
        duration: e,
        ease: "none",
        left: `${a}px`
      }).to(".small-text", {
        duration: t,
        ease: "none",
        left: `${u}px`
      }).to(".small-text", {
        duration: i,
        ease: "none",
        left: `${s + 200}px`,
        onComplete: this.runCallback
      });
    },
    runCallback() {
      this.callback && this.callback();
    }
  }
}), oa = {
  key: 0,
  class: "header-text"
}, ra = { class: "big-text-background" }, aa = { class: "small-text-background" };
function la(e, t, i, s, n, o) {
  const r = L("blue-box");
  return p(), h("div", {
    class: "countdown-container",
    style: b([e.transformCoef, e.fullWidthPercent, e.fullHeightPercent])
  }, [
    e.showHeader ? (p(), h("div", oa, [
      M(r, { "is-scaled": !1 }, {
        default: F(() => [
          K($(e.headerText), 1)
        ]),
        _: 1
      })
    ])) : w("", !0),
    Ae(l("div", ra, [
      l("div", {
        ref: "bigTextRef",
        class: _(["big-text", e.textClass])
      }, null, 2)
    ], 512), [
      [Ze, e.showBig]
    ]),
    Ae(l("div", aa, [
      l("div", {
        ref: "smallTextRef",
        class: _(["small-text", e.textClass])
      }, null, 2)
    ], 512), [
      [Ze, e.showSmall]
    ])
  ], 4);
}
const i0 = /* @__PURE__ */ S(na, [["render", la]]), da = T({
  name: "PowerButton",
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    /**
     * Sets disabled state on and off.
     */
    disabled: {
      default: !1,
      type: Boolean,
      required: !1
    },
    /**
     * Sets the type of component. It helps for theming.
     * Allowed are: ['primary', 'secondary']
     */
    type: {
      default: "primary",
      type: String,
      required: !1,
      validator(e) {
        return [
          "primary",
          "secondary"
        ].indexOf(e) > -1;
      }
    },
    /**
     * Sets button size.
     * Allowed are: ['auto', 'small', 'medium', 'large', 'full-width, '']
     */
    size: {
      default: "",
      type: String,
      required: !1,
      validator(e) {
        const t = ["small", "medium", "large", "full-width", ""], i = e.split(" ");
        return i.length === 1 ? t.indexOf(e) > -1 : i.every((s) => t.includes(s));
      }
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    basicButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["click", "keyup", "keydown", "keypress", "blur", "focus"],
  data() {
    return {
      isSsm: !1,
      active: !1
    };
  },
  computed: {
    scaleComputed() {
      return { scale: `${this.active ? 0.95 : 1}` };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    onClick(e) {
      this.$emit("click", e);
    },
    onBlur(e) {
      this.$emit("blur", e);
    },
    onFocus(e) {
      this.$emit("focus", e);
    },
    onKeyPress(e) {
      this.$emit("keypress", e);
    },
    onKeyDown(e) {
      this.$emit("keydown", e);
    },
    onKeyUp(e) {
      this.$emit("keyup", e);
    }
  }
}), ua = ["disabled"], ca = {
  key: 0,
  class: "power-button-text"
};
function pa(e, t, i, s, n, o) {
  return p(), h("button", {
    disabled: e.disabled,
    class: _(["power-button", { "power-button-ssm": e.isSsm }, e.type, e.size]),
    style: b([e.style, { rounded: e.rounded }, e.scaleComputed]),
    onClick: t[0] || (t[0] = (r) => e.onClick(r)),
    onFocus: t[1] || (t[1] = (r) => e.onFocus(r)),
    onBlur: t[2] || (t[2] = (r) => e.onBlur(r)),
    onKeydown: t[3] || (t[3] = (r) => e.onKeyDown(r)),
    onKeyup: t[4] || (t[4] = (r) => e.onKeyUp(r)),
    onKeypress: t[5] || (t[5] = (r) => e.onKeyPress(r)),
    onMousedown: t[6] || (t[6] = A((r) => e.active = !0, ["stop"])),
    onMouseup: t[7] || (t[7] = A((r) => e.active = !1, ["stop"])),
    onTouchstart: t[8] || (t[8] = A((r) => e.active = !0, ["stop"])),
    onTouchend: t[9] || (t[9] = A((r) => e.active = !1, ["stop"]))
  }, [
    e.basicButton ? (p(), h("span", ca, [
      J(e.$slots, "default")
    ])) : J(e.$slots, "default", { key: 1 })
  ], 46, ua);
}
const zt = /* @__PURE__ */ S(da, [["render", pa]]);
function ha(e) {
  function t() {
    return Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
  }
  return `${e}-${t()}${t()}-${t()}-${t()}-${t()}-${t()}${t()}${t()}`;
}
const fa = T({
  name: "PowerCheckBox",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    id: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Boolean,
      required: !0
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      defaultId: this.id || ha("Checkbox"),
      isSsm: !1
    };
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    onClick() {
      this.$emit("update:modelValue", !this.modelValue);
    }
  }
}), ma = ["for"], ga = ["id", "checked"];
function ya(e, t, i, s, n, o) {
  return p(), h("div", {
    style: b([e.style]),
    class: _(["power-checkbox", { "power-checkbox-ssm": e.isSsm }])
  }, [
    l("label", { for: e.defaultId }, [
      J(e.$slots, "default"),
      l("input", {
        id: e.defaultId,
        class: _(["checkbox", { checked: e.modelValue }]),
        type: "checkbox",
        checked: e.modelValue,
        onClick: t[0] || (t[0] = (...r) => e.onClick && e.onClick(...r))
      }, null, 10, ga),
      l("span", {
        class: _([{ checked: e.modelValue }, "checkmark"])
      }, null, 2)
    ], 8, ma)
  ], 6);
}
const va = /* @__PURE__ */ S(fa, [["render", ya]]), ba = T({
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Number,
      required: !0
    },
    min: {
      type: Number,
      required: !0
    },
    max: {
      type: Number,
      required: !0
    },
    step: {
      type: Number,
      default: 1
    },
    optionRange: {
      type: Array,
      default: null
    },
    disabledValue: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      currentValue: this.modelValue,
      isSsm: !1
    };
  },
  computed: {
    defaultArray() {
      const e = [];
      for (let t = this.min; t <= this.max; t = t + this.step) {
        const i = {
          num: t,
          label: t
        };
        e.push(i);
      }
      return e;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    onInput() {
      this.$emit("update:modelValue", Number(this.currentValue));
    }
  }
}), $a = { class: "slider-container" }, ka = ["min", "max", "step", "disabled"], _a = {
  id: "steplist",
  class: "ticks"
};
function wa(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["power-slider", e.disabledValue ? "slider-disabled" : "", { "power-slider-ssm": e.isSsm }])
  }, [
    l("div", $a, [
      Ae(l("input", {
        ref: "input",
        "onUpdate:modelValue": t[0] || (t[0] = (r) => e.currentValue = r),
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step,
        class: "slider",
        disabled: e.disabledValue,
        list: "steplist",
        onInput: t[1] || (t[1] = (...r) => e.onInput && e.onInput(...r))
      }, null, 40, ka), [
        [Bn, e.currentValue]
      ]),
      l("div", _a, [
        (p(!0), h(H, null, de(e.optionRange || e.defaultArray, (r) => (p(), h("span", {
          key: r.num,
          class: "tick"
        }, $(r.label), 1))), 128))
      ])
    ])
  ], 2);
}
const Ta = /* @__PURE__ */ S(ba, [["render", wa]]), Sa = T({
  name: "PowerSwitch",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: [Boolean, Number],
      required: !0
    },
    textOn: {
      type: String,
      required: !1,
      default: "utOn"
    },
    textOff: {
      type: String,
      required: !1,
      default: "utOff"
    },
    valueOn: {
      type: null,
      required: !1,
      default: !0
    },
    valueOff: {
      type: null,
      required: !1,
      default: !1
    },
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      isSsm: !1
    };
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    onOnClick() {
      console.log("on", this.textOn), this.$emit("update:modelValue", this.valueOn);
    },
    onOffClick() {
      console.log("off"), this.$emit("update:modelValue", this.valueOff);
    },
    getModelBoolValue() {
      return this.modelValue === this.valueOn;
    }
  }
}), xa = ["aria-checked"], Ca = { class: "text" }, za = { class: "text" };
function ja(e, t, i, s, n, o) {
  return p(), h("button", {
    type: "button",
    role: "switch",
    "aria-checked": e.getModelBoolValue(),
    style: b([e.style]),
    class: _(["power-switch", { active: e.getModelBoolValue() }, { "power-switch-ssm": e.isSsm }])
  }, [
    l("span", {
      class: "on",
      onClick: t[0] || (t[0] = (...r) => e.onOnClick && e.onOnClick(...r))
    }, [
      l("span", Ca, $(e.$t(e.textOn)), 1)
    ]),
    l("span", {
      class: "off",
      onClick: t[1] || (t[1] = (...r) => e.onOffClick && e.onOffClick(...r))
    }, [
      l("span", za, $(e.$t(e.textOff)), 1)
    ])
  ], 14, xa);
}
const Sn = /* @__PURE__ */ S(Sa, [["render", ja]]), Ba = T({
  name: "ExitDisciplineModal",
  components: {
    PowerButton: zt
  },
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    isTraining: {
      type: Boolean,
      required: !0,
      default: !1
    },
    isTutorial: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: ["yes", "back"],
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    basicStyle() {
      return {
        transform: `translateY(-50%) scale(${this.scaleCoef})`,
        width: `${100 / this.scaleCoef}%`,
        "transform-origin": "center left"
      };
    },
    textsPostFix() {
      return this.isTraining ? "Training" : this.isTutorial ? "Tutorial" : "";
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), Pa = { class: "exit-discipline-header" }, Da = { class: "exit-discipline-text" }, La = { class: "exit-discipline-buttons" }, Oa = { class: "exit-discipline-button-text" }, Ia = { class: "exit-discipline-button-text" };
function Ma(e, t, i, s, n, o) {
  const r = L("power-button");
  return p(), h("div", {
    class: _(["exit-discipline-modal", { "exit-dicipline-modal-ssm": e.isSsm }, e.isMobile() ? "mobile-overlay" : ""]),
    style: b([e.style, e.basicStyle])
  }, [
    l("div", Pa, $(e.$t("quitCompetition" + e.textsPostFix)), 1),
    l("div", Da, $(e.$t("quitCompetitionConfirm" + e.textsPostFix)), 1),
    l("div", La, [
      M(r, {
        type: "primary",
        onClick: t[0] || (t[0] = (a) => e.$emit("yes"))
      }, {
        default: F(() => [
          l("span", Oa, $(e.$t("yes")), 1)
        ]),
        _: 1
      }),
      M(r, {
        type: "secondary",
        onClick: t[1] || (t[1] = (a) => e.$emit("back"))
      }, {
        default: F(() => [
          l("span", Ia, $(e.$t("back")), 1)
        ]),
        _: 1
      })
    ])
  ], 6);
}
const s0 = /* @__PURE__ */ S(Ba, [["render", Ma]]), Na = T({
  name: "FpsLooker",
  data() {
    return {
      isStarted: !1,
      fpsLookerState: ss()
    };
  },
  methods: {
    startFps() {
      this.isStarted || (console.log("FPS started"), this.isStarted = !0, ss().isStarted = !0);
    }
  }
}), Aa = {
  key: 0,
  class: "fps"
};
function Ra(e, t, i, s, n, o) {
  return p(), h("section", {
    class: "fps-looker",
    onClick: t[0] || (t[0] = (...r) => e.startFps && e.startFps(...r))
  }, [
    e.isStarted ? (p(), h("p", Aa, $(Math.round(e.fpsLookerState.actualFps)) + " / " + $(Math.round(e.fpsLookerState.actualAverageFps)) + " / " + $(Math.round(e.fpsLookerState.averageFps)), 1)) : w("", !0)
  ]);
}
const n0 = /* @__PURE__ */ S(Na, [["render", Ra], ["__scopeId", "data-v-f745b04a"]]), Ea = T({
  name: "PowerSkijumpUserInfo",
  props: {
    playerData: {
      type: Object,
      required: !0
    }
  }
}), Fa = { class: "power-user-info-skijump" }, Va = { class: "table-row" }, qa = { class: "position" }, Wa = { class: "pos-number" }, Ua = { class: "row" }, Ha = { class: "sider" }, Xa = { class: "country" }, Ga = ["src", "alt"], Ya = { class: "player-name" }, Ka = { class: "country-name" }, Za = {
  key: 0,
  class: "length-second"
}, Ja = { class: "length" }, Qa = { class: "points" }, el = { class: "points-section" };
function tl(e, t, i, s, n, o) {
  return p(), h("div", Fa, [
    l("div", Va, [
      l("div", qa, [
        l("span", Wa, $(e.playerData.position), 1)
      ]),
      l("div", Ua, [
        l("div", Ha, [
          l("div", Xa, [
            l("img", {
              class: "image",
              src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${e.playerData.country.toLowerCase()}.png`,
              alt: e.playerData.country
            }, null, 8, Ga),
            l("div", Ya, $(e.playerData.name), 1),
            l("div", Ka, " (" + $(e.playerData.countryString) + ") ", 1)
          ])
        ])
      ]),
      e.playerData.secondLength ? (p(), h("div", Za, $(e.playerData.secondLength), 1)) : w("", !0),
      l("div", Ja, $(e.playerData.length), 1),
      l("div", Qa, [
        t[0] || (t[0] = l("div", { class: "points-section" }, " Points: ", -1)),
        l("div", el, $(e.playerData.points), 1)
      ])
    ])
  ]);
}
const il = /* @__PURE__ */ S(Ea, [["render", tl]]), sl = T({
  name: "PowerOpinionInfoSkijump",
  props: {
    opinionInfo: {
      type: Array,
      required: !0
    }
  },
  computed: {
    opinionInfoSorted() {
      return [...this.opinionInfo].sort((e, t) => t.points - e.points);
    }
  },
  methods: {
    afterStyle(e) {
      return e === 0 || e === this.opinionInfoSorted.length - 1 ? "dark" : "no-dark";
    }
  }
}), nl = { class: "power-opinion-info-skijump" }, ol = ["src", "alt"], rl = { class: "country-name" }, al = {
  key: 0,
  class: "shadow"
};
function ll(e, t, i, s, n, o) {
  return p(), h("div", nl, [
    (p(!0), h(H, null, de(e.opinionInfoSorted, (r, a) => (p(), h("div", {
      key: a,
      class: _(["opinion", e.afterStyle(a)])
    }, [
      l("div", {
        class: _(["opinion-section-left", e.afterStyle(a)])
      }, [
        l("img", {
          class: "image",
          src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${r.country.toLowerCase()}.png`,
          alt: r.country
        }, null, 8, ol),
        l("div", rl, $(r.countryString), 1)
      ], 2),
      l("div", {
        class: _(["opinion-section-right", e.afterStyle(a)])
      }, $(r.points), 3),
      a === 0 || a === e.opinionInfoSorted.length - 1 ? (p(), h("div", al)) : w("", !0)
    ], 2))), 128))
  ]);
}
const dl = /* @__PURE__ */ S(sl, [["render", ll]]), ul = T({
  name: "PowerWindInfoSkijump",
  props: {
    wind: {
      type: String || Number,
      required: !0
    }
  }
}), cl = { class: "power-wind-info-skijump" }, pl = { class: "wind-section" }, hl = { class: "wind-section" };
function fl(e, t, i, s, n, o) {
  return p(), h("div", cl, [
    l("div", pl, $(e.$t("wind")) + ": ", 1),
    l("div", hl, $(e.wind), 1)
  ]);
}
const ml = /* @__PURE__ */ S(ul, [["render", fl]]), gl = T({
  name: "FullInfo",
  components: {
    SkyjumpUserInfoRow: il,
    WindInfo: ml,
    MarksInfo: dl
  },
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    elementData: {
      type: Object,
      required: !0
    }
  },
  computed: {
    basicStyle() {
      return {
        transform: `scale(${this.scaleCoef})`
      };
    }
  }
}), yl = { class: "wind-info" };
function vl(e, t, i, s, n, o) {
  const r = L("marks-info"), a = L("wind-info"), u = L("skyjump-user-info-row");
  return p(), h("div", {
    class: "power-info-layout-skijump",
    style: b([e.style, e.basicStyle])
  }, [
    M(r, {
      class: "opinion",
      "opinion-info": e.elementData.opinionInfo
    }, null, 8, ["opinion-info"]),
    l("div", yl, [
      e.elementData.wind ? (p(), V(a, {
        key: 0,
        wind: e.elementData.wind
      }, null, 8, ["wind"])) : w("", !0)
    ]),
    M(u, {
      class: "skijump-user",
      "player-data": e.elementData.playerObject
    }, null, 8, ["player-data"])
  ], 4);
}
const o0 = /* @__PURE__ */ S(gl, [["render", vl], ["__scopeId", "data-v-dd8f8277"]]), bl = T({
  components: {
    BlueBox: Mi
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    gameVersion: {
      type: String,
      required: !1,
      default: ""
    }
  },
  data() {
    return {
      loadingState: _s()
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef})`
      };
    },
    getTutorialName() {
      const e = this.$t(this.loadingState.tutorial.text);
      return e === this.loadingState.tutorial.text ? "" : `${e} (${this.$t("tutorial")})`;
    }
  }
}), $l = { key: 2 }, kl = { class: "game-loading-tutorial-text" }, _l = {
  key: 0,
  class: "game-loeading-cross-header"
}, wl = ["href"], Tl = ["src"], Sl = {
  key: 2,
  class: "game-loading-cross-divider"
}, xl = { class: "game-loading-cross-hint-text-wrapper" }, Cl = { class: "game-loading-progress-bar-wrapper" };
function zl(e, t, i, s, n, o) {
  const r = L("blue-box");
  return e.loadingState.showLoading ? (p(), h("div", {
    key: 0,
    class: _(["game-loading-container", e.isMobile() ? "mobile-overlay" : ""])
  }, [
    l("div", {
      class: "game-loading-wrapper",
      style: b([e.style])
    }, [
      e.loadingState.tutorial.isEnabled ? (p(), h("div", {
        key: 0,
        class: "game-loading-logo-tutorial",
        style: b([e.transformCoef])
      }, null, 4)) : e.loadingState.crossConfig.fullsized ? w("", !0) : (p(), h("div", {
        key: 1,
        class: "game-loading-logo",
        style: b([e.transformCoef])
      }, null, 4)),
      l("div", {
        class: "placeholder",
        style: b([e.transformCoef])
      }, null, 4),
      e.loadingState.tutorial.isEnabled ? (p(), h("div", $l, [
        l("div", kl, [
          M(r, {
            "show-border": !0,
            "border-color": "white"
          }, {
            default: F(() => [
              K($(e.getTutorialName), 1)
            ]),
            _: 1
          })
        ])
      ])) : e.loadingState.crossConfig.isActive ? (p(), h("div", {
        key: 3,
        style: b([e.transformCoef]),
        class: _(e.loadingState.crossConfig.fullsized ? "game-loading-cross" : "game-loading-cross-small")
      }, [
        e.loadingState.crossConfig.fullsized ? (p(), h("div", _l, " VYSKÚŠAJ TIEŽ ")) : w("", !0),
        e.loadingState.crossConfig.fullsized ? (p(), h("a", {
          key: 1,
          class: "game-loading-cross-url",
          href: e.loadingState.crossConfig.imgHref,
          target: "_blank"
        }, [
          l("img", {
            class: "game-loading-cross-image",
            src: e.loadingState.crossConfig.imgSrc,
            alt: "loading"
          }, null, 8, Tl)
        ], 8, wl)) : w("", !0),
        e.loadingState.crossConfig.fullsized ? (p(), h("div", Sl)) : w("", !0),
        l("div", xl, [
          t[0] || (t[0] = l("img", {
            src: "https://appspowerplaymanager.vshcdn.net/images/winter-sports/minigame/core-ui/loading/ICO_INFO_ROUNDED_80px.png",
            alt: "info"
          }, null, -1)),
          K(" " + $(e.loadingState.hintText), 1)
        ]),
        t[1] || (t[1] = l("div", { class: "corner-top-right" }, [
          l("div", { class: "corner-top-top-right" })
        ], -1)),
        t[2] || (t[2] = l("div", { class: "corner-bottom-left" }, [
          l("div", { class: "corner-bottom-bottom-left" })
        ], -1))
      ], 6)) : w("", !0),
      l("div", {
        style: b([e.transformCoef]),
        class: "game-loading-progress-bar-container"
      }, [
        t[3] || (t[3] = l("span", { class: "game-loading-progress-bar-text" }, " Loading... ", -1)),
        l("div", Cl, [
          l("div", {
            class: "game-loading-progress-bar",
            style: b(
              {
                width: `${e.loadingState.loadingProgress}%`
              }
            )
          }, null, 4)
        ])
      ], 4),
      l("div", {
        style: b([e.style, e.transformCoef]),
        class: "game-loading-version"
      }, " v" + $(e.gameVersion), 5)
    ], 4)
  ], 2)) : w("", !0);
}
const r0 = /* @__PURE__ */ S(bl, [["render", zl]]), jl = T({
  name: "HeartMonitorBox",
  mixins: [P],
  props: {
    isRight: {
      type: Boolean,
      default: !0
    },
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    heartRate: {
      type: String || Number,
      required: !1,
      default: ""
    },
    glow: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"]
}), Bl = {
  key: 0,
  class: "yellow-glow"
}, Pl = { class: "heart-monitor-box-wrapper-row-1" }, Dl = { class: "heart-monitor-box-text-row-1" };
function Ll(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["heart-monitor-box", [e.isRight ? "heart-monitor-box-right" : "heart-monitor-box-left"]]),
    style: b([e.style])
  }, [
    e.glow ? (p(), h("div", Bl)) : w("", !0),
    l("div", Pl, [
      l("div", Dl, $(e.heartRate), 1),
      t[0] || (t[0] = l("span", { class: "icon-heart" }, null, -1))
    ])
  ], 6);
}
const a0 = /* @__PURE__ */ S(jl, [["render", Ll]]);
var Ol = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Il(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var xn = { exports: {} };
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */
(function(e) {
  (function(t, i) {
    e.exports ? e.exports = i() : t.numeral = i();
  })(Ol, function() {
    var t, i, s = "2.0.6", n = {}, o = {}, r = {
      currentLocale: "en",
      zeroFormat: null,
      nullFormat: null,
      defaultFormat: "0,0",
      scalePercentBy100: !0
    }, a = {
      currentLocale: r.currentLocale,
      zeroFormat: r.zeroFormat,
      nullFormat: r.nullFormat,
      defaultFormat: r.defaultFormat,
      scalePercentBy100: r.scalePercentBy100
    };
    function u(d, c) {
      this._input = d, this._value = c;
    }
    return t = function(d) {
      var c, g, f, m;
      if (t.isNumeral(d))
        c = d.value();
      else if (d === 0 || typeof d > "u")
        c = 0;
      else if (d === null || i.isNaN(d))
        c = null;
      else if (typeof d == "string")
        if (a.zeroFormat && d === a.zeroFormat)
          c = 0;
        else if (a.nullFormat && d === a.nullFormat || !d.replace(/[^0-9]+/g, "").length)
          c = null;
        else {
          for (g in n)
            if (m = typeof n[g].regexps.unformat == "function" ? n[g].regexps.unformat() : n[g].regexps.unformat, m && d.match(m)) {
              f = n[g].unformat;
              break;
            }
          f = f || t._.stringToNumber, c = f(d);
        }
      else
        c = Number(d) || null;
      return new u(d, c);
    }, t.version = s, t.isNumeral = function(d) {
      return d instanceof u;
    }, t._ = i = {
      // formats numbers separators, decimals places, signs, abbreviations
      numberToFormat: function(d, c, g) {
        var f = o[t.options.currentLocale], m = !1, v = !1, y = 0, k = "", C = 1e12, x = 1e9, j = 1e6, D = 1e3, z = "", N = !1, I, O, B, R, W, Z, X;
        if (d = d || 0, O = Math.abs(d), t._.includes(c, "(") ? (m = !0, c = c.replace(/[\(|\)]/g, "")) : (t._.includes(c, "+") || t._.includes(c, "-")) && (W = t._.includes(c, "+") ? c.indexOf("+") : d < 0 ? c.indexOf("-") : -1, c = c.replace(/[\+|\-]/g, "")), t._.includes(c, "a") && (I = c.match(/a(k|m|b|t)?/), I = I ? I[1] : !1, t._.includes(c, " a") && (k = " "), c = c.replace(new RegExp(k + "a[kmbt]?"), ""), O >= C && !I || I === "t" ? (k += f.abbreviations.trillion, d = d / C) : O < C && O >= x && !I || I === "b" ? (k += f.abbreviations.billion, d = d / x) : O < x && O >= j && !I || I === "m" ? (k += f.abbreviations.million, d = d / j) : (O < j && O >= D && !I || I === "k") && (k += f.abbreviations.thousand, d = d / D)), t._.includes(c, "[.]") && (v = !0, c = c.replace("[.]", ".")), B = d.toString().split(".")[0], R = c.split(".")[1], Z = c.indexOf(","), y = (c.split(".")[0].split(",")[0].match(/0/g) || []).length, R ? (t._.includes(R, "[") ? (R = R.replace("]", ""), R = R.split("["), z = t._.toFixed(d, R[0].length + R[1].length, g, R[1].length)) : z = t._.toFixed(d, R.length, g), B = z.split(".")[0], t._.includes(z, ".") ? z = f.delimiters.decimal + z.split(".")[1] : z = "", v && Number(z.slice(1)) === 0 && (z = "")) : B = t._.toFixed(d, 0, g), k && !I && Number(B) >= 1e3 && k !== f.abbreviations.trillion)
          switch (B = String(Number(B) / 1e3), k) {
            case f.abbreviations.thousand:
              k = f.abbreviations.million;
              break;
            case f.abbreviations.million:
              k = f.abbreviations.billion;
              break;
            case f.abbreviations.billion:
              k = f.abbreviations.trillion;
              break;
          }
        if (t._.includes(B, "-") && (B = B.slice(1), N = !0), B.length < y)
          for (var Q = y - B.length; Q > 0; Q--)
            B = "0" + B;
        return Z > -1 && (B = B.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + f.delimiters.thousands)), c.indexOf(".") === 0 && (B = ""), X = B + z + (k || ""), m ? X = (m && N ? "(" : "") + X + (m && N ? ")" : "") : W >= 0 ? X = W === 0 ? (N ? "-" : "+") + X : X + (N ? "-" : "+") : N && (X = "-" + X), X;
      },
      // unformats numbers separators, decimals places, signs, abbreviations
      stringToNumber: function(d) {
        var c = o[a.currentLocale], g = d, f = {
          thousand: 3,
          million: 6,
          billion: 9,
          trillion: 12
        }, m, v, y;
        if (a.zeroFormat && d === a.zeroFormat)
          v = 0;
        else if (a.nullFormat && d === a.nullFormat || !d.replace(/[^0-9]+/g, "").length)
          v = null;
        else {
          v = 1, c.delimiters.decimal !== "." && (d = d.replace(/\./g, "").replace(c.delimiters.decimal, "."));
          for (m in f)
            if (y = new RegExp("[^a-zA-Z]" + c.abbreviations[m] + "(?:\\)|(\\" + c.currency.symbol + ")?(?:\\))?)?$"), g.match(y)) {
              v *= Math.pow(10, f[m]);
              break;
            }
          v *= (d.split("-").length + Math.min(d.split("(").length - 1, d.split(")").length - 1)) % 2 ? 1 : -1, d = d.replace(/[^0-9\.]+/g, ""), v *= Number(d);
        }
        return v;
      },
      isNaN: function(d) {
        return typeof d == "number" && isNaN(d);
      },
      includes: function(d, c) {
        return d.indexOf(c) !== -1;
      },
      insert: function(d, c, g) {
        return d.slice(0, g) + c + d.slice(g);
      },
      reduce: function(d, c) {
        if (this === null)
          throw new TypeError("Array.prototype.reduce called on null or undefined");
        if (typeof c != "function")
          throw new TypeError(c + " is not a function");
        var g = Object(d), f = g.length >>> 0, m = 0, v;
        if (arguments.length === 3)
          v = arguments[2];
        else {
          for (; m < f && !(m in g); )
            m++;
          if (m >= f)
            throw new TypeError("Reduce of empty array with no initial value");
          v = g[m++];
        }
        for (; m < f; m++)
          m in g && (v = c(v, g[m], m, g));
        return v;
      },
      /**
       * Computes the multiplier necessary to make x >= 1,
       * effectively eliminating miscalculations caused by
       * finite precision.
       */
      multiplier: function(d) {
        var c = d.toString().split(".");
        return c.length < 2 ? 1 : Math.pow(10, c[1].length);
      },
      /**
       * Given a variable number of arguments, returns the maximum
       * multiplier that must be used to normalize an operation involving
       * all of them.
       */
      correctionFactor: function() {
        var d = Array.prototype.slice.call(arguments);
        return d.reduce(function(c, g) {
          var f = i.multiplier(g);
          return c > f ? c : f;
        }, 1);
      },
      /**
       * Implementation of toFixed() that treats floats more like decimals
       *
       * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
       * problems for accounting- and finance-related software.
       */
      toFixed: function(d, c, g, f) {
        var m = d.toString().split("."), v = c - (f || 0), y, k, C, x;
        return m.length === 2 ? y = Math.min(Math.max(m[1].length, v), c) : y = v, C = Math.pow(10, y), x = (g(d + "e+" + y) / C).toFixed(y), f > c - y && (k = new RegExp("\\.?0{1," + (f - (c - y)) + "}$"), x = x.replace(k, "")), x;
      }
    }, t.options = a, t.formats = n, t.locales = o, t.locale = function(d) {
      return d && (a.currentLocale = d.toLowerCase()), a.currentLocale;
    }, t.localeData = function(d) {
      if (!d)
        return o[a.currentLocale];
      if (d = d.toLowerCase(), !o[d])
        throw new Error("Unknown locale : " + d);
      return o[d];
    }, t.reset = function() {
      for (var d in r)
        a[d] = r[d];
    }, t.zeroFormat = function(d) {
      a.zeroFormat = typeof d == "string" ? d : null;
    }, t.nullFormat = function(d) {
      a.nullFormat = typeof d == "string" ? d : null;
    }, t.defaultFormat = function(d) {
      a.defaultFormat = typeof d == "string" ? d : "0.0";
    }, t.register = function(d, c, g) {
      if (c = c.toLowerCase(), this[d + "s"][c])
        throw new TypeError(c + " " + d + " already registered.");
      return this[d + "s"][c] = g, g;
    }, t.validate = function(d, c) {
      var g, f, m, v, y, k, C, x;
      if (typeof d != "string" && (d += "", console.warn && console.warn("Numeral.js: Value is not string. It has been co-erced to: ", d)), d = d.trim(), d.match(/^\d+$/))
        return !0;
      if (d === "")
        return !1;
      try {
        C = t.localeData(c);
      } catch {
        C = t.localeData(t.locale());
      }
      return m = C.currency.symbol, y = C.abbreviations, g = C.delimiters.decimal, C.delimiters.thousands === "." ? f = "\\." : f = C.delimiters.thousands, x = d.match(/^[^\d]+/), x !== null && (d = d.substr(1), x[0] !== m) || (x = d.match(/[^\d]+$/), x !== null && (d = d.slice(0, -1), x[0] !== y.thousand && x[0] !== y.million && x[0] !== y.billion && x[0] !== y.trillion)) ? !1 : (k = new RegExp(f + "{2}"), d.match(/[^\d.,]/g) ? !1 : (v = d.split(g), v.length > 2 ? !1 : v.length < 2 ? !!v[0].match(/^\d+.*\d$/) && !v[0].match(k) : v[0].length === 1 ? !!v[0].match(/^\d+$/) && !v[0].match(k) && !!v[1].match(/^\d+$/) : !!v[0].match(/^\d+.*\d$/) && !v[0].match(k) && !!v[1].match(/^\d+$/)));
    }, t.fn = u.prototype = {
      clone: function() {
        return t(this);
      },
      format: function(d, c) {
        var g = this._value, f = d || a.defaultFormat, m, v, y;
        if (c = c || Math.round, g === 0 && a.zeroFormat !== null)
          v = a.zeroFormat;
        else if (g === null && a.nullFormat !== null)
          v = a.nullFormat;
        else {
          for (m in n)
            if (f.match(n[m].regexps.format)) {
              y = n[m].format;
              break;
            }
          y = y || t._.numberToFormat, v = y(g, f, c);
        }
        return v;
      },
      value: function() {
        return this._value;
      },
      input: function() {
        return this._input;
      },
      set: function(d) {
        return this._value = Number(d), this;
      },
      add: function(d) {
        var c = i.correctionFactor.call(null, this._value, d);
        function g(f, m, v, y) {
          return f + Math.round(c * m);
        }
        return this._value = i.reduce([this._value, d], g, 0) / c, this;
      },
      subtract: function(d) {
        var c = i.correctionFactor.call(null, this._value, d);
        function g(f, m, v, y) {
          return f - Math.round(c * m);
        }
        return this._value = i.reduce([d], g, Math.round(this._value * c)) / c, this;
      },
      multiply: function(d) {
        function c(g, f, m, v) {
          var y = i.correctionFactor(g, f);
          return Math.round(g * y) * Math.round(f * y) / Math.round(y * y);
        }
        return this._value = i.reduce([this._value, d], c, 1), this;
      },
      divide: function(d) {
        function c(g, f, m, v) {
          var y = i.correctionFactor(g, f);
          return Math.round(g * y) / Math.round(f * y);
        }
        return this._value = i.reduce([this._value, d], c), this;
      },
      difference: function(d) {
        return Math.abs(t(this._value).subtract(d).value());
      }
    }, t.register("locale", "en", {
      delimiters: {
        thousands: ",",
        decimal: "."
      },
      abbreviations: {
        thousand: "k",
        million: "m",
        billion: "b",
        trillion: "t"
      },
      ordinal: function(d) {
        var c = d % 10;
        return ~~(d % 100 / 10) === 1 ? "th" : c === 1 ? "st" : c === 2 ? "nd" : c === 3 ? "rd" : "th";
      },
      currency: {
        symbol: "$"
      }
    }), function() {
      t.register("format", "bps", {
        regexps: {
          format: /(BPS)/,
          unformat: /(BPS)/
        },
        format: function(d, c, g) {
          var f = t._.includes(c, " BPS") ? " " : "", m;
          return d = d * 1e4, c = c.replace(/\s?BPS/, ""), m = t._.numberToFormat(d, c, g), t._.includes(m, ")") ? (m = m.split(""), m.splice(-1, 0, f + "BPS"), m = m.join("")) : m = m + f + "BPS", m;
        },
        unformat: function(d) {
          return +(t._.stringToNumber(d) * 1e-4).toFixed(15);
        }
      });
    }(), function() {
      var d = {
        base: 1e3,
        suffixes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
      }, c = {
        base: 1024,
        suffixes: ["B", "KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"]
      }, g = d.suffixes.concat(c.suffixes.filter(function(m) {
        return d.suffixes.indexOf(m) < 0;
      })), f = g.join("|");
      f = "(" + f.replace("B", "B(?!PS)") + ")", t.register("format", "bytes", {
        regexps: {
          format: /([0\s]i?b)/,
          unformat: new RegExp(f)
        },
        format: function(m, v, y) {
          var k, C = t._.includes(v, "ib") ? c : d, x = t._.includes(v, " b") || t._.includes(v, " ib") ? " " : "", j, D, z;
          for (v = v.replace(/\s?i?b/, ""), j = 0; j <= C.suffixes.length; j++)
            if (D = Math.pow(C.base, j), z = Math.pow(C.base, j + 1), m === null || m === 0 || m >= D && m < z) {
              x += C.suffixes[j], D > 0 && (m = m / D);
              break;
            }
          return k = t._.numberToFormat(m, v, y), k + x;
        },
        unformat: function(m) {
          var v = t._.stringToNumber(m), y, k;
          if (v) {
            for (y = d.suffixes.length - 1; y >= 0; y--) {
              if (t._.includes(m, d.suffixes[y])) {
                k = Math.pow(d.base, y);
                break;
              }
              if (t._.includes(m, c.suffixes[y])) {
                k = Math.pow(c.base, y);
                break;
              }
            }
            v *= k || 1;
          }
          return v;
        }
      });
    }(), function() {
      t.register("format", "currency", {
        regexps: {
          format: /(\$)/
        },
        format: function(d, c, g) {
          var f = t.locales[t.options.currentLocale], m = {
            before: c.match(/^([\+|\-|\(|\s|\$]*)/)[0],
            after: c.match(/([\+|\-|\)|\s|\$]*)$/)[0]
          }, v, y, k;
          for (c = c.replace(/\s?\$\s?/, ""), v = t._.numberToFormat(d, c, g), d >= 0 ? (m.before = m.before.replace(/[\-\(]/, ""), m.after = m.after.replace(/[\-\)]/, "")) : d < 0 && !t._.includes(m.before, "-") && !t._.includes(m.before, "(") && (m.before = "-" + m.before), k = 0; k < m.before.length; k++)
            switch (y = m.before[k], y) {
              case "$":
                v = t._.insert(v, f.currency.symbol, k);
                break;
              case " ":
                v = t._.insert(v, " ", k + f.currency.symbol.length - 1);
                break;
            }
          for (k = m.after.length - 1; k >= 0; k--)
            switch (y = m.after[k], y) {
              case "$":
                v = k === m.after.length - 1 ? v + f.currency.symbol : t._.insert(v, f.currency.symbol, -(m.after.length - (1 + k)));
                break;
              case " ":
                v = k === m.after.length - 1 ? v + " " : t._.insert(v, " ", -(m.after.length - (1 + k) + f.currency.symbol.length - 1));
                break;
            }
          return v;
        }
      });
    }(), function() {
      t.register("format", "exponential", {
        regexps: {
          format: /(e\+|e-)/,
          unformat: /(e\+|e-)/
        },
        format: function(d, c, g) {
          var f, m = typeof d == "number" && !t._.isNaN(d) ? d.toExponential() : "0e+0", v = m.split("e");
          return c = c.replace(/e[\+|\-]{1}0/, ""), f = t._.numberToFormat(Number(v[0]), c, g), f + "e" + v[1];
        },
        unformat: function(d) {
          var c = t._.includes(d, "e+") ? d.split("e+") : d.split("e-"), g = Number(c[0]), f = Number(c[1]);
          f = t._.includes(d, "e-") ? f *= -1 : f;
          function m(v, y, k, C) {
            var x = t._.correctionFactor(v, y), j = v * x * (y * x) / (x * x);
            return j;
          }
          return t._.reduce([g, Math.pow(10, f)], m, 1);
        }
      });
    }(), function() {
      t.register("format", "ordinal", {
        regexps: {
          format: /(o)/
        },
        format: function(d, c, g) {
          var f = t.locales[t.options.currentLocale], m, v = t._.includes(c, " o") ? " " : "";
          return c = c.replace(/\s?o/, ""), v += f.ordinal(d), m = t._.numberToFormat(d, c, g), m + v;
        }
      });
    }(), function() {
      t.register("format", "percentage", {
        regexps: {
          format: /(%)/,
          unformat: /(%)/
        },
        format: function(d, c, g) {
          var f = t._.includes(c, " %") ? " " : "", m;
          return t.options.scalePercentBy100 && (d = d * 100), c = c.replace(/\s?\%/, ""), m = t._.numberToFormat(d, c, g), t._.includes(m, ")") ? (m = m.split(""), m.splice(-1, 0, f + "%"), m = m.join("")) : m = m + f + "%", m;
        },
        unformat: function(d) {
          var c = t._.stringToNumber(d);
          return t.options.scalePercentBy100 ? c * 0.01 : c;
        }
      });
    }(), function() {
      t.register("format", "time", {
        regexps: {
          format: /(:)/,
          unformat: /(:)/
        },
        format: function(d, c, g) {
          var f = Math.floor(d / 60 / 60), m = Math.floor((d - f * 60 * 60) / 60), v = Math.round(d - f * 60 * 60 - m * 60);
          return f + ":" + (m < 10 ? "0" + m : m) + ":" + (v < 10 ? "0" + v : v);
        },
        unformat: function(d) {
          var c = d.split(":"), g = 0;
          return c.length === 3 ? (g = g + Number(c[0]) * 60 * 60, g = g + Number(c[1]) * 60, g = g + Number(c[2])) : c.length === 2 && (g = g + Number(c[0]) * 60, g = g + Number(c[1])), Number(g);
        }
      });
    }(), t;
  });
})(xn);
var Ml = xn.exports;
const Nl = /* @__PURE__ */ Il(Ml), Ee = (e) => Nl(e).format("0,0").replace(/,/g, " "), Al = T({
  name: "HighScoreBox",
  components: {
    ShrinkingTextBox: pe
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: ""
    },
    points: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    pointsFormated() {
      return Ee(Number(this.points));
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), Rl = {
  key: 0,
  class: "high-score-box-wrapper-row"
}, El = { class: "high-score-box-points-row" }, Fl = { class: "text-tp" }, Vl = {
  key: 1,
  class: "high-score-box-wrapper-row"
}, ql = { class: "high-score-box-text-row" }, Wl = { class: "high-score-box-points-row" }, Ul = { class: "text-tp" };
function Hl(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: _(["high-score-box", { "high-score-box-ssm": e.isSsm }]),
    style: b([e.style])
  }, [
    e.isSsm ? (p(), h("div", Vl, [
      l("div", ql, $(e.text), 1),
      l("div", Wl, [
        l("span", Ul, $(e.pointsFormated), 1),
        t[2] || (t[2] = K()),
        t[3] || (t[3] = l("span", { class: "icon-tp" }, null, -1))
      ])
    ])) : (p(), h("div", Rl, [
      M(r, {
        text: e.text,
        "font-size": e.isSsm ? 36 : 34,
        width: 250,
        height: 60,
        class: "high-score-box-text-row"
      }, null, 8, ["text", "font-size"]),
      l("div", El, [
        l("span", Fl, $(e.pointsFormated), 1),
        t[0] || (t[0] = K()),
        t[1] || (t[1] = l("span", { class: "icon-tp" }, null, -1))
      ])
    ]))
  ], 6);
}
const Xl = /* @__PURE__ */ S(Al, [["render", Hl]]), Gl = T({
  name: "HorizontalBalanceBar",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    numberLocation: {
      type: Number,
      required: !0
    },
    glow: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      pathImages: E
    };
  },
  computed: {
    transformCoef() {
      return `scale(${this.isScaled ? this.scaleCoef : 1})`;
    },
    numberRotate() {
      return (this.numberLocation - 0) / 100 * 88 + -44;
    }
  }
}), Yl = ["src"];
function Kl(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["horizontal-balance-bar", { disabled: e.disabled }]),
    style: b([e.style, { transform: e.transformCoef }])
  }, [
    e.glow ? (p(), h("div", {
      key: 0,
      class: "stroke",
      style: b({
        backgroundImage: `url(${e.pathImages}/horizontal-balance-bar/STROKE.png)`
      })
    }, null, 4)) : w("", !0),
    e.glow ? (p(), h("div", {
      key: 1,
      class: "glow",
      style: b({
        backgroundImage: `url(${e.pathImages}/horizontal-balance-bar/GLOW.png)`
      })
    }, null, 4)) : w("", !0),
    l("div", {
      class: "bar",
      style: b({
        backgroundImage: `url(${e.pathImages}/horizontal-balance-bar/BG_BAR.png)`
      })
    }, [
      l("img", {
        src: `${e.pathImages}/horizontal-balance-bar/BAR_ARROW.png`,
        alt: "bar-arrow",
        class: "arrow",
        style: b({ transform: `rotate(${e.numberRotate}deg) translateY(-485px)` })
      }, null, 12, Yl)
    ], 4)
  ], 6);
}
const l0 = /* @__PURE__ */ S(Gl, [["render", Kl]]), Zl = T({
  name: "HorizontalBarWithIdeal",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    glow: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    mark: {
      type: Number,
      default: 0
    },
    gradient: {
      type: Array,
      default: [0, 0, 0, 0, 0, 0, 0]
    }
  },
  data() {
    return {
      pathImages: E
    };
  },
  computed: {
    transformCoef() {
      return `scale(${this.isScaled ? this.scaleCoef : 1})`;
    },
    dynamicMark() {
      return `left: calc(${Math.floor(this.mark)}%);`;
    },
    borderImage() {
      return `${E}/start-bar/border.png`;
    },
    barMark() {
      return `${E}/start-bar/bar-pointer.png`;
    },
    backgroundGradient() {
      return `background-image: linear-gradient(to right, #e32927 ${this.gradient[0]}%, #e86e24 ${this.gradient[1]}%, #f4e805 ${this.gradient[2]}%, #53dc00 ${this.gradient[3]}%, #f4e805 ${this.gradient[4]}%, #e86e24 ${this.gradient[5]}%, #e32927 ${this.gradient[6]}%)`;
    }
  }
}), Jl = { class: "power-horizontal-bar" }, Ql = {
  key: 0,
  class: "yellow-glow"
}, ed = ["src"], td = ["src"];
function id(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "horizontal-bar-with-ideal",
    style: b([e.style, { transform: e.transformCoef }])
  }, [
    l("div", Jl, [
      e.glow ? (p(), h("div", Ql)) : w("", !0),
      l("div", {
        class: "inside-fill",
        style: b(e.backgroundGradient)
      }, null, 4),
      l("img", {
        src: e.borderImage,
        alt: "start bar",
        class: "positioner"
      }, null, 8, ed),
      l("img", {
        src: e.barMark,
        class: "mark-style special",
        style: b(e.dynamicMark)
      }, null, 12, td)
    ])
  ], 4);
}
const d0 = /* @__PURE__ */ S(Zl, [["render", id]]), sd = T({
  name: "ImpactEffect",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    isVisible: {
      type: Boolean,
      default: !1
    },
    sideX: {
      type: String,
      default: "left"
    },
    sideY: {
      type: String,
      default: "bottom"
    }
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), `scale( ${e} )`;
    },
    customClasses() {
      const e = `impact-effect-${this.sideX}`, t = `impact-effect-${this.sideY}`, i = this.isVisible ? "impact-effect-visible" : "", s = this.isMobile() ? "mobile-overlay" : "";
      return [e, t, i, s];
    },
    customStyle() {
      return { "transform-origin": `${this.sideX} ${this.sideY}` };
    }
  },
  methods: {}
});
function nd(e, t, i, s, n, o) {
  return p(), h("div", {
    style: b([{ transform: e.transformCoef }, e.customStyle]),
    class: _([e.customClasses, "impact-effect-container"])
  }, t[0] || (t[0] = [
    l("div", { class: "impact-effect" }, null, -1)
  ]), 6);
}
const u0 = /* @__PURE__ */ S(sd, [["render", nd]]), od = T({
  name: "ImpulseInputComponent",
  mixins: [P],
  props: {
    side: {
      type: String,
      default: ""
    },
    barDuration: {
      type: Number,
      default: 0
    },
    framesTotal: {
      type: Number,
      default: 0
    },
    framesCorrect: {
      type: Number,
      default: 0
    },
    framesIncorrect: {
      type: Number,
      default: 0
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    leftMessageClass: {
      type: String,
      default: ""
    },
    rightMessageClass: {
      type: String,
      default: ""
    },
    disappearTime: {
      type: Number,
      default: 1
    },
    glow: {
      type: Boolean,
      default: !1
    },
    barWidth: {
      type: Number,
      default: 406
    }
  },
  data() {
    return {
      left: {
        green: 0,
        red: 0,
        white: 0,
        barDuration: 0
      },
      right: {
        green: 0,
        red: 0,
        white: 0,
        barDuration: 0
      }
    };
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), {
        transform: `scale( ${e} )`
      };
    },
    leftGreenStyle() {
      let e = `${100 / this.left.barDuration * (this.left.green + this.left.red)}%`;
      return this.side !== "left" && (e = "0%"), {
        width: e
      };
    },
    rightGreenStyle() {
      let e = `${100 / this.right.barDuration * (this.right.green + this.right.red)}%`;
      return this.side !== "right" && (e = "0%"), {
        width: e
      };
    },
    leftPointerStyle() {
      let e = `${100 / this.left.barDuration * (this.left.green + this.left.red)}%`;
      return this.left.green === 0 && (e = "0%"), 100 / this.left.barDuration * (this.left.green + this.left.red) > 100 && (e = "100%"), {
        width: e
      };
    },
    rightPointerStyle() {
      let e = `${100 / this.right.barDuration * (this.right.green + this.right.red)}%`;
      return this.right.green === 0 && (e = "0%"), 100 / this.left.barDuration * (this.right.green + this.right.red) > 100 && (e = "100%"), {
        width: e
      };
    },
    leftRedStyle() {
      return {
        width: `${100 / this.left.barDuration * this.left.red}%`
      };
    },
    rightRedStyle() {
      return {
        width: `${100 / this.right.barDuration * this.right.red}%`
      };
    },
    leftWhiteStyle() {
      return {
        width: this.side === "left" ? `${100 / this.left.barDuration * this.left.white}%` : 0
      };
    },
    rightWhiteStyle() {
      return {
        width: this.side === "right" ? `${100 / this.right.barDuration * this.right.white}%` : 0
      };
    }
  },
  watch: {
    framesTotal: {
      handler() {
        this.handleUpdate();
      }
    },
    framesCorrect: {
      handler() {
        this.handleUpdate();
      }
    },
    framesIncorrect: {
      handler() {
        this.handleUpdate();
      }
    }
  },
  methods: {
    handleUpdate() {
      this.side === "left" && (this.left.green = this.framesCorrect, this.left.red = this.framesIncorrect, this.left.white = this.framesTotal, this.right.red = 0, this.right.white = 0, this.left.barDuration = this.barDuration), this.side === "right" && (this.right.green = this.framesCorrect, this.right.red = this.framesIncorrect, this.right.white = this.framesTotal, this.left.red = 0, this.left.white = 0, this.right.barDuration = this.barDuration);
    }
  }
}), rd = { class: "impulse-input-wrapper" }, ad = { class: "left-info" }, ld = { class: "right-info" };
function dd(e, t, i, s, n, o) {
  return p(), h("div", rd, [
    l("div", {
      class: "left",
      style: b([e.transformCoef, { "transform-origin": "right bottom" }])
    }, [
      l("div", ad, [
        J(e.$slots, "leftInfo")
      ]),
      l("div", {
        class: _(["bar left-bar", e.glow ? "yellow-glow" : ""]),
        style: b({ width: e.barWidth + "px" })
      }, [
        l("div", {
          class: _(["bar-message", e.leftMessageClass])
        }, null, 2),
        l("div", {
          class: "filled-bar",
          style: b(e.leftWhiteStyle)
        }, t[0] || (t[0] = [
          l("div", { class: "gradient gradient-white" }, null, -1)
        ]), 4),
        l("div", {
          class: "filled-bar",
          style: b(e.leftGreenStyle)
        }, t[1] || (t[1] = [
          l("div", { class: "gradient gradient-green" }, null, -1)
        ]), 4),
        l("div", {
          class: "filled-bar",
          style: b(e.leftRedStyle)
        }, t[2] || (t[2] = [
          l("div", { class: "gradient gradient-red" }, null, -1)
        ]), 4),
        l("div", {
          class: "filled-bar",
          style: b(e.leftPointerStyle)
        }, t[3] || (t[3] = [
          l("div", { class: "pointer" }, null, -1)
        ]), 4)
      ], 6)
    ], 4),
    l("div", {
      class: "right",
      style: b([e.transformCoef, { "transform-origin": "left bottom" }])
    }, [
      l("div", {
        class: _(["bar right-bar", e.glow ? "yellow-glow" : ""]),
        style: b({ width: e.barWidth + "px" })
      }, [
        l("div", {
          class: _(["bar-message", e.rightMessageClass])
        }, null, 2),
        l("div", {
          class: "filled-bar",
          style: b(e.rightWhiteStyle)
        }, t[4] || (t[4] = [
          l("div", { class: "gradient gradient-white" }, null, -1)
        ]), 4),
        l("div", {
          class: "filled-bar",
          style: b(e.rightGreenStyle)
        }, t[5] || (t[5] = [
          l("div", { class: "gradient gradient-green" }, null, -1)
        ]), 4),
        l("div", {
          class: "filled-bar",
          style: b(e.rightRedStyle)
        }, t[6] || (t[6] = [
          l("div", { class: "gradient gradient-red" }, null, -1)
        ]), 4),
        l("div", {
          class: "filled-bar",
          style: b(e.rightPointerStyle)
        }, t[7] || (t[7] = [
          l("div", { class: "pointer" }, null, -1)
        ]), 4)
      ], 6),
      l("div", ld, [
        J(e.$slots, "rightInfo")
      ])
    ], 4)
  ]);
}
const c0 = /* @__PURE__ */ S(od, [["render", dd]]), ud = T({
  name: "InfoBox",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  },
  data() {
    return {
      pathImages: E,
      waitingState: mt()
    };
  },
  computed: {
    transformCoef() {
      return `translateX(-50%) scale(${this.scaleCoef})`;
    }
  },
  mounted() {
    U.to(".waiting-circle", {
      rotation: 360,
      repeat: -1,
      ease: "none"
    });
  }
}), cd = ["src"];
function pd(e, t, i, s, n, o) {
  return p(), h("img", {
    class: "waiting-circle",
    src: `${e.pathImages}/loading/LOADING_CIRCLE.png`,
    alt: "waiting"
  }, null, 8, cd);
}
const es = /* @__PURE__ */ S(ud, [["render", pd]]), hd = T({
  name: "InfoBox",
  components: {
    WaitingComponent: es
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      showBorder: !1,
      isSsm: !1,
      waitingState: mt()
    };
  },
  computed: {
    transformCoef() {
      const e = this.scaleCoef;
      return this.isScaled ? {
        transform: `translateX(-50%) scale(${e})`,
        "transform-origin": "center bottom",
        left: "50%"
      } : {};
    },
    italicStyle() {
      return this.isSsm ? {} : { fontStyle: "italic" };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm", this.showBorder = this.isSsm;
  }
}), fd = { key: 1 }, md = {
  key: 0,
  class: "border-top"
}, gd = {
  key: 1,
  class: "border-bottom"
}, yd = { key: 1 }, vd = {
  key: 0,
  class: "border-top"
}, bd = {
  key: 1,
  class: "border-bottom"
};
function $d(e, t, i, s, n, o) {
  const r = L("waiting-component");
  return p(), h("div", {
    class: "info-box pointer-events-auto",
    style: b([e.style, e.transformCoef])
  }, [
    e.isMobile() ? (p(), h("div", {
      key: 0,
      class: "info-box-mobile",
      style: b(e.italicStyle)
    }, [
      e.waitingState.isWaiting ? (p(), V(r, { key: 0 })) : (p(), h("section", fd, [
        e.showBorder ? (p(), h("div", md)) : w("", !0),
        K(" " + $(e.$t("tapToContinue")) + " ", 1),
        e.showBorder ? (p(), h("div", gd)) : w("", !0)
      ]))
    ], 4)) : (p(), h("div", {
      key: 1,
      class: "info-box-desktop",
      style: b(e.italicStyle)
    }, [
      e.waitingState.isWaiting ? (p(), V(r, { key: 0 })) : (p(), h("section", yd, [
        e.showBorder ? (p(), h("div", vd)) : w("", !0),
        l("span", null, $(e.$t("clickToContinue")), 1),
        e.showBorder ? (p(), h("div", bd)) : w("", !0)
      ]))
    ], 4))
  ], 4);
}
const kd = /* @__PURE__ */ S(hd, [["render", $d]]), _d = T({
  name: "LandingBox",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    text1: {
      type: String,
      required: !1,
      default: ""
    },
    text2: {
      type: String,
      default: ""
    },
    text3: {
      type: String,
      default: ""
    },
    color: {
      type: Number,
      default: 0
    }
  },
  emits: ["close"],
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef}) translate(-50%, 0)`
      };
    },
    colorClass() {
      let e = "green";
      return this.color === 1 && (e = "orange"), this.color === 2 && (e = "red"), e;
    }
  }
}), wd = { class: "landing-box-first-line" }, Td = { class: "landing-box-second-line-text" }, Sd = { class: "landing-box-third-line-text" };
function xd(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "landing-box",
    style: b([e.style, e.transformCoef])
  }, [
    l("div", wd, [
      l("span", {
        class: _(["landing-box-first-line-text", e.colorClass])
      }, $(e.text1), 3)
    ]),
    l("div", {
      class: _(["landing-box-second-line", e.text3.length > 0 ? "third-active" : ""])
    }, [
      t[0] || (t[0] = l("div", { class: "border-top" }, null, -1)),
      l("span", Td, $(e.text2), 1),
      l("span", Sd, $(e.text3), 1),
      t[1] || (t[1] = l("div", { class: "border-bottom" }, null, -1))
    ], 2)
  ], 4);
}
const p0 = /* @__PURE__ */ S(_d, [["render", xd]]), Cd = T({
  name: "LoadingCircleOverlay",
  components: {
    WaitingComponent: es
  },
  mixins: [P],
  data() {
    return {
      loadingCircleState: Rn()
    };
  }
});
function zd(e, t, i, s, n, o) {
  const r = L("waiting-component");
  return e.loadingCircleState.isActive ? (p(), h("section", {
    key: 0,
    class: _(["game-in-black", e.isMobile() ? "mobile-game-in-black" : ""])
  }, [
    M(r)
  ], 2)) : w("", !0);
}
const h0 = /* @__PURE__ */ S(Cd, [["render", zd], ["__scopeId", "data-v-2ae774c6"]]), jd = T({
  name: "MenuOverlay",
  mixins: [P],
  data() {
    return {
      pathImages: E,
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isSsm || (e = 1), `scale(${e})`;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), Bd = { class: "paused-text" }, Pd = ["src"], Dd = { key: 1 };
function Ld(e, t, i, s, n, o) {
  return p(), h("section", {
    onMousedown: t[0] || (t[0] = A(() => {
    }, ["stop"])),
    onMouseup: t[1] || (t[1] = A(() => {
    }, ["stop"])),
    onTouchstart: t[2] || (t[2] = A(() => {
    }, ["stop"])),
    onTouchend: t[3] || (t[3] = A(() => {
    }, ["stop"])),
    onClick: t[4] || (t[4] = A(() => {
    }, ["stop"]))
  }, [
    l("div", {
      class: _(["menu-overlay", e.isMobile() ? "mobile-menu-overlay" : ""])
    }, null, 2),
    l("div", {
      class: "text-wrapper",
      style: b([{ transform: e.transformCoef }])
    }, [
      l("div", Bd, [
        e.isSsm ? (p(), h("img", {
          key: 0,
          src: `${e.pathImages}/common/paused.png`,
          alt: ""
        }, null, 8, Pd)) : (p(), h("span", Dd, $(e.$t("utPaused")), 1))
      ])
    ], 4)
  ], 32);
}
const f0 = /* @__PURE__ */ S(jd, [["render", Ld]]), Od = T({
  name: "PowerIconSlot",
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  }
});
function Id(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "icon-slot",
    style: b([e.style]),
    onMousedown: t[0] || (t[0] = A(() => {
    }, ["stop"])),
    onMouseup: t[1] || (t[1] = A(() => {
    }, ["stop"])),
    onTouchstart: t[2] || (t[2] = A(() => {
    }, ["stop"])),
    onTouchend: t[3] || (t[3] = A(() => {
    }, ["stop"])),
    onClick: t[4] || (t[4] = A(() => {
    }, ["stop"]))
  }, [
    J(e.$slots, "default")
  ], 36);
}
const ri = /* @__PURE__ */ S(Od, [["render", Id]]), Md = T({
  name: "TooltipComponent",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    /**
     * Text to display
     */
    text: {
      type: String,
      default: ""
    },
    /**
     * Sirka textu
     */
    textWidth: {
      type: Number,
      default: 250
    },
    /**
     * Ci sa ma zobrazovat tooltip
     */
    active: {
      type: Boolean,
      default: !0
    },
    /**
     * which to display the arrow on
     * Values: left | right | top | bottom | undefined
     */
    side: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * Header can be defined
     */
    headerText: {
      type: String,
      required: !1,
      default: null
    },
    verticalAdjust: {
      type: Number,
      default: 0
    },
    horizontalAdjust: {
      type: Number,
      default: 0
    },
    arrowVerticalAdjust: {
      type: String,
      default: ""
    },
    arrowHorizontalAdjust: {
      type: String,
      default: ""
    },
    clickType: {
      type: Boolean,
      default: !1
    },
    /** kliknutim na tooltip klikneme na element na ktory tooltip ukazuje */
    clickPropagatesToSlot: {
      type: Boolean,
      default: !1
    },
    minHeight: {
      type: Number,
      default: 80
    },
    minWidth: {
      type: Number,
      default: 200
    }
  },
  data() {
    return {
      isActive: !1,
      tooltipWidth: 0,
      tooltipHeight: 0,
      tooltipShiftTop: 0,
      tooltipShiftBottom: 0,
      tooltipShiftRight: 0,
      tooltipShiftLeft: 0,
      isSsm: !1
    };
  },
  computed: {
    basicStyle() {
      let e = {};
      return this.side === "right" && (e = {
        top: `${this.tooltipShiftTop}px`,
        right: `${this.tooltipShiftRight}px`,
        height: `${this.tooltipHeight}px`
      }), this.side === "left" && (e = {
        top: `${this.tooltipShiftTop}px`,
        left: `${this.tooltipShiftLeft}px`,
        height: `${this.tooltipHeight}px`
      }), this.side === "top" && (e = {
        left: `${this.tooltipShiftLeft}px`,
        bottom: `${this.tooltipShiftBottom}px`,
        height: `${this.tooltipHeight}px`
      }), this.side === "bottom" && (e = {
        left: `${this.tooltipShiftLeft}px`,
        top: `${this.tooltipShiftTop}px`,
        height: `${this.tooltipHeight}px`
      }), this.hasContent || (e = {
        ...e,
        padding: "0 25px"
      }), e = {
        ...e,
        minWidth: `${this.minWidth}px`,
        minHeight: `${this.minHeight}px`
      }, e;
    },
    hasContent() {
      return !!this.$slots.content;
    },
    arrowStyle() {
      return this.side === "left" ? {
        left: this.arrowHorizontalAdjust.length > 0 ? this.arrowHorizontalAdjust : "-30px"
      } : this.side === "right" ? {
        right: this.arrowHorizontalAdjust.length > 0 ? this.arrowHorizontalAdjust : "-30px"
      } : this.side === "bottom" ? {
        left: this.arrowHorizontalAdjust.length > 0 ? this.arrowHorizontalAdjust : "50%",
        bottom: this.arrowVerticalAdjust.length > 0 ? this.arrowVerticalAdjust : "-35px",
        transform: "rotate(90deg), translate(-50%)"
      } : this.side === "top" ? {
        left: this.arrowHorizontalAdjust.length > 0 ? this.arrowHorizontalAdjust : "50%",
        top: this.arrowVerticalAdjust.length > 0 ? this.arrowVerticalAdjust : "-30px",
        transform: "translate(-50%)"
      } : null;
    },
    arrowSide() {
      return `arrow-${this.side}`;
    },
    borderSide() {
      return `border-${this.side}`;
    },
    showTooltip() {
      return this.isActive && !this.isMobile() || this.isMobile() && this.clickType && this.isActive || this.isMobile() && !this.clickType;
    }
  },
  watch: {
    isActive(e) {
      e && this.$nextTick(() => {
        this.positionTooltip();
      });
    }
  },
  mounted() {
    this.defineEvents(), this.positionTooltip();
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    onTooltipClick() {
      this.activate(), this.clickSlot();
    },
    activate() {
      this.isMobile() && this.clickType && (this.isActive = !this.isActive);
    },
    clickSlot() {
      if (!this.clickPropagatesToSlot || !this.isMobile()) return;
      this.$refs.childComponent.children[0].click();
    },
    defineEvents() {
      if (this.isMobile()) return;
      const e = this.$refs.childComponent;
      e.addEventListener(
        "mouseover",
        () => {
          this.isActive = !0;
        }
      ), e.addEventListener(
        "mouseleave",
        () => {
          this.isActive = !1;
        }
      );
    },
    positionTooltip() {
      const e = this.$refs.childComponent, t = this.$refs.tooltipContainer;
      if (t) {
        if (this.tooltipWidth = t.clientWidth, this.tooltipHeight = t.clientHeight, this.side === "right") {
          const i = e == null ? void 0 : e.children[0].clientWidth;
          this.tooltipShiftRight = i + this.horizontalAdjust;
        }
        this.side === "left" && (this.tooltipShiftLeft = this.tooltipWidth * 1, this.horizontalAdjust !== 0 && (this.tooltipShiftLeft = -this.tooltipWidth - this.horizontalAdjust)), this.side === "top" && (this.tooltipShiftLeft = this.tooltipWidth / -2, this.tooltipShiftBottom = -1.3 * this.tooltipHeight, this.verticalAdjust !== 0 && (this.tooltipShiftBottom = -this.tooltipHeight - this.verticalAdjust), this.horizontalAdjust !== 0 && (this.tooltipShiftLeft = this.tooltipWidth / -2 + this.horizontalAdjust)), this.side === "bottom" && (this.tooltipShiftLeft = this.tooltipWidth / -2, this.tooltipShiftTop = -1.3 * this.tooltipHeight, this.verticalAdjust !== 0 && (this.tooltipShiftTop = -this.tooltipHeight - this.verticalAdjust), this.horizontalAdjust !== 0 && (this.tooltipShiftLeft = this.tooltipWidth / -2 + this.horizontalAdjust));
      }
    }
  }
}), Nd = { class: "tooltip-wrapper" }, Ad = {
  key: 0,
  class: "tooltip-header"
}, Rd = { class: "tooltip-text" };
function Ed(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    ref: "childComponent",
    class: _(["tooltip", { "tooltip-ssm": e.isSsm }]),
    onClick: t[0] || (t[0] = (a) => e.onTooltipClick())
  }, [
    J(e.$slots, "default"),
    e.showTooltip && e.active ? (p(), h("div", {
      key: 0,
      ref: "tooltipContainer",
      class: _(["tooltip-container", e.borderSide]),
      style: b([
        e.basicStyle,
        e.style
      ])
    }, [
      l("div", {
        class: _(["arrow", e.arrowSide]),
        style: b(e.arrowStyle ?? void 0)
      }, null, 6),
      J(e.$slots, "content", {}, () => [
        l("div", Nd, [
          e.headerText ? (p(), h("div", Ad, [
            M(r, {
              text: e.headerText,
              width: e.textWidth,
              height: 80,
              "font-size": 48
            }, null, 8, ["text", "width"])
          ])) : w("", !0),
          l("div", Rd, [
            M(r, {
              text: e.text,
              width: e.textWidth,
              height: 60,
              "font-size": e.isSsm ? 32 : 28
            }, null, 8, ["text", "width", "font-size"])
          ])
        ])
      ])
    ], 6)) : w("", !0)
  ], 2);
}
const qt = /* @__PURE__ */ S(Md, [["render", Ed]]), Fd = T({
  name: "MenuComponent",
  components: {
    PowerIconSlot: ri,
    Tooltip: qt
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    exitFlashing: {
      type: Boolean,
      required: !1,
      default: !1
    },
    showExit: {
      type: Boolean,
      default: !0
    },
    toggleAutomatic: {
      default: !1,
      type: Boolean
    },
    showEsc: {
      default: !1,
      type: Boolean
    },
    lockMenu: {
      default: !1,
      type: Boolean
    }
  },
  emits: ["settingsAction", "instructionsAction", "exitAction", "onToggle"],
  data() {
    return {
      pathImages: E,
      isOpen: !1,
      isSsm: !1
    };
  },
  computed: {
    iconStyle() {
      return {
        transform: this.isSsm ? "" : "skewX(-8deg)",
        margin: "0.25em 0"
      };
    },
    basicStyle() {
      return {
        transform: `scale(${this.scaleCoef})`,
        "transform-origin": "100% 0"
      };
    },
    menuIconSrc() {
      return `${E}/icons/menu.png`;
    },
    settingsIconSrc() {
      return `${E}/icons/settings.png`;
    },
    infoIconSrc() {
      return `${E}/icons/instructions.png`;
    },
    exitIconSrc() {
      return `${E}/icons/exit.png`;
    }
  },
  watch: {
    toggleAutomatic(e) {
      this.isOpen = e;
    },
    isOpen(e) {
      this.$emit("onToggle", e);
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    toggle() {
      this.lockMenu || (this.isOpen = !this.isOpen);
    },
    closeAndCallEmit(e) {
      this.isOpen = !1, this.$emit(e);
    }
  }
}), Vd = ["src"], qd = {
  key: 0,
  class: "esc"
}, Wd = {
  key: 0,
  style: { "z-index": 1, position: "relative" }
}, Ud = ["src"], Hd = ["src"], Xd = ["src"];
function Gd(e, t, i, s, n, o) {
  const r = L("power-icon-slot"), a = L("tooltip");
  return p(), h("div", {
    class: _(["menu", { "menu-ssm": e.isSsm }]),
    style: b([e.style, e.basicStyle]),
    onMousedown: t[3] || (t[3] = A(() => {
    }, ["stop"])),
    onMouseup: t[4] || (t[4] = A(() => {
    }, ["stop"])),
    onTouchstart: t[5] || (t[5] = A(() => {
    }, ["stop"])),
    onTouchend: t[6] || (t[6] = A(() => {
    }, ["stop"]))
  }, [
    M(r, {
      class: _(["menu-icon", [e.isOpen ? "active-menu-icon" : "inactive-menu-icon"]]),
      style: b([e.iconStyle, { "z-index": 101, position: "relative" }]),
      onClick: A(e.toggle, ["stop"])
    }, {
      default: F(() => [
        l("img", {
          src: e.menuIconSrc,
          class: "icon-fix",
          alt: ""
        }, null, 8, Vd)
      ]),
      _: 1
    }, 8, ["style", "class", "onClick"]),
    e.showEsc ? (p(), h("div", qd, " (ESC) ")) : w("", !0),
    M(ks, { name: "fade" }, {
      default: F(() => [
        e.isOpen ? (p(), h("div", Wd, [
          M(a, {
            text: e.$t("settings"),
            side: "right",
            style: { width: "250px", "margin-top": "7px" },
            "horizontal-adjust": 50
          }, {
            default: F(() => [
              M(r, {
                class: "settings-icon inactive-menu-icon",
                style: b(e.iconStyle),
                onClick: t[0] || (t[0] = A((u) => e.closeAndCallEmit("settingsAction"), ["stop"]))
              }, {
                default: F(() => [
                  l("img", {
                    src: e.settingsIconSrc,
                    class: "icon-fix",
                    alt: ""
                  }, null, 8, Ud)
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }, 8, ["text"]),
          M(a, {
            text: e.$t("instructions"),
            side: "right",
            style: { width: "250px", "margin-top": "7px" },
            "horizontal-adjust": 50
          }, {
            default: F(() => [
              M(r, {
                class: "instructions-icon inactive-menu-icon",
                style: b(e.iconStyle),
                onClick: t[1] || (t[1] = A((u) => e.closeAndCallEmit("instructionsAction"), ["stop"]))
              }, {
                default: F(() => [
                  l("img", {
                    src: e.infoIconSrc,
                    class: "icon-fix",
                    alt: ""
                  }, null, 8, Hd)
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }, 8, ["text"]),
          e.showExit ? (p(), V(a, {
            key: 0,
            text: e.$t("quit"),
            side: "right",
            style: b({ width: "250px", "margin-right": e.isSsm ? "" : "-5px", "margin-top": "7px" }),
            "horizontal-adjust": 50
          }, {
            default: F(() => [
              M(r, {
                class: _(["exit-icon inactive-menu-icon", [e.exitFlashing ? "exit-flashing" : ""]]),
                style: b([e.iconStyle, { "padding-left": e.isSsm ? 0 : "5px" }]),
                onClick: t[2] || (t[2] = A((u) => e.closeAndCallEmit("exitAction"), ["stop"]))
              }, {
                default: F(() => [
                  l("img", {
                    src: e.exitIconSrc,
                    class: "icon-fix",
                    alt: ""
                  }, null, 8, Xd)
                ]),
                _: 1
              }, 8, ["class", "style"])
            ]),
            _: 1
          }, 8, ["text", "style"])) : w("", !0)
        ])) : w("", !0)
      ]),
      _: 1
    })
  ], 38);
}
const m0 = /* @__PURE__ */ S(Fd, [["render", Gd]]), Yd = T({
  name: "MissedText",
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  },
  data() {
    return {
      pathImages: E,
      actualVals: {
        scale: 0,
        opacity: 0,
        bottom: 110
      },
      tweenScale: null,
      tweenOpacity: null,
      tweenHideComponent: null,
      tweenBottom: null,
      showComponent: !1
    };
  },
  computed: {
    getScaleAndOpacity() {
      return `
      opacity: ${this.actualVals.opacity};
      transform: scale(${this.actualVals.scale});
      bottom: ${this.actualVals.bottom}px;`;
    }
  },
  mounted() {
    this.startAnimation();
  },
  methods: {
    getConfig() {
      return {
        // na ake hodnoty nastavujeme ked nieje vidno element
        initValues: {
          scale: 0,
          opacity: 0
        },
        // kam najprv chceme dostat scale
        scaleFirst: {
          value: 1,
          seconds: 0.5
        },
        // po kolkych sekundach po zacati scalovania zacneme nastavovat opacity
        opacityStartSeconds: 0.1,
        // kam najprv chceme dostat opacity
        opacityFirst: {
          value: 1,
          seconds: 0.4
        },
        // ako dlho cakame bez zmeny po dosiahnuti prveho ciela
        pauseSeconds: {
          scale: 0.5,
          opacity: 0.5
        },
        // ako chceme nastavit scale na konci
        scaleFinal: {
          value: 1.5,
          seconds: 0.5
        },
        // ako chceme nastavit opacity na konci
        opacityFinal: {
          value: 0,
          seconds: 0.5
        },
        // Zmena vysky missed
        bottomFinal: {
          value: 250,
          seconds: 1.5
        }
      };
    },
    startAnimation() {
      this.tweenScale && this.tweenScale.kill(), this.tweenOpacity && this.tweenOpacity.kill(), this.tweenHideComponent && this.tweenHideComponent.kill(), this.tweenBottom && this.tweenBottom.kill(), this.showComponent = !0;
      const e = this.getConfig();
      this.tweenScale = U.timeline().to(this.actualVals, {
        // zvacsime
        duration: e.scaleFirst.seconds,
        scale: e.scaleFirst.value
      }).to({}, {
        // cakame
        duration: e.pauseSeconds.scale
      }).to(this.actualVals, {
        // zmensujeme
        scale: e.scaleFinal.value,
        duration: e.scaleFinal.seconds
      }), this.tweenOpacity = U.timeline().to({}, {
        // cakame na zaciatku
        duration: e.opacityStartSeconds
      }).to(this.actualVals, {
        // zvacsime
        duration: e.opacityFirst.seconds,
        opacity: e.opacityFirst.value
      }).to({}, {
        // cakame
        duration: e.pauseSeconds.opacity
      }).to(this.actualVals, {
        // zmensujeme
        opacity: e.opacityFinal.value,
        duration: e.opacityFinal.seconds
      }), this.tweenBottom = U.timeline().to(
        this.actualVals,
        {
          // posuvame hore
          duration: e.bottomFinal.seconds,
          bottom: e.bottomFinal.value
        }
      );
      const t = Math.max(
        e.scaleFirst.seconds + e.pauseSeconds.scale + e.scaleFinal.seconds,
        e.opacityStartSeconds + e.opacityFirst.seconds + e.pauseSeconds.opacity + e.opacityFinal.seconds
      );
      this.tweenHideComponent = U.to({}, {
        duration: t,
        onComplete: () => {
          this.showComponent = !1;
        }
      });
    }
  }
}), Kd = ["src"];
function Zd(e, t, i, s, n, o) {
  return e.showComponent ? (p(), h("div", {
    key: 0,
    style: b(e.getScaleAndOpacity),
    class: "missed-text"
  }, [
    l("img", {
      src: `${e.pathImages}/push-bar/MISSED-TEXT.png`
    }, null, 8, Kd)
  ], 4)) : w("", !0);
}
const Jd = /* @__PURE__ */ S(Yd, [["render", Zd]]), Qd = T({
  name: "PowerMobileButton",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    glow: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    disabledAnimationActive: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      active: !1,
      pathImages: E,
      isSsm: !1,
      tweenLayer1: null,
      tweenLayer2: null
    };
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), !this.active || this.disabled ? `scale(${e})` : `scale(${e * 0.95})`;
    },
    decideBackgroundImage() {
      return this.isSsm ? "url(https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/mobile-input/btn-bg-ssm.png)" : `url(${E}/mobile-button/BG_BUTTON.png)`;
    },
    decideImage() {
      return this.isSsm ? `https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/mobile-input/btn_${this.type}.png` : `${this.pathImages}/mobile-button/inside/btn_${this.type}.png`;
    },
    decideHigher() {
      return this.type === "speed-up-skating-l" || this.type === "speed-up-skating-r";
    }
  },
  watch: {
    disabled: {
      handler(e) {
        var t, i;
        this.disabledAnimationActive && ((t = this.tweenLayer1) == null || t.kill(), (i = this.tweenLayer2) == null || i.kill(), this.tweenLayer1 = U.to(
          `#layer-1-${this.type}`,
          {
            duration: 0,
            opacity: e ? 0 : 1
          }
        ), this.tweenLayer2 = U.to(
          `#layer-2-${this.type}`,
          {
            duration: e ? 0 : 1,
            opacity: e ? 0.5 : 0,
            scale: e ? this.isScaled ? this.scaleCoef : 1 : this.scaleCoef * 2
          }
        ));
      }
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), eu = ["id"], tu = {
  key: 0,
  class: "yellow-glow"
}, iu = {
  id: "button-element",
  class: "button-element"
}, su = ["id"], nu = {
  key: 0,
  class: "yellow-glow"
}, ou = {
  id: "button-element",
  class: "button-element"
};
function ru(e, t, i, s, n, o) {
  return p(), h("div", null, [
    e.disabledAnimationActive ? (p(), h("button", {
      key: 0,
      id: `layer-2-${e.type}`,
      style: b([
        { backgroundImage: e.decideBackgroundImage },
        { transform: e.transformCoef },
        e.style,
        { position: "absolute" }
      ]),
      class: _(["power-mobile-button", { "power-mobile-button-ssm": e.isSsm }, "disabled"]),
      onMousedown: t[0] || (t[0] = A((r) => e.active = !0, ["prevent"])),
      onMouseup: t[1] || (t[1] = A((r) => e.active = !1, ["prevent"])),
      onTouchstart: t[2] || (t[2] = A((r) => e.active = !0, ["prevent"])),
      onTouchend: t[3] || (t[3] = A((r) => e.active = !1, ["prevent"]))
    }, [
      e.glow ? (p(), h("div", tu)) : w("", !0),
      l("div", iu, [
        l("div", {
          style: b({ backgroundImage: "url(" + e.decideImage + ")" }),
          class: _(["image", e.decideHigher ? "higher" : ""])
        }, null, 6)
      ])
    ], 46, eu)) : w("", !0),
    l("button", {
      id: `layer-1-${e.type}`,
      style: b([
        { backgroundImage: e.decideBackgroundImage },
        { transform: e.transformCoef },
        e.style
      ]),
      class: _(["power-mobile-button", { disabled: e.disabled }, { "power-mobile-button-ssm": e.isSsm }]),
      onMousedown: t[4] || (t[4] = A((r) => e.active = !0, ["prevent"])),
      onMouseup: t[5] || (t[5] = A((r) => e.active = !1, ["prevent"])),
      onTouchstart: t[6] || (t[6] = A((r) => e.active = !0, ["prevent"])),
      onTouchend: t[7] || (t[7] = A((r) => e.active = !1, ["prevent"]))
    }, [
      e.glow ? (p(), h("div", nu)) : w("", !0),
      l("div", ou, [
        l("div", {
          style: b({ backgroundImage: "url(" + e.decideImage + ")" }),
          class: _(["image", e.decideHigher ? "higher" : ""])
        }, null, 6)
      ])
    ], 46, su)
  ]);
}
const au = /* @__PURE__ */ S(Qd, [["render", ru]]), lu = T({
  name: "MovementButtons",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    /**
     * orientation of the button
     * value: "horizontal" || "vertical"
     */
    orientation: {
      type: String,
      required: !1,
      default: "horizontal"
    },
    bgLeftActive: {
      type: Boolean,
      default: !1
    },
    bgRightActive: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    glow: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "default"
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["position", "endContact"],
  data() {
    return {
      pathImages: E,
      isPressedLeft: !1,
      isPressedRight: !1,
      value: 0,
      leftButton: null,
      rightButton: null,
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), this.orientation === "vertical" ? `rotate(-90deg) scale(${e})` : `scale(${e})`;
    },
    leftButtonStyle() {
      return this.orientation === "vertical" ? {
        backgroundImage: `url(${this.pathImages}/movement-buttons/BTN_ICO_MINUS.png)`,
        transform: "rotate(90deg)"
      } : {
        backgroundImage: `url(${this.pathImages}/movement-buttons/BTN_ICO_ARROW_LEFT.png)`
      };
    },
    rightButtonStyle() {
      return this.orientation === "vertical" ? {
        backgroundImage: `url(${this.pathImages}/movement-buttons/BTN_ICO_PLUS.png)`,
        transform: "rotate(90deg)"
      } : {
        backgroundImage: `url(${this.pathImages}/movement-buttons/BTN_ICO_ARROW_RIGHT.png)`
      };
    },
    leftButtonBgStyle() {
      if (this.type === "paddle")
        return {
          backgroundImage: `url(${this.pathImages}/movement-buttons/btn-left-kayak.png)`
        };
      if (this.bgLeftActive)
        return {
          backgroundImage: `url(${this.pathImages}/movement-buttons/BTN_BG_LEFT_ACTIVE.png)`
        };
      const e = this.isSsm ? "btn-left" : "BTN_BG_LEFT";
      return { backgroundImage: `url(${this.pathImages}/movement-buttons/${e}.png)` };
    },
    rightButtonBgStyle() {
      if (this.type === "paddle")
        return {
          backgroundImage: `url(${this.pathImages}/movement-buttons/btn-right-kayak.png)`
        };
      if (this.bgRightActive)
        return {
          backgroundImage: `url(${this.pathImages}/movement-buttons/BTN_BG_RIGHT_ACTIVE.png)`
        };
      const e = this.isSsm ? "btn-right" : "BTN_BG_RIGHT";
      return { backgroundImage: `url(${this.pathImages}/movement-buttons/${e}.png)` };
    }
  },
  mounted() {
    this.registerEventsInner();
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    registerEventsInner() {
      const e = this.$refs.buttonLeft, t = this.$refs.buttonRight;
      !e || !t || ("ontouchstart" in document.documentElement ? (e.addEventListener("touchstart", this.onMouseDownLeft), e.addEventListener("touchend", this.onMouseUpLeft), t.addEventListener("touchstart", this.onMouseDownRight), t.addEventListener("touchend", this.onMouseUpRight)) : (e.addEventListener("mousedown", this.onMouseDownLeft), e.addEventListener("mouseup", this.onMouseUpLeft), t.addEventListener("mousedown", this.onMouseDownRight), t.addEventListener("mouseup", this.onMouseUpRight)));
    },
    // event: TouchEvent | MouseEvent
    onMouseDownLeft() {
      this.disabled || (this.isPressedLeft = !0, this.value--, this.$emit("position", this.value));
    },
    onMouseUpLeft() {
      this.disabled || (this.isPressedLeft = !1, this.value = 0, this.$emit("endContact"));
    },
    onMouseDownRight() {
      this.disabled || (this.isPressedRight = !0, this.value++, this.$emit("position", this.value));
    },
    onMouseUpRight() {
      this.disabled || (this.isPressedRight = !1, this.value = 0, this.$emit("endContact"));
    }
  }
}), du = {
  key: 0,
  class: "yellow-glow"
}, uu = {
  key: 0,
  class: "image-container"
}, cu = {
  key: 0,
  class: "image-container"
};
function pu(e, t, i, s, n, o) {
  return p(), h("div", {
    style: b([e.style, { transform: e.transformCoef }]),
    class: _(["mobile-buttons-container", { disabled: e.disabled }])
  }, [
    e.glow ? (p(), h("div", du)) : w("", !0),
    l("button", {
      id: "directionButtonLeft",
      ref: "buttonLeft",
      class: _(["direction-button left", { "is-clicked": e.isPressedLeft }]),
      style: b(e.leftButtonBgStyle)
    }, [
      e.isSsm ? w("", !0) : (p(), h("div", uu, [
        l("div", {
          class: "image",
          style: b(e.leftButtonStyle)
        }, null, 4)
      ]))
    ], 6),
    l("button", {
      id: "directionButtonRight",
      ref: "buttonRight",
      class: _(["direction-button right", { "is-clicked": e.isPressedRight }]),
      style: b(e.rightButtonBgStyle)
    }, [
      e.isSsm ? w("", !0) : (p(), h("div", cu, [
        l("div", {
          class: "image",
          style: b(e.rightButtonStyle)
        }, null, 4)
      ]))
    ], 6)
  ], 6);
}
const g0 = /* @__PURE__ */ S(lu, [["render", pu]]), hu = T({
  name: "SmallMovementButton",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    type: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    text: {
      type: String,
      default: ""
    },
    glow: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      pathImages: E,
      active: !1
    };
  },
  computed: {
    transformClick() {
      return this.active ? { transform: `scale(${1 * 0.95})` } : { transform: "scale(1)" };
    },
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), `scale(${e})`;
    },
    basicStyle() {
      let e = "unset", t = "unset", i = "translate(50%, -50%)";
      return this.type === "double-arrow-right" ? e = "580px" : (i = " translate(-50%, -50%)", t = "580px"), {
        transform: `${this.transformCoef} ${i}`,
        right: e,
        left: t,
        bottom: "-290px"
      };
    },
    additionalStyle() {
      return this.type === "double-arrow-right" ? {
        backgroundImage: `url(${this.pathImages}/mobile-button/DOUBLE-ARROW.png)`
      } : this.type === "double-arrow-left" ? {
        backgroundImage: `url(${this.pathImages}/mobile-button/DOUBLE-ARROW.png)`,
        transform: "rotate(180deg)"
      } : {};
    }
  }
}), fu = {
  key: 0,
  class: "tutorial-keyboard-header"
}, mu = {
  key: 0,
  class: "yellow-glow"
}, gu = {
  id: "button-element",
  class: "button-element"
};
function yu(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: "small-movement-button-container",
    style: b([e.basicStyle]),
    onMousedown: t[0] || (t[0] = A((a) => e.active = !0, ["stop"])),
    onMouseup: t[1] || (t[1] = A((a) => e.active = !1, ["stop"])),
    onTouchstart: t[2] || (t[2] = A((a) => e.active = !0, ["stop"])),
    onTouchend: t[3] || (t[3] = A((a) => e.active = !1, ["stop"]))
  }, [
    e.text.length > 0 ? (p(), h("section", fu, [
      M(r, {
        text: e.text,
        "font-size": 28,
        width: 256,
        height: 36
      }, null, 8, ["text"])
    ])) : w("", !0),
    l("div", {
      class: "small-movement-button-wrapper",
      style: b([e.transformClick])
    }, [
      e.glow ? (p(), h("div", mu)) : w("", !0),
      l("div", {
        class: _(["small-movement-button", { disabled: e.disabled }])
      }, [
        l("div", gu, [
          l("div", {
            style: b(e.additionalStyle),
            class: "image"
          }, null, 4)
        ])
      ], 2)
    ], 4)
  ], 36);
}
const vu = /* @__PURE__ */ S(hu, [["render", yu]]), bu = T({
  name: "MovementSides",
  components: {
    MobileButton: au,
    SmallMovementButton: vu
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    styleOuter: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    styleInner: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    leftStyle: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    rightStyle: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    glowOuter: {
      type: Boolean,
      default: !1
    },
    glowInner: {
      type: Boolean,
      default: !1
    },
    showInnerButtons: {
      type: Boolean,
      default: !1
    },
    glow: {
      type: Boolean,
      default: !1
    },
    rightText: {
      type: String,
      default: ""
    },
    leftText: {
      type: String,
      default: ""
    },
    ignoreSafeZones: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "arrow"
    }
  },
  emits: ["position", "endContact", "positionInner", "endContactInner"],
  data() {
    return {
      isPressedLeft: !1,
      isPressedRight: !1,
      isPressedLeftInner: !1,
      isPressedRightInner: !1,
      value: 0,
      valueInner: 0
    };
  },
  computed: {
    transformCoef() {
      return `scale(${this.scaleCoef})`;
    }
  },
  mounted() {
    this.registerEventsOuter(), this.registerEventsInner();
  },
  methods: {
    registerEventsOuter() {
      const e = this.$refs.arrowLeft, t = this.$refs.arrowRight, i = e.$el, s = t.$el;
      "ontouchstart" in document.documentElement ? (i.addEventListener("touchstart", this.onMouseDownLeft), i.addEventListener("touchend", this.onMouseUpLeft), s.addEventListener("touchstart", this.onMouseDownRight), s.addEventListener("touchend", this.onMouseUpRight)) : (i.addEventListener("mousedown", this.onMouseDownLeft), i.addEventListener("mouseup", this.onMouseUpLeft), s.addEventListener("mousedown", this.onMouseDownRight), s.addEventListener("mouseup", this.onMouseUpRight));
    },
    registerEventsInner() {
      const e = this.$refs.arrowLeftInner, t = this.$refs.arrowRightInner;
      if (!e || !t) return;
      const i = e.$el, s = t.$el;
      "ontouchstart" in document.documentElement ? (i.addEventListener("touchstart", this.onMouseDownLeftInner), i.addEventListener("touchend", this.onMouseUpLeftInner), s.addEventListener("touchstart", this.onMouseDownRightInner), s.addEventListener("touchend", this.onMouseUpRightInner)) : (i.addEventListener("mousedown", this.onMouseDownLeftInner), i.addEventListener("mouseup", this.onMouseUpLeftInner), s.addEventListener("mousedown", this.onMouseDownRightInner), s.addEventListener("mouseup", this.onMouseUpRightInner));
    },
    // event: TouchEvent | MouseEvent
    onMouseDownLeft() {
      this.disabled || (this.isPressedLeft = !0, this.chechOtherButtonPressed("left") ? this.value = 0 : this.value--, this.$emit("position", this.value));
    },
    onMouseUpLeft() {
      this.disabled || (this.isPressedLeft = !1, this.chechOtherButtonPressed("left") ? this.value++ : this.value = 0, this.$emit("endContact", this.value));
    },
    onMouseDownRight() {
      this.disabled || (this.isPressedRight = !0, this.chechOtherButtonPressed("right") ? this.value = 0 : this.value++, this.$emit("position", this.value));
    },
    onMouseUpRight() {
      this.disabled || (this.isPressedRight = !1, this.chechOtherButtonPressed("right") ? this.value-- : this.value = 0, this.$emit("endContact", this.value));
    },
    onMouseDownLeftInner() {
      this.disabled || (this.isPressedLeftInner = !0, this.chechOtherButtonPressed("leftInner") ? this.valueInner = 0 : this.valueInner--, this.$emit("positionInner", this.valueInner));
    },
    onMouseUpLeftInner() {
      this.disabled || (this.isPressedLeftInner = !1, this.chechOtherButtonPressed("leftInner") ? this.valueInner++ : this.valueInner = 0, this.$emit("endContactInner", this.valueInner));
    },
    onMouseDownRightInner() {
      this.disabled || (this.isPressedRightInner = !0, this.chechOtherButtonPressed("rightInner") ? this.valueInner = 0 : this.valueInner++, this.$emit("positionInner", this.valueInner));
    },
    onMouseUpRightInner() {
      this.disabled || (this.isPressedRightInner = !1, this.chechOtherButtonPressed("rightInner") ? this.valueInner-- : this.valueInner = 0, this.$emit("endContactInner", this.valueInner));
    },
    chechOtherButtonPressed(e) {
      return !!(e !== "left" && this.isPressedLeft || e !== "right" && this.isPressedRight || e !== "leftInner" && this.isPressedLeftInner || e !== "rightInner" && this.isPressedRightInner);
    },
    isGlowInner() {
      return this.glow || this.glowInner;
    },
    isGlowOuter() {
      return this.glow || this.glowOuter;
    }
  }
});
function $u(e, t, i, s, n, o) {
  const r = L("mobile-button"), a = L("small-movement-button");
  return p(), h("div", {
    style: b([e.style]),
    class: _(["movement-sides-container", { disabled: e.disabled }])
  }, [
    l("div", {
      class: _(["left-side", { "without-safe-zones": e.ignoreSafeZones }]),
      style: b({ transform: e.transformCoef })
    }, [
      M(r, {
        ref: "arrowLeft",
        "is-scaled": !1,
        type: `${e.type}-left`,
        glow: e.isGlowOuter(),
        class: "left-side-button",
        style: b([e.styleOuter, e.leftStyle])
      }, null, 8, ["type", "glow", "style"]),
      e.showInnerButtons ? (p(), V(a, {
        key: 0,
        ref: "arrowLeftInner",
        text: e.leftText,
        type: "double-arrow-left",
        "is-scaled": !1,
        glow: e.isGlowInner(),
        class: "left-inner-side-button",
        style: b([e.styleInner, e.leftStyle])
      }, null, 8, ["text", "glow", "style"])) : w("", !0)
    ], 6),
    l("div", {
      class: _(["right-side", { "without-safe-zones": e.ignoreSafeZones }]),
      style: b({ transform: e.transformCoef })
    }, [
      M(r, {
        ref: "arrowRight",
        "is-scaled": !1,
        type: `${e.type}-right`,
        glow: e.isGlowOuter(),
        class: "right-side-button",
        style: b([e.styleOuter, e.rightStyle])
      }, null, 8, ["type", "glow", "style"]),
      e.showInnerButtons ? (p(), V(a, {
        key: 0,
        ref: "arrowRightInner",
        text: e.rightText,
        type: "double-arrow-right",
        glow: e.isGlowInner(),
        "is-scaled": !1,
        class: "right-inner-side-button",
        style: b([e.styleInner, e.rightStyle])
      }, null, 8, ["text", "glow", "style"])) : w("", !0)
    ], 6)
  ], 6);
}
const y0 = /* @__PURE__ */ S(bu, [["render", $u]]), ku = T({
  name: "PlayerInfoAvatar",
  mixins: [P],
  props: {
    style: {
      type: Object,
      default: () => ({})
    },
    texts: {
      type: Object,
      default: () => ({
        name: "Matej Knoho",
        country: "fin",
        countryString: "fin",
        additionlInfo: "Additional info"
      })
    },
    isTraining: {
      type: Boolean,
      default: !1
    },
    backgroundId: {
      type: Number,
      default: 1
    },
    backgroundExt: {
      type: String,
      default: "png"
    },
    avatarId: {
      type: Number,
      default: 1
    },
    avatarExt: {
      type: String,
      default: "png"
    },
    sex: {
      type: String,
      default: "male"
    },
    secondLineTitle: {
      type: String,
      default: "utToBeat"
    }
  },
  emits: ["yes", "back"],
  data() {
    return {
      pathAvatars: mo,
      isSsm: !1
    };
  },
  computed: {
    basicStyle() {
      return {
        transform: `scale(${this.scaleCoef})`
      };
    },
    formatedAdditionlInfo() {
      return this.isTraining ? Ee(Number(this.texts.additionlInfo)) : this.texts.additionlInfo;
    },
    backgroundImage() {
      return `url(${this.pathAvatars}/backgrounds/${this.backgroundId}.${this.backgroundExt})`;
    },
    avatarImage() {
      return `${this.pathAvatars}/${this.sex}/${this.avatarId}.${this.avatarExt}`;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), _u = {
  key: 0,
  class: "player-info-avatar-first-line"
}, wu = { class: "player-info-avatar-country-text" }, Tu = ["src", "alt"], Su = { class: "player-info-avatar-name" }, xu = {
  key: 1,
  class: "player-info-avatar-first-line"
}, Cu = ["src", "alt"], zu = { class: "player-info-avatar-name" }, ju = { class: "player-info-avatar-country-text" }, Bu = { class: "player-info-avatar-second-line" }, Pu = { class: "player-info-avatar-second-line-add-info" }, Du = {
  key: 0,
  class: "icon-tp"
}, Lu = ["src", "alt"];
function Ou(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["player-info-avatar", { "player-info-avatar-ssm": e.isSsm }]),
    style: b([e.style, e.basicStyle])
  }, [
    e.isSsm ? (p(), h("div", _u, [
      l("span", wu, $(e.texts.countryString), 1),
      l("img", {
        class: "player-info-avatar-country-image",
        src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${e.texts.country.toLowerCase()}.png`,
        alt: e.texts.country
      }, null, 8, Tu),
      l("span", Su, $(e.texts.name), 1)
    ])) : (p(), h("div", xu, [
      l("img", {
        class: "player-info-avatar-country-image",
        src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${e.texts.country.toLowerCase()}.png`,
        alt: e.texts.country
      }, null, 8, Cu),
      l("span", zu, $(e.texts.name), 1),
      l("span", ju, " (" + $(e.texts.countryString) + ") ", 1)
    ])),
    l("div", Bu, [
      K($(e.$t(e.secondLineTitle)) + ": ", 1),
      l("span", Pu, $(e.formatedAdditionlInfo), 1),
      e.isTraining ? (p(), h("span", Du)) : w("", !0)
    ]),
    l("div", {
      class: "player-info-avatar-avatar",
      style: b({ "background-image": e.backgroundImage })
    }, [
      l("img", {
        class: "player-info-avatar-avatar-image",
        src: e.avatarImage,
        alt: e.texts.country
      }, null, 8, Lu),
      t[0] || (t[0] = l("div", { class: "player-info-avatar-avatar-stroke" }, null, -1))
    ], 4)
  ], 6);
}
const v0 = /* @__PURE__ */ S(ku, [["render", Ou]]), Iu = T({
  name: "PowerModal",
  components: {
    PowerIconSlot: ri
  },
  mixins: [P],
  props: {
    hasHeader: {
      type: Boolean,
      default: !0
    },
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    header: {
      type: String,
      required: !1,
      default: "Settings"
    },
    hasHeaderCloseButton: {
      type: Boolean,
      required: !1,
      default: !0
    }
  },
  emits: ["close"],
  data() {
    return {
      pathImages: E,
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return `translate(-50%,-50%) scale(${this.scaleCoef})`;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), Mu = {
  key: 0,
  class: "header"
}, Nu = ["src"], Au = { class: "content" }, Ru = {
  key: 1,
  class: "corner-top-right"
}, Eu = {
  key: 2,
  class: "corner-bottom-left"
}, Fu = {
  key: 3,
  class: "shadow-box"
};
function Vu(e, t, i, s, n, o) {
  const r = L("power-icon-slot");
  return p(), h("div", {
    class: _(["power-modal overlay", { "power-modal-ssm": e.isSsm }]),
    onMousedown: t[1] || (t[1] = A(() => {
    }, ["stop"])),
    onMouseup: t[2] || (t[2] = A(() => {
    }, ["stop"])),
    onTouchstart: t[3] || (t[3] = A(() => {
    }, ["stop"])),
    onTouchend: t[4] || (t[4] = A(() => {
    }, ["stop"])),
    onClick: t[5] || (t[5] = A(() => {
    }, ["stop"]))
  }, [
    l("div", {
      class: "modal",
      style: b([e.style, { transform: e.transformCoef }])
    }, [
      e.hasHeader ? (p(), h("div", Mu, [
        K($(e.header) + " ", 1),
        e.hasHeaderCloseButton ? (p(), V(r, {
          key: 0,
          class: "close-icon small",
          onClick: t[0] || (t[0] = A((a) => e.$emit("close", a), ["stop"]))
        }, {
          default: F(() => [
            l("img", {
              src: `${e.pathImages}/icons/close.png`,
              alt: ""
            }, null, 8, Nu)
          ]),
          _: 1
        })) : w("", !0)
      ])) : w("", !0),
      l("div", Au, [
        J(e.$slots, "default")
      ]),
      e.isSsm ? w("", !0) : (p(), h("div", Ru, t[6] || (t[6] = [
        l("div", { class: "corner-top-top-right" }, null, -1)
      ]))),
      e.isSsm ? w("", !0) : (p(), h("div", Eu, t[7] || (t[7] = [
        l("div", { class: "corner-bottom-bottom-left" }, null, -1)
      ]))),
      e.isSsm ? w("", !0) : (p(), h("div", Fu))
    ], 4)
  ], 34);
}
const Cn = /* @__PURE__ */ S(Iu, [["render", Vu]]), qu = T({
  data() {
    return {
      isSsm: !1
    };
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
});
function Wu(e, t, i, s, n, o) {
  return p(), h("hr", {
    class: _(["power-rule", { "power-rule-ssm": e.isSsm }])
  }, null, 2);
}
const Uu = /* @__PURE__ */ S(qu, [["render", Wu]]), Hu = T({
  name: "PowerJoystick",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    maxDistance: {
      type: Number,
      default: 100
    },
    deadzone: {
      type: Number,
      default: 7
    },
    onlyHorizontal: {
      type: Boolean,
      default: !1
    },
    onlyVertical: {
      type: Boolean,
      default: !1
    },
    glow: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    isFullScreen: {
      type: Boolean,
      default: !1
    },
    isMoveAllowed: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["positionX", "positionY", "direction", "endContact"],
  data: () => ({
    pathImages: E,
    width: 286,
    height: 286,
    pressed: 0,
    // Bool - 1=Yes - 0=No
    circumference: 2 * Math.PI,
    wholeStick: null,
    stickBackground: null,
    stick: null,
    // location from which drag begins, used to calculate offsets
    dragStart: {
      x: 0,
      y: 0
    },
    active: !1,
    value: {
      x: 0,
      y: 0
    },
    lastClient: {
      x: 0,
      y: 0
    },
    touchId: null,
    wholeStickPosition: {
      x: 0,
      y: 0
    },
    isSsm: !1
  }),
  computed: {
    size() {
      return this.isFullScreen ? {
        width: "100%",
        height: "100%"
      } : {
        width: "572px",
        height: "572px"
      };
    },
    transformCoef() {
      let e = 1;
      return this.isScaled && (e = this.scaleCoef), console.log("scale", e), `scale(${e})`;
    },
    decideImageStyle() {
      return this.isSsm ? { margin: "13.5px" } : {};
    },
    decideImage() {
      return this.onlyHorizontal ? `${this.pathImages}/joystick/BG_JOYSTICK_LEFT_RIGHT.png` : this.isFullScreen ? "" : this.isSsm ? "https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/mobile-input/joystick.png" : `${this.pathImages}/joystick/BG_JOYSTICK_FULL.png`;
    },
    decideBackground() {
      return this.isFullScreen ? "" : this.isSsm ? "https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/mobile-input/joystick-bg.png" : `${E}/joystick/BG_JOYSTICK.png`;
    }
  },
  mounted() {
    this.wholeStick = this.$refs["power-stick"], this.stickBackground = this.$refs["stick-background"], this.stick = this.$refs.stick, "ontouchstart" in document.documentElement ? (this.wholeStick.addEventListener("touchstart", this.handleDown), window.addEventListener("touchmove", this.handleMove, { passive: !1 }), window.addEventListener("touchend", this.handleUp)) : (this.wholeStick.addEventListener("mousedown", this.handleDown), window.addEventListener("mousemove", this.handleMove, { passive: !1 }), window.addEventListener("mouseup", this.handleUp));
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    // helper function to get an element's exact position
    // eslint-disable-next-line
    getPosition(e) {
      var s;
      console.log("getPosition");
      let t = 0, i = 0;
      for (e === window && (e = ((s = this.$refs["power-stick"]) == null ? void 0 : s.offsetParent) ?? document.body); e; ) {
        if (e.tagName === "BODY") {
          const n = e.scrollLeft || document.documentElement.scrollLeft, o = e.scrollTop || document.documentElement.scrollTop;
          console.log("added body x", e.tagName, e.offsetLeft, n, e.clientLeft), t += e.offsetLeft - n + e.clientLeft, i += e.offsetTop - o + e.clientTop;
        } else
          console.log("added  x", e.tagName, e.offsetLeft, e.scrollLeft, e.clientLeft), t += e.offsetLeft - e.scrollLeft + e.clientLeft, i += e.offsetTop - e.scrollTop + e.clientTop;
        e = e.offsetParent, console.log(e == null ? void 0 : e.tagName);
      }
      return {
        x: t,
        y: i
      };
    },
    getClickPosition(e) {
      const t = this.getPosition(e.currentTarget);
      let i, s;
      console.log("getClickPosition"), console.log("parentPosition", t), window.TouchEvent && e instanceof TouchEvent ? e.changedTouches ? (console.log("is changedTouches"), console.log("e.changedTouches[0].clientX", e.changedTouches[0].clientX), console.log("e.changedTouches[0].pageX", e.changedTouches[0].pageX), console.log("this.wholeStick.clientWidth", this.wholeStick.clientWidth), console.log(e.changedTouches[0].clientX - t.x - this.wholeStick.clientWidth / 2), i = e.changedTouches[0].clientX - t.x - this.wholeStick.clientWidth / 2, s = e.changedTouches[0].clientY - t.y - this.wholeStick.clientHeight / 2, console.log("xPosition", i)) : (i = t.x - this.wholeStick.clientWidth / 2, s = t.y - this.wholeStick.clientHeight / 2) : (i = e.clientX - t.x - this.wholeStick.clientWidth / 2, s = e.clientY - t.y - this.wholeStick.clientHeight / 2), console.log("xPosition", i), this.wholeStick.style.left = `${i}px`, this.wholeStick.style.top = `${s}px`;
    },
    handleDown(e) {
      if (this.disabled) return;
      this.active = !0;
      let t = 1;
      this.isScaled && (t = this.scaleCoef), console.log("scale", t), this.getClickPosition(e), this.dragStart = {
        x: this.stick.getBoundingClientRect().left + 75 * t,
        y: this.stick.getBoundingClientRect().top + 75 * t
      }, console.log("dragstart", this.dragStart), this.stick.style.transition = "0s";
      let i = 0, s = 0;
      e.cancelable && e.preventDefault(), window.TouchEvent && e instanceof TouchEvent ? e.changedTouches && (i = e.changedTouches[0].clientX, s = e.changedTouches[0].clientY, this.touchId = e.changedTouches[0].identifier) : (i = e.clientX, s = e.clientY);
      const n = i - this.dragStart.x, o = s - this.dragStart.y, r = Math.atan2(o, n), a = Math.min(this.maxDistance, Math.hypot(n, o)), u = a * Math.cos(r), d = a * Math.sin(r), c = a < this.deadzone ? 0 : this.maxDistance / (this.maxDistance - this.deadzone) * (a - this.deadzone), g = c * Math.cos(r), f = c * Math.sin(r), m = parseFloat((g / this.maxDistance).toFixed(4)), v = parseFloat((f / this.maxDistance).toFixed(4));
      this.onlyHorizontal ? (this.stick.style.transform = `translate3d(calc(-50% + ${u}px), -50%, 0px)`, this.value = {
        x: m,
        y: 0
      }) : this.onlyVertical ? (this.stick.style.transform = `translate3d(0%, calc(-50% + ${d}px), 0px)`, this.value = {
        x: 0,
        y: v
      }) : (this.stick.style.transform = `translate3d(calc(-50% + ${u}px), calc(-50% + ${d}px), 0px)`, this.value = {
        x: m,
        y: v
      }), this.emitAll();
    },
    handleMove(e) {
      if (!this.active || this.disabled) return;
      if (!this.isMoveAllowed) {
        this.handleDown(e);
        return;
      }
      let t = null, i = null;
      if (window.TouchEvent && e instanceof TouchEvent && e.changedTouches)
        for (let v = 0; v < e.targetTouches.length; v++)
          e.changedTouches[v] && e.changedTouches[v].identifier === this.touchId && (t = e.changedTouches[v].clientX, i = e.changedTouches[v].clientY);
      e instanceof MouseEvent && (t = e.clientX, i = e.clientY), !t || !i ? (t = this.lastClient.x, i = this.lastClient.y) : (this.lastClient.x = t, this.lastClient.y = i);
      const s = t - this.dragStart.x, n = i - this.dragStart.y, o = Math.atan2(n, s), r = Math.min(this.maxDistance, Math.hypot(s, n)), a = r * Math.cos(o), u = r * Math.sin(o), d = r < this.deadzone ? 0 : this.maxDistance / (this.maxDistance - this.deadzone) * (r - this.deadzone), c = d * Math.cos(o), g = d * Math.sin(o), f = parseFloat((c / this.maxDistance).toFixed(4)), m = parseFloat((g / this.maxDistance).toFixed(4));
      this.onlyHorizontal ? (this.stick.style.transform = `translate3d(calc(-50% + ${a}px), -50%, 0px)`, this.value = {
        x: f,
        y: 0
      }) : this.onlyVertical ? (this.stick.style.transform = `translate3d(0%, calc(-50% + ${u}px), 0px)`, this.value = {
        x: 0,
        y: m
      }) : (this.stick.style.transform = `translate3d(calc(-50% + ${a}px), calc(-50% + ${u}px), 0px)`, this.value = {
        x: f,
        y: m
      }), this.emitAll();
    },
    handleUp(e) {
      this.active && (window.TouchEvent && e instanceof TouchEvent && e.changedTouches && this.touchId !== e.changedTouches[0].identifier || (this.stick.style.transition = ".2s", this.stick.style.transform = "translate3d(-50%, -50%, 0px)", this.wholeStick.style.top = "0%", this.wholeStick.style.left = "0%", this.touchId = null, this.active = !1, this.$emit("endContact")));
    },
    emitAll() {
      this.emitPositionX(), this.emitPositionY(), this.emitDirection();
    },
    /**
     * The X position of the cursor relative to the canvas that contains it and to its dimensions
     */
    emitPositionX() {
      this.$emit("positionX", this.value.x);
    },
    /**
     * The Y position of the cursor relative to the canvas that contains it and to its dimensions
     */
    emitPositionY() {
      this.$emit("positionY", this.value.y);
    },
    /**
     *  Get the direction of the cursor as a string that indicates the cardinal points where this is oriented
     * @emits String of cardinal point S, SZ, Z, JZ, J, JZ, V, JV and C when it is placed in the center
     */
    emitDirection() {
      let e = "";
      const t = this.value.x, i = this.value.y, s = Math.atan2(t, i);
      s > -0.4 && s <= 0.4 && (e = "J"), s > 0.4 && s <= 1.1 && (e = "JV"), s > 1.1 && s <= 1.8 && (e = "V"), s > 1.8 && s <= 2.7 && (e = "SV"), (s > 2.7 || s <= -2.7) && (e = "S"), s > -2.7 && s <= -1.9 && (e = "SZ"), s > -1.9 && s <= -1.1 && (e = "Z"), s > -1.1 && s <= -0.4 && (e = "JZ"), i >= -0.1 && i <= 0.1 && t >= -0.1 && t <= 0.1 && (e = "C"), this.$emit("direction", e);
    }
  }
}), Xu = {
  key: 0,
  class: "yellow-glow"
}, Gu = {
  key: 1,
  class: "stick-background"
}, Yu = ["src"], Ku = {
  id: "stick",
  ref: "stick",
  class: "stick"
}, Zu = ["src"];
function Ju(e, t, i, s, n, o) {
  return p(), h("div", {
    id: "power-stick",
    ref: "power-stick",
    class: _({ disabled: e.disabled }),
    style: b([e.style, { transform: e.transformCoef }, e.size])
  }, [
    e.glow ? (p(), h("div", Xu)) : w("", !0),
    e.isFullScreen ? (p(), h("div", Gu)) : (p(), h("img", {
      key: 2,
      id: "stick-background",
      ref: "stick-background",
      class: "stick-background",
      src: e.decideBackground
    }, null, 8, Yu)),
    l("div", Ku, [
      e.isFullScreen ? (p(), h("div", {
        key: 0,
        style: b(e.decideImageStyle),
        class: "stick-img"
      }, null, 4)) : (p(), h("img", {
        key: 1,
        style: b(e.decideImageStyle),
        class: "stick-img",
        src: e.decideImage
      }, null, 12, Zu))
    ], 512)
  ], 6);
}
const b0 = /* @__PURE__ */ S(Hu, [["render", Ju]]), Qu = T({
  name: "ProgressBar",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    actualValue: {
      type: Number,
      required: !0
    },
    maxValue: {
      type: Number,
      required: !0
    },
    leftText: {
      type: String,
      required: !0
    },
    rightText: {
      type: String,
      required: !0
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef}) translate(-50%, 0)`,
        "transform-origin": "0 0"
      };
    },
    progressBarWidth() {
      const e = this.actualValue / this.maxValue * 100;
      return `${e < 100 ? e : 100}%`;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    formatThousands(e) {
      return Ee(e);
    }
  }
}), ec = { class: "progress-bar-actual-value" }, tc = { class: "progress-bar-parent" }, ic = { class: "progress-bar-max-value" };
function sc(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["progress-bar-container", { "progress-bar-container-ssm": e.isSsm }])
  }, [
    l("div", ec, $(e.formatThousands(e.leftText)), 1),
    l("div", tc, [
      l("div", {
        class: "progress-bar-value",
        style: b({ width: e.progressBarWidth })
      }, null, 4)
    ]),
    l("div", ic, $(e.formatThousands(e.rightText)), 1)
  ], 2);
}
const nc = /* @__PURE__ */ S(Qu, [["render", sc]]), oc = T({
  name: "RecordBox",
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    side: {
      type: String,
      default: ""
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    yellowText: {
      type: String,
      default: ""
    },
    blueText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      let e = "0 0";
      this.side === "right" && (e = "100% 0");
      let t = 1;
      return this.isScaled && (t = this.scaleCoef), {
        transform: `scale( ${t} )`,
        "transform-origin": e,
        margin: "0.25em 0"
      };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), rc = { class: "blue-skewed" }, ac = { class: "blue-text" }, lc = { class: "yellow-part" }, dc = { class: "yellow-text" };
function uc(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _([e.isSsm ? "record-box-ssm" : "record-box"]),
    style: b([e.transformCoef, e.style])
  }, [
    l("div", rc, [
      l("div", ac, $(e.blueText), 1)
    ]),
    l("div", lc, [
      l("div", dc, $(e.yellowText), 1),
      J(e.$slots, "default")
    ])
  ], 6);
}
const $0 = /* @__PURE__ */ S(oc, [["render", uc]]), cc = T({
  name: "DoubleBox",
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    side: {
      type: String,
      default: ""
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    leftText: {
      type: String,
      default: ""
    },
    leftImage: {
      type: String,
      default: ""
    },
    leftWidth: {
      type: Number,
      default: 104
    },
    rightText: {
      type: String,
      default: ""
    },
    rightImage: {
      type: String,
      default: ""
    },
    rightWidth: {
      type: Number,
      default: 104
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      let e = "0 0";
      this.side === "right" && (e = "100% 0");
      let t = 1;
      return this.isScaled && (t = this.scaleCoef), {
        transform: `scale( ${t} )`,
        "transform-origin": e
      };
    },
    getStyleLeft() {
      return {
        width: `${this.leftWidth}px`
      };
    },
    getStyleLeftImage() {
      return this.leftImage !== "" ? {
        background: `no-repeat center url('${this.leftImage}')`,
        display: "block"
      } : "";
    },
    getStyleRight() {
      return {
        width: `${this.rightWidth}px`
      };
    },
    getStyleRightImage() {
      return this.rightImage !== "" ? {
        background: `no-repeat center url('${this.rightImage}')`,
        display: "block"
      } : "";
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), pc = { class: "text" }, hc = { class: "text" };
function fc(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "double-box",
    style: b([e.transformCoef, e.style])
  }, [
    l("div", {
      class: "left-part",
      style: b(e.getStyleLeft)
    }, [
      l("div", pc, $(e.leftText), 1),
      l("div", {
        class: "image",
        style: b(e.getStyleLeftImage)
      }, null, 4)
    ], 4),
    l("div", {
      class: "right-part",
      style: b(e.getStyleRight)
    }, [
      l("div", hc, $(e.rightText), 1),
      l("div", {
        class: "image",
        style: b(e.getStyleRightImage)
      }, null, 4)
    ], 4)
  ], 4);
}
const k0 = /* @__PURE__ */ S(cc, [["render", fc], ["__scopeId", "data-v-3cfb5932"]]), mc = T({
  name: "PushBar",
  components: {
    ArrowAnimation: Gn,
    ArrowStatic: Zn,
    MissedText: Jd
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    numberLocation: {
      type: Number,
      required: !0
    },
    showMainPoint: {
      type: Boolean,
      default: !0
    },
    showOpacityPoint: {
      type: Boolean,
      default: !1
    },
    numberLocationWithOpacity: {
      type: Number,
      default: 0
    },
    text: {
      type: String,
      default: ""
    },
    colorPoint: {
      type: String,
      default: "blue",
      validator(e) {
        return [
          "blue",
          "red",
          "green"
        ].indexOf(e) > -1;
      }
    },
    colorOpacityPoint: {
      type: String,
      default: "blue",
      validator(e) {
        return [
          "blue",
          "red",
          "green"
        ].indexOf(e) > -1;
      }
    },
    glow: {
      type: Boolean,
      default: !1
    },
    showLeftArrow: {
      type: Boolean,
      default: !1
    },
    showRightArrow: {
      type: Boolean,
      default: !1
    },
    showLeftMiss: {
      type: Boolean,
      default: !1
    },
    showRightMiss: {
      type: Boolean,
      default: !1
    }
  },
  data: () => ({
    pathImages: E
  }),
  computed: {
    transformCoef() {
      return `scale(${this.scaleCoef})`;
    },
    getImgSourcePoint() {
      return `${this.pathImages}/push-bar/DOT_${this.colorPoint.toUpperCase()}.png`;
    },
    getImgSourceOpacityPoint() {
      return `${this.pathImages}/push-bar/DOT_${this.colorOpacityPoint.toUpperCase()}.png`;
    }
  },
  methods: {
    numberRotate(e) {
      return (e - 0) / 100 * 88 - 44;
    }
  }
}), gc = ["src"], yc = { class: "text" }, vc = ["src"];
function bc(e, t, i, s, n, o) {
  const r = L("arrow-animation"), a = L("arrow-static"), u = L("missed-text");
  return p(), h("div", {
    class: _(["push-bar", { disabled: e.disabled }]),
    style: b([e.style, { transform: e.transformCoef }])
  }, [
    e.glow ? (p(), V(r, {
      key: 0,
      position: "bottom",
      style: { position: "absolute", bottom: "0", left: "0", height: "160px", width: "75px" },
      "is-scaled": !1
    })) : w("", !0),
    e.glow ? (p(), V(r, {
      key: 1,
      position: "bottom",
      style: { position: "absolute", bottom: "0", right: "0", height: "160px", width: "75px" },
      "is-scaled": !1
    })) : w("", !0),
    e.glow ? (p(), h("div", {
      key: 2,
      class: "glow",
      style: b({
        backgroundImage: `url(${e.pathImages}/push-bar/GLOW.png)`
      })
    }, null, 4)) : w("", !0),
    e.showLeftArrow ? (p(), V(a, {
      key: 3,
      "is-scaled": !1,
      class: "left-static-arrow"
    })) : w("", !0),
    e.showRightArrow ? (p(), V(a, {
      key: 4,
      "is-scaled": !1,
      class: "right-static-arrow"
    })) : w("", !0),
    e.showLeftMiss ? (p(), V(u, {
      key: 5,
      class: "left-miss"
    })) : w("", !0),
    e.showRightMiss ? (p(), V(u, {
      key: 6,
      class: "right-miss"
    })) : w("", !0),
    l("div", {
      class: "bar",
      style: b({ backgroundImage: `url(${e.pathImages}/push-bar/PUSH_BAR.png)` })
    }, [
      e.showMainPoint ? (p(), h("div", {
        key: 0,
        class: "point",
        style: b({
          transform: `rotate(${e.numberRotate(e.numberLocation)}deg) translateY(-515px)`
        })
      }, [
        l("img", {
          src: e.getImgSourcePoint,
          alt: "bar-point"
        }, null, 8, gc),
        l("div", yc, $(e.text), 1)
      ], 4)) : w("", !0),
      e.showOpacityPoint ? (p(), h("img", {
        key: 1,
        class: "point",
        style: b({
          transform: `rotate(${e.numberRotate(e.numberLocationWithOpacity)}deg) translateY(-515px)`,
          opacity: 0.7
        }),
        src: e.getImgSourceOpacityPoint,
        alt: "bar-point"
      }, null, 12, vc)) : w("", !0)
    ], 4)
  ], 6);
}
const _0 = /* @__PURE__ */ S(mc, [["render", bc]]), $c = T({
  name: "ShrinkingTextBox",
  components: {
    TypeWriterComponent: ws
  },
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    useTypeWriter: {
      type: Boolean,
      default: !1
    },
    texts: {
      type: Array,
      default: []
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    fontSize: {
      type: Number,
      default: 0
    }
  },
  emits: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shrinkingFontSize: (e) => !0,
    showFullText: () => !0
  },
  data() {
    return {
      shrinkedFontSize: `${this.fontSize}px`
    };
  },
  watch: {
    useTypeWriter: {
      handler(e) {
        if (e === !1) {
          const t = this.$refs.shrinkingText;
          setTimeout(() => {
            this.shrinkText(t);
          }, 0);
        }
      }
    }
  },
  mounted() {
    const e = this.$refs.shrinkingText;
    e.style.maxWidth = `${this.width}px`, e.style.height = `${this.height}px`, e.style.fontSize = `${this.fontSize}px`, this.shrinkText(e);
  },
  methods: {
    shrinkText(e) {
      if (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) {
        e.style.fontSize = `${parseInt(e.style.fontSize) - 1}px`, this.shrinkText(e);
        return;
      }
      this.shrinkedFontSize = e.style.fontSize, this.$emit("shrinkingFontSize", e.style.fontSize);
    }
  }
}), kc = {
  ref: "shrinkingText",
  class: "shrinking-block"
}, _c = { key: 1 };
function wc(e, t, i, s, n, o) {
  const r = L("type-writer-component");
  return p(), h("div", kc, [
    (p(!0), h(H, null, de(e.texts, (a) => (p(), h(H, { key: a }, [
      e.useTypeWriter ? (p(), V(r, {
        key: 0,
        text: a,
        "font-size": e.shrinkedFontSize,
        onShowFullText: t[0] || (t[0] = (u) => e.$emit("showFullText")),
        onShrinkText: t[1] || (t[1] = (u) => e.shrinkText(e.$refs.shrinkingText))
      }, null, 8, ["text", "font-size"])) : (p(), h("span", _c, $(a), 1))
    ], 64))), 128))
  ]);
}
const Tc = /* @__PURE__ */ S($c, [["render", wc]]), Sc = T({
  name: "ShrinkTextUniversal",
  props: {
    text: {
      type: String,
      required: !0
    },
    italic: {
      type: Boolean,
      default: !0
    },
    fontSize: {
      type: Number,
      default: 24,
      validator: (e) => [
        24,
        26,
        28,
        30,
        32,
        34,
        36,
        38,
        40,
        44,
        48,
        50,
        60,
        72,
        90,
        110
      ].includes(e)
    },
    forcedFontSize: {
      type: Number,
      default: null
    },
    containerClassList: {
      type: [String, Array, Object],
      default: () => []
    },
    textClassList: {
      type: [String, Array, Object],
      default: () => []
    },
    animatedOverflow: {
      type: Boolean,
      default: null
    },
    maxLineLimit: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      fontSizePoints: [24, 26, 28, 30, 32, 34, 36, 38, 40, 44, 48, 50, 60, 72, 90, 110],
      localFontSize: this.fontSize,
      truncatedText: this.text,
      isOverflowing: !1,
      scrollHeight: 0,
      resizeCount: 0
    };
  },
  watch: {
    text() {
      this.truncatedText = this.text, this.checkOverflow(!0);
    },
    fontsize() {
      this.localFontSize = this.fontSize, this.checkOverflow(!0);
    }
  },
  mounted() {
    this.checkOverflow(!0);
  },
  methods: {
    checkOverflow(e = !1) {
      const t = this.$refs.textContainer, i = this.$refs.shrinkText;
      if (t && i) {
        const s = t.offsetWidth;
        i.offsetWidth > s ? (this.isOverflowing = !0, e && (this.localFontSize = this.findAndRetrieveElement(this.localFontSize), this.resizeCount++, this.fontSize <= 40 && this.resizeCount === 1 ? this.checkOverflow(!0) : this.checkOverflow())) : this.isOverflowing = !1;
      }
    },
    findAndRetrieveElement(e) {
      const t = this.fontSizePoints.indexOf(e);
      return t > 0 ? this.fontSizePoints[t - 1] : this.fontSizePoints[0];
    }
  }
}), xc = {
  key: 0,
  class: "animated-container__inner"
}, Cc = ["title"], zc = ["title"];
function jc(e, t, i, s, n, o) {
  return p(), h("div", {
    ref: "textContainer",
    class: _(["flex text-container w-full", [e.containerClassList, { "animated-container": e.animatedOverflow && e.isOverflowing }]])
  }, [
    e.isOverflowing && e.animatedOverflow ? (p(), h("div", xc, [
      l("span", {
        ref: "shrinkText",
        class: _(["base shrink-text", [
          `text-${e.forcedFontSize ? e.forcedFontSize : e.localFontSize}`,
          e.textClassList,
          {
            "italic-text": e.italic,
            "animated-text": e.animatedOverflow && e.isOverflowing
          }
        ]]),
        title: e.truncatedText
      }, $(e.truncatedText), 11, Cc)
    ])) : (p(), h("span", {
      key: 1,
      ref: "shrinkText",
      class: _(["base shrink-text", [
        `text-${e.forcedFontSize ? e.forcedFontSize : e.localFontSize}`,
        e.textClassList,
        {
          "italic-text": e.italic,
          "overflow-hidden": e.isOverflowing && !e.animatedOverflow,
          [`multi-line line-clamp-${e.maxLineLimit}`]: e.maxLineLimit && e.isOverflowing
        }
      ]]),
      title: e.isOverflowing ? e.truncatedText : ""
    }, $(e.truncatedText), 11, zc))
  ], 2);
}
const ai = /* @__PURE__ */ S(Sc, [["render", jc], ["__scopeId", "data-v-b3e92bae"]]), Bc = T({
  name: "SpeedBox",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    showSpeed: {
      type: Boolean,
      default: !1
    },
    text: {
      type: String,
      required: !1,
      default: "Settings"
    }
  },
  emits: ["close"]
}), Pc = { class: "speed-box" }, Dc = { class: "speed-box-text" };
function Lc(e, t, i, s, n, o) {
  return p(), h("div", Pc, [
    e.showSpeed ? (p(), h("div", {
      key: 0,
      class: "speed-box-wrapper",
      style: b([e.style])
    }, [
      l("div", Dc, $(e.text), 1)
    ], 4)) : w("", !0)
  ]);
}
const Oc = /* @__PURE__ */ S(Bc, [["render", Lc]]), Ic = T({
  name: "StatsTopBox",
  mixins: [P],
  props: {
    isRight: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    firstLine: {
      type: String,
      required: !1,
      default: ""
    },
    secondLine: {
      type: String,
      required: !1,
      default: ""
    },
    countDown: {
      type: String,
      required: !1,
      default: "10"
    },
    showThirdRow: {
      type: Boolean,
      required: !1,
      default: !1
    },
    glow: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"]
}), Mc = {
  key: 0,
  class: "yellow-glow"
}, Nc = { class: "stats-top-box-wrapper-row-1" }, Ac = { class: "stats-top-box-text-row-1" }, Rc = { class: "stats-top-box-wrapper-row-2" }, Ec = { class: "stats-top-box-text-row-2" }, Fc = {
  key: 1,
  class: "stats-top-box-wrapper-row-3"
}, Vc = { class: "stats-top-box-text-row-3" };
function qc(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["stats-top-box", [e.isRight ? "stats-top-box-right" : "stats-top-box-left"]]),
    style: b([e.style])
  }, [
    e.glow ? (p(), h("div", Mc)) : w("", !0),
    l("div", Nc, [
      l("div", Ac, $(e.firstLine), 1)
    ]),
    l("div", Rc, [
      l("div", Ec, [
        J(e.$slots, "secondLineIcon"),
        K($(e.secondLine), 1)
      ])
    ]),
    e.showThirdRow ? (p(), h("div", Fc, [
      t[0] || (t[0] = l("div", { class: "row-3-dot" }, null, -1)),
      l("div", Vc, $(e.countDown) + "s ", 1)
    ])) : w("", !0)
  ], 6);
}
const Wc = /* @__PURE__ */ S(Ic, [["render", qc]]), Uc = T({
  name: "StartgateCounterSmall",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    actualGate: {
      type: Number,
      default: 0
    },
    allGates: {
      type: Number,
      default: 0
    }
  }
}), Hc = { class: "startgate-counter-small-container" }, Xc = { class: "startgate-small-text" };
function Gc(e, t, i, s, n, o) {
  return p(), h("div", Hc, [
    t[0] || (t[0] = l("div", { class: "corner-top-right" }, [
      l("div", { class: "corner-top-top-right" })
    ], -1)),
    t[1] || (t[1] = l("div", { class: "corner-bottom-left" }, [
      l("div", { class: "corner-bottom-bottom-left" })
    ], -1)),
    l("div", Xc, $(e.$t("startgate")) + " " + $(e.actualGate) + "/" + $(e.allGates), 1)
  ]);
}
const Yc = /* @__PURE__ */ S(Uc, [["render", Gc]]), Kc = T({
  name: "SkijumpLeftTopInfo",
  components: {
    SpeedBox: Oc,
    StatsTopBox: Wc,
    StartgateCounterSmall: Yc
  },
  mixins: [P],
  props: {
    speed: {
      type: Number,
      default: 0
    },
    showSpeed: {
      type: Boolean,
      default: !1
    },
    showWind: {
      type: Boolean,
      default: !1
    },
    firstLine: {
      type: String,
      default: ""
    },
    secondLine: {
      type: String,
      default: ""
    },
    showThirdRow: {
      type: Boolean,
      default: !1
    },
    timer: {
      type: Number,
      default: 0
    },
    glow: {
      type: Boolean,
      default: !1
    },
    showStartgateCounter: {
      type: Boolean,
      default: !1
    },
    startgateActualGate: {
      type: Number,
      default: 0
    },
    startgateAllGates: {
      type: Number,
      default: 0
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.isScaled ? this.scaleCoef : 1})`,
        "transform-origin": "0 0"
      };
    }
  }
});
function Zc(e, t, i, s, n, o) {
  const r = L("speed-box"), a = L("startgate-counter-small"), u = L("stats-top-box");
  return p(), h("div", {
    class: "skijump-left-top-info",
    style: b([e.transformCoef])
  }, [
    M(r, {
      "show-speed": e.showSpeed,
      text: e.speed + " km/h"
    }, null, 8, ["show-speed", "text"]),
    e.showStartgateCounter ? (p(), V(a, {
      key: 0,
      "actual-gate": e.startgateActualGate,
      "all-gates": e.startgateAllGates
    }, null, 8, ["actual-gate", "all-gates"])) : w("", !0),
    e.showWind ? (p(), V(u, {
      key: 1,
      "first-line": e.firstLine,
      "second-line": e.secondLine,
      "show-third-row": e.showThirdRow,
      "count-down": String(e.timer),
      glow: e.glow
    }, {
      secondLineIcon: F(() => [
        J(e.$slots, "statsTopBoxSlot")
      ]),
      _: 3
    }, 8, ["first-line", "second-line", "show-third-row", "count-down", "glow"])) : w("", !0)
  ], 4);
}
const w0 = /* @__PURE__ */ S(Kc, [["render", Zc]]), Jc = T({
  name: "SmallActionButton",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    piePercent: {
      type: Number,
      default: 0
    },
    /** farby- green, yellow, red */
    color: {
      type: String,
      required: !1,
      default: "yellow"
    },
    glow: {
      type: Boolean,
      default: !1
    },
    letter: {
      type: String,
      default: ""
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      pathImages: E,
      active: !1
    };
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), this.active ? `scale(${e * 0.95})` : `scale(${e})`;
    },
    scaleStyle() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), {
        transform: `scale(${e})`,
        "transform-origin": "bottom"
      };
    },
    basicStyle() {
      return {
        transform: this.transformCoef
      };
    },
    decideImage() {
      return this.type === "biatlon-speed" ? this.disabled || ["green", "red"].includes(this.color) ? `${this.pathImages}/mobile-button/BTN_BIATLON_SPEED_WHITE.png` : `${this.pathImages}/mobile-button/BTN_BIATLON_SPEED.png` : this.type === "biatlon-tuck" ? this.disabled || ["green", "red"].includes(this.color) ? `${this.pathImages}/mobile-button/BTN_BIATLON_TUCK_WHITE.png` : `${this.pathImages}/mobile-button/BTN_BIATLON_TUCK.png` : this.type === "cc-speed" ? this.disabled || ["green", "red"].includes(this.color) ? `${this.pathImages}/mobile-button/BTN_CC_SPEED_WHITE.png` : `${this.pathImages}/mobile-button/BTN_CC_SPEED.png` : this.type === "cc-tuck" ? this.disabled || ["green", "red"].includes(this.color) ? `${this.pathImages}/mobile-button/BTN_CC_TUCK_WHITE.png` : `${this.pathImages}/mobile-button/BTN_CC_TUCK.png` : null;
    },
    pieStyle() {
      const e = 360 * (this.piePercent / 100), t = "rgba(255, 239, 153, 0.37)";
      return this.disabled ? {
        background: `conic-gradient(#636363 ${e}deg, #939393 ${e}deg 360deg)`
      } : this.color === "green" ? {
        background: `conic-gradient(#0bc110 ${e}deg, ${t} ${e}deg 360deg)`
      } : this.color === "red" ? {
        background: `conic-gradient(#f51818 ${e}deg, ${t} ${e}deg 360deg)`
      } : {
        background: `conic-gradient(#f6c717 ${e}deg, ${t} ${e}deg 360deg)`
      };
    }
  }
}), Qc = { class: "small-action-button-container" };
function ep(e, t, i, s, n, o) {
  var r;
  return p(), h("div", Qc, [
    l("button", {
      class: "small-action-button-wrapper",
      onMousedown: t[0] || (t[0] = A((a) => e.active = !0, ["prevent"])),
      onMouseup: t[1] || (t[1] = A((a) => e.active = !1, ["prevent"])),
      onTouchstart: t[2] || (t[2] = A((a) => e.active = !0, ["prevent"])),
      onTouchend: t[3] || (t[3] = A((a) => e.active = !1, ["prevent"]))
    }, [
      e.glow ? (p(), h("div", {
        key: 0,
        style: b([e.basicStyle, e.style]),
        class: "yellow-glow"
      }, null, 4)) : w("", !0),
      l("div", {
        class: _(["small-action-button", { disabled: e.disabled }]),
        style: b([e.basicStyle, e.style])
      }, [
        l("div", {
          id: "button-element",
          class: "button-element",
          style: b(e.pieStyle)
        }, [
          l("div", {
            style: b({ backgroundImage: "url(" + e.decideImage + ")" }),
            class: "image"
          }, null, 4)
        ], 4)
      ], 6)
    ], 32),
    ((r = e.letter) == null ? void 0 : r.length) > 0 ? (p(), h("div", {
      key: 0,
      class: "letter",
      style: b(e.scaleStyle)
    }, $(e.letter), 5)) : w("", !0)
  ]);
}
const T0 = /* @__PURE__ */ S(Jc, [["render", ep]]), tp = T({
  name: "SpeedControlBar",
  mixins: [P],
  props: {
    fillSize: {
      type: Number,
      default: 0
    },
    maxFill: {
      type: Number,
      default: 100
    },
    reversedMode: {
      type: Boolean,
      default: !1
    },
    glow: {
      type: Boolean,
      default: !1
    },
    showSpeedSign: {
      type: Boolean,
      default: !1
    },
    showMark: {
      type: Boolean,
      default: !0
    },
    onlyGreen: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      pathImages: E
    };
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), `scale(${e})`;
    },
    dynamicStyle() {
      if (this.onlyGreen)
        return `top: ${100 - Math.floor(this.fillSize)}%;  background-image: linear-gradient(to top, #169410, #3fe443);`;
      const e = this.reversedMode ? "to top, #169410, #3fe443" : "to top, #a10404, #df0404", t = this.reversedMode ? "to top, #169410, #3fe443" : "to top, #b36e24, #e8bf13", i = this.reversedMode ? "to top, #a10404, #df0404" : "to top, #169410, #3fe443";
      return Math.floor(this.fillSize) > Math.floor(this.maxFill) ? `top: ${Math.floor(100 - this.maxFill)}%;  background-image: linear-gradient(${i});` : Math.floor(this.fillSize) < 0 ? `top: 100%; background-image: linear-gradient(${e});` : Math.floor(this.fillSize) <= this.maxFill - 50 ? `top: ${100 - Math.floor(this.fillSize)}%;  background-image: linear-gradient(${e});` : Math.floor(this.fillSize) <= this.maxFill - 10 ? `top: ${100 - Math.floor(this.fillSize)}%;  background-image: linear-gradient(${t});` : `top: ${100 - Math.floor(this.fillSize)}%;  background-image: linear-gradient(${i});`;
    },
    dynamicWhite() {
      return this.maxFill < 100 ? `bottom: ${100 - Math.floor(103 - this.maxFill)}%;  background-color: white;` : "bottom: 0;";
    },
    dynamicMark() {
      return this.showMark ? this.maxFill < 100 ? `bottom: ${Math.floor(this.maxFill) - 13}%;` : "bottom: 87%;" : "display: none;";
    }
  }
}), ip = {
  key: 0,
  class: "speed-sign"
}, sp = {
  key: 1,
  class: "yellow-glow"
}, np = ["src"], op = ["src"];
function rp(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "power-start-bar",
    style: b([{ transform: e.transformCoef }])
  }, [
    e.showSpeedSign ? (p(), h("div", ip)) : w("", !0),
    e.glow ? (p(), h("div", sp)) : w("", !0),
    l("div", {
      class: "white-fill",
      style: b(e.dynamicWhite)
    }, null, 4),
    l("div", {
      class: "inside-fill",
      style: b(e.dynamicStyle)
    }, null, 4),
    l("img", {
      src: `${e.pathImages}/speed-control-bar/BAR_MARK.png`,
      class: "mark-style",
      style: b(e.dynamicMark)
    }, null, 12, np),
    l("img", {
      src: `${e.pathImages}/speed-control-bar/BAR_BORDER.png`,
      alt: "start bar",
      class: "positioner"
    }, null, 8, op)
  ], 4);
}
const S0 = /* @__PURE__ */ S(tp, [["render", rp]]), ap = T({
  name: "SpeedBarRun",
  mixins: [P],
  props: {
    fillSize: {
      type: Number,
      default: 0
    },
    markPositionPercent: {
      type: Number,
      default: 0
    },
    glow: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      pathImages: E
    };
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), `scale(${e})`;
    },
    dynamicStyle() {
      let e = "to top, #169410, #3fe443";
      return this.fillSize < this.markPositionPercent && (e = "to top, #b36e24, #e8bf13"), this.fillSize > 100 && (e = "to top, #a10404, #df0404"), `top: ${100 - Math.floor(this.fillSize)}%;  background-image: linear-gradient(${e});`;
    },
    dynamicMark() {
      return `bottom: ${this.markPositionPercent - 2}%;`;
    }
  }
}), lp = {
  key: 0,
  class: "yellow-glow"
}, dp = ["src"], up = ["src"];
function cp(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "power-speed-bar-run",
    style: b([{ transform: e.transformCoef }])
  }, [
    e.glow ? (p(), h("div", lp)) : w("", !0),
    l("div", {
      class: "inside-fill",
      style: b(e.dynamicStyle)
    }, null, 4),
    l("img", {
      src: `${e.pathImages}/speed-control-bar/BAR_MARK.png`,
      class: "mark-style",
      style: b(e.dynamicMark)
    }, null, 12, dp),
    l("img", {
      src: `${e.pathImages}/speed-control-bar/BAR_BORDER.png`,
      alt: "start bar",
      class: "positioner"
    }, null, 8, up)
  ], 4);
}
const x0 = /* @__PURE__ */ S(ap, [["render", cp]]), pp = T({
  name: "PowerSplitTimesSkijump",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    splitTimes: {
      type: Array,
      default: () => []
    },
    penalty: {
      type: String,
      default: ""
    }
  },
  computed: {
    transformCoef() {
      return `scale(${this.scaleCoef})`;
    }
  }
}), hp = {
  key: 0,
  class: "time-keeper-penalty-text"
}, fp = { style: { "text-transform": "uppercase" } }, mp = { class: "middle-time-set" }, gp = { class: "time-text" };
function yp(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "power-middle-time-info-skijump",
    style: b([e.style, { transform: e.transformCoef }])
  }, [
    l("div", {
      class: _([e.penalty.length > 0 ? "" : "invisible", "time-keeper-penalty-wrapper"])
    }, [
      e.penalty.length > 0 ? (p(), h("div", hp, [
        l("span", fp, $(e.$t("penalty")), 1),
        K(": + " + $(e.penalty) + "s ", 1)
      ])) : w("", !0)
    ], 2),
    l("div", mp, [
      (p(!0), h(H, null, de(e.splitTimes, (r, a) => (p(), h("div", {
        key: a,
        class: _(["time-item", r.color])
      }, [
        l("span", gp, $(r.text), 1),
        t[0] || (t[0] = l("div", { class: "pseudo-after" }, null, -1))
      ], 2))), 128))
    ])
  ], 4);
}
const C0 = /* @__PURE__ */ S(pp, [["render", yp]]), vp = T({
  name: "PowerStartBar",
  mixins: [P],
  props: {
    fillSize: {
      type: Number,
      default: 0
    },
    reversedMode: {
      type: Boolean,
      default: !1
    },
    glow: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    mark: {
      type: Number,
      default: 0
    },
    showMark: {
      type: Boolean,
      default: !1
    },
    hideDefaultMark: {
      type: Boolean,
      default: !1
    },
    horizontal: {
      type: Boolean,
      default: !1
    },
    redFillSize: {
      type: Number,
      default: 90
    },
    orangeFillSize: {
      type: Number,
      default: 50
    }
  },
  data() {
    return {
      pathImages: E
    };
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), `scale(${e})`;
    },
    dynamicStyle() {
      let e = "top";
      console.log(this.fillSize), this.horizontal && (e = "right");
      const t = this.reversedMode ? `to ${e}, #169410, #3fe443` : `to ${e}, #a10404, #df0404`, i = this.reversedMode ? `to ${e}, #169410, #3fe443` : `to ${e}, #b36e24, #e8bf13`, s = this.reversedMode ? `to ${e}, #a10404, #df0404` : `to ${e}, #169410, #3fe443`;
      return Math.floor(this.fillSize) > 100 ? `${e}: 0%;  background-image: linear-gradient(${s});` : Math.floor(this.fillSize) < 0 ? `${e}: 100%; background-image: linear-gradient(${t});` : Math.floor(this.fillSize) <= this.orangeFillSize ? `${e}: ${100 - Math.floor(this.fillSize)}%;
          background-image: linear-gradient(${t});` : Math.floor(this.fillSize) <= this.redFillSize ? `${e}: ${100 - Math.floor(this.fillSize)}%;
          background-image: linear-gradient(${i});` : `${e}: ${100 - Math.floor(this.fillSize)}%;
          background-image: linear-gradient(${s});`;
    },
    dynamicMark() {
      return this.showMark ? this.horizontal ? `left: calc(${Math.floor(this.mark)}%);` : `bottom: calc(${Math.floor(this.mark)}% * 0.97);` : "display: none;";
    },
    borderImage() {
      return this.horizontal ? `${E}/start-bar/border.png` : this.hideDefaultMark ? `${E}/speed-control-bar/BAR_BORDER.png` : `${E}/start-bar/BG_BAR_FINAL.png`;
    },
    barMark() {
      return this.horizontal ? `${E}/start-bar/bar-pointer.png` : `${E}/speed-control-bar/BAR_MARK.png`;
    }
  }
}), bp = {
  key: 0,
  class: "yellow-glow"
}, $p = ["src"], kp = ["src"];
function _p(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["power-start-bar", { horizontal: e.horizontal }]),
    style: b([{ transform: e.transformCoef }])
  }, [
    e.glow ? (p(), h("div", bp)) : w("", !0),
    l("div", {
      class: "inside-fill",
      style: b(e.dynamicStyle)
    }, null, 4),
    l("img", {
      src: e.borderImage,
      alt: "start bar",
      class: "positioner"
    }, null, 8, $p),
    l("img", {
      src: e.barMark,
      class: "mark-style special",
      style: b(e.dynamicMark)
    }, null, 12, kp)
  ], 6);
}
const wp = /* @__PURE__ */ S(vp, [["render", _p]]), Tp = T({
  name: "TrafficLightBox",
  components: {
    ShrinkingTextBox: pe
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    text: {
      type: String,
      required: !1,
      default: ""
    },
    color: {
      type: Number,
      required: !1,
      default: 0
    },
    isV2: {
      type: Boolean,
      required: !1,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    withAnimation: {
      type: Boolean,
      default: !1
    },
    duration: {
      type: Number,
      default: 0.15
    },
    delayStart: {
      type: Number,
      default: 1
    },
    delayHide: {
      type: Number,
      default: 1.5
    },
    coefTextRight: {
      type: Number,
      default: -0.4
    }
  },
  emits: ["close"],
  data() {
    return {
      timelineBackground: null,
      timelineText: null
    };
  },
  computed: {
    transformCoef() {
      return this.isScaled ? {
        transform: `scale(${this.scaleCoef}) translate(-50%, 0)`,
        "transform-origin": "0 0"
      } : {};
    },
    colorClass() {
      let e = "green";
      return this.color === 1 && (e = "orange"), this.color === 2 && (e = "red"), this.color === 3 && (e = "teal"), e;
    },
    v2Class() {
      return this.isV2 ? "traffic-light-box-v2" : "traffic-light-box";
    }
  },
  mounted() {
    this.withAnimation && this.setUpTweens();
  },
  beforeUnmount() {
    this.withAnimation && this.resetAllTimelines();
  },
  methods: {
    setUpTweens() {
      const e = this.scaleCoef ? this.scaleCoef : 1, t = document.body.clientWidth / e;
      this.resetAllTimelines();
      const i = this.$refs.partBackground, s = t * -0.2, n = t * 0.2;
      i.style.marginLeft = `${s}px`, i.style.opacity = "0";
      const o = this.$refs.partText, r = t * this.coefTextRight, a = t * 0.2;
      o.style.marginRight = `${r}px`, o.style.opacity = "0";
      let u = this.delayStart;
      this.backgroundArrive(u), u += this.duration, this.textShow(u), u += this.duration + this.delayHide, this.textHide(u, a), u += this.duration, this.backgroundLeave(u, n);
    },
    backgroundArrive(e) {
      this.timelineBackground = U.timeline().to(
        ".traffic-light-box-background",
        {
          "margin-left": "0px",
          ease: "none",
          opacity: 1,
          duration: this.duration
        },
        e
      );
    },
    textShow(e) {
      this.timelineText = U.timeline().to(
        ".traffic-light-box-text",
        {
          "margin-right": "0px",
          ease: "none",
          opacity: 1,
          duration: this.duration
        },
        e
      );
    },
    backgroundLeave(e, t) {
      this.timelineBackground = U.timeline().to(
        ".traffic-light-box-background",
        {
          "margin-left": `${t}px`,
          ease: "none",
          opacity: 0,
          duration: this.duration
        },
        e
      );
    },
    textHide(e, t) {
      this.timelineText = U.timeline().to(
        ".traffic-light-box-text",
        {
          "margin-right": `${t}px`,
          ease: "none",
          opacity: 0,
          duration: this.duration
        },
        e
      );
    },
    resetAllTimelines() {
      var e, t;
      (e = this.timelineBackground) == null || e.kill(), (t = this.timelineText) == null || t.kill();
    }
  }
}), Sp = {
  ref: "partBackground",
  class: "traffic-light-box-background"
}, xp = {
  ref: "partText",
  class: "traffic-light-box-text"
};
function Cp(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: _([e.colorClass, e.v2Class]),
    style: b([e.style, e.transformCoef])
  }, [
    l("div", Sp, null, 512),
    l("div", xp, [
      M(r, {
        text: e.text,
        "font-size": 60,
        width: 600,
        height: 92,
        class: _(e.colorClass)
      }, null, 8, ["text", "class"])
    ], 512)
  ], 6);
}
const z0 = /* @__PURE__ */ S(Tp, [["render", Cp]]), zp = T({
  name: "StartgateCounterBig",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    actualGate: {
      type: Number,
      default: 0
    },
    allGates: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    topGate: {
      top: 35,
      left: 134
    },
    bottomGate: {
      top: 88,
      left: 170
    }
  }),
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef}) translate(0, 0)`
      };
    },
    indicatorStyle() {
      const e = 1 - (this.actualGate - 1) / (this.allGates - 1), t = this.bottomGate.top - this.topGate.top, i = this.bottomGate.left - this.topGate.left;
      return {
        top: `${this.topGate.top + t * e}px`,
        left: `${this.topGate.left + i * e}px`
      };
    }
  }
}), jp = { class: "startgate-big-text" }, Bp = { class: "startgate-big-picture" }, Pp = { class: "startgate-bridge" };
function Dp(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "startgate-counter-big-container",
    style: b([e.style, e.transformCoef])
  }, [
    t[0] || (t[0] = l("div", { class: "corner-top-right" }, [
      l("div", { class: "corner-top-top-right" })
    ], -1)),
    t[1] || (t[1] = l("div", { class: "corner-bottom-left" }, [
      l("div", { class: "corner-bottom-bottom-left" })
    ], -1)),
    l("div", jp, $(e.$t("startgate")) + " " + $(e.actualGate) + "/" + $(e.allGates), 1),
    l("div", Bp, [
      l("div", Pp, [
        l("div", {
          id: "startgateIndicator",
          style: b([e.indicatorStyle]),
          class: "startgate-indicator"
        }, null, 4)
      ])
    ])
  ], 4);
}
const j0 = /* @__PURE__ */ S(zp, [["render", Dp]]), Lp = T({
  name: "ShinyTextAnimated",
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tweenShine: U.timeline(),
      tweenText: U.timeline()
    };
  },
  computed: {
    transformCoef() {
      let e = 1;
      return this.isScaled && (e = this.scaleCoef), {
        transform: `scale( ${e} )`
      };
    }
  },
  watch: {
    active: {
      handler(e) {
        e && (this.tweenShine.progress(0), this.tweenText.progress(0), this.tweenShine.play(), this.tweenText.play());
      }
    }
  },
  mounted() {
    this.tweenShine = U.timeline({ paused: !0 }).to(`#${this.type}-shine`, {
      duration: 0.3,
      x: "0",
      opacity: 1
    }).to(`#${this.type}-shine`, {
      duration: 0.35
    }).to(`#${this.type}-shine`, {
      duration: 0.25,
      scale: 2,
      opacity: 0
    }).to(`#${this.type}-shine`, {
      duration: 0,
      scale: 1,
      x: "1000px"
    }), this.tweenText = U.timeline({ paused: !0 }).to(`#${this.type}-text`, {
      duration: 0.3,
      x: "0",
      opacity: 1
    }).to(`#${this.type}-text`, {
      duration: 0.35
    }).to(`#${this.type}-text`, {
      duration: 0.25,
      scale: 2,
      opacity: 0
    }).to(`#${this.type}-text`, {
      duration: 0,
      scale: 1,
      x: "-1000px"
    });
  }
}), Op = { class: "shiny-text-animated-wrapper" }, Ip = ["id"], Mp = ["id"];
function Np(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "shiny-text-animated-container",
    style: b([e.style, e.transformCoef])
  }, [
    l("div", Op, [
      l("div", {
        id: `${e.type}-shine`,
        class: _(["shine", [e.type]])
      }, null, 10, Ip),
      l("div", {
        id: `${e.type}-text`,
        class: _(["text", [e.type]])
      }, null, 10, Mp)
    ])
  ], 4);
}
const B0 = /* @__PURE__ */ S(Lp, [["render", Np]]), Ap = T({
  name: "MovementButtonsSmooth",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    maxDistance: {
      type: Number,
      default: 100
    },
    deadzone: {
      type: Number,
      default: 7
    },
    glow: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    onlyBinary: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["positionX", "positionY"],
  data: () => ({
    pathImages: E,
    width: 286,
    height: 286,
    pressed: 0,
    // Bool - 1=Yes - 0=No
    circumference: 2 * Math.PI,
    wholeStick: null,
    stickBackground: null,
    stick: null,
    // location from which drag begins, used to calculate offsets
    dragStart: {
      x: 0,
      y: 0
    },
    active: !1,
    value: {
      x: 0,
      y: 0
    },
    lastClient: {
      x: 0,
      y: 0
    },
    touchId: null,
    wholeStickPosition: {
      x: 0,
      y: 0
    },
    isPressedLeft: !1,
    isPressedRight: !1
  }),
  computed: {
    leftButtonBgStyle() {
      const e = this.isPressedLeft ? 0.9 : 1;
      return {
        backgroundImage: `url(${this.pathImages}/movement-buttons/btn-left.png)`,
        transform: `scale(${e})`
      };
    },
    rightButtonBgStyle() {
      const e = this.isPressedRight ? 0.9 : 1;
      return {
        backgroundImage: `url(${this.pathImages}/movement-buttons/btn-right.png)`,
        transform: `scale(${e})`
      };
    },
    transformCoef() {
      let e = 1;
      return this.isScaled && (e = this.scaleCoef), `scale(${e})`;
    }
  },
  mounted() {
    this.wholeStick = document.getElementById("power-stick-smooth"), this.stickBackground = document.getElementById("stick-smooth-background"), this.stick = document.getElementById("stick-smooth"), "ontouchstart" in document.documentElement ? (this.wholeStick.addEventListener("touchstart", this.handleDown), window.addEventListener("touchmove", this.handleMove, { passive: !1 }), window.addEventListener("touchend", this.handleUp)) : (this.wholeStick.addEventListener("mousedown", this.handleDown), window.addEventListener("mousemove", this.handleMove, { passive: !1 }), window.addEventListener("mouseup", this.handleUp));
  },
  methods: {
    // helper function to get an element's exact position
    // eslint-disable-next-line
    getPosition(e) {
      let t = 0, i = 0;
      for (; e; ) {
        if (e.tagName === "BODY") {
          const s = e.scrollLeft || document.documentElement.scrollLeft, n = e.scrollTop || document.documentElement.scrollTop;
          t += e.offsetLeft - s + e.clientLeft, i += e.offsetTop - n + e.clientTop;
        } else
          t += e.offsetLeft - e.scrollLeft + e.clientLeft, i += e.offsetTop - e.scrollTop + e.clientTop;
        e = e.offsetParent;
      }
      return {
        x: t,
        y: i
      };
    },
    handleDown(e) {
      if (this.disabled) return;
      this.active = !0, this.dragStart = {
        x: this.stick.getBoundingClientRect().left + 75 * this.scaleCoef,
        y: this.stick.getBoundingClientRect().top + 75 * this.scaleCoef
      };
      let t = 0, i = 0;
      e.cancelable && e.preventDefault(), window.TouchEvent && e instanceof TouchEvent ? e.changedTouches && (t = e.changedTouches[0].clientX, i = e.changedTouches[0].clientY, this.touchId = e.changedTouches[0].identifier) : (t = e.clientX, i = e.clientY);
      const s = t - this.dragStart.x, n = i - this.dragStart.y, o = Math.atan2(n, s), r = Math.min(this.maxDistance, Math.hypot(s, n)), u = (r < this.deadzone ? 0 : this.maxDistance / (this.maxDistance - this.deadzone) * (r - this.deadzone)) * Math.cos(o), d = parseFloat((u / this.maxDistance).toFixed(4));
      this.value = {
        x: d,
        y: 0
      }, this.emitPositionX();
    },
    handleMove(e) {
      if (!this.active || this.disabled) return;
      let t = null, i = null;
      if (window.TouchEvent && e instanceof TouchEvent && e.changedTouches)
        for (let c = 0; c < e.targetTouches.length; c++)
          e.changedTouches[c] && e.changedTouches[c].identifier === this.touchId && (t = e.changedTouches[c].clientX, i = e.changedTouches[c].clientY);
      e instanceof MouseEvent && (t = e.clientX, i = e.clientY), !t || !i ? (t = this.lastClient.x, i = this.lastClient.y) : (this.lastClient.x = t, this.lastClient.y = i);
      const s = t - this.dragStart.x, n = i - this.dragStart.y, o = Math.atan2(n, s), r = Math.min(this.maxDistance, Math.hypot(s, n)), u = (r < this.deadzone ? 0 : this.maxDistance / (this.maxDistance - this.deadzone) * (r - this.deadzone)) * Math.cos(o), d = parseFloat((u / this.maxDistance).toFixed(4));
      this.value = {
        x: d,
        y: 0
      }, this.emitPositionX();
    },
    handleUp(e) {
      this.active && (window.TouchEvent && e instanceof TouchEvent && e.changedTouches && this.touchId !== e.changedTouches[0].identifier || (this.touchId = null, this.active = !1, this.value.x = 0, this.value.y = 0, this.emitPositionX()));
    },
    /**
     * The X position of the cursor relative to the canvas that contains it and to its dimensions
     */
    emitPositionX() {
      let e = 0;
      this.isPressedRight = !1, this.isPressedLeft = !1, this.value.x > 0 && (e = 1, this.isPressedRight = !0), this.value.x < 0 && (e = -1, this.isPressedLeft = !0), this.$emit("positionX", e);
    }
  }
}), Rp = {
  key: 0,
  class: "yellow-glow"
};
function Ep(e, t, i, s, n, o) {
  return p(), h("div", {
    id: "power-stick-smooth",
    class: _(["mobile-buttons-container", { disabled: e.disabled }]),
    style: b([e.style, { transform: e.transformCoef }])
  }, [
    e.glow ? (p(), h("div", Rp)) : w("", !0),
    t[0] || (t[0] = l("img", {
      id: "stick-smooth-background",
      class: "stick-smooth-background"
    }, null, -1)),
    t[1] || (t[1] = l("div", {
      id: "stick-smooth",
      class: "stick"
    }, null, -1)),
    l("button", {
      id: "directionButtonLeft",
      class: _(["direction-button left", { "is-clicked": e.isPressedLeft }]),
      style: b(e.leftButtonBgStyle)
    }, null, 6),
    l("button", {
      id: "directionButtonRight",
      class: _(["direction-button right", { "is-clicked": e.isPressedRight }]),
      style: b(e.rightButtonBgStyle)
    }, null, 6)
  ], 6);
}
const P0 = /* @__PURE__ */ S(Ap, [["render", Ep]]), Fp = T({
  name: "CountdownShiny",
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: ""
    },
    duration: {
      type: Number,
      required: !0
    },
    leftStart: {
      type: Number,
      required: !1,
      default: -1
    }
  },
  emits: ["callback"],
  data() {
    return {
      tweenShine: U.timeline(),
      tweenText: U.timeline()
    };
  },
  computed: {
    transformCoef() {
      let e = 1;
      return this.isScaled && (e = this.scaleCoef), {
        transform: `scale( ${e} )`
      };
    }
  },
  watch: {
    active: {
      handler(e) {
        if (e) {
          const t = document.body.clientWidth / this.scaleCoef, i = this.leftStart * t, s = this.$refs.smallTextRef, n = this.$refs.bigTextRef;
          s.style.transform = `translateX(${i}px)`, n.style.transform = `translateX(${i}px)`, this.tweenShine.progress(0), this.tweenText.progress(0), this.tweenShine.play(), this.tweenText.play();
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      const e = document.body.clientWidth / this.scaleCoef, t = this.duration * 0.2, i = this.duration * 0.7, s = this.duration * 0.1, n = this.$refs.smallTextRef, o = n.clientWidth, r = e * 0.45 - o / 2, a = e * 0.5 - o / 2, u = this.$refs.bigTextRef, d = u.clientWidth, c = e * 0.4 - d / 2, g = e * 0.5 - d / 2, f = this.leftStart * e;
      n.style.transform = `translateX(${f}px)`, n.style.left = `${-(e - o)}px`, u.style.transform = `translateX(${f}px)`, u.style.left = `${-(e - d)}px`, console.log(n.style), this.tweenShine = U.timeline({ paused: !0 }).to(`#${this.type}-shine`, {
        duration: t,
        ease: "none",
        x: `${c}px`
      }).to(`#${this.type}-shine`, {
        duration: i,
        ease: "none",
        x: `${g}px`
      }).to(`#${this.type}-shine`, {
        duration: s,
        ease: "none",
        x: `${e}px`
      }), this.tweenText = U.timeline({ paused: !0 }).to(`#${this.type}-text`, {
        duration: t,
        ease: "none",
        x: `${r}px`
      }).to(`#${this.type}-text`, {
        duration: i,
        ease: "none",
        x: `${a}px`
      }).to(`#${this.type}-text`, {
        duration: s,
        ease: "none",
        x: `${e + 500}px`,
        onComplete: this.runCallback
      });
    });
  },
  methods: {
    runCallback() {
      this.$emit("callback");
    }
  }
}), Vp = { class: "countdown-shiny-wrapper" }, qp = ["id"], Wp = ["id"];
function Up(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "countdown-shiny-container",
    style: b([e.style, e.transformCoef])
  }, [
    l("div", Vp, [
      l("div", {
        id: `${e.type}-shine`,
        ref: "smallTextRef",
        class: _(["shine", [e.type]])
      }, null, 10, qp),
      l("div", {
        id: `${e.type}-text`,
        ref: "bigTextRef",
        class: _(["text", [e.type]])
      }, null, 10, Wp)
    ])
  ], 4);
}
const D0 = /* @__PURE__ */ S(Fp, [["render", Up]]), Hp = T({
  name: "TrafficLightLuge",
  mixins: [P],
  props: {
    isDark: {
      default: !1,
      type: Boolean
    },
    color: {
      default: "grey",
      type: String
    },
    content: {
      default: "",
      type: String
    }
  }
}), Xp = { class: "content" };
function Gp(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["traffic-light-luge-container", { dark: e.isDark }])
  }, [
    l("div", {
      class: _(["circle", e.color])
    }, [
      l("span", Xp, $(e.content), 1)
    ], 2)
  ], 2);
}
const Yp = /* @__PURE__ */ S(Hp, [["render", Gp]]), Kp = T({
  name: "TrafficLightStartBar",
  components: {
    TrafficLightLuge: Yp,
    StartBar: wp
  },
  mixins: [P],
  props: {
    circles: {
      type: Object,
      default: () => ({})
    },
    fillSize: {
      type: Number,
      default: 0
    },
    mark: {
      type: Number,
      default: 0
    },
    showMark: {
      type: Boolean,
      default: !0
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    glow: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), `scale(${e})`;
    }
  }
}), Zp = { class: "circles-wrapper" };
function Jp(e, t, i, s, n, o) {
  const r = L("traffic-light-luge"), a = L("start-bar");
  return p(), h("div", {
    class: "traffic-light-start-bar-container",
    style: b([{ transform: e.transformCoef }])
  }, [
    l("div", Zp, [
      (p(!0), h(H, null, de(e.circles, (u, d) => (p(), V(r, {
        key: u.content,
        "is-dark": d === 0,
        color: u.color,
        content: u.content
      }, null, 8, ["is-dark", "color", "content"]))), 128))
    ]),
    M(a, {
      "fill-size": e.fillSize,
      "reversed-mode": !1,
      mark: e.mark,
      "show-mark": e.showMark,
      "hide-default-mark": "",
      "is-scaled": !1,
      horizontal: "",
      glow: e.glow
    }, null, 8, ["fill-size", "mark", "show-mark", "glow"])
  ], 4);
}
const L0 = /* @__PURE__ */ S(Kp, [["render", Jp]]), Qp = T({
  name: "BlockingEffectCenter",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    isVisible: {
      type: Boolean,
      default: !1
    },
    sideY: {
      type: String,
      default: ""
    },
    rotate: {
      type: String,
      default: "0deg"
    },
    effectType: {
      type: String,
      required: !0
    },
    verticalPositionOffset: {
      type: Number,
      default: 0
    }
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), `scale( ${e} )`;
    },
    customClasses() {
      const e = `blocking-effect-center-${this.sideY}`, t = this.isVisible ? "blocking-effect-center-visible" : "", i = this.isMobile() ? "mobile-overlay" : "";
      return [e, t, i];
    },
    effectStyle() {
      let e = "unset", t = "unset";
      const i = "";
      return this.sideY !== "bottom" ? e = `${this.verticalPositionOffset}%` : t = `${this.verticalPositionOffset}%`, {
        "margin-top": e,
        "margin-bottom": t,
        transform: `rotate(${this.rotate}) ${i}`
      };
    },
    customStyle() {
      return { "transform-origin": `center ${this.sideY}` };
    }
  }
});
function eh(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "blocking-effect-center-container",
    style: b(e.style)
  }, [
    l("div", {
      style: b([{ transform: e.transformCoef }, e.customStyle]),
      class: _([e.customClasses, "blocking-effect-center-wrapper"])
    }, [
      l("div", {
        class: _(["blocking-effect-center", e.effectType + "-effect"]),
        style: b(e.effectStyle)
      }, null, 6)
    ], 6)
  ], 4);
}
const O0 = /* @__PURE__ */ S(Qp, [["render", eh]]), th = T({
  name: "BlockingEffect",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    isVisible: {
      type: Boolean,
      default: !1
    },
    sideX: {
      type: String,
      default: "left"
    },
    sideY: {
      type: String,
      default: "bottom"
    },
    effectType: {
      type: String,
      required: !0
    },
    verticalPositionOffset: {
      type: Number,
      default: 0
    },
    horizontalPositionOffset: {
      type: Number,
      default: 0
    }
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), `scale( ${e} )`;
    },
    customClasses() {
      const e = `blocking-effect-${this.sideX}`, t = `blocking-effect-${this.sideY}`, i = this.isVisible ? "blocking-effect-visible" : "", s = this.isMobile() ? "mobile-overlay" : "";
      return [e, t, i, s];
    },
    effectStyle() {
      let e = "unset", t = "unset", i = "unset", s = "unset";
      return this.sideX === "left" ? t = `${this.horizontalPositionOffset}px` : this.sideX === "right" && (e = `${this.horizontalPositionOffset}px`), this.sideY === "top" ? i = `${this.verticalPositionOffset}px` : this.sideY === "bottom" && (s = `${this.verticalPositionOffset}px`), {
        "margin-left": e,
        "margin-right": t,
        "margin-top": i,
        "margin-bottom": s
      };
    },
    customStyle() {
      let e = "center";
      return this.sideX === "left" ? e = "right" : this.sideX === "right" && (e = "left"), { "transform-origin": `${e} ${this.sideY}` };
    }
  }
});
function ih(e, t, i, s, n, o) {
  return p(), h("div", {
    style: b([{ transform: e.transformCoef }, e.customStyle, e.style]),
    class: _([e.customClasses, "blocking-effect-container"])
  }, [
    l("div", {
      class: _(["blocking-effect", e.effectType + "-effect"]),
      style: b(e.effectStyle)
    }, null, 6)
  ], 6);
}
const I0 = /* @__PURE__ */ S(th, [["render", ih]]), sh = T({
  name: "StartCountdownTime",
  components: {
    ShrinkingTextBox: pe
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    glow: {
      type: Boolean,
      default: !1
    },
    time: {
      type: Number,
      required: !1,
      default: 0
    }
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef}) translate(-50%, 0)`,
        "transform-origin": "0 0"
      };
    }
  }
}), nh = {
  key: 0,
  class: "yellow-glow"
}, oh = { class: "right-wrapper" }, rh = { class: "time" };
function ah(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: "start-countdown-time-container",
    style: b([e.style, e.transformCoef])
  }, [
    e.glow ? (p(), h("div", nh)) : w("", !0),
    M(r, {
      text: e.$t("timeToStart"),
      "font-size": 32,
      width: 210,
      height: 57,
      class: "left-wrapper"
    }, null, 8, ["text"]),
    l("div", oh, [
      t[0] || (t[0] = l("span", { class: "green-dot" }, null, -1)),
      l("span", rh, $(e.time) + "s", 1)
    ])
  ], 4);
}
const M0 = /* @__PURE__ */ S(sh, [["render", ah]]), lh = T({
  name: "WindBox",
  mixins: [P],
  props: {
    rotateValue: {
      type: Number,
      default: 0
    },
    isRed: {
      type: Boolean,
      default: !1
    },
    windValue: {
      type: String || Number,
      default: "0"
    },
    windUnit: {
      type: String,
      default: "m/s"
    },
    glow: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    transformCoef() {
      let e = 1;
      return this.isScaled && (e = this.scaleCoef), {
        transform: `scale( ${e} )`
      };
    },
    rotateStyle() {
      return {
        transform: `rotate(${this.rotateValue}deg)`
      };
    }
  }
}), dh = {
  key: 0,
  class: "yellow-glow"
}, uh = { class: "wind-box-title" }, ch = { class: "wind-box-value" }, ph = { class: "wind-text" };
function hh(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "wind-box",
    style: b(e.transformCoef)
  }, [
    e.glow ? (p(), h("div", dh)) : w("", !0),
    l("div", uh, $(e.$t("wind")), 1),
    l("div", ch, [
      l("span", {
        class: _(["wind-arrow", [e.isRed ? "red-arrow" : "green-arrow"]]),
        style: b(e.rotateStyle)
      }, null, 6),
      l("span", ph, $(e.windValue) + " " + $(e.windUnit), 1)
    ])
  ], 4);
}
const N0 = /* @__PURE__ */ S(lh, [["render", hh]]), fh = T({
  name: "SpeedBarV2",
  mixins: [P],
  props: {
    fillSize: {
      type: Number,
      default: 0
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    glow: {
      type: Boolean,
      default: !1
    },
    mark: {
      type: Number,
      default: 0
    },
    showMark: {
      type: Boolean,
      default: !1
    },
    showArrows: {
      type: Boolean,
      default: !1
    },
    colorOverride: {
      type: String,
      default: ""
    },
    fillSizeTop: {
      type: Number,
      default: 0
    },
    fillColorTop: {
      type: String,
      default: "white"
    }
  },
  data() {
    return {
      pathImages: E,
      uniqueId: Math.random().toString(16).slice(2)
    };
  },
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isScaled || (e = 1), `scale(${e})`;
    },
    fillColor() {
      if (this.colorOverride.length > 0)
        return this.colorOverride;
      let e = "green";
      return this.fillSize < this.mark && (e = "orange"), this.fillSize > 100 && (e = "red"), e;
    },
    arrows() {
      return this.mark + (100 - this.mark) / 2;
    }
  }
}), mh = {
  key: 0,
  class: "yellow-glow"
}, gh = { class: "start-bar-wrapper" }, yh = { class: "start-bar-frame-wrapper" };
function vh(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "start-bar-v2",
    style: b([{ transform: e.transformCoef }])
  }, [
    e.glow ? (p(), h("div", mh)) : w("", !0),
    l("div", gh, [
      e.fillSizeTop > 0 ? (p(), h("div", {
        key: 0,
        class: "start-bar-fill-wrapper-top",
        style: b({ height: `${e.fillSizeTop}%` })
      }, [
        l("div", {
          class: _(["start-bar-fill", e.fillColorTop])
        }, null, 2)
      ], 4)) : w("", !0),
      l("div", {
        class: "start-bar-fill-wrapper",
        style: b({ height: `${e.fillSize}%` })
      }, [
        l("div", {
          class: _(["start-bar-fill", e.fillColor])
        }, null, 2)
      ], 4)
    ]),
    l("div", yh, [
      t[0] || (t[0] = l("div", { class: "start-bar-frame" }, null, -1)),
      l("div", {
        ref: "frameGlow",
        class: _(["start-bar-frame-glow", "start-bar-frame-glow-" + e.uniqueId])
      }, null, 2)
    ]),
    e.showArrows ? (p(), h("div", {
      key: 1,
      style: b({ bottom: `${e.arrows}%` }),
      class: "start-bar-arrows"
    }, t[1] || (t[1] = [
      l("div", { class: "arrow-right" }, null, -1),
      l("div", { class: "arrow-left" }, null, -1)
    ]), 4)) : w("", !0),
    e.showMark ? (p(), h("div", {
      key: 2,
      style: b({ bottom: `${e.mark}%` }),
      class: "start-bar-mark"
    }, null, 4)) : w("", !0)
  ], 4);
}
const A0 = /* @__PURE__ */ S(fh, [["render", vh]]), bh = T({
  name: "TextMessageWithNumber",
  components: {},
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    targetNumber: {
      type: Number,
      default: 1
    },
    textType: {
      type: Number,
      default: 0
    },
    isScaled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close"],
  computed: {
    transformCoef() {
      let e = 1;
      return this.isScaled && (e = this.scaleCoef), {
        transform: `scale(${e})`,
        "transform-origin": "0 0"
      };
    },
    textSrc() {
      let e = "txt-points";
      return this.targetNumber === 1 && (e = "txt-point"), this.textType === 1 && (e = "target"), this.textType === 2 && (e = "txt-arrow"), this.textType === 3 && (e = "txt-last-arrow"), this.textType === 4 && (e = "txt-last-target"), `https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/${e}.png`;
    },
    numberStyle() {
      if (this.textType === 0) {
        const e = `${this.targetNumber * -172}px`;
        let t = -110;
        return this.targetNumber === 10 && (t = -75), this.targetNumber === 11 && (t = -5), {
          background: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/points.png') ${e} 0`,
          width: "172px",
          height: "90px",
          "margin-left": `${t}px`
        };
      }
      return this.textType === 1 ? {
        background: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/numbers-sprite.png') 0 ${`${(this.targetNumber - 1) * -96}px`}`,
        width: this.targetNumber % 10 !== 0 ? "70px" : "112px",
        height: "96px"
        // 'margin-right': '20px'
      } : this.textType === 2 ? {
        background: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/arrow-number-sprite.png') ${`${(this.targetNumber - 1) * -117}px`} 0`,
        width: "117px",
        height: "142px"
      } : {};
    }
  }
}), $h = ["src"];
function kh(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["text-message-with-number", { reversed: e.textType === 0 }]),
    style: b([e.style, e.transformCoef])
  }, [
    l("img", {
      class: "text-message-with-number-left",
      src: e.textSrc
    }, null, 8, $h),
    l("div", {
      style: b(e.numberStyle),
      class: "text-message-with-number-right"
    }, null, 4)
  ], 6);
}
const _h = /* @__PURE__ */ S(bh, [["render", kh]]), wh = T({
  name: "TextMessageDynamic",
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    styleBg: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    firstLineText: {
      type: String,
      default: ""
    },
    firstLineTextSecond: {
      type: String,
      default: ""
    },
    secondLineText: {
      type: String,
      default: ""
    },
    secondLineTextSecond: {
      type: String,
      default: ""
    },
    duration: {
      type: Number,
      default: 0.2
    },
    delayStart: {
      type: Number,
      default: 1
    },
    delayShowText: {
      type: Number,
      default: 1.5
    },
    delayBetweenTwoTexts: {
      type: Number,
      default: 0.5
    }
  },
  emits: ["finished"],
  data() {
    return {
      timelineBackgroundArrive: null,
      timelineTextFirstShow: null,
      timelineTextSecondShow: null,
      timelineBackgroundLeave: null,
      phase: 0
    };
  },
  computed: {
    textFirstLine() {
      return this.phase === 0 ? this.firstLineText : this.firstLineTextSecond;
    },
    textSecondLine() {
      return this.phase === 0 ? this.secondLineText : this.secondLineTextSecond;
    }
  },
  mounted() {
    this.setUpTweens();
  },
  beforeUnmount() {
    this.resetAllTimelines();
  },
  methods: {
    setUpTweens() {
      const e = this.scaleCoef ? this.scaleCoef : 1, t = document.body.clientWidth / e;
      this.resetAllTimelines();
      const i = 0.8, s = 1.5, n = s / i, o = this.$refs.backgroundTop, r = t * -s;
      o.style.left = `${r}px`;
      const a = t * 0.079 * n;
      o.style.top = `${a}px`;
      const u = this.$refs.backgroundMiddle, d = t * -s;
      u.style.right = `${d}px`;
      const c = t * -0.08 * n;
      u.style.top = `${c}px`;
      const g = this.$refs.backgroundBottom, f = t * -s;
      g.style.left = `${f}px`;
      const m = 174 + t * 0.065 * n;
      g.style.top = `${m}px`;
      const v = this.$refs.firstLineDynamic, y = t * -0.2, k = t * 0.2;
      v.style.left = `${y}px`;
      const C = t * 29e-4, x = t * -29e-4;
      v.style.top = `${C}px`, v.style.opacity = "0";
      const j = this.$refs.secondLineDynamic, D = t * -0.2, z = t * 0.2;
      j.style.right = `${D}px`;
      const N = t * -29e-4, I = t * 29e-4;
      j.style.top = `${N}px`, j.style.opacity = "0";
      const O = this.firstLineText !== "" && this.secondLineText !== "", B = this.firstLineTextSecond !== "" && this.secondLineTextSecond !== "";
      this.phase = O ? 0 : 1;
      let R = this.delayStart;
      this.backgroundArrive(R), R += this.duration * 3, this.textFirstShow(
        R,
        k,
        x,
        z,
        I
      ), R += this.duration * 4 + this.delayShowText, B && O && (this.textSecondShow(
        R,
        k,
        x,
        z,
        I
      ), R += this.delayBetweenTwoTexts + this.duration * 3 + this.delayShowText), this.backgroundLeave(
        R,
        r,
        a,
        d,
        c,
        f,
        m
      );
    },
    backgroundArrive(e) {
      this.timelineBackgroundArrive = U.timeline().to(
        ".emotions-message-background .top",
        {
          left: "0px",
          top: "0px",
          ease: "none",
          opacity: 1,
          duration: this.duration
        },
        e
      ).to(
        ".emotions-message-background .middle",
        {
          right: "0px",
          top: "0px",
          ease: "none",
          opacity: 1,
          duration: this.duration
        },
        e + this.duration
      ).to(
        ".emotions-message-background .bottom",
        {
          left: "0px",
          top: "174px",
          ease: "none",
          opacity: 1,
          duration: this.duration
        },
        e + this.duration * 2
      );
    },
    textFirstShow(e, t, i, s, n) {
      this.timelineTextFirstShow = U.timeline().to(
        ".emotions-message-background .first-line-dynamic",
        {
          left: "0px",
          top: "0px",
          ease: "none",
          opacity: 1,
          duration: this.duration
        },
        e
      ).to(
        ".emotions-message-background .second-line-dynamic",
        {
          right: "0px",
          top: "0px",
          ease: "none",
          opacity: 1,
          duration: this.duration
        },
        e + this.duration
      ).to(
        ".emotions-message-background .first-line-dynamic",
        {
          duration: this.duration,
          opacity: 0,
          left: `${t}px`,
          top: `${i}px`
        },
        e + this.duration * 2 + this.delayShowText
      ).to(
        ".emotions-message-background .second-line-dynamic",
        {
          duration: this.duration,
          opacity: 0,
          right: `${s}px`,
          top: `${n}px`,
          onComplete: () => {
            this.phase = 1;
          }
        },
        e + this.duration * 2 + this.delayShowText
      );
    },
    textSecondShow(e, t, i, s, n) {
      this.timelineTextSecondShow = U.timeline().to(
        {},
        {
          duration: this.delayBetweenTwoTexts
        },
        e
      ).to(
        ".emotions-message-background .first-line-dynamic",
        {
          left: "0px",
          top: "0px",
          ease: "none",
          opacity: 1,
          duration: this.duration
        },
        e + this.delayBetweenTwoTexts
      ).to(
        ".emotions-message-background .second-line-dynamic",
        {
          right: "0px",
          top: "0px",
          ease: "none",
          opacity: 1,
          duration: this.duration
        },
        e + this.delayBetweenTwoTexts + this.duration
      ).to(
        ".emotions-message-background .first-line-dynamic",
        {
          duration: this.duration,
          opacity: 0,
          left: `${t}px`,
          top: `${i}px`
        },
        e + this.delayBetweenTwoTexts + this.duration * 2 + this.delayShowText
      ).to(
        ".emotions-message-background .second-line-dynamic",
        {
          duration: this.duration,
          opacity: 0,
          right: `${s}px`,
          top: `${n}px`
        },
        e + this.delayBetweenTwoTexts + this.duration * 2 + this.delayShowText
      );
    },
    backgroundLeave(e, t, i, s, n, o, r) {
      this.timelineBackgroundLeave = U.timeline().to(
        ".emotions-message-background .top",
        {
          left: `${t}px`,
          top: `${i}px`,
          ease: "none",
          duration: this.duration
        },
        e
      ).to(
        ".emotions-message-background .middle",
        {
          right: `${s}px`,
          top: `${n}px`,
          ease: "none",
          duration: this.duration
        },
        e + this.duration
      ).to(
        ".emotions-message-background .bottom",
        {
          left: `${o}px`,
          top: `${r}px`,
          ease: "none",
          duration: this.duration,
          onComplete: () => {
            this.$emit("finished");
          }
        },
        e + this.duration * 2
      );
    },
    resetAllTimelines() {
      var e, t, i, s;
      (e = this.timelineBackgroundArrive) == null || e.kill(), (t = this.timelineTextFirstShow) == null || t.kill(), (i = this.timelineTextSecondShow) == null || i.kill(), (s = this.timelineBackgroundLeave) == null || s.kill();
    }
  }
}), Th = {
  ref: "backgroundTop",
  class: "top"
}, Sh = {
  ref: "backgroundMiddle",
  class: "middle"
}, xh = {
  ref: "backgroundBottom",
  class: "bottom"
}, Ch = { class: "text-message-wrapper" }, zh = {
  ref: "firstLineDynamic",
  class: "first-line-dynamic"
}, jh = { class: "shadow" }, Bh = { class: "text" }, Ph = {
  ref: "secondLineDynamic",
  class: "second-line-dynamic"
}, Dh = { class: "shadow second" }, Lh = { class: "text" };
function Oh(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "text-message-dynamic",
    style: b([e.style])
  }, [
    l("div", {
      class: "emotions-message-background",
      style: b([e.styleBg])
    }, [
      l("div", Th, null, 512),
      l("div", Sh, null, 512),
      l("div", xh, null, 512),
      l("div", Ch, [
        l("div", zh, [
          l("div", jh, $(e.textFirstLine), 1),
          l("div", Bh, $(e.textFirstLine), 1)
        ], 512),
        l("div", Ph, [
          l("div", Dh, $(e.textSecondLine), 1),
          l("div", Lh, $(e.textSecondLine), 1)
        ], 512)
      ])
    ], 4)
  ], 4);
}
const R0 = /* @__PURE__ */ S(wh, [["render", Oh]]), Ih = T({
  name: "TextMessage",
  components: {
    TextMessageWithNumber: _h
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    firstLineText: {
      type: String,
      default: ""
    },
    firstLineSpriteType: {
      type: Number,
      default: 0
    },
    secondLineTextType: {
      type: Number,
      default: 2
    },
    secondLineLeftNumber: {
      type: Number,
      default: 0
    },
    thirdLineText: {
      type: String,
      default: ""
    },
    showFirstLine: {
      type: Boolean,
      default: !1
    },
    showSecondLine: {
      type: Boolean,
      default: !1
    },
    showThirdLine: {
      type: Boolean,
      default: !1
    },
    withAnimation: {
      type: Boolean,
      default: !0
    },
    durationTranslation: {
      type: Array,
      default: () => [0.5, 0.5, 0.5 * 2.5, 0.5]
    },
    durationHide: {
      type: Array,
      default: () => [0.5, 0.5, 0.5 * 2, 0.5]
    },
    startScale: {
      type: Array,
      default: () => [1, 1, 4, 0]
    },
    endScale: {
      type: Array,
      default: () => [1, 1, 1, 2]
    },
    easings: {
      type: Array,
      default: () => ["none", "none", "elastic.out(0.5, 0.25)", "power2.out"]
    },
    delayToHide: {
      type: Number,
      default: 0.5
    },
    showType: {
      type: Number,
      default: 1
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["finished-first-line", "finished-second-line", "finished-third-line"],
  data() {
    return {
      tweenFirstLine: null,
      tweenSecondLine: null,
      tweenThirdLine: null
    };
  },
  computed: {
    transformCoef() {
      let e = 1;
      return this.isScaled && (e = this.scaleCoef), {
        transform: `scale(${e}) translate(-50%, 0)`,
        "transform-origin": "0 0"
      };
    },
    showFirstLineSrc() {
      const e = ["text-trap-sprite", "100m-start-texts", "keirin-start-texts", "keirin-togo-texts", "kayak-start-texts", "kayak-togo-texts"];
      return this.firstLineText.length > 0 && !e.includes(this.firstLineText);
    },
    firstLineSrc() {
      return `https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/${this.firstLineText}.png`;
    },
    firstLineSpriteStyle() {
      return this.firstLineText === "text-trap-sprite" ? {
        width: "795px",
        height: "142px",
        background: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/text-trap-sprite.png') 0 ${this.firstLineSpriteType * -142}px`
      } : this.firstLineText === "100m-start-texts" ? {
        width: "922px",
        height: "100px",
        background: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/100m-start-texts-large.png') 0 ${this.firstLineSpriteType * -100}px`
      } : this.firstLineText === "kayak-start-texts" ? {
        width: "922px",
        height: "100px",
        background: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/kayak-start-texts-large.png') 0 ${this.firstLineSpriteType * -100}px`
      } : this.firstLineText === "keirin-start-texts" ? {
        width: "580px",
        height: "170px",
        background: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/321start-sprite.png') 0 ${this.firstLineSpriteType * -170}px`
      } : this.firstLineText === "keirin-togo-texts" ? {
        width: "572px",
        height: "100px",
        background: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/200-100-to-go.png') 0 ${this.firstLineSpriteType * -100}px`
      } : this.firstLineText === "kayak-togo-texts" ? {
        width: "572px",
        height: "100px",
        background: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/100-50-to-go.png') 0 ${this.firstLineSpriteType * -100}px`
      } : {};
    },
    thirdLineSrc() {
      return `https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/${this.thirdLineText}.png`;
    }
  },
  mounted() {
    this.withAnimation && this.setUpTweens();
  },
  methods: {
    setUpTweens() {
      const t = -0.2 * document.body.clientWidth;
      console.log("offset mame text message ", t), this.setFirstLineTween(t), this.setSecondLineTween(t), this.setThirdLineTween(t);
    },
    setFirstLineTween(e) {
      if (!this.showFirstLine) return;
      this.tweenFirstLine && this.tweenFirstLine.kill();
      const t = this.$refs.firstLine;
      this.showType === 1 && (t.style.left = `${e}px`), t.style.opacity = "0";
      const i = ".points-message .first-line";
      this.tweenFirstLine = U.timeline().to(
        i,
        {
          scale: this.startScale[this.showType],
          duration: 0.01
        }
      ).to(
        i,
        {
          duration: this.durationTranslation[this.showType],
          ease: this.easings[this.showType],
          left: "0px",
          opacity: 1,
          scale: 1
        }
      ).to(
        i,
        {
          duration: this.durationHide[this.showType],
          ease: "none",
          opacity: 0,
          scale: this.endScale[this.showType],
          left: `${this.showType === 1 ? e * -1 : 0}px`,
          delay: this.delayToHide + (this.showType === 2 ? this.durationTranslation[this.showType] - 0.5 : 0),
          onComplete: () => {
            this.$emit("finished-first-line");
          }
        }
      );
    },
    setSecondLineTween(e) {
      if (!this.showSecondLine) return;
      this.tweenSecondLine && this.tweenSecondLine.kill();
      const t = this.$refs.secondLine;
      this.showType === 1 && (t.style.right = `${e}px`), t.style.opacity = "0";
      const i = ".points-message .second-line";
      this.tweenSecondLine = U.timeline().to(
        i,
        {
          scale: this.startScale[this.showType],
          duration: 0.01,
          delay: this.showType === 2 && this.showFirstLine ? this.durationTranslation[this.showType] - 0.5 : 0
        }
      ).to(
        i,
        {
          duration: this.durationTranslation[this.showType],
          ease: this.easings[this.showType],
          right: "0px",
          opacity: 1,
          scale: 1
        }
      ).to(
        i,
        {
          duration: this.durationHide[this.showType],
          ease: "none",
          right: `${this.showType === 1 ? e * -1 : 0}px`,
          opacity: 0,
          scale: this.endScale[this.showType],
          delay: this.delayToHide,
          onComplete: () => {
            this.$emit("finished-second-line");
          }
        }
      );
    },
    setThirdLineTween(e) {
      if (!this.showThirdLine) return;
      this.tweenThirdLine && this.tweenThirdLine.kill();
      const t = this.$refs.thirdLine;
      this.showType === 1 && (t.style.right = `${e}px`), t.style.opacity = "0";
      const i = ".third-line";
      this.tweenThirdLine = U.timeline().to(
        i,
        {
          scale: this.startScale[this.showType],
          duration: 0.01,
          delay: this.showType === 2 && this.showSecondLine ? this.durationTranslation[this.showType] - 0.5 : 0
        }
      ).to(
        i,
        {
          duration: this.durationTranslation[this.showType],
          ease: this.easings[this.showType],
          right: "0px",
          opacity: 1,
          scale: 1
        }
      ).to(
        i,
        {
          duration: this.durationHide[this.showType],
          ease: "none",
          right: `${this.showType === 1 ? e * -1 : 0}px`,
          opacity: 0,
          delay: this.delayToHide,
          onComplete: () => {
            this.$emit("finished-third-line");
          }
        }
      );
    },
    beforeUnmount() {
      var e, t, i;
      (e = this.tweenFirstLine) == null || e.kill(), (t = this.tweenSecondLine) == null || t.kill(), (i = this.tweenThirdLine) == null || i.kill();
    }
  }
}), Mh = {
  key: 0,
  class: "first-line-wrapper"
}, Nh = ["src"], Ah = {
  ref: "secondLine",
  class: "second-line"
}, Rh = {
  key: 1,
  class: "third-line-wrapper"
}, Eh = ["src"];
function Fh(e, t, i, s, n, o) {
  const r = L("text-message-with-number");
  return p(), h("div", {
    class: "points-message",
    style: b([e.style, e.transformCoef])
  }, [
    e.showFirstLine ? (p(), h("div", Mh, [
      e.showFirstLineSrc ? (p(), h("img", {
        key: 0,
        ref: "firstLine",
        class: "first-line",
        src: e.firstLineSrc
      }, null, 8, Nh)) : (p(), h("div", {
        key: 1,
        ref: "firstLine",
        class: "first-line",
        style: b(e.firstLineSpriteStyle)
      }, null, 4))
    ])) : w("", !0),
    l("div", Ah, [
      e.showSecondLine ? (p(), V(r, {
        key: 0,
        "target-number": e.secondLineLeftNumber,
        "text-type": e.secondLineTextType
      }, null, 8, ["target-number", "text-type"])) : w("", !0)
    ], 512),
    e.showThirdLine ? (p(), h("div", Rh, [
      l("img", {
        ref: "thirdLine",
        class: "third-line",
        src: e.thirdLineSrc
      }, null, 8, Eh)
    ])) : w("", !0)
  ], 4);
}
const E0 = /* @__PURE__ */ S(Ih, [["render", Fh]]), Vh = T({
  name: "InstructionBox",
  components: { ShrinkingTextUniversal: ai },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    leftContentText: {
      type: String,
      default: ""
    },
    icon: {
      type: Number,
      default: -1
    },
    rightContentText: {
      type: String,
      default: ""
    },
    textForParse: {
      type: String,
      default: ""
    },
    onlyLeftText: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    transformCoef() {
      return this.isScaled ? {
        transform: `scale(${this.scaleCoef}) translateX(-50%)`,
        "transform-origin": "0 center"
      } : {
        transform: "translateX(-50%)"
      };
    },
    decideIconClass() {
      return this.icon === 0 ? "down" : this.icon === 1 ? "up" : "";
    },
    leftTextToRender() {
      let e = "";
      const t = "[b]", i = "[/b]", s = this.textForParse, n = s.indexOf(t) + t.length, o = s.indexOf(i);
      return n >= 0 && o >= 0 && (e = s.substring(n, o)), console.log(e, n, o), e;
    },
    rightTextToRenderFirstPart() {
      let e = "";
      const t = "[/b]", i = this.textForParse, s = i.indexOf(t);
      return s >= 0 && (e = i.substring(s + t.length)), console.log(e, s), e;
    },
    rightTextToRender() {
      return this.textForParse.length <= 0 ? this.rightContentText : "";
    },
    onlyLeftStyle() {
      return this.onlyLeftText ? {
        width: "1050px",
        padding: "0 20px"
      } : {};
    }
  }
}), qh = { class: "text left-text" }, Wh = { class: "text right-text" }, Uh = { class: "right-content-text" };
function Hh(e, t, i, s, n, o) {
  const r = L("shrinking-text-universal");
  return p(), h("div", {
    class: _(["instruction-box", e.rightTextToRender[0] === " " ? "gap" : ""]),
    style: b([e.style, e.transformCoef, e.onlyLeftStyle])
  }, [
    e.onlyLeftText ? (p(), V(r, {
      key: 0,
      "font-size": 40,
      text: e.leftTextToRender,
      "container-class-list": "text left-text",
      "max-line-limit": 2
    }, null, 8, ["text"])) : (p(), h(H, { key: 1 }, [
      l("div", qh, [
        J(e.$slots, "left", {}, () => {
          var a;
          return [
            l("div", {
              class: _(e.decideIconClass)
            }, null, 2),
            l("span", {
              class: _(["", `left-content-text-${e.decideIconClass}`])
            }, $(e.leftTextToRender), 3),
            ((a = e.rightTextToRenderFirstPart) == null ? void 0 : a.length) > 0 ? (p(), h("span", {
              key: 0,
              class: "left-content-text-special",
              style: b({ paddingLeft: e.rightTextToRenderFirstPart[0] === "," ? "0" : "10px" })
            }, $(e.rightTextToRenderFirstPart), 5)) : w("", !0)
          ];
        })
      ]),
      l("div", Wh, [
        J(e.$slots, "right", {}, () => [
          l("div", Uh, $(e.rightTextToRender), 1)
        ])
      ])
    ], 64))
  ], 6);
}
const F0 = /* @__PURE__ */ S(Vh, [["render", Hh]]), Xh = T({
  name: "MiniTableRow",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    rowData: {
      type: Object,
      required: !0
    },
    showPlayerTime: {
      type: Boolean,
      required: !1,
      default: !1
    },
    i: {
      type: Number,
      default: 0
    },
    isLast: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    basicStyle() {
      return {
        transform: `scale(${this.scaleCoef})`,
        "transform-origin": "0 0"
      };
    },
    getClass() {
      var t, i, s;
      let e = "";
      return (((t = this.rowData.player) == null ? void 0 : t.isPlayer) ?? !1) && (e += " isPlayer"), this.isLast && (e += " isLast"), (s = (i = this.rowData) == null ? void 0 : i.lastAttempt) != null && s.length && (e += " is-longer"), e;
    }
  }
}), Gh = { class: "pos-number" }, Yh = { class: "row-i" }, Kh = { class: "sider" }, Zh = { class: "country" }, Jh = { class: "country-name" }, Qh = ["src", "alt"], ef = {
  key: 0,
  class: "last-attempt"
}, tf = { class: "time" };
function sf(e, t, i, s, n, o) {
  var a, u;
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: _(["mini-table-row", e.getClass]),
    style: b(e.style)
  }, [
    l("div", {
      class: _(["position", `position-${e.rowData.position}`])
    }, [
      l("span", Gh, $(e.rowData.position), 1)
    ], 2),
    l("div", Yh, [
      l("div", Kh, [
        l("div", Zh, [
          l("div", Jh, $(e.rowData.countryString), 1),
          l("img", {
            class: "image",
            src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${e.rowData.country.toLowerCase()}.png`,
            alt: e.rowData.country
          }, null, 8, Qh)
        ]),
        M(r, {
          text: e.rowData.player.name,
          "font-size": 30,
          width: 300,
          height: 50,
          class: "player-name"
        }, null, 8, ["text"])
      ]),
      (u = (a = e.rowData) == null ? void 0 : a.lastAttempt) != null && u.length ? (p(), h("div", ef, $(e.rowData.lastAttempt), 1)) : w("", !0)
    ]),
    l("div", tf, $(e.rowData.textRight), 1)
  ], 6);
}
const nf = /* @__PURE__ */ S(Xh, [["render", sf]]), of = T({
  name: "BiathlonSplitTimes",
  components: { MiniTableRow: nf },
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    rowsData: {
      type: Array,
      required: !0
    }
  },
  computed: {
    basicStyle() {
      return {
        transform: `scale(${this.scaleCoef})`,
        "transform-origin": "0 0"
      };
    }
  }
});
function rf(e, t, i, s, n, o) {
  const r = L("mini-table-row");
  return p(), h("div", {
    class: "mini-table",
    style: b([e.style, e.basicStyle])
  }, [
    (p(!0), h(H, null, de(e.rowsData, (a, u) => (p(), V(r, {
      key: u,
      "row-data": a,
      i: u,
      "is-last": u == e.rowsData.length - 1,
      class: _(`${u}`)
    }, null, 8, ["row-data", "i", "is-last", "class"]))), 128))
  ], 4);
}
const V0 = /* @__PURE__ */ S(of, [["render", rf]]), af = T({
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    backgroundFile: {
      type: String,
      default: "bg-loading-trap.jpg"
    },
    gameVersion: {
      type: String,
      required: !1,
      default: ""
    }
  },
  data() {
    return {
      loadingState: _s()
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef})`
      };
    },
    backgroundStyle() {
      return { backgroundImage: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/loading/${this.backgroundFile}')` };
    },
    styleMessageBoxContainer() {
      return { bottom: `calc(120px * ${this.scaleCoef})` };
    },
    styleBottomLeftCornerWrapper() {
      return { "padding-left": `calc((30px + (var(--safe-area-inset-left) / 2)) / ${this.scaleCoef})` };
    }
  },
  created() {
    console.log(getComputedStyle(document.documentElement).getPropertyValue("--safe-area-inset-top"));
  }
}), lf = { class: "game-loading-version" }, df = { class: "loading-text" }, uf = { class: "loading-progress" }, cf = { class: "message-box-text" };
function pf(e, t, i, s, n, o) {
  return e.loadingState.showLoading ? (p(), h("div", {
    key: 0,
    class: _(["game-loading-container-ssm", e.isMobile() ? "mobile-overlay" : ""]),
    style: b([e.style, e.backgroundStyle])
  }, [
    l("div", {
      class: "top-right-corner-wrapper",
      style: b([e.transformCoef])
    }, t[0] || (t[0] = [
      l("img", {
        src: "https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/loading/SSM-logo.png",
        alt: ""
      }, null, -1)
    ]), 4),
    l("div", {
      class: "bottom-left-corner-wrapper",
      style: b([e.transformCoef, e.styleBottomLeftCornerWrapper])
    }, [
      l("div", lf, " VER. " + $(e.gameVersion), 1),
      l("div", df, [
        t[1] || (t[1] = K(" Loading... ")),
        l("span", uf, $(Math.min(Math.round(e.loadingState.loadingProgress), 100)) + "%", 1)
      ])
    ], 4),
    l("div", {
      class: "message-box-container",
      style: b(e.styleMessageBoxContainer)
    }, [
      l("div", {
        class: "message-box-wrapper",
        style: b([e.transformCoef])
      }, [
        t[3] || (t[3] = l("img", {
          class: "info-icon",
          src: "https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/loading/ICO_INFO_80px.png"
        }, null, -1)),
        l("div", cf, [
          t[2] || (t[2] = l("span", { class: "tip" }, "tip:", -1)),
          K(" " + $(e.loadingState.hintText), 1)
        ])
      ], 4)
    ], 4)
  ], 6)) : w("", !0);
}
const q0 = /* @__PURE__ */ S(af, [["render", pf]]), hf = T({
  name: "RecordBox",
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    side: {
      type: String,
      default: "left"
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    text: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    specialStyle() {
      let e = "0 0";
      this.side === "right" && (e = "100% 0");
      let t = 1;
      this.isScaled && (t = this.scaleCoef);
      const i = this.side === "right" ? {
        "background-image": "linear-gradient(to left, rgba(35,43,70,1) 0%, rgba(35,43,70,0.9) 30%, rgba(35,43,70,0.7) 70%, rgba(35,43,70,0) 100%)",
        "border-image-source": "linear-gradient(to left, rgba(254,185,66,1) 0%, rgba(254,185,66,0.9) 30%, rgba(254,185,66,0.7) 70%, rgba(254,185,66,0) 100%)",
        "justify-content": "flex-end",
        "padding-left": "0",
        "padding-right": "30px"
      } : {
        "background-image": "linear-gradient(to right, rgba(35,43,70,1) 0%, rgba(35,43,70,0.9) 30%, rgba(35,43,70,0.7) 70%, rgba(35,43,70,0) 100%)",
        "border-image-source": "linear-gradient(to right, rgba(254,185,66,1) 0%, rgba(254,185,66,0.9) 30%, rgba(254,185,66,0.7) 70%, rgba(254,185,66,0) 100%)",
        "justify-content": "flex-start",
        "padding-left": "30px",
        "padding-right": "0"
      };
      return {
        transform: `scale( ${t} )`,
        "transform-origin": e,
        ...i
      };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
});
function ff(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "position-box",
    style: b([e.specialStyle, e.style])
  }, $(e.text), 5);
}
const W0 = /* @__PURE__ */ S(hf, [["render", ff]]), mf = T({
  name: "AppSvgIcon",
  props: {
    iconName: {
      type: String,
      required: !0
    },
    width: {
      type: String,
      default: ""
    },
    height: {
      type: String,
      default: ""
    },
    fill: {
      type: String,
      default: ""
    },
    verticalFlip: {
      type: Boolean,
      default: !1
    },
    backgroundImage: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), gf = {
  key: 0,
  class: "svg-icon__reward-box",
  viewBox: "0 0 135.3 165.6",
  style: { "enable-background": "new 0 0 135.3 165.6" }
}, yf = { id: "base_and_stroke" }, vf = { transform: "translate(-1118.12 -753.219)" }, bf = {
  id: "reward-box__border-gradient",
  gradientUnits: "userSpaceOnUse",
  x1: "3422.01",
  y1: "1429.219",
  x2: "3422.01",
  y2: "1594.819",
  gradientTransform: "matrix(1 0 0 1 -2236.24 -676)"
}, $f = { id: "borders" }, kf = {
  key: 0,
  id: "reward-box-border-top",
  class: "reward-box__corner-border",
  points: "134.1,0 120.8,0 120.8,1.2 134.1,1.2 134.1,14.5 135.3,14.5 135.3,1.2 135.3,0"
}, _f = {
  key: 1,
  id: "reward-box-border-bottom",
  class: "reward-box__corner-border",
  points: "1.2,165.6 14.5,165.6 14.5,164.4 1.2,164.4 1.2,151 0,151 0,164.4 0,165.6"
}, wf = {
  key: 0,
  id: "img_clipping_mask"
};
function Tf(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["svg-icon", { "svg-icon-ssm": e.isSsm }])
  }, [
    e.iconName === "rewardBox" ? (p(), h("svg", gf, [
      l("g", yf, [
        l("g", vf, [
          l("linearGradient", bf, [
            e.isSsm ? w("", !0) : (p(), h(H, { key: 0 }, [
              t[0] || (t[0] = l("stop", {
                offset: "0",
                style: { "stop-color": "#22638c" }
              }, null, -1)),
              t[1] || (t[1] = l("stop", {
                offset: "1",
                style: { "stop-color": "#22638c" }
              }, null, -1))
            ], 64)),
            e.isSsm ? (p(), h(H, { key: 1 }, [
              t[2] || (t[2] = l("stop", {
                offset: "0",
                style: { "stop-color": "#7b87b8" }
              }, null, -1)),
              t[3] || (t[3] = l("stop", {
                offset: "1",
                style: { "stop-color": "#7b87b8" }
              }, null, -1))
            ], 64)) : w("", !0)
          ]),
          t[4] || (t[4] = l("polygon", {
            class: "reward-box__base",
            points: "1118.6,753.7 1252.9,753.7 1252.9,904.7 1240.5,918.3 1118.6,918.3"
          }, null, -1))
        ])
      ]),
      l("g", $f, [
        e.isSsm ? w("", !0) : (p(), h("polygon", kf)),
        e.isSsm ? w("", !0) : (p(), h("polygon", _f))
      ]),
      t[6] || (t[6] = is('<g id="glow" data-v-038d4d60><g transform="translate(-1118.12 -753.219)" data-v-038d4d60><polygon class="reward-box__glow-inner" points="1119.2,754.6 1252.4,754.6 1252.4,904.3 1240.1,917.8 1119.2,917.8" data-v-038d4d60></polygon></g><defs data-v-038d4d60><filter id="OpacityMaskFilter" filterUnits="userSpaceOnUse" x="1.1" y="1.4" width="133.2" height="163.2" data-v-038d4d60><feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB" result="source" data-v-038d4d60></feColorMatrix></filter></defs><mask id="inner-glow-mask" maskUnits="userSpaceOnUse" x="1.1" y="1.4" width="133.2" height="163.2" data-v-038d4d60><g class="reward-box__opacity-mask" data-v-038d4d60><image style="overflow:visible;" width="138" height="168" xlink:href="https://appspowerplaymanager.vshcdn.net/images/winter-sports/test/1AA123AA68C084E6.jpg" transform="matrix(1 0 0 1 -1 -1.4)" data-v-038d4d60></image></g></mask><g style="opacity:0.8;mask:url(#inner-glow-mask);" data-v-038d4d60><g transform="translate(-1118.12 -753.219)" data-v-038d4d60><polygon class="reward-box__glow" points="1119.2,754.6 1252.4,754.6 1252.4,904.3 1240.1,917.8 1119.2,917.8" data-v-038d4d60></polygon></g></g></g>', 1)),
      e.backgroundImage ? (p(), h("g", wf, t[5] || (t[5] = [
        is('<defs data-v-038d4d60><polygon id="clipping-mask-polygon" points="1.1,1.2 134.2,1.2 134.2,150.9 121.9,164.4 1.1,164.4" data-v-038d4d60></polygon></defs><clipPath id="clipping-mask-clippath" data-v-038d4d60><use xlink:href="#clipping-mask-polygon" style="overflow:visible;" data-v-038d4d60></use></clipPath><g id="image" style="clip-path:url(#clipping-mask-clippath);" data-v-038d4d60><image style="overflow:visible;" width="95" height="116" xlink:href="https://appspowerplaymanager.vshcdn.net/images/winter-sports/disciplines/2-training-practice.avif" transform="matrix(1.4233 0 0 1.4233 4.440183e-02 0.25)" data-v-038d4d60></image></g>', 3)
      ]))) : w("", !0)
    ])) : w("", !0)
  ], 2);
}
const Sf = /* @__PURE__ */ S(mf, [["render", Tf], ["__scopeId", "data-v-038d4d60"]]), xf = T({
  name: "BoatStats",
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    boatsData: {
      type: Array,
      default: []
    },
    text: {
      type: String,
      default: ""
    }
  },
  computed: {
    transformCoef() {
      const e = "0 0";
      let t = 1;
      return this.isScaled && (t = this.scaleCoef), {
        transform: `scale( ${t} )`,
        "transform-origin": e
      };
    }
  },
  methods: {
    getStyle(e) {
      return {
        top: `${e}%`
      };
    }
  }
}), Cf = { class: "boat-stats-container" }, zf = { class: "boat-track" }, jf = {
  key: 0,
  class: "vertical-line"
}, Bf = { class: "center-line" }, Pf = { class: "text" };
function Df(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "boat-stats",
    style: b([e.transformCoef, e.style])
  }, [
    l("div", Cf, [
      (p(!0), h(H, null, de(e.boatsData, (r, a) => (p(), h(H, { key: a }, [
        l("div", zf, [
          l("div", {
            class: _(["boat", r.isPlayer ? "is-player" : ""]),
            style: b(e.getStyle(r.offset))
          }, null, 6)
        ]),
        a < e.boatsData.length - 1 ? (p(), h("div", jf)) : w("", !0)
      ], 64))), 128)),
      l("div", Bf, [
        l("div", Pf, $(e.text), 1)
      ]),
      t[0] || (t[0] = l("div", { class: "bottom-line" }, null, -1))
    ])
  ], 4);
}
const U0 = /* @__PURE__ */ S(xf, [["render", Df]]), Lf = T({
  name: "ErrorModal",
  components: {
    PowerModal: Cn,
    PowerButton: zt
  },
  emits: ["close"],
  data() {
    return {
      pathImages: E,
      isSsm: !1,
      errorState: yi()
    };
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    handleErrorClick() {
      this.$emit("close"), yi().$reset();
    }
  }
}), Of = { class: "modal-container" }, If = ["src"], Mf = { class: "error-text" };
function Nf(e, t, i, s, n, o) {
  const r = L("power-button"), a = L("power-modal");
  return Ae((p(), h("div", {
    class: _(["error-modal", { "error-modal-ssm": e.isSsm }])
  }, [
    M(a, {
      header: e.errorState.headerText,
      "has-header-close-button": !1
    }, {
      default: F(() => [
        l("div", Of, [
          Ae(l("img", {
            src: `${e.pathImages}/icons/ICO_CONNECTION_LOST.png`,
            alt: ""
          }, null, 8, If), [
            [Ze, e.errorState.isConnectionError]
          ]),
          l("div", Mf, $(e.errorState.errorText), 1),
          M(r, {
            type: "primary",
            style: { width: "90%", "font-size": "40px" },
            onClick: e.handleErrorClick
          }, {
            default: F(() => t[0] || (t[0] = [
              K(" Close ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["header"])
  ], 2)), [
    [Ze, e.errorState.errorText]
  ]);
}
const H0 = /* @__PURE__ */ S(Lf, [["render", Nf]]), X0 = () => ({
  install: (e) => {
    e.config.errorHandler = (t, i, s) => (yi().addError({
      err: t,
      vm: i,
      info: s
    }), t);
  }
}), Af = T({
  name: "TutorialMessageBox",
  mixins: [P],
  props: {
    style: {
      type: Object,
      default: () => ({})
    },
    isRight: {
      type: Boolean,
      default: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    isBigger: {
      type: Boolean,
      default: !1
    },
    instructorName: {
      type: String,
      default: "anne"
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      const e = this.isScaled ? this.scaleCoef : 1, t = `scale(${this.isRight ? -e : e}, ${e})`, i = `translateX(${this.isRight ? "50%" : "0"})`;
      return console.warn(t, i), {
        transform: `${t} ${i}`,
        "transform-origin": `${this.isRight ? "right" : "left"} bottom`
      };
    },
    instructorStyle() {
      return {
        "background-image": `url("https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/tutorial/instructors/${this.instructorName}.png")`
      };
    },
    sideCss() {
      return this.isRight ? { right: "15%" } : { left: this.isSsm ? "0" : "5%" };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
});
function Rf(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["tutorial-anne", { "tutorial-anne-ssm": e.isSsm }, { bigger: e.isBigger }]),
    style: b([e.transformCoef, e.sideCss, e.instructorStyle, e.style])
  }, null, 6);
}
const Ef = /* @__PURE__ */ S(Af, [["render", Rf]]), Ff = T({
  name: "TutorialMobile",
  mixins: [P],
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    imgUrl: {
      type: String,
      required: !0
    },
    modelValue: {
      type: [Boolean, Number],
      required: !0
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      isSsm: !1,
      gameSettingsState: Gt()
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef}) translate(-50%, 0)`,
        "transform-origin": "bottom left"
      };
    },
    getImgBackground() {
      return {
        backgroundImage: `url(${this.imgUrl})`
      };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    onOnClick() {
      console.log("on"), this.$emit("update:modelValue", !0);
    },
    onOffClick() {
      console.log("off"), this.$emit("update:modelValue", !1);
    }
  }
}), Vf = { class: "mobile-wrapper" };
function qf(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["tutorial-mobil", { "tutorial-mobil-ssm": e.isSsm }]),
    style: b([e.transformCoef])
  }, [
    l("div", Vf, [
      l("div", {
        class: "picture-img",
        style: b([e.getImgBackground])
      }, null, 4),
      J(e.$slots, "default"),
      t[2] || (t[2] = l("div", { class: "mobile-img" }, null, -1))
    ]),
    l("div", {
      class: _(["hand hand-left", { yellow: e.gameSettingsState.isLeft }]),
      onClick: t[0] || (t[0] = (...r) => e.onOnClick && e.onOnClick(...r))
    }, null, 2),
    l("div", {
      class: _(["hand hand-right", { yellow: !e.gameSettingsState.isLeft }]),
      onClick: t[1] || (t[1] = (...r) => e.onOffClick && e.onOffClick(...r))
    }, null, 2)
  ], 6);
}
const Wf = /* @__PURE__ */ S(Ff, [["render", qf]]), Uf = T({
  name: "TutorialHandSettings",
  components: {
    BlueBox: Mi,
    TutorialMobile: Wf,
    PowerSwitch: Sn,
    PowerButton: zt,
    Tooltip: qt,
    PowerIconSlot: ri
  },
  mixins: [P],
  props: {
    imgUrl: {
      type: String,
      required: !0
    }
  },
  emits: ["clickContinue"],
  data() {
    return {
      pathImages: E,
      isSsm: !1,
      gameSettingsState: Gt()
    };
  },
  computed: {
    transformCoefBottom() {
      return {
        transform: `scale(${this.scaleCoef}) translate(-50%, 0)`,
        "transform-origin": "0 100%"
      };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    onClickButton() {
      this.$emit("clickContinue");
    }
  }
}), Hf = { class: "blue-box-text" }, Xf = { class: "tutorial-hand-bottom-item item-left" }, Gf = { class: "tutorial-hand-bottom-tooltip-content" }, Yf = { class: "primary-text" }, Kf = ["src"], Zf = { class: "tutorial-hand-bottom-item" }, Jf = { class: "tutorial-hand-bottom-item item-right" };
function Qf(e, t, i, s, n, o) {
  const r = L("blue-box"), a = L("tutorial-mobile"), u = L("power-icon-slot"), d = L("tooltip"), c = L("power-switch"), g = L("power-button");
  return p(), h("div", {
    class: _(["tutorial-hand-settings", { "tutorial-hand-settings-ssm": e.isSsm }])
  }, [
    M(r, { style: {
      width: "1216px",
      height: "78px",
      left: "50%",
      top: "20px"
    } }, {
      default: F(() => [
        l("span", Hf, $(e.$t("selectControls")), 1)
      ]),
      _: 1
    }),
    M(a, {
      modelValue: e.gameSettingsState.isLeft,
      "onUpdate:modelValue": t[0] || (t[0] = (f) => e.gameSettingsState.isLeft = f),
      "img-url": e.imgUrl
    }, {
      default: F(() => [
        J(e.$slots, "default")
      ]),
      _: 3
    }, 8, ["modelValue", "img-url"]),
    l("section", {
      class: "tutorial-hand-bottom",
      style: b([e.transformCoefBottom])
    }, [
      l("div", Xf, [
        M(d, {
          class: "tutorial-hand-bottom-tooltip",
          side: "bottom",
          "min-height": 135,
          "min-width": 490,
          style: { "margin-left": "11px" },
          "horizontal-adjust": 225,
          "arrow-horizontal-adjust": "20px",
          "click-type": !0
        }, {
          content: F(() => [
            l("div", Gf, [
              t[3] || (t[3] = l("div", { class: "shadow-box" }, null, -1)),
              l("div", Yf, $(e.$t("controlsInfoTooltip")), 1)
            ])
          ]),
          default: F(() => [
            M(u, { class: "instructions-icon" }, {
              default: F(() => [
                l("img", {
                  src: `${e.pathImages}/icons/instructions${e.isSsm ? "-ssm" : ""}.png`,
                  alt: "",
                  style: b({ transform: `skewX(${e.isSsm ? 0 : 8}deg)` })
                }, null, 12, Kf)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      l("div", Zf, [
        M(c, {
          modelValue: e.gameSettingsState.isLeft,
          "onUpdate:modelValue": t[1] || (t[1] = (f) => e.gameSettingsState.isLeft = f),
          "text-on": "leftHanded",
          "text-off": "rightHanded"
        }, null, 8, ["modelValue"])
      ]),
      l("div", Jf, [
        M(g, {
          class: _({ showButton: "btn-inactive" }),
          onClick: t[2] || (t[2] = (f) => e.onClickButton())
        }, {
          default: F(() => [
            K($(e.$t("continue")), 1)
          ]),
          _: 1
        })
      ])
    ], 4)
  ], 2);
}
const G0 = /* @__PURE__ */ S(Uf, [["render", Qf]]), em = T({
  name: "TutorialKeyboardKey",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: ""
    },
    letter: {
      type: String,
      default: ""
    },
    rotation: {
      type: String,
      default: ""
    },
    glow: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    keyClass() {
      let e = "";
      this.type === "space" ? e = "space-key" : this.type === "space-pressed" ? e = "space-key-pressed" : this.type === "shift" ? e = "shift-key" : e = `arrow-key arrow-${this.rotation}`;
      const t = this.glow ? "yellow-glow" : "";
      return `${e} ${t}`;
    },
    rotateKey() {
      return { transform: `rotate(${{
        down: "-90deg",
        right: "180deg",
        top: "90deg",
        left: "0deg"
      }[this.rotation] ?? 0})` };
    },
    isSpace() {
      return this.type.includes("space");
    },
    isShift() {
      return this.type.includes("shift");
    },
    isPressed() {
      return this.type.includes("pressed");
    },
    showLetter() {
      return this.letter.length > 0;
    },
    letterPosition() {
      return this.rotation === "left" ? {
        top: "5px",
        left: "15px"
      } : {
        top: "5px",
        right: "15px"
      };
    }
  }
}), tm = { key: 1 }, im = { key: 2 }, sm = {
  key: 0,
  class: "hand-icon"
}, nm = { class: "mouse-icon-wrapper" }, om = {
  key: 0,
  class: "hold-text"
};
function rm(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["tutorial-keyboard-key", e.keyClass]),
    style: b([e.style])
  }, [
    !e.isSpace || !e.isShift ? (p(), h("span", {
      key: 0,
      class: "arrow",
      style: b(e.rotateKey)
    }, null, 4)) : w("", !0),
    e.isSpace ? (p(), h("span", tm, " SPACE ")) : w("", !0),
    e.isShift ? (p(), h("span", im, " SHIFT ")) : w("", !0),
    e.isSpace ? (p(), h(H, { key: 3 }, [
      e.isPressed ? (p(), h("div", sm)) : w("", !0),
      l("div", nm, [
        e.isPressed ? (p(), h("div", om, $(e.$t("hold")), 1)) : w("", !0),
        t[0] || (t[0] = l("div", { class: "mouse-icon" }, null, -1)),
        t[1] || (t[1] = l("div", { class: "mouse-divider" }, " / ", -1))
      ])
    ], 64)) : w("", !0),
    e.showLetter ? (p(), h("div", {
      key: 4,
      class: "letter",
      style: b(e.letterPosition)
    }, $(e.letter), 5)) : w("", !0)
  ], 6);
}
const Y0 = /* @__PURE__ */ S(em, [["render", rm]]), am = T({
  name: "TutorialKeyboardKeys",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: ""
    },
    isScaled: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return this.isScaled ? { transform: `scale(${this.scaleCoef})` } : {};
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), lm = {
  key: 0,
  class: "tutorial-keyboard-header"
};
function dm(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: _(["tutorial-keyboard-keys", { "tutorial-keyboard-keys-ssm": e.isSsm }]),
    style: b([e.style, e.transformCoef])
  }, [
    e.text.length > 0 ? (p(), h("section", lm, [
      M(r, {
        text: e.text,
        "font-size": 28,
        width: 256,
        height: e.isSsm ? 40 : 36
      }, null, 8, ["text", "height"])
    ])) : w("", !0),
    J(e.$slots, "default")
  ], 6);
}
const K0 = /* @__PURE__ */ S(am, [["render", dm]]), um = T({
  name: "TutorialMessageBox",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    headerText: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "no"
    },
    buttonYellowText: {
      type: String,
      default: ""
    },
    forceHideWhiteText: {
      type: Boolean,
      default: !1
    },
    typeWrite: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["showFullText"],
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef}) translate(-50%, 0)`
      };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    showFullText() {
      this.$emit("showFullText");
    }
  }
}), cm = { class: "tutorial-message-header" }, pm = { class: "tutorial-message-text" }, hm = {
  key: 0,
  class: "tutorial-message-button-text-wrapper"
}, fm = { class: "tutorial-message-button-yellow-text" };
function mm(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    style: b([e.style, e.transformCoef]),
    class: _(["tutorial-message", `${e.color}-glow`, e.text.length > 165 ? "taller" : "", { "tutorial-message-ssm": e.isSsm }])
  }, [
    l("section", cm, $(e.headerText), 1),
    l("section", pm, [
      M(r, {
        text: e.text,
        "font-size": 34,
        width: 910,
        height: e.text.length > 165 ? 195 : 115,
        "use-type-writer": e.typeWrite,
        class: "tutorial-task-text-row",
        onShowFullText: e.showFullText
      }, null, 8, ["text", "height", "use-type-writer", "onShowFullText"])
    ]),
    e.typeWrite ? w("", !0) : (p(), h("section", hm, [
      l("div", fm, $(e.buttonYellowText), 1)
    ])),
    t[0] || (t[0] = l("div", { class: "glow-box" }, null, -1))
  ], 6);
}
const Z0 = /* @__PURE__ */ S(um, [["render", mm]]), gm = T({
  name: "TutorialOverlay",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    }
  }
});
function ym(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["tutorial-overlay", e.isMobile() ? "mobile-overlay" : ""]),
    style: b([e.style])
  }, null, 6);
}
const J0 = /* @__PURE__ */ S(gm, [["render", ym]]), vm = T({
  name: "TutorialTask",
  components: { ShrinkingTextUniversal: ai },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "blue"
    }
  },
  data() {
    return {
      isSsm: !1,
      isLongerClass: ""
    };
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  mounted() {
    var e;
    (e = this.$refs.tutorialTaskText) != null && e.isOverflowing && (this.isLongerClass = "longer");
  }
}), bm = { class: "tutorial-checkbox" }, $m = {
  key: 0,
  class: "icon-ok"
}, km = {
  key: 1,
  class: "icon-x"
}, _m = { class: "tutorial-task-text-row-box" };
function wm(e, t, i, s, n, o) {
  const r = L("shrinking-text-universal");
  return p(), h("div", {
    class: _(["tutorial-task", { "tutorial-task-ssm": e.isSsm }]),
    style: b([e.style])
  }, [
    l("section", {
      class: _(["tutorial-task-wrapper-row", [`${e.color}-task`, e.isLongerClass]])
    }, [
      l("div", bm, [
        e.color === "green" ? (p(), h("span", $m)) : w("", !0),
        e.color === "red" ? (p(), h("span", km)) : w("", !0)
      ]),
      l("div", _m, [
        M(r, {
          ref: "tutorialTaskText",
          text: e.text,
          "font-size": 32,
          "max-line-limit": 2,
          "container-class-list": "tutorial-task-text-row",
          "text-class-list": "tutorial-task-text-align"
        }, null, 8, ["text"])
      ])
    ], 2)
  ], 6);
}
const Tm = /* @__PURE__ */ S(vm, [["render", wm]]), Sm = T({
  name: "TutorialTasks",
  components: {
    TutorialTask: Tm
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    tasks: {
      type: Array,
      default: () => [
        {
          text: "",
          color: ""
        }
      ]
    }
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef}) translate(0, 0)`,
        "transform-origin": "0 0"
      };
    }
  }
});
function xm(e, t, i, s, n, o) {
  const r = L("tutorial-task");
  return p(), h("div", {
    class: "tutorial-tasks",
    style: b([e.style, e.transformCoef])
  }, [
    (p(!0), h(H, null, de(e.tasks, (a) => (p(), V(r, {
      key: a.text,
      text: a.text,
      color: a.color
    }, null, 8, ["text", "color"]))), 128))
  ], 4);
}
const Q0 = /* @__PURE__ */ S(Sm, [["render", xm]]), Cm = T({
  name: "RewardAnneTable",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    headerText: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "1132px"
    },
    height: {
      type: String,
      default: "unset"
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.isScaled ? this.scaleCoef : 1})`,
        width: this.width,
        height: this.height
      };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), zm = { class: "reward-anne-table-header" };
function jm(e, t, i, s, n, o) {
  return p(), h("div", {
    class: _(["reward-anne-table", { "reward-anne-table-ssm": e.isSsm }]),
    style: b([e.style, e.transformCoef])
  }, [
    l("section", zm, $(e.headerText), 1),
    J(e.$slots, "default"),
    t[0] || (t[0] = l("div", { class: "shadow-box" }, null, -1))
  ], 6);
}
const Bm = /* @__PURE__ */ S(Cm, [["render", jm]]), Pm = T({
  name: "TrainingRewards",
  components: {
    Tooltip: qt,
    AppSvgIcon: Sf
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    rewards: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      pathImages: E,
      pathEvents: go,
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef})`
      };
    },
    fullWidthCoef() {
      return 100 / this.scaleCoef;
    },
    fullHeightCoef() {
      return 100 / this.scaleCoef;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  /**
   *nepridane rewardy
   *[
   *'gallery_pieces',
   *'benefits',
   *'ranking_points',
   *'gp-basic',
   *'gp-bronze',
   *'gp-silver',
   *'gp-gold',
   *'gp-diamond'
   *]
   */
  methods: {
    additionalStyle(e) {
      return e ? {
        backgroundSize: "cover"
      } : {};
    },
    getRewardIcon(e, t) {
      if (e = e.toLowerCase(), t) return `url(${this.pathEvents}/${t}/icons/ico-${e}.png)`;
      if (e === "universal_training_points") return `url(${this.pathImages}/icons/training_icons_120.png) 0 0`;
      if (e === "energy") return `url(${this.pathImages}/icons/training_icons_120.png) -120px 0`;
      if (e === "money") return `url(${this.pathImages}/icons/training_icons_120.png) -240px 0`;
      if (e === "gems") return `url(${this.pathImages}/icons/training_icons_120.png) -360px 0`;
      if (e === "starts") return `url(${this.pathImages}/icons/training_icons_120.png) -480px 0`;
      if (e === "training_points") return `url(${this.pathImages}/icons/training_icons_120.png) -600px 0`;
      if (e === "prestige") return `url(${this.pathImages}/icons/training_icons_120.png) -720px 0`;
      if (e === "wild_card") return `url(${this.pathImages}/icons/training_icons_120.png) -840px 0`;
      if (e === "energy_drink") return `url(${this.pathImages}/icons/training_icons_120.png) -960px 0`;
      if (e === "experience") return `url(${this.pathImages}/icons/training_icons_120.png) -1080px 0`;
      if (e === "research_points") return `url(${this.pathImages}/icons/training_icons_120.png) -1200px 0`;
      console.warn("icon type not implemented:", e);
    },
    getHighlight(e, t) {
      return e === "reputation" && t === "discipline-event";
    },
    formatThousands(e) {
      return Ee(e);
    }
  }
}), Dm = { class: "all-rewards-text" }, Lm = { class: "training-reward" }, Om = { class: "training-reward-number" };
function Im(e, t, i, s, n, o) {
  const r = L("app-svg-icon"), a = L("tooltip");
  return p(), h("div", {
    class: _(["training-rewards-container", { "training-rewards-container-ssm": e.isSsm }])
  }, [
    l("div", Dm, [
      l("div", null, $(e.$t("rewards")), 1)
    ]),
    (p(!0), h(H, null, de(e.rewards, (u, d) => (p(), V(a, {
      key: d,
      side: "bottom",
      "arrow-horizontal-adjust": "40%",
      "horizontal-adjust": 50,
      "click-type": !0,
      text: e.$t(u.title),
      "min-height": 100,
      "min-width": 185
    }, {
      default: F(() => [
        l("div", Lm, [
          M(r, {
            class: "training-reward-bg",
            "icon-name": "rewardBox"
          }),
          l("div", {
            class: "training-reward-icon",
            style: b([
              { background: e.getRewardIcon(u.type, u.eventName ?? "") },
              e.additionalStyle(u.eventName)
            ])
          }, null, 4),
          l("div", Om, $(e.formatThousands(u.count)), 1)
        ])
      ]),
      _: 2
    }, 1032, ["text"]))), 128))
  ], 2);
}
const zn = /* @__PURE__ */ S(Pm, [["render", Im]]), Mm = T({
  name: "TutorialRewards",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    rewards: {
      type: Array,
      required: !0
    }
  },
  data() {
    return {
      pathImages: E
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef})`
      };
    },
    fullWidthCoef() {
      return 100 / this.scaleCoef;
    },
    fullHeightCoef() {
      return 100 / this.scaleCoef;
    }
  },
  /**
   *nepridane rewardy
   *[
   *'gallery_pieces',
   *'benefits',
   *'ranking_points',
   *'gp-basic',
   *'gp-bronze',
   *'gp-silver',
   *'gp-gold',
   *'gp-diamond'
   *]
   */
  methods: {
    getRewardIcon(e) {
      if (e = e.toLowerCase(), e === "universal_tutorial_points") return `url(${this.pathImages}/icons/training_icons_184.png) 0 0`;
      if (e === "energy") return `url(${this.pathImages}/icons/training_icons_184.png) -184px 0`;
      if (e === "money") return `url(${this.pathImages}/icons/training_icons_184.png) -368px 0`;
      if (e === "gems") return `url(${this.pathImages}/icons/training_icons_184.png) -552px 0`;
      if (e === "starts") return `url(${this.pathImages}/icons/training_icons_184.png) -736px 0`;
      if (e === "training_points") return `url(${this.pathImages}/icons/training_icons_184.png) -920px 0`;
      if (e === "prestige") return `url(${this.pathImages}/icons/training_icons_184.png) -1104px 0`;
      if (e === "wild_card") return `url(${this.pathImages}/icons/training_icons_184.png) -1288px 0`;
      if (e === "energy_drink") return `url(${this.pathImages}/icons/training_icons_184.png) -1472px 0`;
      if (e === "experience") return `url(${this.pathImages}/icons/training_icons_184.png) -1656px 0`;
      if (e === "research_points") return `url(${this.pathImages}/icons/training_icons_184.png) -1840px 0`;
      if (e === "blur") return `url(${this.pathImages}/icons/bg_blue_blur.png)`;
      console.warn("icon type not implemented:", e);
    }
  }
}), Nm = { class: "tutorial-rewards-container" }, Am = { class: "tutorial-reward-title" }, Rm = { class: "tutorial-reward-text" };
function Em(e, t, i, s, n, o) {
  return p(), h("div", Nm, [
    (p(!0), h(H, null, de(e.rewards, (r, a) => (p(), h("div", {
      key: a,
      class: "tutorial-reward"
    }, [
      l("div", {
        class: "tutorial-reward-icon-glow",
        style: b({ backgroundImage: e.getRewardIcon("blur") })
      }, null, 4),
      l("div", {
        class: "tutorial-reward-icon",
        style: b({ background: e.getRewardIcon(r.type) })
      }, null, 4),
      l("div", null, [
        l("div", Am, $(r.title), 1),
        l("div", Rm, $(r.text), 1)
      ])
    ]))), 128))
  ]);
}
const Fm = /* @__PURE__ */ S(Mm, [["render", Em]]), Vm = T({
  name: "TutorialTrainingRewards",
  components: {
    RewardAnneTable: Bm,
    TrainingRewards: zn,
    BlueBoxSolid: Ts,
    PowerButton: zt,
    TutorialAnne: Ef,
    TutorialRewards: Fm
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    headerText: {
      type: String,
      default: "anne"
    },
    width: {
      type: String,
      default: "1132px"
    },
    height: {
      type: String,
      default: "unset"
    },
    subheader: {
      type: String,
      default: ""
    },
    rewards: {
      type: Array,
      required: !0
    },
    mainRewards: {
      type: Array,
      required: !0
    },
    instructorName: {
      type: String,
      default: "anne"
    }
  },
  emits: ["onClickContinue"],
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.specialScaleCoef})`,
        "transform-origin": "0% 0%",
        width: `calc(100% / ${this.specialScaleCoef})`,
        height: `calc(100% / ${this.specialScaleCoef})`
      };
    },
    getStyleBottomBox() {
      const e = `calc(var(--safe-area-inset-left) / ${this.specialScaleCoef})`, t = `calc(var(--safe-area-inset-right) / ${this.specialScaleCoef})`;
      let i = "23.5px";
      return this.isIOS() && !this.isTablet() && (i = `calc(23.5px + calc(var(--safe-area-inset-bottom) / ${this.specialScaleCoef}))`), {
        width: `calc(98% - ${e} - ${t})`,
        bottom: i,
        position: this.isMobile() ? "fixed" : "absolute",
        left: "1%",
        "margin-left": e,
        "margin-right": t
      };
    },
    specialScaleCoef() {
      let e = this.scaleCoef;
      if (this.isIOS() && !this.isTablet()) {
        const t = document.getElementById("game-wrapper"), i = getComputedStyle(t).getPropertyValue("--safe-area-inset-bottom").replace("px", "") || 0;
        e = this.scaleCoef - Number(i) / window.innerHeight;
      }
      return e;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), qm = { class: "tutorial-rewards-subheader" }, Wm = { class: "buttons-container" };
function Um(e, t, i, s, n, o) {
  const r = L("tutorial-anne"), a = L("tutorial-rewards"), u = L("reward-anne-table"), d = L("training-rewards"), c = L("power-button"), g = L("blue-box-solid");
  return p(), h("div", {
    class: _(["tutorial-training-rewards-container", e.isMobile() ? "mobile-overlay" : ""]),
    style: b([e.style, e.transformCoef])
  }, [
    M(r, {
      "is-scaled": !1,
      "is-bigger": "",
      style: {
        left: "4%"
      },
      "instructor-name": e.instructorName
    }, null, 8, ["instructor-name"]),
    M(u, {
      "header-text": e.$t(e.headerText),
      style: {
        position: "absolute",
        left: "calc(590px + 8%)",
        top: "10%"
      },
      "is-scaled": !1
    }, {
      default: F(() => [
        l("div", qm, $(e.subheader), 1),
        M(a, { rewards: e.mainRewards }, null, 8, ["rewards"])
      ]),
      _: 1
    }, 8, ["header-text"]),
    M(g, {
      class: _(["training-rewards-row", { "training-rewards-row-ssm": e.isSsm }]),
      style: b(e.getStyleBottomBox)
    }, {
      default: F(() => [
        M(d, { rewards: e.rewards }, null, 8, ["rewards"]),
        l("div", Wm, [
          M(c, {
            class: _(["button-continue", { disabled: !1 }]),
            onClick: t[0] || (t[0] = (f) => e.$emit("onClickContinue"))
          }, {
            default: F(() => [
              K($(e.$t("continue")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["class", "style"])
  ], 6);
}
const e$ = /* @__PURE__ */ S(Vm, [["render", Um]]), Hm = T({
  name: "TrainingAttribute",
  components: {
    ProgressBar: nc
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    from: {
      type: Number,
      required: !0
    },
    next: {
      type: Number,
      required: !0
    },
    tpNew: {
      type: Number,
      required: !0
    },
    tpMilestone: {
      type: Number,
      required: !0
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return {
        /*
         * transform: 'scale(' + this.scaleCoef + ') translate(0, 0)',
         * 'transform-origin': '0 0'
         */
      };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    formatThousands(e) {
      return Ee(e);
    }
  }
}), Xm = { class: "training-attribute-header" }, Gm = { class: "training-progress-container" }, Ym = { class: "training-progress-bar" }, Km = { class: "training-progress-numeric" }, Zm = { class: "from" }, Jm = { class: "next" };
function Qm(e, t, i, s, n, o) {
  const r = L("progress-bar");
  return p(), h("div", {
    class: _(["training-attribute-container", { "training-attribute-container-ssm": e.isSsm }]),
    style: b([e.transformCoef, e.style])
  }, [
    l("div", Xm, $(e.$t("attribute")), 1),
    l("div", Gm, [
      l("div", Ym, [
        M(r, {
          "actual-value": e.tpNew,
          "max-value": e.tpMilestone,
          "left-text": e.formatThousands(e.from).toString(),
          "right-text": e.formatThousands(e.next).toString()
        }, null, 8, ["actual-value", "max-value", "left-text", "right-text"])
      ]),
      l("div", Km, [
        l("div", Zm, $(e.formatThousands(e.tpNew)), 1),
        l("div", Jm, " /" + $(e.formatThousands(e.tpMilestone)), 1),
        t[0] || (t[0] = l("span", { class: "icon-tp" }, null, -1))
      ])
    ])
  ], 6);
}
const eg = /* @__PURE__ */ S(Hm, [["render", Qm]]), tg = T({
  name: "TrainingBlueBox",
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    text: {
      type: String,
      required: !1,
      default: ""
    },
    points: {
      type: String,
      requred: !1,
      default: ""
    }
  },
  data() {
    return {
      isSsm: !1,
      tweenFirstLine: null,
      tweenSecondLine: null,
      tweenBg: null
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef}) translate(-50%, -50%)`,
        "transform-origin": "0 0"
      };
    },
    formatedPoints() {
      return Ee(Number(this.points));
    },
    basicStyle() {
      return {
        width: `${100 / this.scaleCoef}%`,
        height: "184px"
      };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  mounted() {
    this.setUpTweens();
  },
  methods: {
    setUpTweens() {
      this.$nextTick(() => {
        const t = -0.2 * (document.body.clientWidth / this.scaleCoef), i = 0.5;
        this.setFirstLineTween(i, t), this.setSecondLineTween(i, t), this.setBackgroundTween(i);
      });
    },
    setFirstLineTween(e, t) {
      this.tweenFirstLine && this.tweenFirstLine.kill();
      const i = this.$refs.firstLine;
      i.style.left = `${t}px`, i.style.opacity = "0", this.tweenFirstLine = U.to(
        ".training-blue-box-first-line",
        {
          duration: e,
          ease: "none",
          left: "0px",
          opacity: 1
        }
      );
    },
    setSecondLineTween(e, t) {
      this.tweenSecondLine && this.tweenSecondLine.kill();
      const i = this.$refs.secondLine;
      i.style.right = `${t}px`, i.style.opacity = "0", this.tweenSecondLine = U.to(
        ".training-blue-box-second-line",
        {
          duration: e,
          ease: "none",
          right: "0px",
          opacity: 1
        }
      );
    },
    setBackgroundTween(e) {
      this.tweenBg && this.tweenBg.kill();
      const t = this.$refs.bg;
      t.style.opacity = "0", this.tweenBg = U.to(
        ".training-blue-box",
        {
          duration: e,
          ease: "none",
          opacity: 1
        }
      );
    }
  }
}), ig = {
  ref: "firstLine",
  class: "training-blue-box-first-line"
}, sg = {
  ref: "secondLine",
  class: "training-blue-box-second-line"
}, ng = { class: "training-blue-box-second-line-shadow" }, og = { class: "training-blue-box-second-line-text" };
function rg(e, t, i, s, n, o) {
  return p(), h("div", {
    ref: "bg",
    class: _(["training-blue-box", { "training-blue-box-ssm": e.isSsm }]),
    style: b([e.style, e.basicStyle, e.transformCoef])
  }, [
    l("div", ig, [
      K($(e.formatedPoints) + " ", 1),
      t[0] || (t[0] = l("span", { class: "icon-tp" }, null, -1))
    ], 512),
    t[1] || (t[1] = l("div", { class: "training-blue-box-divider" }, null, -1)),
    l("div", sg, [
      l("div", ng, $(e.text), 1),
      l("div", og, $(e.text), 1)
    ], 512)
  ], 6);
}
const t$ = /* @__PURE__ */ S(tg, [["render", rg]]), ag = T({
  name: "TrainingTask",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    text: {
      type: String,
      default: ""
    },
    showPoints: {
      type: Boolean,
      default: !1
    },
    percent: {
      type: String,
      default: ""
    },
    points: {
      type: String,
      default: ""
    },
    showPointsDelay: {
      type: Number,
      default: 500
    },
    maxTPLength: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      showPointsValue: !1,
      isSsm: !1
    };
  },
  computed: {
    showPointsClass() {
      return this.showPointsValue ? "points-stick-out" : "";
    },
    widthClass() {
      return this.maxTPLength < 6 ? `width-${this.maxTPLength}` : "width-5";
    },
    pointsFormated() {
      return Ee(Number(this.points));
    }
  },
  watch: {
    showPoints() {
      this.showPointsValue = this.showPoints;
    }
  },
  mounted() {
    setTimeout(() => {
      this.showPointsValue = this.showPoints;
    }, this.showPointsDelay);
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), lg = { class: "training-task-wrapper-row" }, dg = { class: "training-task-percent-row" }, ug = { class: "text-tp" }, cg = { class: "text-tp" };
function pg(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: _(["training-task", { "training-task-ssm": e.isSsm }]),
    style: b([e.style])
  }, [
    l("section", lg, [
      M(r, {
        text: e.text,
        "font-size": e.isSsm ? 30 : 34,
        width: 255,
        height: 42,
        class: "training-task-text-row"
      }, null, 8, ["text", "font-size"]),
      l("div", dg, [
        l("span", ug, $(e.percent) + "%", 1)
      ])
    ]),
    l("section", {
      class: _(["training-task-points-row", [e.showPointsClass, e.widthClass]])
    }, [
      l("span", cg, $(e.pointsFormated), 1),
      t[0] || (t[0] = K()),
      t[1] || (t[1] = l("span", { class: "icon-tp" }, null, -1))
    ], 2)
  ], 6);
}
const hg = /* @__PURE__ */ S(ag, [["render", pg]]), fg = T({
  name: "TrainingTasks",
  components: {
    TrainingTask: hg
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    tasks: {
      type: Array,
      default: () => [
        {
          text: "",
          percent: "",
          points: "",
          showPoints: !1
        }
      ]
    },
    maxTPLength: {
      type: Number,
      default: 5
    }
  }
});
function mg(e, t, i, s, n, o) {
  const r = L("training-task");
  return p(), h("div", {
    class: "training-tasks",
    style: b([e.style])
  }, [
    (p(!0), h(H, null, de(e.tasks, (a) => (p(), V(r, {
      key: a.text,
      text: e.$t(a.text),
      "show-points": a.showPoints,
      percent: a.percent,
      points: a.points,
      "max-t-p-length": e.maxTPLength
    }, null, 8, ["text", "show-points", "percent", "points", "max-t-p-length"]))), 128))
  ], 4);
}
const gg = /* @__PURE__ */ S(fg, [["render", mg]]), yg = T({
  name: "TrainingLeftTopBox",
  components: {
    TrainingTasks: gg,
    HighScoreBox: Xl
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    text: {
      type: String,
      default: ""
    },
    points: {
      type: String,
      default: ""
    },
    tasks: {
      type: Array,
      default: () => [
        {
          text: "",
          percent: "",
          points: "",
          showPoints: !1
        }
      ]
    },
    maxTPLength: {
      type: Number,
      default: 5
    }
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef})`,
        "transform-origin": "0 0"
      };
    }
  }
});
function vg(e, t, i, s, n, o) {
  const r = L("high-score-box"), a = L("training-tasks");
  return p(), h("div", {
    style: b([e.style, e.transformCoef])
  }, [
    M(r, {
      text: e.text,
      points: e.points
    }, null, 8, ["text", "points"]),
    M(a, {
      tasks: e.tasks,
      "max-t-p-length": e.maxTPLength
    }, null, 8, ["tasks", "max-t-p-length"])
  ], 4);
}
const i$ = /* @__PURE__ */ S(yg, [["render", vg]]), bg = T({
  name: "TrainingStars",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    stars: {
      type: Number,
      required: !0
    }
  },
  data() {
    return {
      pathImages: E
    };
  },
  computed: {
    transformCoef() {
      return {
        /*
         * transform: 'scale(' + this.scaleCoef + ') translate(0, -50%)',
         * transformOrigin: '50% 100%'
         */
        // transform: 'scale(' + this.scaleCoef + ') translate(0, -50%)'
        /*
         * transform: 'scale(' + this.scaleCoef + ') translate(-50%, 0)',
         * 'transform-origin': '0 0'
         */
        // transform: 'scale(' + this.scaleCoef + ')'
      };
    }
  }
});
function $g(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "training-stars-container",
    style: b([e.transformCoef, e.style])
  }, [
    l("div", {
      class: _(["training-star training-star-left", { "gray-star": e.stars < 1 }]),
      style: b({ backgroundImage: `url(${e.pathImages}/icons/training-star.png)` })
    }, null, 6),
    l("div", {
      class: _(["training-star training-star-middle", { "gray-star": e.stars < 2 }]),
      style: b({ backgroundImage: `url(${e.pathImages}/icons/training-star.png)` })
    }, null, 6),
    l("div", {
      class: _(["training-star training-star-right", { "gray-star": e.stars < 3 }]),
      style: b({ backgroundImage: `url(${e.pathImages}/icons/training-star.png)` })
    }, null, 6)
  ], 4);
}
const kg = /* @__PURE__ */ S(bg, [["render", $g]]), _g = T({
  name: "TrainingScore",
  components: {
    PowerIconSlot: ri,
    Tooltip: qt
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    base: {
      type: String,
      required: !0
    },
    total: {
      type: String,
      required: !0
    },
    bonuses: {
      type: String,
      required: !0
    },
    subscription: {
      type: Object,
      required: !1,
      default: null
    },
    bonus: {
      type: Object,
      required: !1,
      default: null
    }
  },
  data() {
    return {
      pathImages: E,
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return {
        /*
         * transform: 'scale(' + this.scaleCoef + ')',
         * transformOrigin: '50% 0%'
         */
      };
    },
    isSubscriptionDisabled() {
      var e;
      return !((e = this.subscription) != null && e.active);
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), wg = ["src"], Tg = { class: "training-score-score left-score" }, Sg = { class: "training-score-trext-wrapper" }, xg = { class: "training-score-text" }, Cg = { class: "training-score-number-container" }, zg = { class: "training-score-number" }, jg = { class: "training-score-score" }, Bg = { class: "training-score-text total-score" }, Pg = { class: "training-score-number-container" }, Dg = { class: "training-score-number total-score-number" }, Lg = { class: "training-score-bonuses" }, Og = { class: "training-score-score right-score" }, Ig = { class: "training-score-trext-wrapper" }, Mg = { class: "training-score-text" }, Ng = { class: "training-score-number-container" }, Ag = { class: "training-score-number" }, Rg = { class: "training-score-info-tooltip-content" }, Eg = {
  key: 0,
  class: "shadow-box"
}, Fg = { class: "tooltip-header" }, Vg = { style: { "z-index": "100" } }, qg = { class: "primary-text" }, Wg = { key: 0 }, Ug = ["src"];
function Hg(e, t, i, s, n, o) {
  const r = L("power-icon-slot"), a = L("tooltip");
  return p(), h("div", {
    class: _(["training-score-container", { "training-score-container-ssm": e.isSsm }]),
    style: b([e.transformCoef, {}, e.style])
  }, [
    l("img", {
      src: `${e.pathImages}/icons/${e.isSsm ? "BG_BOX_CENTER_PURPLE_LIGHT" : "BG_BOX_CENTER_BLUE_LIGHT"}.png`,
      class: "background-img"
    }, null, 8, wg),
    l("div", Tg, [
      l("div", Sg, [
        l("div", xg, $(e.$t("baseScore")), 1),
        l("div", Cg, [
          l("div", zg, $(e.base), 1),
          t[0] || (t[0] = l("span", { class: "icon-tp small-tp" }, null, -1))
        ])
      ])
    ]),
    l("div", jg, [
      l("div", Bg, $(e.$t("totalScore")), 1),
      l("div", Pg, [
        l("div", Dg, $(e.total), 1),
        t[1] || (t[1] = l("span", { class: "icon-tp" }, null, -1))
      ])
    ]),
    l("div", Lg, [
      l("div", Og, [
        l("div", Ig, [
          l("div", Mg, $(e.$t("bonuses")), 1),
          l("div", Ng, [
            l("div", Ag, $(e.bonuses), 1),
            t[2] || (t[2] = l("span", { class: "icon-tp small-tp" }, null, -1))
          ])
        ])
      ]),
      M(a, {
        class: "training-score-info-tooltip",
        side: "bottom",
        "min-height": 233,
        "min-width": 550,
        "vertical-adjust": 30,
        "horizontal-adjust": 10,
        style: { "margin-left": "11px" },
        "click-type": !0
      }, {
        content: F(() => [
          l("div", Rg, [
            e.isSsm ? w("", !0) : (p(), h("div", Eg)),
            l("div", Fg, [
              t[3] || (t[3] = l("div", { class: "elipse" }, null, -1)),
              l("span", Vg, $(e.$t("bonuses")), 1)
            ]),
            l("div", qg, [
              e.bonus.equipment ? (p(), h("div", Wg, $(e.$t("bonusEquipment").replace("%s", `${e.bonus.equipment}%`)), 1)) : w("", !0),
              l("div", null, $(e.$t("bonusAlchemy").replace("%s", `${e.bonus.alchemy}%`)), 1),
              l("div", null, $(e.$t("bonusBenefits").replace("%s", `${e.bonus.benefits}%`)), 1)
            ])
          ])
        ]),
        default: F(() => [
          M(r, { class: "instructions-icon" }, {
            default: F(() => [
              l("img", {
                src: `${e.pathImages}/icons/instructions${e.isSsm ? "-ssm" : ""}.png`,
                alt: "",
                style: b({ transform: `skewX(${e.isSsm ? 0 : 8}deg)` })
              }, null, 12, Ug)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 6);
}
const Xg = /* @__PURE__ */ S(_g, [["render", Hg]]), Gg = T({
  name: "TrainingResult",
  components: {
    TrainingStars: kg,
    TrainingScore: Xg,
    TrainingAttribute: eg,
    TrainingRewards: zn,
    PowerButton: zt,
    BlueBoxSolid: Ts,
    ShrinkingTextBox: pe,
    WaitingComponent: es,
    Tooltip: qt
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    rewardData: {
      type: Object,
      required: !0
    },
    trainingName: {
      type: String,
      required: !0
    },
    trainingIcon: {
      type: String,
      required: !0
    },
    showTrainAgain: {
      type: Boolean,
      required: !1,
      default: !0
    },
    highScore: {
      type: Number,
      required: !0
    },
    disabledPlayAgainButton: {
      type: Boolean,
      default: !1
    },
    isNewHighScore: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "button-click-play-again",
    "button-click-continue"
  ],
  data() {
    return {
      pathImages: E,
      energyFontSize: "37px",
      isSsm: !1,
      waitingState: mt()
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.specialScaleCoef})`,
        "transform-origin": "0% 0%",
        width: `calc(100% / ${this.specialScaleCoef})`,
        height: `calc(100% / ${this.specialScaleCoef})`
      };
    },
    fullWidthCoef() {
      return 100 / this.specialScaleCoef;
    },
    isTrainAgainDisabled() {
      return !this.rewardData.energy.available || mt().trainingButtonsDisabled || this.disabledPlayAgainButton;
    },
    getStyleTopArea() {
      return {
        "margin-left": `calc(var(--safe-area-inset-left) / ${this.specialScaleCoef})`,
        "margin-right": `calc(var(--safe-area-inset-right) / ${this.specialScaleCoef})`
      };
    },
    getStyleBottomBox() {
      const e = `calc(var(--safe-area-inset-left) / ${this.specialScaleCoef})`, t = `calc(var(--safe-area-inset-right) / ${this.specialScaleCoef})`;
      let i = "23.5px";
      return this.isIOS() && !this.isTablet() && (i = `calc(23.5px + calc(var(--safe-area-inset-bottom) / ${this.specialScaleCoef}))`), {
        width: `calc(98% - ${e} - ${t})`,
        bottom: i,
        position: this.isMobile() ? "fixed" : "absolute",
        left: "1%",
        "margin-left": e,
        "margin-right": t
      };
    },
    specialScaleCoef() {
      let e = this.scaleCoef;
      if (this.isIOS() && !this.isTablet()) {
        const t = document.getElementById("game-wrapper"), i = getComputedStyle(t).getPropertyValue("--safe-area-inset-bottom").replace("px", "") || 0;
        e = this.scaleCoef - Number(i) / window.innerHeight;
      }
      return e;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    onContinueClick: function() {
      mt().trainingButtonsDisabled || this.$emit("button-click-continue");
    },
    onPlayAgainClick: function() {
      mt().trainingButtonsDisabled || this.$emit("button-click-play-again");
    },
    formatThousands(e) {
      return Ee(e);
    },
    setEnergyFontSize(e) {
      this.energyFontSize = e;
    }
  }
}), Yg = { class: "tranining-wrapper" }, Kg = { class: "training-discipline" }, Zg = { class: "training-icon" }, Jg = ["src", "alt"], Qg = {
  class: "training-discipline-description",
  style: /* @__PURE__ */ b([])
}, ey = { class: "training-discipline-name" }, ty = { class: "training-discipline-points" }, iy = { class: "points" }, sy = {
  ref: "trainingHeader",
  class: "training-header"
}, ny = { class: "training-complete-text-parent" }, oy = { class: "training-complete-text" }, ry = { class: "buttons-container" }, ay = { class: "button-energy-cost" };
function ly(e, t, i, s, n, o) {
  const r = L("shrinking-text-box"), a = L("training-stars"), u = L("training-score"), d = L("training-attribute"), c = L("training-rewards"), g = L("waiting-component"), f = L("power-button"), m = L("tooltip"), v = L("blue-box-solid");
  return p(), h("div", {
    class: _(["training-container", [e.isMobile() ? "mobile-overlay" : "", { "training-container-ssm": e.isSsm }]]),
    style: b([e.transformCoef])
  }, [
    l("div", Yg, [
      l("div", {
        class: "training-title-row",
        style: b(e.getStyleTopArea)
      }, [
        l("div", Kg, [
          l("div", Zg, [
            l("img", {
              src: e.trainingIcon,
              alt: e.trainingName
            }, null, 8, Jg)
          ]),
          l("div", Qg, [
            l("div", ey, $(e.trainingName), 1),
            l("div", ty, [
              K($(e.$t("highScore")) + ": ", 1),
              l("div", iy, $(e.formatThousands(e.highScore)), 1),
              t[0] || (t[0] = l("span", { class: "icon-tp" }, null, -1))
            ])
          ])
        ]),
        Ae(l("div", sy, [
          M(r, {
            width: 800,
            height: 85,
            "font-size": e.isSsm ? 69 : 61,
            text: e.$t("newHighScore")
          }, null, 8, ["font-size", "text"])
        ], 512), [
          [Ze, e.isNewHighScore]
        ]),
        l("div", ny, [
          l("div", oy, [
            M(r, {
              width: 300,
              height: 40,
              "font-size": 40,
              text: e.$t("trainingCompleted")
            }, null, 8, ["text"])
          ])
        ])
      ], 4),
      M(a, {
        stars: e.rewardData.stars
      }, null, 8, ["stars"]),
      M(u, {
        base: e.formatThousands(e.rewardData.score.base),
        total: e.formatThousands(e.rewardData.score.total),
        bonuses: e.formatThousands(e.rewardData.score.bonuses),
        subscription: e.rewardData.subscription,
        bonus: e.rewardData.bonus
      }, null, 8, ["base", "total", "bonuses", "subscription", "bonus"]),
      M(d, {
        from: e.rewardData.attribute.value_from,
        next: e.rewardData.attribute.value_next,
        "tp-new": e.rewardData.attribute.tp_new,
        "tp-milestone": e.rewardData.attribute.tp_milestone
      }, null, 8, ["from", "next", "tp-new", "tp-milestone"]),
      M(v, {
        class: "training-rewards-row",
        style: b(e.getStyleBottomBox),
        "show-shadow-box": !e.isSsm
      }, {
        default: F(() => [
          M(c, {
            rewards: e.rewardData.rewards
          }, null, 8, ["rewards"]),
          l("div", ry, [
            e.waitingState.isWaiting ? (p(), V(g, { key: 0 })) : w("", !0),
            M(m, {
              text: e.$t("noEnergy"),
              side: "bottom",
              "text-width": 400,
              style: { width: "400px", left: "15px", top: "-140px", height: "100px" },
              "click-propagates-to-slo": "",
              "click-type": !0,
              active: e.isTrainAgainDisabled
            }, {
              default: F(() => [
                e.showTrainAgain && !e.waitingState.isWaiting ? (p(), V(f, {
                  key: 0,
                  class: _(["button-play-again", { disabled: e.isTrainAgainDisabled }]),
                  "basic-button": !1,
                  onClick: e.onPlayAgainClick
                }, {
                  default: F(() => [
                    M(r, {
                      class: "button-play-again-text",
                      width: 225,
                      height: 70,
                      "font-size": 37,
                      text: e.$t("trainAgain"),
                      onShrinkingFontSize: e.setEnergyFontSize
                    }, null, 8, ["text", "onShrinkingFontSize"]),
                    l("div", ay, [
                      l("div", {
                        class: "button-energy-cost-number",
                        style: b({ fontSize: e.energyFontSize })
                      }, $(e.rewardData.energy.value_new_game), 5),
                      l("div", {
                        class: "button-energy-cost-icon",
                        style: b({ background: `url(${e.pathImages}/icons/training_icons_80.png) -80px 0` })
                      }, null, 4)
                    ])
                  ]),
                  _: 1
                }, 8, ["class", "onClick"])) : w("", !0)
              ]),
              _: 1
            }, 8, ["text", "active"]),
            e.waitingState.isWaiting ? w("", !0) : (p(), V(f, {
              key: 1,
              class: _(["button-continue", { disabled: e.waitingState.trainingButtonsDisabled }]),
              onClick: e.onContinueClick
            }, {
              default: F(() => [
                K($(e.$t("continue")), 1)
              ]),
              _: 1
            }, 8, ["class", "onClick"]))
          ])
        ]),
        _: 1
      }, 8, ["style", "show-shadow-box"])
    ])
  ], 6);
}
const s$ = /* @__PURE__ */ S(Gg, [["render", ly]]), dy = T({
  name: "SettingsModal",
  components: {
    PowerSwitch: Sn,
    PowerModal: Cn,
    PowerCheck: va,
    PowerRule: Uu,
    PowerSlider: Ta,
    ShrinkingTextUniversal: ai
  },
  mixins: [P],
  props: {
    texts: {
      type: Object,
      required: !1,
      default: () => ({
        header: "Settings",
        sliderText: "Graphic details",
        sliderLow: "Lowaaaaa",
        sliderMedium: "Mediumaaaa",
        sliderMax: "Maxaaaa",
        radioText: "Auto",
        volume: "Volume",
        switchOn: "On",
        switchOff: "Off"
      })
    },
    showGraphicsSettings: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showControlsMobile: {
      type: Boolean,
      default: !0
    },
    showControlsType: {
      type: Boolean,
      default: !1
    },
    showAimSensitivity: {
      type: Boolean,
      default: !1
    },
    showOneFinger: {
      type: Boolean,
      default: !1
    },
    showVibration: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["close", "settings-change"],
  data() {
    return {
      min: 0,
      max: 8,
      optionRange: [
        {
          num: 0
        },
        {
          num: 1
        },
        {
          num: 2
        },
        {
          num: 3
        },
        {
          num: 4
        },
        {
          num: 5
        },
        {
          num: 6
        },
        {
          num: 7
        },
        {
          num: 8
        }
      ],
      aimSensitivityData: {
        min: 0,
        max: 6,
        optionRange: [
          {
            num: 0
          },
          {
            num: 1
          },
          {
            num: 2
          },
          {
            num: 3
          },
          {
            num: 4
          },
          {
            num: 5
          },
          {
            num: 6
          }
        ]
      },
      isSsm: !1,
      gameSettingsState: Gt()
    };
  },
  watch: {
    settings: {
      handler(e) {
        Gt().$patch({
          graphicsSettings: e.graphicsSettings,
          graphicsAuto: e.graphicsAuto,
          volume: e.volume,
          isLeft: e.isLeft,
          controlsType: e.controlsType,
          aimSensitivity: e.aimSensitivity
        }), this.$emit("settings-change");
      },
      deep: !0
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm", this.optionRange = [
      {
        num: 0,
        label: this.$t("utLow")
      },
      {
        num: 1
      },
      {
        num: 2
      },
      {
        num: 3
      },
      {
        num: 4,
        label: this.$t("utMedium")
      },
      {
        num: 5
      },
      {
        num: 6
      },
      {
        num: 7
      },
      {
        num: 8,
        label: this.$t("utHigh")
      }
    ], this.aimSensitivityData.optionRange = [
      {
        num: 0,
        label: this.$t("utLow")
      },
      {
        num: 1
      },
      {
        num: 2
      },
      {
        num: 3,
        label: this.$t("utMedium")
      },
      {
        num: 4
      },
      {
        num: 5
      },
      {
        num: 6,
        label: this.$t("utHigh")
      }
    ];
  }
}), uy = { class: "line line-bigger-padding" }, cy = { class: "modal-text" }, py = { class: "check" }, hy = { class: "label" }, fy = { class: "line line-bigger-padding" }, my = { class: "line line-bigger-padding" }, gy = { class: "modal-text" }, yy = { class: "line line-bigger-padding" }, vy = { class: "slider with-margin" }, by = { class: "line line-half" }, $y = { class: "line line-no-padding" }, ky = { class: "line-with-bg" }, _y = { class: "modal-text" }, wy = {
  key: 0,
  class: "line line-no-padding"
}, Ty = { class: "line-with-bg" }, Sy = { class: "subline" }, xy = { class: "modal-text" }, Cy = {
  key: 2,
  class: "line"
}, zy = { class: "line-with-bg" }, jy = { class: "modal-text" }, By = {
  key: 3,
  class: "line"
}, Py = { class: "line-with-bg" }, Dy = { class: "modal-text" }, Ly = {
  key: 4,
  class: "line"
}, Oy = { class: "line-with-bg" }, Iy = { class: "subline" }, My = { class: "modal-text" }, Ny = { class: "modal-sub-text" };
function Ay(e, t, i, s, n, o) {
  const r = L("power-check"), a = L("power-slider"), u = L("power-rule"), d = L("power-switch"), c = L("shrinking-text-universal"), g = L("power-modal");
  return p(), h("div", {
    class: _(["setting-modal", { "setting-modal-ssm": e.isSsm }])
  }, [
    M(g, {
      header: e.$t("settings"),
      onClose: t[8] || (t[8] = (f) => e.$emit("close", f))
    }, {
      default: F(() => [
        e.showGraphicsSettings ? (p(), h(H, { key: 0 }, [
          l("div", uy, [
            l("p", cy, $(e.$t("graphicDetails")), 1),
            l("div", py, [
              M(r, {
                modelValue: e.gameSettingsState.graphicsAuto,
                "onUpdate:modelValue": t[0] || (t[0] = (f) => e.gameSettingsState.graphicsAuto = f)
              }, {
                default: F(() => [
                  l("span", hy, $(e.$t("utAuto")), 1)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          l("div", fy, [
            l("div", {
              class: _(["slider", { "with-margin": !e.showAimSensitivity }])
            }, [
              M(a, {
                modelValue: e.gameSettingsState.graphicsSettings,
                "onUpdate:modelValue": t[1] || (t[1] = (f) => e.gameSettingsState.graphicsSettings = f),
                min: e.min,
                max: e.max,
                "option-range": e.optionRange,
                "disabled-value": e.gameSettingsState.graphicsAuto
              }, null, 8, ["modelValue", "min", "max", "option-range", "disabled-value"])
            ], 2)
          ]),
          e.showAimSensitivity ? (p(), V(u, { key: 0 })) : w("", !0)
        ], 64)) : w("", !0),
        e.showAimSensitivity ? (p(), h(H, { key: 1 }, [
          l("div", my, [
            l("p", gy, $(e.$t("aimSensitivity")), 1)
          ]),
          l("div", yy, [
            l("div", vy, [
              M(a, {
                modelValue: e.gameSettingsState.aimSensitivity,
                "onUpdate:modelValue": t[2] || (t[2] = (f) => e.gameSettingsState.aimSensitivity = f),
                min: e.aimSensitivityData.min,
                max: e.aimSensitivityData.max,
                "option-range": e.aimSensitivityData.optionRange
              }, null, 8, ["modelValue", "min", "max", "option-range"])
            ])
          ])
        ], 64)) : w("", !0),
        l("div", by, [
          l("div", $y, [
            l("div", ky, [
              l("p", _y, $(e.$t("sounds")), 1),
              M(r, {
                modelValue: e.gameSettingsState.volume,
                "onUpdate:modelValue": t[3] || (t[3] = (f) => e.gameSettingsState.volume = f)
              }, {
                default: F(() => t[9] || (t[9] = [
                  l("span", { class: "label" }, null, -1)
                ])),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          e.showVibration ? (p(), h("div", wy, [
            l("div", Ty, [
              l("div", Sy, [
                l("p", xy, $(e.$t("vibrations")), 1)
              ]),
              M(r, {
                modelValue: e.gameSettingsState.vibrations,
                "onUpdate:modelValue": t[4] || (t[4] = (f) => e.gameSettingsState.vibrations = f)
              }, {
                default: F(() => t[10] || (t[10] = [
                  l("span", { class: "label" }, null, -1)
                ])),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])) : w("", !0)
        ]),
        e.showControlsMobile && e.isMobile() ? (p(), h("div", Cy, [
          l("div", zy, [
            l("p", jy, $(e.$t("controls")), 1),
            M(d, {
              modelValue: e.gameSettingsState.isLeft,
              "onUpdate:modelValue": t[5] || (t[5] = (f) => e.gameSettingsState.isLeft = f),
              "text-on": "leftHanded",
              "text-off": "rightHanded"
            }, null, 8, ["modelValue"])
          ])
        ])) : w("", !0),
        e.showControlsType ? (p(), h("div", By, [
          l("div", Py, [
            l("p", Dy, $(e.$t("downhillSetting")), 1),
            M(d, {
              modelValue: e.gameSettingsState.controlsType,
              "onUpdate:modelValue": t[6] || (t[6] = (f) => e.gameSettingsState.controlsType = f),
              "text-on": "manual",
              "text-off": "automatic",
              "value-on": 1,
              "value-off": 2
            }, null, 8, ["modelValue"])
          ])
        ])) : w("", !0),
        e.showOneFinger ? (p(), h("div", Ly, [
          l("div", Oy, [
            l("div", Iy, [
              l("p", My, $(e.$t("oneFingerControls")), 1),
              l("p", Ny, [
                M(c, {
                  text: e.$t("oneFingerControlsDescription"),
                  "font-size": 32,
                  "animated-overflow": ""
                }, null, 8, ["text"])
              ])
            ]),
            M(r, {
              modelValue: e.gameSettingsState.oneFinger,
              "onUpdate:modelValue": t[7] || (t[7] = (f) => e.gameSettingsState.oneFinger = f)
            }, {
              default: F(() => t[11] || (t[11] = [
                l("span", { class: "label" }, null, -1)
              ])),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])) : w("", !0)
      ]),
      _: 1
    }, 8, ["header"])
  ], 2);
}
const n$ = /* @__PURE__ */ S(dy, [["render", Ay]]), Ry = T({
  name: "DownhillSkierTime",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    playerData: {
      type: Object,
      required: !0
    }
  },
  computed: {
    basicStyle() {
      return {
        transform: `scale(${this.scaleCoef})`,
        "transform-origin": "100% 100%"
      };
    }
  }
}), Ey = { class: "table-row-player" }, Fy = { class: "position" }, Vy = { class: "pos-number" }, qy = { class: "row-i" }, Wy = { class: "sider" }, Uy = { class: "country" }, Hy = ["src", "alt"], Xy = { class: "country-name" }, Gy = { class: "player-time-row" }, Yy = { class: "player-time" };
function Ky(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: "right-table-rows",
    style: b([e.style, e.basicStyle])
  }, [
    l("div", Ey, [
      l("div", Fy, [
        l("span", Vy, $(e.playerData.position), 1)
      ]),
      l("div", qy, [
        l("div", Wy, [
          l("div", Uy, [
            l("img", {
              class: "image",
              src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${e.playerData.country.toLowerCase()}.png`,
              alt: e.playerData.country
            }, null, 8, Hy),
            M(r, {
              text: e.playerData.player.name,
              "font-size": 34,
              width: 270,
              height: 40,
              class: "player-name"
            }, null, 8, ["text"]),
            l("div", Xy, " (" + $(e.playerData.countryString) + ") ", 1)
          ])
        ])
      ]),
      l("div", {
        class: _(["time", { bonus: e.playerData.isBonus }])
      }, $(e.playerData.timeDiff), 3)
    ]),
    l("div", Gy, [
      l("div", Yy, $(e.playerData.time), 1)
    ])
  ], 4);
}
const Zy = /* @__PURE__ */ S(Ry, [["render", Ky], ["__scopeId", "data-v-04ead67e"]]), Jy = T({
  name: "DownhillTimesTable",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    rowData: {
      type: Array,
      required: !0
    }
  },
  computed: {
    basicStyle() {
      return {
        transform: `scale(${this.scaleCoef})`,
        "transform-origin": "0px 100%"
      };
    }
  },
  methods: {
    isFirstElement: function(e) {
      return e === 0;
    }
  }
}), Qy = { class: "position" }, ev = { class: "pos-number" }, tv = { class: "row-i" }, iv = { class: "sider" }, sv = { class: "country" }, nv = ["src", "alt"], ov = { class: "country-name" }, rv = { class: "time" };
function av(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: "left-table-rows",
    style: b([e.style, e.basicStyle])
  }, [
    (p(!0), h(H, null, de(e.rowData, (a, u) => (p(), h("div", {
      key: u,
      class: _(["table-row", {
        isFirst: e.isFirstElement(u),
        isPlayer: a.player.isPlayer
      }])
    }, [
      l("div", Qy, [
        l("span", ev, $(a.position), 1)
      ]),
      l("div", tv, [
        l("div", iv, [
          l("div", sv, [
            l("img", {
              class: "image",
              src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${a.country.toLowerCase()}.png`,
              alt: a.country
            }, null, 8, nv),
            M(r, {
              text: a.player.name,
              "font-size": 34,
              width: 270,
              height: 40,
              class: "player-name"
            }, null, 8, ["text"]),
            l("div", ov, " (" + $(a.countryString) + ") ", 1)
          ])
        ])
      ]),
      l("div", rv, $(e.isFirstElement(u) ? a.time : a.timeDiff), 1)
    ], 2))), 128))
  ], 4);
}
const lv = /* @__PURE__ */ S(Jy, [["render", av], ["__scopeId", "data-v-454c81f1"]]), dv = T({
  name: "DownhillTimes",
  components: {
    DownhillTimesTable: lv,
    DownhillSkierTime: Zy
  },
  mixins: [P],
  props: {
    rowData: {
      type: Array,
      required: !0
    },
    playerData: {
      type: Object,
      required: !0
    },
    showLeftTable: {
      type: Boolean,
      required: !1,
      default: !0
    },
    showRightTable: {
      type: Boolean,
      required: !1,
      default: !0
    }
  }
}), uv = { class: "downhill-times" };
function cv(e, t, i, s, n, o) {
  const r = L("downhill-times-table"), a = L("downhill-skier-time");
  return p(), h("div", uv, [
    e.showLeftTable ? (p(), V(r, {
      key: 0,
      "row-data": e.rowData
    }, null, 8, ["row-data"])) : w("", !0),
    e.showRightTable ? (p(), V(a, {
      key: 1,
      "player-data": e.playerData
    }, null, 8, ["player-data"])) : w("", !0)
  ]);
}
const o$ = /* @__PURE__ */ S(dv, [["render", cv]]), pv = T({
  name: "InstructionCard",
  components: {
    ShrinkingTextUniversal: ai,
    ShrinkingBlock: Tc
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    cardContent: {
      type: Object,
      required: !1,
      default: () => ({
        imgSrc: "https://via.placeholder.com/343x229",
        header: "štart",
        text: [
          `Lorem ipsum dolor sit amet,
            consectetur adipiscing elit.
            Vestibulum mattis vehicula
            volutpat.`,
          `Donec sit amet
            sodales nibh, eu vehicula
            metus. Sed est nisl, dictum
            egetporttitor nec.`
        ]
      })
    },
    cardIndex: {
      type: Number,
      required: !0
    }
  },
  data() {
    return {
      textLength: 0,
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return `translateX(-50%) scale(${this.scaleCoef})`;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm", this.cardContent.text.forEach((e) => {
      this.textLength += e.length;
    });
  },
  methods: {
    computeHeight(e) {
      return 210 / this.textLength * e.length;
    }
  }
}), hv = { class: "instruciton-card-photo" }, fv = ["src"], mv = {
  class: "instruction-card-header",
  style: { width: "355px", height: "48px" }
};
function gv(e, t, i, s, n, o) {
  const r = L("shrinking-text-universal"), a = L("shrinking-block");
  return p(), h("div", {
    class: _(["instruction-card", { "instruction-card-ssm": e.isSsm }])
  }, [
    l("div", hv, [
      l("img", {
        src: e.cardContent.imgSrc
      }, null, 8, fv)
    ]),
    l("div", mv, [
      M(r, {
        text: e.cardContent.header,
        "font-size": 40,
        "container-class-list": "shrinking-text-container-header",
        "animated-overflow": ""
      }, {
        default: F(() => [
          K($(e.cardContent.header), 1)
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    l("div", {
      ref: "cardText" + e.cardIndex,
      class: "instruction-card-text"
    }, [
      M(a, {
        texts: e.cardContent.text,
        "font-size": 28,
        width: 355,
        height: 210
      }, null, 8, ["texts"])
    ], 512)
  ], 2);
}
const yv = /* @__PURE__ */ S(pv, [["render", gv]]), ze = {
  addEventListeners(e, t, i) {
    for (let s = 0, n = t.length; s < n; s++)
      e.addEventListener(t[s], i, { passive: !1 });
  },
  removeEventListeners(e, t, i) {
    for (let s = 0, n = t.length; s < n; s++)
      e.removeEventListener(t[s], i, { passive: !1 });
  },
  emitEvent: function(e, t, i) {
    if (e.componentInstance)
      e.componentInstance.$emit(t, i);
    else {
      let s = new window.CustomEvent(t, { detail: i });
      e.el.dispatchEvent(s);
    }
  }
}, Li = ["mousedown", "touchstart"], Oi = ["mousemove", "touchmove"], Ii = ["mouseup", "touchend"], $s = function(e, t, i) {
  let s = e, n = !0, o = window;
  typeof t.value == "boolean" ? n = t.value : typeof t.value == "object" ? (typeof t.value.target == "string" ? (s = e.querySelector(t.value.target), s || console.error("There is no element with the current target value.")) : typeof t.value.target < "u" && console.error(`The parameter "target" should be either 'undefined' or 'string'.`), typeof t.value.container == "string" ? (o = document.querySelector(t.value.container), o || console.error("There is no element with the current container value.")) : typeof t.value.container < "u" && console.error(`The parameter "container" should be be either 'undefined' or 'string'.`), typeof t.value.active == "boolean" ? n = t.value.active : typeof t.value.active < "u" && console.error(`The parameter "active" value should be either 'undefined', 'true' or 'false'.`)) : typeof t.value < "u" && console.error("The passed value should be either 'undefined', 'true' or 'false' or 'object'.");
  const r = function(u, d) {
    o === window ? window.scrollBy(u, d) : (o.scrollLeft += u, o.scrollTop += d);
  }, a = function() {
    let u, d, c, g = !1;
    s.md = function(f) {
      const m = f instanceof window.MouseEvent, v = m ? f.pageX : f.touches[0].pageX, y = m ? f.pageY : f.touches[0].pageY, k = document.elementFromPoint(v - window.pageXOffset, y - window.pageYOffset), C = t.arg === "nochilddrag", x = t.modifiers.noleft, j = t.modifiers.noright, D = t.modifiers.nomiddle, z = t.modifiers.noback, N = t.modifiers.noforward, I = t.arg === "firstchilddrag", O = k === s, B = k === s.firstChild, R = C ? typeof (k == null ? void 0 : k.dataset.dragscroll) < "u" : typeof (k == null ? void 0 : k.dataset.noDragscroll) > "u";
      if (!(!O && (!R || I && !B)) && !(f.button === 0 && x)) {
        if (f.button === 1 && D || f.button === 2 && j || f.button === 3 && z || f.button === 4 && N)
          return;
        c = 1, u = m ? f.clientX : f.touches[0].clientX, d = m ? f.clientY : f.touches[0].clientY;
      }
    }, s.mu = function(f) {
      c = 0, g && ze.emitEvent(i, "dragscrollend"), g = !1;
    }, s.mm = function(f) {
      const m = f instanceof window.MouseEvent;
      let v, y;
      if (c) {
        f.preventDefault(), g || ze.emitEvent(i, "dragscrollstart"), g = !0;
        const k = s.scrollLeft + s.clientWidth >= s.scrollWidth || s.scrollLeft === 0, C = s.scrollTop + s.clientHeight >= s.scrollHeight || s.scrollTop === 0;
        v = -u + (u = m ? f.clientX : f.touches[0].clientX), y = -d + (d = m ? f.clientY : f.touches[0].clientY), t.modifiers.pass ? (s.scrollLeft -= t.modifiers.y ? -0 : v, s.scrollTop -= t.modifiers.x ? -0 : y, s === document.body && (s.scrollLeft -= t.modifiers.y ? -0 : v, s.scrollTop -= t.modifiers.x ? -0 : y), (k || t.modifiers.y) && r(-v, 0), (C || t.modifiers.x) && r(0, -y)) : (t.modifiers.x && (y = -0), t.modifiers.y && (v = -0), s.scrollLeft -= v, s.scrollTop -= y, s === document.body && (s.scrollLeft -= v, s.scrollTop -= y)), ze.emitEvent(i, "dragscrollmove", {
          deltaX: -v,
          deltaY: -y
        });
      }
    }, ze.addEventListeners(s, Li, s.md), ze.addEventListeners(window, Ii, s.mu), ze.addEventListeners(window, Oi, s.mm);
  };
  n ? document.readyState === "complete" ? a() : window.addEventListener("load", a) : (ze.removeEventListeners(s, Li, s.md), ze.removeEventListeners(window, Ii, s.mu), ze.removeEventListeners(window, Oi, s.mm));
}, vv = (e) => {
  const t = e;
  ze.removeEventListeners(t, Li, t.md), ze.removeEventListeners(window, Ii, t.mu), ze.removeEventListeners(window, Oi, t.mm);
}, jn = {
  mounted: (e, t, i) => $s(e, t, i),
  updated: (e, t, i) => {
    JSON.stringify(t.value) !== JSON.stringify(t.oldValue) && $s(e, t, i);
  },
  unmounted: (e) => vv(e)
};
typeof window < "u" && window.Vue && (window.VueDragscroll = jn);
const bv = T({
  name: "InstructionsComponent",
  components: {
    InstructionCard: yv,
    InfoBox: kd,
    PowerButton: zt
  },
  directives: {
    dragscroll: jn
  },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    cards: {
      type: Array,
      default: () => []
    },
    showButton: {
      type: Boolean,
      default: !0
    },
    disciplineName: {
      type: String,
      default: ""
    }
  },
  emits: ["button-click"],
  data() {
    return {
      pathImages: E,
      isDown: !1,
      movedDelta: 0,
      isScrollableClass: "",
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return {
        transform: `scale(${this.scaleCoef}) translate(-50%, -50%)`,
        "transform-origin": "0 0"
      };
    },
    showScrollArrows() {
      return this.cards.length > 4;
    }
  },
  beforeUnmount() {
    document.removeEventListener("keyup", this.listenerMethod);
  },
  mounted() {
    const e = this.$refs.cardsWrapper;
    this.isScrollableClass = e.scrollWidth > e.clientWidth ? "is-scrollable" : "", this.showScrollArrows && (this.changeOpacityArrows(), e.addEventListener("scroll", () => {
      this.changeOpacityArrows();
    })), document.addEventListener("keyup", this.listenerMethod), "ontouchstart" in document.documentElement ? (e.addEventListener("touchstart", this.handleDown), window.addEventListener("touchmove", this.handleMove, { passive: !1 }), window.addEventListener("touchend", this.handleUp)) : (e.addEventListener("mousedown", this.handleDown), window.addEventListener("mousemove", this.handleMove, { passive: !1 }), window.addEventListener("mouseup", this.handleUp));
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  },
  methods: {
    listenerMethod(e) {
      (e.code === "Space" || e.keyCode === 32 || e.key === " ") && this.$emit("button-click");
    },
    scrollWrapper(e) {
      const t = this.$refs.cardsWrapper;
      t.scrollLeft += e;
    },
    onClickButton() {
      this.$emit("button-click");
    },
    changeOpacityArrows() {
      if (this.handleMove(), !this.showScrollArrows)
        return;
      const e = this.$refs.cardsWrapper, t = this.$refs.instructionsRightArrow, i = this.$refs.instructionsLeftArrow;
      e && e.scrollWidth === e.scrollLeft + e.clientWidth ? t.classList.add("arrow-transparent") : t.classList.remove("arrow-transparent"), e && e.scrollLeft === 0 ? i.classList.add("arrow-transparent") : i.classList.remove("arrow-transparent");
    },
    handleDown() {
      this.isDown = !0;
    },
    handleUp() {
      this.isDown && this.movedDelta < 5 && this.onClickButton(), this.isDown = !1, this.movedDelta = 0;
    },
    handleMove() {
      this.isDown && (this.movedDelta += 1);
    }
  }
}), $v = { key: 0 }, kv = { key: 1 }, _v = { class: "instructions-carousel" }, wv = ["src"], Tv = ["src"], Sv = ["src"], xv = ["src"];
function Cv(e, t, i, s, n, o) {
  const r = L("instruction-card"), a = L("power-button"), u = L("info-box"), d = Pn("dragscroll");
  return p(), h("section", {
    class: _(["instructor", { "instructor-ssm": e.isSsm }]),
    onClick: t[5] || (t[5] = A((c) => e.onClickButton(), ["self"]))
  }, [
    l("div", {
      class: "instructions",
      style: b([e.style, e.transformCoef]),
      onClick: t[4] || (t[4] = A((c) => e.onClickButton(), ["self"]))
    }, [
      l("div", {
        class: "instructions-header",
        onClick: t[0] || (t[0] = A((c) => e.onClickButton(), ["self"]))
      }, [
        e.disciplineName.length > 0 ? (p(), h("span", $v, $(`${e.$t("instructions")} - ${e.disciplineName}`), 1)) : (p(), h("span", kv, $(e.$t("instructions")), 1))
      ]),
      l("div", _v, [
        e.showScrollArrows ? (p(), h("div", {
          key: 0,
          ref: "instructionsLeftArrow",
          class: "carousel-arrow arrow-left",
          onClick: t[1] || (t[1] = A((c) => e.scrollWrapper(-150), ["stop"]))
        }, [
          e.isSsm ? (p(), h("img", {
            key: 0,
            src: `${e.pathImages}/table/btn-back.jpg`
          }, null, 8, wv)) : (p(), h("img", {
            key: 1,
            src: `${e.pathImages}/table/BTN_PREW_ROUNDED.png`
          }, null, 8, Tv))
        ], 512)) : w("", !0),
        e.isMobile() ? (p(), h("div", {
          key: 1,
          ref: "cardsWrapper",
          class: _(["instructions-cards-wrapper", e.isScrollableClass])
        }, [
          (p(!0), h(H, null, de(e.cards, (c, g) => (p(), V(r, {
            key: g,
            "card-index": g,
            "card-content": c
          }, null, 8, ["card-index", "card-content"]))), 128))
        ], 2)) : Ae((p(), h("div", {
          key: 2,
          ref: "cardsWrapper",
          class: _(["instructions-cards-wrapper", e.isScrollableClass])
        }, [
          (p(!0), h(H, null, de(e.cards, (c, g) => (p(), V(r, {
            key: g,
            "card-index": g,
            "card-content": c
          }, null, 8, ["card-index", "card-content"]))), 128))
        ], 2)), [
          [d]
        ]),
        e.showScrollArrows ? (p(), h("div", {
          key: 3,
          ref: "instructionsRightArrow",
          class: "carousel-arrow arrow-right",
          onClick: t[2] || (t[2] = A((c) => e.scrollWrapper(150), ["stop"]))
        }, [
          e.isSsm ? (p(), h("img", {
            key: 0,
            src: `${e.pathImages}/table/btn-forward.jpg`
          }, null, 8, Sv)) : (p(), h("img", {
            key: 1,
            src: `${e.pathImages}/table/BTN_NEXT_ROUNDED.png`
          }, null, 8, xv))
        ], 512)) : w("", !0)
      ]),
      l("section", {
        class: "centering",
        onClick: t[3] || (t[3] = (c) => e.onClickButton())
      }, [
        e.isSsm ? (p(), V(a, { key: 0 }, {
          default: F(() => [
            K($(e.$t("continue")), 1)
          ]),
          _: 1
        })) : (p(), V(u, {
          key: 1,
          class: _({ "btn-inactive": !e.showButton }),
          "is-scaled": !1
        }, null, 8, ["class"]))
      ])
    ], 4)
  ], 2);
}
const r$ = /* @__PURE__ */ S(bv, [["render", Cv]]), a$ = {
  utPersonalBestShort: "pb",
  utLow: "low",
  utMedium: "medium",
  utHigh: "high",
  utAuto: "auto",
  utOn: "on",
  utOff: "off",
  utToBeat: "To beat",
  utPaused: "Paused",
  utFinalLap: "Final lap",
  utLeader: "Leader",
  utFalseStart: "False start",
  utSharpRight: "Sharp right",
  utSharpLeft: "Sharp left",
  tableText3: "",
  tableText6: "Boss",
  tableText11: "Easy",
  tableText12: "Medium",
  tableText13: "Hard",
  proneShootingShort: "P",
  standingShootingShort: "S",
  anne: "ANNE",
  utHold: "hold",
  disciplineName1: "Zjazd",
  disciplineName2: "Biatlon",
  disciplineName3: "Skoky na lyžiach",
  disciplineName4: "Boby",
  disciplineName5: "Rýchlokorčuľovanie",
  disciplineName6: "Obrovský slalom",
  disciplineName7: "Sánkovanie",
  disciplineName8: "Beh na lyžiach",
  disciplineName9: "Snoubordkros",
  disciplineName10: "Šortrek",
  clickToContinue: "Pokračuj kliknutím",
  clickToContinueTemp: "Pokračuj kliknutím",
  tapToContinue: "Pokračuj ťuknutím",
  settings: "Nastavenia",
  instructions: "Inštrukcie",
  quit: "Ukončiť",
  startList: "Štartová listina",
  finalStandings: "Konečné výsledky",
  meters: "Metre",
  points: "Body",
  graphicDetails: "Grafické detaily",
  sounds: "Zvuky",
  controls: "Ovládanie<!--controls-->",
  oneFingerControls: "Ovládanie jedným prstom",
  oneFingerControlsDescription: "Namier joystickom a vystrel zdvihnutím prsta z displeja",
  vibrations: "Vibrácie",
  leftHanded: "Ľavák",
  rightHanded: "Pravák",
  quitCompetition: "Ukončiť súťaž<!--quit-->",
  quitCompetitionConfirm: "Naozaj chceš ukončiť súťaž?",
  yes: "Áno",
  back: "Späť",
  wind: "Vietor",
  tapTheXButton: "Ťukni na tlačidlo START",
  finish: "Cieľ<!--finish-->",
  congratulations: "Gratulujeme!",
  winner: "Víťaz<!--winner-->",
  rankX: "%s. miesto",
  newPersonalBest: "Nový osobný rekord",
  personalBest: "Osobný rekord",
  newWorldRecord: "Nový svetový rekord",
  worldRecord: "Svetový rekord",
  perfectTakeOff: "Dokonalý odraz",
  excellentTakeOff: "Skvelý odraz",
  goodTakeOff: "Dobrý odraz",
  poorTakeOff: "Slabý odraz",
  perfectLanding: "Dokonalé pristátie",
  excellentLanding: "Skvelé pristátie",
  goodLanding: "Dobré pristátie",
  poorLanding: "Zlé pristátie",
  lateLanding: "Neskoré pristátie",
  fall: "Pád",
  perfectStart: "Dokonalý štart",
  excellentStart: "Skvelý štart",
  goodStart: "Dobrý štart",
  slowStart: "Pomalý štart",
  poorRunUp: "Slabá rýchlosť",
  goodRunUp: "Dobrá rýchlosť",
  excellentRunUp: "Výborná rýchlosť",
  perfectRunUp: "Maximálna rýchlosť",
  continue: "Pokračovať",
  start: "Štart",
  instructionsDiscipline1Cell1Title: "Štart",
  instructionsDiscipline1Cell1Text1: "Snaž sa odštartovať v ideálnom momente.",
  instructionsDiscipline1Cell2Title: "Ovládanie lyžiara",
  instructionsDiscipline1Cell2Text1: "Šípkami ovládaj lyžiara.",
  instructionsDiscipline1Cell3Title: "Vynechanie bránky",
  instructionsDiscipline1Cell3Text1: "Za vynechanie bránky je penalizácia 2 sekundy.",
  instructionsDiscipline1Cell4Title: "Zjazdový postoj",
  instructionsDiscipline1Cell4Text1: "V rovnejších úsekoch trate sa snaž držať v zjazdovom postoji.",
  instructionsDiscipline2Cell1Title: "Štart",
  instructionsDiscipline2Cell1Text1: "Snaž sa odštartovať v ideálnom momente.",
  instructionsDiscipline2Cell2Title: "Ovládanie smeru",
  instructionsDiscipline2Cell2Text1: "Šípkami vľavo a vpravo ovládaj smer.",
  instructionsDiscipline2Cell3Title: "Ovládanie tempa",
  instructionsDiscipline2Cell3Text1: "Šípkami hore a dole ovládaj tempo. Pri nižšom tempe sa rýchlejšie dopĺňa energia na šprint a máš pomalší tep.",
  instructionsDiscipline2Cell3Text1Mobile: "Tlačidlami plus a mínus ovládaj tempo. Pri nižšom tempe sa rýchlejšie dopĺňa energia na šprint a máš pomalší tep.",
  instructionsDiscipline2Cell4Title: "Šprint",
  instructionsDiscipline2Cell4Text1: "Ak máš aspoň trochu energie, môžeš aktivovať šprint. Čím viac energie máš, tým dlhšie môžeš šprintovať. Šprint nie je dostupný v zjazdoch.",
  instructionsDiscipline2Cell5Title: "Zjazdový postoj",
  instructionsDiscipline2Cell5Text1: "V zjazdoch použi zjazdový postoj, aby si ušetril energiu na šprint a znížil svoj tep.",
  instructionsDiscipline2Cell6Title: "Tep",
  instructionsDiscipline2Cell6Text1: "Príliš vysoký tep spôsobí zníženie tvojho maximálneho tempa.",
  instructionsDiscipline2Cell6Text2: "Snaž sa prísť na strelnicu s pomalším tepom, aby sa ti ľahšie mierilo.",
  instructionsDiscipline2Cell7Title: "Streľba",
  instructionsDiscipline2Cell7Text1: "Myšou namier na terč a vystreľ ľavým tlačidlom myši.",
  instructionsDiscipline2Cell7Text1Mobile: "Joystickom namier na terč a vystreľ.",
  instructionsDiscipline2Cell7Text2: "Za každý netrafený terč je penalizácia 5 sekúnd.",
  instructionsDiscipline3Cell1Title: "Štart",
  instructionsDiscipline3Cell1Text1: "Sleduj vietor a snaž sa spustiť v čo najvýhodnejšom momente.",
  instructionsDiscipline3Cell1Text2: "Protivietor ti umožní dlhšie skoky.",
  instructionsDiscipline3Cell2Title: "Nájazd",
  instructionsDiscipline3Cell2Text1: "Snaž sa držať ideálnu rovnováhu počas nájazdu.",
  instructionsDiscipline3Cell3Title: "Odraz",
  instructionsDiscipline3Cell3Text1: "Snaž sa odraziť v ideálnom momente.",
  instructionsDiscipline3Cell4Title: "Letová fáza",
  instructionsDiscipline3Cell4Text1: "Snaž sa držať v ideálnej pozícii počas letovej fázy.",
  instructionsDiscipline3Cell5Title: "Pristátie",
  instructionsDiscipline3Cell5Text1: "Aby si získal čo najviac bodov za štýl, začni pristávať dostatočne vysoko nad zemou.",
  instructionsDiscipline3Cell6Title: "Nájazdové okno",
  instructionsDiscipline3Cell6Text1: "Nájazdové okno má zásadný vplyv na dĺžku skoku. Okno sa vyberá automaticky podľa sily najsilnejšieho skokana v súťaži.",
  instructionsDiscipline4Cell1Title: "Rozbeh",
  instructionsDiscipline4Cell1Text1: "Naber rýchlosť kliknutím vždy keď je ukazovateľ rozbehu na ľavom alebo pravom okraji.",
  instructionsDiscipline4Cell2Title: "Naskočenie",
  instructionsDiscipline4Cell2Text1: "Snaž sa naskočiť do bobov v ideálnom momente.",
  instructionsDiscipline4Cell3Title: "Ovládanie bobov",
  instructionsDiscipline4Cell3Text1: "Šípkami ovládaj smer jazdy.",
  instructionsDiscipline4Cell3Text2: "Snaž sa držať v ideálnej línii.",
  instructionsDiscipline5Cell1Title: "Štart",
  instructionsDiscipline5Cell1Text1: "Vyštartuj hneď ako zaznie výstrel, ale pozor na predčasný štart.",
  instructionsDiscipline5Cell2Title: "Akcelerácia",
  instructionsDiscipline5Cell2Text1: "Striedavo stláčaj ľavé a pravé tlačidlo najrýchlejšie ako vieš.",
  instructionsDiscipline5Cell3Title: "Udržiavanie tempa",
  instructionsDiscipline5Cell3Text1: "Drž ľavé alebo pravé tlačidlo podľa toho, ktorý ukazovateľ sa napĺňa.",
  instructionsDiscipline6Cell1Title: "Štart",
  instructionsDiscipline6Cell1Text1: "Snaž sa odštartovať v ideálnom momente.",
  instructionsDiscipline6Cell2Title: "Ovládanie lyžiara",
  instructionsDiscipline6Cell2Text1: "Šípkami ovládaj lyžiara.",
  instructionsDiscipline6Cell3Title: "Ostré zákruty",
  instructionsDiscipline6Cell3Text1: "V prípade potreby využi možnosť ostrého zatočenia.",
  instructionsDiscipline6Cell4Title: "Vynechanie bránky",
  instructionsDiscipline6Cell4Text1: "Za vynechanie bránky je penalizácia {2to4} sekundy.",
  instructionsDiscipline7Cell1Title: "Štart",
  instructionsDiscipline7Cell1Text1: "Klikni vždy keď je ukazovateľ sily na maxime, aby si nabral čo najväčšiu rýchlosť.",
  instructionsDiscipline7Cell2Title: "Ovládanie saní",
  instructionsDiscipline7Cell2Text1: "Šípkami ovládaj smer jazdy.",
  instructionsDiscipline7Cell2Text2: "Snaž sa držať v ideálnej línii.",
  instructionsDiscipline8Cell1Title: "Štart",
  instructionsDiscipline8Cell1Text1: "Vyštartuj hneď ako zaznie výstrel a potom naber rýchlosť stláčaním {key}.",
  instructionsDiscipline8Cell1Text1Mobile: "Vyštartuj hneď ako zaznie výstrel a potom naber rýchlosť ťukaním na tlačidlo štart.",
  instructionsDiscipline8Cell2Title: "Ovládanie tempa",
  instructionsDiscipline8Cell2Text1: "Šípkami hore a dole ovládaj tempo. Pri nižšom tempe sa rýchlejšie dopĺňa energia na šprint a máš pomalší tep.",
  instructionsDiscipline8Cell2Text1Mobile: "Tlačidlami plus a mínus ovládaj tempo. Pri nižšom tempe sa rýchlejšie dopĺňa energia na šprint a máš pomalší tep.",
  instructionsDiscipline8Cell3Title: "Zmena dráhy",
  instructionsDiscipline8Cell3Text1: "Šípkami vľavo a vpravo môžeš meniť dráhy.",
  instructionsDiscipline8Cell3Text2: "Pozor! Sneh mimo vyznačenej stopy je pomalší.",
  instructionsDiscipline8Cell4Title: "Šprint",
  instructionsDiscipline8Cell4Text1: "Ak máš aspoň trochu energie, môžeš aktivovať šprint. Čím viac energie máš, tým dlhšie môžeš šprintovať. Šprint nie je dostupný v zjazdoch.",
  instructionsDiscipline8Cell5Title: "Zjazdový postoj",
  instructionsDiscipline8Cell5Text1: "V zjazdoch použi zjazdový postoj, aby si ušetril energiu na šprint a znížil svoj tep.",
  instructionsDiscipline8Cell6Title: "Závetrie",
  instructionsDiscipline8Cell6Text1: "Keď si v závetrí za iným lyžiarom, rýchlejšie sa ti dopĺňa energia na šprint, máš nižší tep a môžeš dosiahnuť vyššiu rýchlosť.",
  instructionsDiscipline8Cell7Title: "Tep",
  instructionsDiscipline8Cell7Text1: "Príliš vysoký tep spôsobí zníženie tvojho maximálneho tempa.",
  tableText1: "Rebríčková súťaž",
  tableText2: "Klubové majstrovstvá",
  tableText4: "Denná liga",
  tableText5: "Kariéra",
  tableText7: "Turnaj",
  highScore: "Najlepšie skóre",
  newHighScore: "Nové najlepšie skóre",
  level: "Úroveň %s",
  "training-text-1": "Pri tréningu využi to, čo sme sa už naučili. Čím lepší výkon podáš, tým viac sa zlepšíš.",
  "trainingTask1-0": "Štart",
  "trainingTask1-1": "Bránky",
  "trainingTask1-2": "Checkpointy",
  "trainingTask2-0": "Trafené terče",
  "trainingTask2-1": "Čas streľby v ľahu",
  "trainingTask2-2": "Čas streľby v stoji",
  "trainingTask3-0": "Nájazd",
  "trainingTask3-1": "Odraz",
  "trainingTask3-2": "Letová fáza",
  "trainingTask3-3": "Pristátie",
  "trainingTask4-0": "Rozbeh",
  "trainingTask4-1": "Naskočenie",
  "trainingTask4-2": "Ideálna línia",
  "trainingTask5-0": "Štart",
  "trainingTask5-1": "Akcelerácia",
  "trainingTask5-2": "Rytmus",
  "trainingTask6-0": "Štart",
  "trainingTask6-1": "Bránky",
  "trainingTask6-2": "Checkpointy",
  "trainingTask7-0": "Štart",
  "trainingTask7-1": "Zrýchlenie",
  "trainingTask7-2": "Ideálna línia",
  "trainingTask7-3": "Čistá jazda",
  "trainingTask8-0": "Štart",
  "trainingTask8-1": "Checkpointy",
  "trainingTask8-2": "Jazda v závetrí",
  "trainingTask8-3": "Umiestnenie v cieli",
  noEnergy: "Nemáš dosť energie",
  quitCompetitionTraining: "Ukončiť tréning",
  quitCompetitionConfirmTraining: "Naozaj chceš ukončiť tréning?",
  trainingCompleted: "Tréning dokončený",
  baseScore: "Základné skóre",
  totalScore: "Celkové skóre",
  bonuses: "Bonusy",
  bonusAlchemy: "%s bonus za výskum",
  bonusBenefits: "%s bonus za benefit",
  bonuseSubscription: "%s bonus za členstvo",
  bonusEquipment: "%s bonus za výbavu",
  attribute: "Atribút",
  activateScubscription: "Aktivuj si členstvo v Premium obchode a získaj 25% bonus na [TP_ICON]",
  rewards: "Odmeny",
  trainAgain: "Trénovať znova",
  subscriptionActivated: "Bonus za členstvo aktivovaný",
  training: "Tréning",
  instructionsDisciplineTraining1Cell1Title: "Štart",
  instructionsDisciplineTraining1Cell1Text1: "Získaj čo najviac bodov za kvalitný štart.",
  instructionsDisciplineTraining1Cell2Title: "Bránky",
  instructionsDisciplineTraining1Cell2Text1: "Prejdi správne všetkými bránkami.",
  instructionsDisciplineTraining1Cell3Title: "Checkpointy",
  instructionsDisciplineTraining1Cell3Text1: "Na trati je 10 checkpointov. Dotkni sa ich, aby si získal extra body.",
  instructionsDisciplineTraining2Cell1Title: "Trafené terče",
  instructionsDisciplineTraining2Cell1Text1: "Snaž sa zostreliť všetkých 10 terčov.",
  instructionsDisciplineTraining2Cell2Title: "Čas streľby",
  instructionsDisciplineTraining2Cell2Text1: "Rýchlou streľbou získaj čo najviac bodov. Ideálny čas je do 15s.",
  instructionsDisciplineTraining3Cell1Title: "Nájazd",
  instructionsDisciplineTraining3Cell1Text1: "Snaž sa držať ideálnu rovnováhu počas nájazdu.",
  instructionsDisciplineTraining3Cell2Title: "Odraz",
  instructionsDisciplineTraining3Cell2Text1: "Načasuj odraz ideálne, aby si získal čo najviac bodov.",
  instructionsDisciplineTraining3Cell3Title: "Letová fáza",
  instructionsDisciplineTraining3Cell3Text1: "Kvalitnou letovou fázou natiahni skok čo najďalej.",
  instructionsDisciplineTraining3Cell4Title: "Pristátie",
  instructionsDisciplineTraining3Cell4Text1: "Získaj čo najviac bodov za kvalitné pristátie.",
  instructionsDisciplineTraining4Cell1Title: "Rozbeh",
  instructionsDisciplineTraining4Cell1Text1: "Dosiahni čo najvyššiu rýchlosť pri rozbehu.",
  instructionsDisciplineTraining4Cell2Title: "Naskočenie",
  instructionsDisciplineTraining4Cell2Text1: "Naskoč do bobov v tom správnom momente.",
  instructionsDisciplineTraining4Cell3Title: "Ideálna línia",
  instructionsDisciplineTraining4Cell3Text1: "Snaž sa držať v ideálnej línii v každej zákrute.",
  instructionsDisciplineTraining5Cell1Title: "Štart",
  instructionsDisciplineTraining5Cell1Text1: "Vyštartuj hneď ako zaznie výstrel, ale pozor na predčasný štart.",
  instructionsDisciplineTraining5Cell2Title: "Akcelerácia",
  instructionsDisciplineTraining5Cell2Text1: "Naber čo najvyššiu rýchlosť v úvodnej fáze.",
  instructionsDisciplineTraining5Cell3Title: "Rytmus",
  instructionsDisciplineTraining5Cell3Text1: "Dodržuj správny rytmus na rovinkách a v zákrutách.",
  instructionsDisciplineTraining6Cell1Title: "Štart",
  instructionsDisciplineTraining6Cell1Text1: "Získaj čo najviac bodov za kvalitný štart.",
  instructionsDisciplineTraining6Cell2Title: "Bránky",
  instructionsDisciplineTraining6Cell2Text1: "Prejdi správne všetkými bránkami.",
  instructionsDisciplineTraining6Cell3Title: "Checkpointy",
  instructionsDisciplineTraining6Cell3Text1: "Na trati je {number} checkpointov. Dotkni sa ich, aby si získal extra body.",
  instructionsDisciplineTraining7Cell1Title: "Štart",
  instructionsDisciplineTraining7Cell1Text1: "Získaj čo najviac bodov za kvalitný štart.",
  instructionsDisciplineTraining7Cell2Title: "Zrýchlenie",
  instructionsDisciplineTraining7Cell2Text1: "Naber čo najvyššiu rýchlosť silnými zábermi.",
  instructionsDisciplineTraining7Cell3Title: "Ideálna línia",
  instructionsDisciplineTraining7Cell3Text1: "Snaž sa držať v ideálnej línii v každej zákrute.",
  instructionsDisciplineTraining7Cell4Title: "Čistá jazda",
  instructionsDisciplineTraining7Cell4Text1: "Vyhýbaj sa kontaktom s krajnicami.",
  instructionsDisciplineTraining8Cell1Title: "Štart",
  instructionsDisciplineTraining8Cell1Text1: "Naber čo najvyššiu rýchlosť v úvodnej fáze.",
  instructionsDisciplineTraining8Cell2Title: "Checkpointy",
  instructionsDisciplineTraining8Cell2Text1: "Na trati je {number} checkpointov. Dotkni sa ich, aby si získal extra body.",
  instructionsDisciplineTraining8Cell3Title: "Jazda v závetrí",
  instructionsDisciplineTraining8Cell3Text1: "Získaj extra body za jazdu v závetrí.",
  instructionsDisciplineTraining8Cell4Title: "Umiestnenie v cieli",
  instructionsDisciplineTraining8Cell4Text1: "Snaž sa prísť do cieľa na čo najlepšom mieste.",
  pressKey: "Stlač [KEY]",
  provisionalResults: "Priebežné poradie",
  round: "%s. kolo<!--round-->",
  time: "Čas",
  "tutorialText1-1": "Zjazd preverí tvoju schopnosť nájsť tú najlepšiu pretekársku líniu. Ukážem ti ako na to.",
  "tutorialText1-2": "Dobrý štart je dôležitý. Pokús sa vyštartovať keď je ukazovateľ sily na maxime, aby si nabral čo najväčšiu rýchlosť.",
  "tutorialText1-3": "Šípkami nasmeruj lyžiara tak, aby prešiel bránkami, ktoré vyznačujú trať. Prejdi správne 10 bránok, aby si úspešne dokončil tutoriál.",
  "tutorialText1-4": "Za vynechanie bránky dostaneš v súťaži časovú penalizáciu. Snaž sa preto prejsť všetkými bránkami správne.",
  "tutorialText1-5": "Narazil si do ochrannej siete. Pád ti našťastie nehrozí, ale stratil si všetku rýchlosť. Snaž sa držať v ideálnej stope.",
  "tutorialText1-6": "Si v cieli, ale vynechal si príliš veľa bránok. Na tomto budeš musieť zapracovať.",
  "tutorialText1-7": "Výborne, myslím, že už vieš ako na to. Pravidelným tréningom sa určite zlepšíš.",
  "tutorialTask1-1": "Štart",
  "tutorialTask1-2": "Prejdi správne 10 bránok",
  "tutorialText2-1": "Biatlon je kombinácia behu na lyžiach a streľby. Začnime behom na lyžiach.",
  "tutorialText2-2": "Dobrý štart je dôležitý. Pokús sa vyštartovať keď je ukazovateľ sily na maxime, aby si nabral čo najväčšiu rýchlosť.",
  "tutorialText2-3": "Šípkami vľavo a vpravo ovládaš smer biatlonistu. Okrem toho vieš šípkami hore a dole ovládať aj jeho tempo. Skús zvýšiť tempo.",
  "tutorialText2-4": "Šípkami ovládaš smer biatlonistu. Okrem toho vieš tlačidlami plus a mínus ovládať aj jeho tempo. Skús zvýšiť tempo.",
  "tutorialText2-5": "Začína sa stúpanie. V stúpaniach sa dá získať veľa času na súperov. Aktivuj šprint, aby si prešiel tento kopec čo najrýchlejšie.",
  "tutorialText2-6": "Šprint môžeš aktivovať vždy keď máš aspoň trochu energie. Čím viac energie máš, tým dlhšie môžeš šprintovať. Šprint aktivuješ a deaktivuješ rovnakým tlačidlom.",
  "tutorialText2-7": "Pri zjazdoch môžeš ušetriť energiu v zjazdovom postoji. Skús si to.",
  "tutorialText2-8": "Zjazdový postoj môžeš deaktivovať rovnakým tlačidlom, ktorým sa aktivuje.",
  "tutorialText2-9": "Pri nižšom tempe sa rýchlejšie dopĺňa energia na šprint a máš pomalší tep. Ak držíš tempo v červenej zóne, energia na šprint sa ti nebude dopĺňať.",
  "tutorialText2-10": "Tep je dôležitý hlavne pri streľbe. Ak prídeš na strelnicu s vysokým tepom, môžeš mať problémy trafiť terče. Snaž sa preto trochu ušetriť energiu pred streľbou.",
  "tutorialText2-11": "Dorazil si na strelnicu. Máš pať nábojov a päť terčov. Myšou namier na terč a vystreľ ľavým tlačidlom myši.",
  "tutorialText2-12": "Dorazil si na strelnicu. Máš pať nábojov a päť terčov. Joystickom namier na terč a vystreľ.",
  "tutorialText2-13": "Nepodarilo sa ti trafiť ani jeden terč. Skús to ešte raz.",
  "tutorialText2-14": "Výborne, myslím, že už vieš ako na to. Pravidelným tréningom sa určite zlepšíš.",
  "tutorialTask2-1": "Štart",
  "tutorialTask2-2": "Šprint",
  "tutorialTask2-3": "Zjazdový postoj",
  "tutorialTask2-4": "Zostreľ aspoň jeden terč",
  "tutorialText3-1": "Si pripravený spustiť sa dole mostíkom? Na úvod je dôležité sledovať silu a smer vetra.",
  "tutorialText3-2": "Keď je šípka zelená, vietor je priaznivý, keď je červená, tak je to horšie. Snaž sa spustiť keď je vietor priaznivý.",
  "tutorialText3-3": "Počas nájazdu sa snaž držať ideálnu rovnováhu pomocou joysticku, aby si nabral čo najvyššiu rýchlosť.",
  "tutorialText3-3-1": "Počas nájazdu sa snaž držať ideálnu rovnováhu pomocou šípok, aby si nabral čo najvyššiu rýchlosť.",
  "tutorialText3-4": "Kľúčom k dlhým skokom je správne načasovaný odraz. Na mostíku vidíš naznačené miesto ideálneho odrazu.",
  "tutorialText3-5": "Letíme! Joystickom sa snaž držať v ideálnej letovej pozícii.",
  "tutorialText3-5-1": "Letíme! Šípkami sa snaž držať v ideálnej letovej pozícii.",
  "tutorialText3-6": "A teraz nám už zostáva len bezpečne pristáť do telemarku. Stlač tlačidlo pristátia, keď sa biely kruh zmenší na veľkosť zelenej zóny v strede.",
  "tutorialText3-7": "Slušný pokus. Skús to teraz sám bez mojej pomoci.",
  "tutorialText3-8": "Nepodarilo sa ti dosiahnuť všetky ciele. Skús to ešte raz.",
  "tutorialText3-9": "Výborne, myslím, že už vieš ako na to. Pravidelným tréningom sa určite zlepšíš.",
  "tutorialText3-10": "Nepodarilo sa ti dosiahnuť všetky ciele. Skús to ešte raz.",
  "tutorialText3-11": "Výborne, myslím, že už vieš ako na to. Pravidelným tréningom sa určite zlepšíš.",
  "tutorialTask3-1": "Nájazdová rýchlosť",
  "tutorialTask3-2": "Odraz",
  "tutorialTask3-3": "Vzdialenosť",
  "tutorialTask3-4": "Pristátie",
  "tutorialText4-1": "Boby sú hlavne o rýchlom štarte a o udržiavaní ideálnej línie pri prejazde zákrut. Ukážem ti ako na to.",
  "tutorialText4-2": "Dobrý štart je dôležitý. Najprv treba boby roztlačiť do čo najväčšej rýchlosti. Ukazovateľ rozbehu sa bude hýbať z jednej strany na druhú. Ty sa snaž kliknúť vždy keď je krúžok na pravom respektíve ľavom okraji. Krúžok sa postupne zrýchľuje.",
  "tutorialText4-3": "Snaž sa kliknúť vždy keď je krúžok na pravom respektíve ľavom okraji.",
  "tutorialText4-4": "Ten rozbeh ti vôbec nevyšiel. Skús to znova a snaž sa kliknúť vždy keď je krúžok na pravom respektíve ľavom okraji.",
  "tutorialText4-5": "Teraz je potrebné správne načasovať naskočenie do bobov. Na trati vidíš naznačené ideálne miesto pre naskočenie.",
  "tutorialText4-6": "Sme v prvej zákrute. Vidíš ideálnu líniu? Snaž sa jej držať, aby si prešiel zákrutou čo najrýchlejšie.",
  "tutorialText4-7": "Narazil si do mantinelu a stratil si trocha rýchlosti. Snaž sa vyhýbať týmto nárazom.",
  "tutorialText4-8": "Si v cieli, ale nepodarilo sa ti nabrať dostatočnú rýchlosť. No nič, budeme musieť viac trénovať.",
  "tutorialText4-9": "Výborne, myslím, že už vieš ako na to. Pravidelným tréningom sa určite zlepšíš.",
  "tutorialText4-10": "Podarilo sa ti dosiahnuť slušnú rýchlosť. Ešte však budeš musieť popracovať na tých štartoch. Pravidelným tréningom sa určite zlepšíš.",
  "tutorialTask4-1": "Rozbeh",
  "tutorialTask4-2": "Naskočenie",
  "tutorialTask4-3": "Rýchlosť",
  "tutorialText5-1": "Dnes sa naučíme základy rýchlokorčuľovania. Pôjdeme najkratšiu vzdialenosť 500 metrov.",
  "tutorialText5-2": "Vyštartuj hneď ako zaznie výstrel alebo keď uvidíš nápis {start}",
  "tutorialText5-3": "Kam sa tak ponáhľaš? Počkaj si na výstrel a potom odštartuj.",
  "tutorialText5-4": "Teraz treba nabrať rýchlosť. Striedavo stláčaj tlačidlá vľavo a vpravo čo najrýchlejšie!",
  "tutorialText5-5": "To je trochu pomalé. Pamätaj: aby si nabral rýchlosť musíš striedavo stláčať tlačidlá vľavo a vpravo najrýchlejšie ako vieš. Nabudúce do toho daj viac.",
  "tutorialText5-6": "Teraz potrebujeme chytiť ten správny rytmus. Dole uvidíš ako sa napĺňajú ukazovateľe záberov. Drž ľavé alebo pravé tlačidlo podľa toho, ktorý ukazovateľ sa napĺňa. Zelená farba znamená, že držíš správne tlačidlo.",
  "tutorialText5-7": "Možno si si všimol, že v zákrute sa rýchlejšie striedajú ľavé a pravé zábery. Daj si na to pozor. Som si istá, že s tým nebudeš mať žiadny problém.",
  "tutorialText5-8": "Ide ti to skvele, zdá sa, že si prirodzený talent. Nemôžem sa dočkať, čo dokážeš v reálnych súťažiach.",
  "tutorialText5-9": "Úspešne sme prišli do cieľa, ale budeš musieť ešte trochu popracovať na rytme korčuľovania. Ak chceš, môžeme si lekciu zopakovať. Nájdeš ma v tréningovej hale.",
  "tutorialTask5-1": "Štart",
  "tutorialTask5-2": "Akcelerácia",
  "tutorialTask5-3": "Dosiahni 10 skvelých záberov",
  "tutorialTask5-4": "Cieľ<!--finish-->",
  "tutorialText6-1": "Obrovský slalom je najtechnickejšia alpská disciplína. Vyžaduje si správne časovanie oblúkov a rýchle reakcie.",
  "tutorialText6-2": "Dobrý štart je dôležitý. Pokús sa vyštartovať keď je ukazovateľ sily na maxime, aby si nabral čo najväčšiu rýchlosť.",
  "tutorialText6-3": "Šípkami nasmeruj lyžiara tak, aby prešiel bránkami, ktoré vyznačujú trať. Prejdi správne {number} bránok, aby si úspešne dokončil tutoriál.",
  "tutorialText6-4": "Občas sa môžeš dostať do situácie, kedy potrebuješ urobiť ostrejšiu zákrutu. Ostré zákruty ťa síce spomalia, ale môžu ťa zachrániť pred vynechaním bránky. Vyskúšaj si to.",
  "tutorialText6-5": "Za vynechanie bránky dostaneš v súťaži časovú penalizáciu. Snaž sa preto prejsť všetkými bránkami správne.",
  "tutorialText6-6": "Narazil si do ochrannej siete. Pád ti našťastie nehrozí, ale stratil si všetku rýchlosť. Snaž sa držať v ideálnej stope.",
  "tutorialText6-7": "Si v cieli, ale vynechal si príliš veľa bránok. Na tomto budeš musieť zapracovať.",
  "tutorialText6-8": "Si v cieli, ale vôbec si si nevyskúšal ostré zákruty. Odporúčam, aby si si ich čo najskôr natrénoval.",
  "tutorialText6-9": "Výborne, myslím, že už vieš ako na to. Pravidelným tréningom sa určite zlepšíš.",
  "tutorialTask6-1": "Štart",
  "tutorialTask6-2": "Prejdi správne {number} bránok",
  "tutorialTask6-3": "Skús ostré zatočenie",
  "tutorialText7-1": "Sánkovanie je v mnohom podobné ako boby. Môžeš síce využiť svoje jazdecké schopnosti, ale trať je iná.",
  "tutorialText7-2": "Dobrý štart je dôležitý. Pokús sa vyštartovať keď je ukazovateľ sily na maxime, aby si nabral čo najväčšiu rýchlosť.",
  "tutorialText7-3": "Odštartovali sme, ale ešte potrebujeme nabrať väčšiu rýchlosť. Urobíš celkom štyri zábery rukami, snaž sa trafiť maximum pri každom zábere.",
  "tutorialText7-4": "Tie zábery rukami ti vôbec nevyšli. Skús to znova a snaž sa kliknúť vždy keď je ukazovateľ sily na maxime.",
  "tutorialText7-5": "Sme v prvej zákrute. Vidíš ideálnu líniu? Snaž sa jej držať, aby si prešiel zákrutou čo najrýchlejšie.",
  "tutorialText7-6": "Narazil si do mantinelu a stratil si trocha rýchlosti. Snaž sa vyhýbať týmto nárazom.",
  "tutorialText7-7": "Si v cieli, ale nepodarilo sa ti nabrať dostatočnú rýchlosť. No nič, budeme musieť viac trénovať.",
  "tutorialText7-8": "Podarilo sa ti dosiahnuť slušnú rýchlosť. Ešte však budeš musieť popracovať na tých štartoch. Pravidelným tréningom sa určite zlepšíš.",
  "tutorialText7-9": "Výborne, myslím, že už vieš ako na to. Pravidelným tréningom sa určite zlepšíš.",
  "tutorialTask7-1": "Štart",
  "tutorialTask7-2": "Zrýchlenie",
  "tutorialTask7-3": "Rýchlosť",
  "tutorialText8-1": "Beh na lyžiach už poznáš z biatlonu. Dnes si ale ukážeme klasickú techniku a jazdu proti viacerým súperom na trati. ",
  "tutorialText8-2": "Vyštartuj hneď ako zaznie výstrel alebo keď uvidíš nápis {start}. Následne naber čo najvyššiu rýchlosť opakovaným stláčaním toho istého tlačidla.",
  "tutorialText8-3": "Tento štart ti vôbec nevyšiel. Skús to znova a nezabudni rýchlo stláčať tlačidlo Štart, aby sme nabrali čo najvyššiu rýchlosť.",
  "tutorialText8-4": "Ovládanie rýchlosti je veľmi podobné ako v biatlone. Rozdiel je v tom, že tu sa ti dopĺňa energia do šprintu aj vtedy, keď ideš na maximum.",
  "tutorialText8-5": "Ďalší rozdiel je v tom, že v tejto disciplíne nemusíš ovládať smer lyžiara. Lyžiar sa automaticky drží vo svojej dráhe. Šípkami však môžeš prechádzať medzi dráhami. Vyskúšaj si to.",
  "tutorialText8-6": "Šípkou vľavo alebo vpravo zmeň dráhu.",
  "tutorialText8-7": "Výborne, teraz sa nachádzaš mimo vyznačenej stopy. Tu je trochu pomalší sneh a preto je lepšie držať sa v stope. Jazda mimo stopy je niekedy nutná, keď potrebuješ niekoho predbehnúť. Zaraď sa teraz späť do stopy.",
  "tutorialText8-8": "Táto dráha je blokovaná iným lyžiarom. Skús prejsť do inej dráhy.",
  "tutorialText8-9": "Vráť sa do vyznačenej stopy.",
  "tutorialText8-10": "Keď si v závetrí za iným lyžiarom, rýchlejšie sa ti dopĺňa energia na šprint a môžeš dosiahnuť vyššiu rýchlosť. Aby si využil túto výhodu, musíš sa zaradiť za iného lyžiara a držať sa pri ňom čo najbližšie.",
  "tutorialText8-11": "Sme v cieli, ale vôbec sme nevyužili jazdu v závetrí. Ak chceš, môžeme si lekciu zopakovať. Nájdeš ma v tréningovej hale.",
  "tutorialText8-12": "Výborne, myslím, že základy už poznáš. Aj tu platí, že ak prepáliš tempo, zvýši sa ti tep a to môže negatívne ovplyvniť tvoju rýchlosť. Nezabudni v zjazdoch využívať zjazdový postoj a v správnych momentoch zašprintovať.",
  "tutorialTask8-1": "Štart",
  "tutorialTask8-2": "Zmena dráhy",
  "tutorialTask8-3": "Jazdi v závetrí {number} sekúnd",
  tutorialAnneTableSubheader: "Výborne, pozrime sa, čo si získal tréningom…",
  tutorialRewardsTitle1: "Tréningové body",
  tutorialRewardsTitle2: "Skúsenosti",
  tutorialRewardsText1: "Tréningové body slúžia na vylepšovanie atribútu trénovanej disciplíny.",
  tutorialRewardsText2: "Skúsenosti potrebuješ na zvyšovanie svojej úrovne a odomykanie nových disciplín a schopností.",
  downhillSetting: "Zjazdový postoj",
  tutorial: "Tutoriál",
  automatic: "Automaticky",
  manual: "Manuálne",
  quitCompetitionTutorial: "Ukončiť tutoriál",
  quitCompetitionConfirmTutorial: "Naozaj chceš ukončiť tutoriál?",
  wrongWay: "Nesprávny smer",
  "hint-0-0": "Ak ti minihra seká, môžeš si zmeniť grafické detaily v nastaveniach.",
  "hint-0-1": "Ak hráš naživo, môžeš dosiahnuť lepší výsledok, ako keď súťaž alebo tréning simuluješ.",
  "hint-0-2": "Staň sa členom klubu a môžeš získať zaujímavé benefity.",
  "hint-0-3": "Výbava sa opotrebováva každou súťažou a tréningom. Keď sa opotrebuje úplne, musíš ju dať opraviť.",
  "hint-0-4": "Ak prekročíš limit energie alebo štartov, budú ti postupne ubúdať, až kým sa zase nedostaneš na hodnotu limitu.",
  "hint-0-5": "Tréningy s trénerom sú oveľa efektívnejšie ako bežné tréningy. Každý deň môžeš trénerom absolvovať obmedzený počet tréningov.",
  "hint-0-6": "Osobné rekordy z tréningov sa nepočítajú.",
  "hint-0-7": "Plň úlohy v Kariére, aby si odomkol nové možnosti v hre.",
  "hint-0-8": "Predmety na mape skrývajú malé odmeny.",
  "hint-1-0": "Manuálny zjazdový postoj je síce náročnejší na ovládanie ale dajú sa ním dosiahnuť rýchlejšie časy.",
  "hint-2-0": "Snaž sa prísť na strelnicu s pomalším tepom, aby sa ti ľahšie mierilo.",
  "hint-2-1": "Príliš vysoký tep spôsobí zníženie tvojho maximálneho tempa.",
  "hint-2-2": "V zjazdoch použi zjazdový postoj, aby si ušetril energiu na šprint a znížil svoj tep.",
  "hint-3-0": "Protivietor je tvoj kamarát. Skús odštartovať keď bude vietor priaznivý.",
  "hint-3-1": "Nájazdové okno má zásadný vplyv na dĺžku skoku. Okno sa vyberá automaticky podľa sily najsilnejšieho skokana v súťaži.",
  "hint-8-0": "Keď si v závetrí za iným lyžiarom, rýchlejšie sa ti dopĺňa energia na šprint, máš nižší tep a môžeš dosiahnuť vyššiu rýchlosť.",
  "hint-8-1": "Príliš vysoký tep spôsobí zníženie tvojho maximálneho tempa.",
  "hint-8-2": "Tvoja pozícia na štarte závisí od tvojho rebríčkového postavenia v porovnaní so súpermi.",
  "hint-8-3": "Taktiku treba prispôsobiť pozícii na štarte. Každá pozícia má svoje výhody aj nevýhody.",
  "hint-8-4": "Dráha na pravej strane je síce najkratšia, ale je v nej aj najväčšie riziko, že ťa súperi zavrú.",
  "hint-8-5": "Pozor! Sneh mimo vyznačenej stopy je pomalší.",
  shootingProne: "Streľba v ľahu",
  shootingStanding: "Streľba v stoji",
  selectControls: "Si pravák alebo ľavák?",
  controlsInfoTooltip: "Orientáciu tlačidiel môžeš kedykoľvek zmeniť v nastaveniach.",
  tapToButton: "Ťukni na [BUTTON]",
  takeOff: "Odraz",
  sprint: "Šprint",
  landing: "Pristátie",
  leftArrow: "Stlač šípku vľavo",
  rightArrow: "Stlač šípku vpravo",
  leftOrRightArrow: "Stlač šípku vľavo alebo vpravo",
  webInfoStart: "Štart",
  webInfoLeft: "Vľavo",
  webInfoRight: "Vpravo",
  webInfoTuck: "Zjazdový postoj",
  webInfoBalance: "Balans",
  webInfoTakeoff: "Odraz",
  webInfoLanding: "Pristátie",
  webInfoTempo: "Ovládanie tempa",
  webInfoSprint: "Šprint",
  webInfoAim: "Mierenie",
  webInfoShoot: "Spúšť",
  webInfoPush: "Roztlačiť",
  webInfoJumpIn: "Naskočiť",
  webInfoAcceleration: "Akcelerácia",
  startgate: "Nájazdové okno",
  reward_training_points: "Tréningové body",
  reward_experience: "Skúsenosti",
  reward_snowflake: "Obrovská vločka",
  "reward_ice-pick": "Bodák na ľad",
  "reward_ice-cube": "Dokonalá kocka ľadu",
  reward_glacier: "Úlomok Arktídy",
  reward_comet: "Meteorit",
  reward_elixir: "Polárna žiara vo fľaši",
  reward_reputation: "Reputácia",
  hardCornering: "Ostré zákruty",
  slipStream: "Závetrie",
  "event_badges-header": "Eventové vavríny",
  "event_badges-first": "Vítazstvo v hlavnom eventovom turnaji",
  "event_badges-second-third": "[rank]. miesto v hlavnom eventovom turnaji",
  "event_badges-footer": "Za menom hráča sa zobrazuje iba najlepšia dosiahnutá trofej."
}, l$ = {
  utPersonalBestShort: "pb",
  utLow: "low",
  utMedium: "medium",
  utHigh: "high",
  utAuto: "auto",
  utOn: "on",
  utOff: "off",
  utToBeat: "To beat",
  utPaused: "Paused",
  utFalseStart: "False start",
  utShells: "Shells",
  utTutorialStefecekova: "Zuzana Rehák-Štefečeková",
  utTutorialLongova: "Alexandra Longová",
  utTutorialVolko: "Ján Volko",
  utTutorialTrainer: "Sam",
  utTutorialBenus: "Matej Beňuš",
  tableText3: "",
  tableText6: "Boss",
  tableText11: "Easy",
  tableText12: "Medium",
  tableText13: "Hard",
  alex: "ALEX",
  utHold: "hold",
  disciplineName11: "100 metrov",
  disciplineName12: "Lukostreľba",
  disciplineName13: "Trap",
  disciplineName14: "Dráhová cyklistika",
  disciplineName15: "Kajak",
  disciplineName16: "Hod oštepom",
  clickToContinue: "Pokračuj kliknutím",
  clickToContinueTemp: "Pokračuj kliknutím",
  tapToContinue: "Pokračuj ťuknutím",
  settings: "Nastavenia",
  instructions: "Inštrukcie",
  quit: "Ukončiť",
  startList: "Štartová listina",
  finalStandings: "Konečné výsledky",
  graphicDetails: "Grafické detaily",
  sounds: "Zvuky",
  controls: "Ovládanie<!--controls-->",
  oneFingerControls: "Ovládanie jedným prstom",
  oneFingerControlsDescription: "Namier joystickom a vystrel zdvihnutím prsta z displeja",
  vibrations: "Vibrácie",
  leftHanded: "Ľavák",
  rightHanded: "Pravák",
  quitCompetition: "Ukončiť súťaž<!--quit-->",
  quitCompetitionConfirm: "Naozaj chceš ukončiť súťaž?",
  yes: "Áno",
  back: "Späť",
  wind: "Vietor",
  tapTheXButton: "Ťukni na tlačidlo START",
  finish: "Cieľ<!--finish-->",
  congratulations: "Gratulujeme!",
  winner: "Víťaz<!--winner-->",
  rankX: "%s. miesto",
  newPersonalBest: "Nový osobný rekord",
  personalBest: "Osobný rekord",
  newWorldRecord: "Nový svetový rekord",
  worldRecord: "Svetový rekord",
  perfectStart: "Dokonalý štart",
  excellentStart: "Skvelý štart",
  goodStart: "Dobrý štart",
  slowStart: "Pomalý štart",
  continue: "Pokračovať",
  start: "Štart",
  instructionsDiscipline11Cell1Title: "Štart",
  instructionsDiscipline11Cell1Text1: "Odštartuj kliknutím alebo ťuknutím.",
  instructionsDiscipline11Cell1Text2: "Daj pozor, aby si neodštartoval predčasne.",
  instructionsDiscipline11Cell2Title: "Beh",
  instructionsDiscipline11Cell2Text1: "Klikaj alebo ťukaj, aby si nabral rýchlosť.",
  instructionsDiscipline11Cell2Text2: "Drž sa v ideálnej zóne.",
  instructionsDiscipline11Cell3Title: "Predklon",
  instructionsDiscipline11Cell3Text1: "Nezabudni sa pred cieľom predkloniť.",
  instructionsDiscipline12Cell1Title: "Natiahni, namier a vystreľ",
  instructionsDiscipline12Cell1Text1: "Klikni a podrž ľavé tlačidlo myši, namier a potom pusti tlačidlo.",
  instructionsDiscipline12Cell1Text1Mobile: "Podrž prst na displeji, namier pohybom prsta a potom ho zodvihni z displeja.",
  instructionsDiscipline12Cell2Title: "Vietor",
  instructionsDiscipline12Cell2Text1: "Sleduj smer a silu vetra a prispôsob tomu kam mieriš.",
  instructionsDiscipline12Cell3Title: "{number} šípov",
  instructionsDiscipline12Cell3Text1: "Získaj čo najviac bodov za každý šíp. Na každý výstrel máš {number} sekúnd.",
  instructionsDiscipline13Cell1Title: "Zavolaj terč",
  instructionsDiscipline13Cell1Text1: "Kliknutím si zavolaj terč.",
  instructionsDiscipline13Cell1Text1Mobile: "Ťuknutím si zavolaj terč.",
  instructionsDiscipline13Cell2Title: "Namier a vystreľ",
  instructionsDiscipline13Cell2Text1: "Namier myšou a vystreľ kliknutím ľavého tlačidla.",
  instructionsDiscipline13Cell2Text1Mobile: "Namier joystickom a vystreľ ťuknutím na tlačidlo.",
  instructionsDiscipline13Cell3Title: "Dva náboje",
  instructionsDiscipline13Cell3Text1: "Snaž sa zasiahnuť terč prvým výstrelom, aby si získal viac bodov.",
  instructionsDiscipline13Cell4Title: "{number} terčov",
  instructionsDiscipline13Cell4Text1: "Získaj čo najviac bodov za každý terč.",
  instructionsDiscipline14Cell1Title: "Zmena dráhy",
  instructionsDiscipline14Cell1Text1: "Šípkami vľavo a vpravo môžeš meniť dráhy.",
  instructionsDiscipline14Cell2Title: "Tempo",
  instructionsDiscipline14Cell2Text1: "Čím rýchlejšie klikáš, tým rýchlejšie ideš.",
  instructionsDiscipline14Cell2Text1Mobile: "Čím rýchlejšie ťukáš, tým rýchlejšie ideš.",
  instructionsDiscipline14Cell2Text2: "Ak sa dostaneš nad vyznačenú hodnotu na tempo lište, znamená to, že špurtuješ.",
  instructionsDiscipline14Cell3Title: "Energia",
  instructionsDiscipline14Cell3Text1: "Energia sa ti automaticky dopĺňa ak nešpurtuješ a naopak míňa sa keď špurtuješ.",
  instructionsDiscipline14Cell3Text2: "Ak sa ti energia minie, začne klesať tvoja maximálna rýchlosť.",
  instructionsDiscipline14Cell4Title: "Závetrie",
  instructionsDiscipline14Cell4Text1: "Keď si v závetrí za iným cyklistom, rýchlejšie sa ti dopĺňa energia na špurt, prípadne sa ti pomalšie míňa ak špurtuješ.",
  instructionsDiscipline14Cell4Text2: "V závetrí môžeš dosiahnuť vyššiu rýchlosť a túto rýchlosť si vieš udržať aj pár sekúnd po vystúpení zo závetria.",
  instructionsDiscipline15Cell1Title: "Štart",
  instructionsDiscipline15Cell1Text1: "Odštartuj ľavým alebo pravým tlačidlom podľa toho, na ktorej strane má kajakár ponorené pádlo.",
  instructionsDiscipline15Cell1Text2: "Daj pozor, aby si neodštartoval predčasne.",
  instructionsDiscipline15Cell2Title: "Pádlovanie",
  instructionsDiscipline15Cell2Text1: "Striedaj ľavé a pravé tlačidlo podľa toho, na ktorej strane kajakár robí záber.",
  instructionsDiscipline15Cell2Text2: "Ideálny moment záberov je vyznačený krúžkami na trati.",
  instructionsDiscipline15Cell3Title: "Posledný záber",
  instructionsDiscipline15Cell3Text1: "Načasuj posledný mohutný záber tak, aby si získal čo najväčšiu výhodu.",
  tableText1: "Rebríčková súťaž",
  tableText2: "Klubové majstrovstvá",
  tableText4: "Denná liga",
  tableText5: "Kariéra",
  tableText7: "Turnaj",
  highScore: "Najlepšie skóre",
  newHighScore: "Nové najlepšie skóre",
  level: "Úroveň %s",
  "training-text-1": "Pri tréningu využi to, čo sme sa už naučili. Čím lepší výkon podáš, tým viac sa zlepšíš.",
  "trainingTask11-0": "Štart",
  "trainingTask11-1": "Beh",
  "trainingTask11-2": "Predklon",
  "trainingTask12-0": "Šíp {number}",
  "trainingTask12-1": "Šíp {number}",
  "trainingTask12-2": "Šíp {number}",
  "trainingTask12-3": "Šíp {number}",
  "trainingTask12-4": "Šíp {number}",
  "trainingTask12-5": "Šíp {number}",
  "trainingTask13-0": "Terč {number}",
  "trainingTask13-1": "Terč {number}",
  "trainingTask13-2": "Terč {number}",
  "trainingTask13-3": "Terč {number}",
  "trainingTask13-4": "Terč {number}",
  "trainingTask14-0": "Maximálna rýchlosť",
  "trainingTask14-1": "Jazda v závetrí",
  "trainingTask14-2": "Získané pozície",
  "trainingTask14-3": "Umiestnenie v cieli",
  "trainingTask15-0": "Štart",
  "trainingTask15-1": "Pádlovanie",
  "trainingTask15-2": "Posledný záber",
  noEnergy: "Nemáš dosť energie",
  quitCompetitionTraining: "Ukončiť tréning",
  quitCompetitionConfirmTraining: "Naozaj chceš ukončiť tréning?",
  trainingCompleted: "Tréning dokončený",
  baseScore: "Základné skóre",
  totalScore: "Celkové skóre",
  bonuses: "Bonusy",
  bonusAlchemy: "%s bonus za výskum",
  bonusBenefits: "%s bonus za benefit",
  bonusEquipment: "%s bonus za výbavu",
  attribute: "Atribút",
  rewards: "Odmeny",
  trainAgain: "Trénovať znova",
  training: "Tréning",
  instructionsDisciplineTraining11Cell1Title: "Štart",
  instructionsDisciplineTraining11Cell1Text1: "Vyštartuj hneď ako zaznie výstrel, ale pozor na predčasný štart.",
  instructionsDisciplineTraining11Cell2Title: "Beh",
  instructionsDisciplineTraining11Cell2Text1: "Drž sa v ideálnej zóne, aby si nabral čo najvyššiu rýchlosť.",
  instructionsDisciplineTraining11Cell3Title: "Predklon",
  instructionsDisciplineTraining11Cell3Text1: "Načasuj predklon tak, aby si ušetril pár stotín sekundy.",
  instructionsDisciplineTraining12Cell1Title: "{number} šípov",
  instructionsDisciplineTraining12Cell1Text1: "Získaj čo najviac bodov za každý šíp.",
  instructionsDisciplineTraining12Cell2Title: "Vietor",
  instructionsDisciplineTraining12Cell2Text1: "Sila vetra sa bude postupne zvyšovať každým pokusom.",
  instructionsDisciplineTraining13Cell1Title: "{number} terčov",
  instructionsDisciplineTraining13Cell1Text1: "Získaj čo najviac bodov za každý terč.",
  instructionsDisciplineTraining13Cell2Title: "Dva náboje",
  instructionsDisciplineTraining13Cell2Text1: "Snaž sa zasiahnuť terč prvým výstrelom, aby si získal viac bodov.",
  instructionsDisciplineTraining13Cell3Title: "Druhá šanca",
  instructionsDisciplineTraining13Cell3Text1: "Ak netrafíš terč, môžeš pokus zopakovať s dvomi novými nábojmi, ale už za menej bodov.",
  instructionsDisciplineTraining14Cell1Title: "Maximálna rýchlosť",
  instructionsDisciplineTraining14Cell1Text1: "Dosiahni čo najvyššiu rýchlosť aj s pomocou závetria.",
  instructionsDisciplineTraining14Cell2Title: "Jazda v závetrí",
  instructionsDisciplineTraining14Cell2Text1: "Získaj extra body za jazdu v závetrí.",
  instructionsDisciplineTraining14Cell3Title: "Získané pozície",
  instructionsDisciplineTraining14Cell3Text1: "Urob aspoň {number} predbiehacích manévrov počas jednej jazdy.",
  instructionsDisciplineTraining14Cell4Title: "Umiestnenie v cieli",
  instructionsDisciplineTraining14Cell4Text1: "Snaž sa prísť do cieľa na čo najlepšom mieste.",
  instructionsDisciplineTraining15Cell1Title: "Štart",
  instructionsDisciplineTraining15Cell1Text1: "Vyštartuj hneď ako zaznie signál, ale pozor na predčasný štart.",
  instructionsDisciplineTraining15Cell2Title: "Pádlovanie",
  instructionsDisciplineTraining15Cell2Text1: "Udržuj ideálny rytmus a frekvenciu pádlovania.",
  instructionsDisciplineTraining15Cell3Title: "Posledný záber",
  instructionsDisciplineTraining15Cell3Text1: "Načasuj posledný mohutný záber tak, aby si získal čo najväčšiu výhodu.",
  pressKey: "Stlač [KEY]",
  provisionalResults: "Priebežné poradie",
  round: "%s. kolo<!--round-->",
  time: "Čas",
  "tutorialText11-1": "Dúfam, že máš rýchle nohy, pretože ich budeš potrebovať. Dám ti zopár tipov, ako dosahovať rýchle časy.",
  "tutorialText11-2": "Vyštartuj hneď ako zaznie výstrel alebo keď uvidíš nápis {start}.",
  "tutorialText11-3": "Kam sa tak ponáhľaš? Počkaj si na výstrel a potom odštartuj.",
  "tutorialText11-4": "Teraz sa snaž udržiavať v ideálnom tempe, aby si nabral čo najväčšiu rýchlosť. Ale pozor, ideálne tempo sa bude zvyšovať spolu s tvojou rýchlosťou.",
  "tutorialText11-5": "Výborne, teraz si to vyskúšaj proti sparing partnerovi.",
  "tutorialText11-6": "Posledných pár metrov už nemusíš riešiť ideálne tempo. V tejto fáze je dôležité správne načasovanie predklonu, ktorým vieš ušetriť nejaké stotinky. Práve teraz je ten vhodný čas.",
  "tutorialText11-7": "Ide ti to skvele, zdá sa, že si prirodzený talent. Nemôžem sa dočkať, čo dokážeš v reálnych súťažiach.",
  "tutorialText11-8": "Na začiatok to bolo celkom dobré. Keď budeš tvrdo trénovať, možno raz budeš bežať stovku pod 10 sekúnd.",
  "tutorialText11-9": "Vyzerá to tak, že ešte musíš veľa trénovať, ale určite sa do toho časom dostaneš. Ak chceš, môžeme si lekciu zopakovať. Nájdeš ma v tréningovom centre.",
  "tutorialInfoBox11-1": "{b}Klikaj rýchlejšie{/b}, aby si sa držal v ideálnom tempe",
  "tutorialInfoBox11-1m": "{b}Ťukaj rýchlejšie{/b}, aby si sa držal v ideálnom tempe",
  "tutorialInfoBox11-2": "{b}Klikáš príliš rýchlo{/b}, snaž sa držať v ideálnom tempe",
  "tutorialInfoBox11-2m": "{b}Ťukáš príliš rýchlo{/b}, snaž sa držať v ideálnom tempe",
  "tutorialTask11-1": "Dobrý štart",
  "tutorialTask11-2": "Načasovanie predklonu",
  "tutorialTask11-3": "Poraz súpera",
  "tutorialText12-1": "Lukostreľba má síce jednoduché pravidlá, ale to neznamená, že je to jednoduchý šport. Poď, ukážem ti ako na to.",
  "tutorialText12-2": "Počas súťaže máš na každý výstrel iba {number} sekúnd.",
  "tutorialText12-3": "Čas vypršal, skús to znova a nezabudni, že máš len {number} sekúnd.",
  "tutorialText12-4": "Teraz si to skúsme aj s vetrom. Smer a silu vetra treba kompenzovať. Ak vietor fúka zľava doprava, potom musíš mieriť viac vľavo. Čím silnejší vietor, tým viac musíš kompenzovať jeho smer.",
  "tutorialText12-5": "Ide ti to skvele, zdá sa, že si prirodzený talent. Nemôžem sa dočkať, čo dokážeš v reálnych súťažiach.",
  "tutorialTask12-1": "Získaj {number} bodov",
  tutorialAnneTableSubheader: "Výborne, pozrime sa, čo si získal tréningom…",
  tutorialRewardsTitle1: "Tréningové body",
  tutorialRewardsTitle2: "Skúsenosti",
  tutorialRewardsText1: "Tréningové body slúžia na vylepšovanie atribútu trénovanej disciplíny.",
  tutorialRewardsText2: "Skúsenosti potrebuješ na zvyšovanie svojej úrovne a odomykanie nových disciplín a schopností.",
  tutorialInfoBox1: "Klikni a podrž ľavé tlačidlo myši, aby si natiahol luk.",
  tutorialInfoBox1m: "Podrž prst na displeji, aby si natiahol luk.",
  tutorialInfoBox2: "Zamier do stredu terča a pusti tlačidlo myši.",
  tutorialInfoBox2m: "Zamier do stredu terča a zodvihni prst z displeja.",
  "tutorialTask13-1": "Zostreľ {2to4} terče",
  "tutorialText13-1": "Trap preverí tvoje reflexy a presnosť. Strieľať budeš z brokovnice na hlinené holuby, ktoré budú vystrelené vysokou rýchlosťou. Poďme si to vyskúšať.",
  "tutorialText13-2": "Terč bude vystrelený hneď ako si ho zavoláš. Na každý terč máš dva náboje. Ak prvým výstrelom netrafíš, stále máš ešte druhú šancu.",
  "tutorialText13-3": "Najprv si kliknutím zavolaj terč. Potom namier myšou a vystreľ kliknutím ľavého tlačidla.",
  "tutorialText13-3m": "Najprv si ťuknutím si zavolaj terč. Potom namier joystickom a vystreľ ťuknutím na tlačidlo.",
  "tutorialText13-4": "Krásny zásah! Málokto trafí hneď prvý terč. Pokračuj kým nezostrelíš {2to4} terče.",
  "tutorialText13-5": "Nezabudni strieľať ľavým tlačidlom myši. Skús to ešte raz.",
  "tutorialText13-5m": "Nezabudni strieľať ťuknutím na tlačidlo. Skús to ešte raz.",
  "tutorialText13-6": "Nezabudni, že ak na prvýkrát netrafíš, máš ešte jeden náboj. Skús to ešte raz.",
  "tutorialText13-7": "Tesne vedľa, ale to nevadí. Málokto trafí hneď prvý terč. Skús to ešte raz.",
  "tutorialText13-8": "Výborne! Tvoj prvý zásah. Vidím ako sa zlepšuješ priamo pred mojimi očami. Pokračuj kým nezostrelíš {2to4} terče.",
  "tutorialText13-9": "Zdá sa, že ešte máme pred sebou veľa práce, ale verím, že pravidelným tréningom sa určite zlepšíš.",
  "tutorialText13-10": "Ide ti to skvele, zdá sa, že si prirodzený talent. Nemôžem sa dočkať, čo dokážeš v reálnych súťažiach.",
  "tutorialTask14-1": "Jazdi v závetrí {number} sekúnd",
  "tutorialTask14-2": "Zmena dráhy",
  "tutorialTask14-3": "Dosiahni rýchlosť {speed}",
  "tutorialTask14-4": "Dokonči preteky",
  "tutorialText14-1": "Keirin je jedna z najzaujímavejších disciplín v rámci dráhovej cyklistiky. Súťažíš na tri kolá proti piatim súperom. Je to hlavne o taktike a rýchlych nohách. ",
  "tutorialText14-2": "V keirine je letmý štart. Akonáhle skončí odpočet môžeš začať zrýchľovať a meniť dráhy.",
  "tutorialText14-3": "Na začiatok si vyskúšame jazdu v závetrí. Snaž sa len držať na zadnom kolese cyklistu pred tebou. Počas jazdy v závetrí sa ti rýchlejšie dopĺňa energia, ktorú budeš neskôr potrebovať.",
  "tutorialText14-4": "Stratil si kontakt s ostatnými cyklistami. Skús to ešte raz.",
  "tutorialText14-5": "Výborne, teraz skúsme predbehnúť zopár súperov. Najprv musíme zmeniť dráhu.",
  "tutorialText14-6": "Šípkou vpravo zmeň dráhu",
  "tutorialText14-7": "Výborne, teraz riadne pridaj a snaž sa dosiahnuť čo najvyššiu rýchlosť. Keď sa dostaneš nad rysku vyznačenú na tejto lište, znamená to, že špurtuješ. Pri špurtovaní sa ti míňa energia, ktorú môžeš sledovať vo vedľajšej lište.",
  "tutorialText14-8": "Ide ti to skvele! Teraz sa už len snaž prísť do cieľa na čo najlepšej pozícii. Dávaj si pozor na energiu. Keď sa ti minie, tak začne klesať aj tvoja maximálna rýchlosť.",
  "tutorialText14-9": "Do cieľa zostáva už len posledných {number} metrov. Teraz už nie je na čo čakať. Daj do toho všetko!",
  "tutorialText14-10": "Sme v cieli, ale nepodarilo sa ti dosiahnuť dostatočnú rýchlosť. Ak chceš, môžeme si lekciu zopakovať. Nájdeš ma v tréningovom centre.",
  "tutorialText14-11": "Výborne, myslím, že základy už poznáš. Chvíľu ti možno potrvá kým nájdeš tú správnu taktiku. Prvé dve kolá je to boj o pozície a potom posledné kolo už je to o tom, kto má najviac síl a najvýhodnejšiu pozíciu.",
  "tutorialInfoBox14-1": "{b}Klikaj rýchlejšie{/b}, aby si nestratil kontakt s ostatnými",
  "tutorialInfoBox14-1m": "{b}Ťukaj rýchlejšie{/b}, aby si nestratil kontakt s ostatnými",
  "tutorialInfoBox14-2": "{b}Klikaj rýchlejšie{/b}, aby si nabral čo najvyššiu rýchlosť",
  "tutorialInfoBox14-2m": "{b}Ťukaj rýchlejšie{/b}, aby si nabral čo najvyššiu rýchlosť",
  "tutorialTask15-1": "Dobrý štart",
  "tutorialTask15-2": "Dosiahni {number} skvelých záberov",
  "tutorialTask15-3": "Rýchly finiš",
  "tutorialText15-1": "Ahoj, ja som dvojnásobný olympijský medailista v kanoistike Matej Beňuš. Som tu, aby som ti pomohol naučiť sa jazdiť na kajaku. Pôjdeme {number}-metrovú trať.",
  "tutorialText15-2": "Vyštartuj hneď ako zaznie signál alebo keď uvidíš nápis {start}. Ak máš ponorené pádlo na ľavej strane, vyštartuj ľavým tlačidlo. Ak ho máš na pravej strane, použi pravé tlačidlo.",
  "tutorialText15-3": "To bolo trochu predčasné. Počkaj si na signál a potom odštartuj.",
  "tutorialText15-4": "Kľúčom k úspechu je správne načasovanie záberov. Ideálny moment záberov je vyznačený krúžkami na trati. Snaž sa nájsť ten správny rytmus.",
  "tutorialText15-5": "Stláčaj striedavo ľavé a pravé tlačidlo podľa krúžkov na trati.",
  "tutorialText15-6": "Stláčaš nesprávne tlačidlá v nesprávnom čase.",
  "tutorialText15-7": "Posledných pár metrov už nemusíš riešiť bežné zábery. V tejto fáze je dôležité správne načasovanie posledného mohutného záberu, ktorým vieš ušetriť nejaké stotinky. Práve teraz je ten vhodný čas.",
  "tutorialText15-8": "Ide ti to skvele, zdá sa, že si prirodzený talent. Nemôžem sa dočkať, čo dokážeš v reálnych súťažiach.",
  "tutorialText15-9": "Vyzerá to tak, že ešte musíš veľa trénovať, ale určite sa do toho časom dostaneš. Ak chceš, môžeme si lekciu zopakovať. Nájdeš ma v tréningovom centre.",
  aimSensitivity: "Citlivosť mierenia",
  tutorial: "Tutoriál",
  automatic: "Automaticky",
  manual: "Manuálne",
  quitCompetitionTutorial: "Ukončiť tutoriál",
  quitCompetitionConfirmTutorial: "Naozaj chceš ukončiť tutoriál?",
  "hint-0-0": "Ak ti minihra seká, môžeš si zmeniť grafické detaily v nastaveniach.",
  "hint-0-1": "Ak hráš naživo, môžeš dosiahnuť lepší výsledok, ako keď súťaž alebo tréning simuluješ.",
  "hint-0-2": "Staň sa členom klubu a môžeš získať zaujímavé benefity.",
  "hint-0-3": "Výbava sa opotrebováva každou súťažou a tréningom. Keď sa opotrebuje úplne, musíš ju dať opraviť.",
  "hint-0-4": "Ak prekročíš limit energie alebo štartov, budú ti postupne ubúdať, až kým sa zase nedostaneš na hodnotu limitu.",
  "hint-0-5": "Tréningy s trénerom sú oveľa efektívnejšie ako bežné tréningy. Každý deň môžeš trénerom absolvovať obmedzený počet tréningov.",
  "hint-0-6": "Osobné rekordy z tréningov sa nepočítajú.",
  "hint-0-7": "Plň úlohy v Kariére, aby si odomkol nové možnosti v hre.",
  "hint-0-8": "Predmety na mape skrývajú malé odmeny.",
  "hint-11-0": "Správnym načasovaním predklonu môžeš ušetriť pár stotín a to môže byť rozdiel medzi víťazstvom a prehrou.",
  "hint-12-0": "V prípade rovnosti bodov rozhoduje o poradí počet zásahov za 10 bodov, potom počet za 10/X bodov a nakoniec celková sila.",
  "hint-12-1": "Zásahy do najmenšieho kruhu v strede sú označené ako 10/X a môžu rozhodnúť v prípade rovnosti bodov.",
  "hint-12-2": "Čím silnejších máš súperov, tým väčšia pravdepodobnosť náročných poveternostných podmienok.",
  "hint-13-0": "V prípade rovnosti bodov rozhoduje o poradí celková sila. Lepšie atribúty zvýšia tvoje šance na výhru.",
  "hint-13-1": "Čím silnejších máš súperov, tým náročnejšie bude triafanie terčov.",
  "hint-13-2": "Čím ďalej necháš terč odletieť, tým menšia pravdepodobnosť zásahu.",
  "hint-14-0": "V poslednom kole už nie je dôvod šetriť energiu. Daj do toho všetko!",
  "hint-14-1": "Využívaj závetrie za inými cyklistami na ušetrenie energie.",
  "hint-14-2": "V závetrí môžeš dosiahnuť vyššiu rýchlosť a túto rýchlosť si vieš udržať aj pár sekúnd po vystúpení zo závetria.",
  "hint-14-3": "Vnútorná dráha je síce najkratšia, ale je v nej aj najväčšie riziko, že ťa súperi zavrú.",
  "hint-14-4": "Počas prvých dvoch kôl sa snaž vybojovať si čo najlepšiu pozíciu pred posledným kolom.",
  selectControls: "Si pravák alebo ľavák?",
  controlsInfoTooltip: "Orientáciu tlačidiel môžeš kedykoľvek zmeniť v nastaveniach.",
  tapToButton: "Ťukni na [BUTTON]",
  webInfoStart: "Štart",
  webInfoAim: "Mierenie",
  webInfoShoot: "Spúšť",
  reward_training_points: "Tréningové body",
  reward_experience: "Skúsenosti",
  reward_snowflake: "Drevo",
  "reward_ice-pick": "Bronz",
  "reward_ice-cube": "Krištáľ",
  reward_glacier: "Striebro",
  reward_comet: "Zlato",
  reward_elixir: "Diamant",
  reward_reputation: "Reputácia",
  "event_badges-header": "Eventové vavríny",
  "event_badges-first": "Vítazstvo v hlavnom eventovom turnaji",
  "event_badges-second-third": "[rank]. miesto v hlavnom eventovom turnaji",
  "event_badges-footer": "Za menom hráča sa zobrazuje iba najlepšia dosiahnutá trofej.",
  timeToStart: "Zostávajúci čas",
  running: "Beh",
  lunge: "Predklon",
  lastStroke: "Posledný záber",
  timeLunge: "Načasuj predklon",
  timeLastStroke: "Načasuj posledný záber",
  runTapping: "Bež ťukaním",
  lungeTap: "Ťukni kamkoľvek",
  callTargetClick: "Kliknutím zavolaj terč",
  callTargetTap: "Ťuknutím zavolaj terč",
  tapAndHold: "Ťukni a podrž prst kdekoľvek",
  pressAndHold: "Stlač a podrž {button}",
  tutorialFirstPick11: "Zavolala som halového majstra Európy Jána Volka, aby ťa uviedol do tejto disciplíny. Je to výborný šprintér a budeš v dobrých rukách.",
  tutorialFirstPick12: "Zavolala som účastníčku Olympijských hier 2016 v Riu, Alexandru Longovú, aby ťa uviedla do tajov lukostreľby. Budeš v dobrých rukách.",
  tutorialFirstPick13: "Som rada, že si si zvolil práve moju disciplínu. Trap je náročná disciplína, ale som si istá, že spolu to zvládneme.",
  trackChange: "Zmena dráhy",
  tempo: "Tempo",
  utSlipstream: "slipstream",
  rightArrow: "Stlač šípku vpravo",
  paddle: "Pádlovanie"
}, zv = T({
  name: "TimeKeeper",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    text1: {
      type: String,
      default: ""
    },
    text2: {
      type: String,
      default: ""
    },
    showText2: {
      type: Boolean,
      defalut: !1
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"],
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return this.isScaled ? {
        transform: `scale(${this.scaleCoef})`,
        "transform-origin": "100% 0"
      } : {};
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), jv = { class: "time-keeper-wrapper" }, Bv = { class: "time-keeper-text" }, Pv = {
  key: 0,
  class: "time-keeper-penalty-wrapper"
}, Dv = { class: "time-keeper-penalty-text" };
function Lv(e, t, i, s, n, o) {
  return p(), h("div", {
    style: b([e.style, e.transformCoef]),
    class: _(["time-keeper", { skew: !e.isSsm, ssm: e.isSsm }])
  }, [
    l("div", jv, [
      l("div", Bv, $(e.text1), 1)
    ]),
    e.showText2 ? (p(), h("div", Pv, [
      l("div", Dv, $(e.text2), 1)
    ])) : w("", !0)
  ], 6);
}
const d$ = /* @__PURE__ */ S(zv, [["render", Lv]]), Ov = T({
  name: "TimeKeeperExpanded",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    showDiff: {
      type: Boolean,
      default: !1
    },
    isV1: {
      type: Boolean,
      required: !0
    },
    v2Expanded: {
      type: Boolean,
      default: !1
    },
    player1: {
      type: Object,
      default: () => ({
        name: "",
        countryString: "",
        country: "",
        position: "",
        time: "",
        diff: "",
        diffColor: ""
      })
    },
    player2: {
      type: Object,
      default: () => ({
        name: "",
        countryString: "",
        country: "",
        time: ""
      })
    }
  },
  emits: ["close"],
  computed: {
    transformCoef() {
      let e = this.scaleCoef;
      return this.isWeb && (e *= 0.8), {
        transform: `scale(${e})`,
        "transform-origin": "top right"
      };
    },
    isWeb() {
      return !this.isMobile();
    },
    hideSecondRow() {
      return !this.player2.time;
    }
  }
}), Iv = { class: "time-keeper-expanded-container" }, Mv = { class: "time-keeper-expanded-text" }, Nv = {
  key: 0,
  class: "position"
}, Av = { class: "pos-number" }, Rv = { class: "row-i" }, Ev = { class: "sider" }, Fv = { class: "country" }, Vv = { class: "country-name" }, qv = ["src", "alt"], Wv = {
  key: 1,
  class: "time-keeper-expanded-text"
}, Uv = { class: "time-keeper-underbelly" }, Hv = {
  key: 0,
  class: "underbelly-name"
}, Xv = { class: "sider" }, Gv = { class: "country" }, Yv = { class: "country-name" }, Kv = ["src", "alt"], Zv = { class: "time-keeper-expanded-text" };
function Jv(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", Iv, [
    e.isV1 ? (p(), h("div", {
      key: 0,
      class: "time-keeper-expanded-v1",
      style: b([e.style, e.transformCoef])
    }, [
      l("div", {
        class: _(["time-keeper-expanded-wrapper", e.showDiff ? "longer" : ""])
      }, [
        l("div", Mv, $(e.player1.time), 1),
        l("div", {
          class: _(["time-keeper-difference", [e.player1.diffColor, e.showDiff ? "diff-visible" : ""]])
        }, $(e.player1.diff), 3)
      ], 2)
    ], 4)) : (p(), h("div", {
      key: 1,
      class: _(["time-keeper-expanded-v2", e.player1.position.length === 0 ? "" : "longer"]),
      style: b([e.style, e.transformCoef])
    }, [
      e.player1.position.length > 0 ? (p(), h("div", Nv, [
        l("span", Av, $(e.player1.position), 1)
      ])) : w("", !0),
      l("div", Rv, [
        l("div", Ev, [
          l("div", Fv, [
            l("div", Vv, " (" + $(e.player1.countryString) + ") ", 1),
            l("img", {
              class: "image",
              src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${e.player1.country.toLowerCase()}.png`,
              alt: e.player1.country
            }, null, 8, qv)
          ]),
          M(r, {
            text: e.player1.name,
            "font-size": 38,
            width: 325,
            height: 70,
            class: "player-name"
          }, null, 8, ["text"])
        ])
      ]),
      e.showDiff ? w("", !0) : (p(), h("div", Wv, $(e.player1.time), 1)),
      e.showDiff ? (p(), h("div", {
        key: 2,
        class: _(["time", e.player1.diffColor])
      }, $(e.player1.diff), 3)) : w("", !0),
      l("div", Uv, [
        l("div", {
          class: _(["time-keeper-expanded-wrapper", e.v2Expanded ? "longer" : ""]),
          style: b(e.hideSecondRow ? "display: none" : "")
        }, [
          e.v2Expanded ? (p(), h("div", Hv, [
            l("div", Xv, [
              l("div", Gv, [
                l("div", Yv, " (" + $(e.player2.countryString) + ") ", 1),
                l("img", {
                  class: "image",
                  src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${e.player2.country.toLowerCase()}.png`,
                  alt: e.player2.country
                }, null, 8, Kv)
              ]),
              M(r, {
                text: e.player2.name,
                "font-size": 31,
                width: 300,
                height: 60,
                class: "player-name"
              }, null, 8, ["text"])
            ])
          ])) : w("", !0),
          l("div", Zv, $(e.player2.time), 1)
        ], 6)
      ])
    ], 6))
  ]);
}
const u$ = /* @__PURE__ */ S(Ov, [["render", Jv]]), Qv = T({
  name: "TimeKeeperLaps",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    showDiff: {
      type: Boolean,
      default: !1
    },
    player: {
      type: Object,
      default: () => ({
        name: "",
        countryString: "",
        country: "",
        position: "",
        time: "",
        timeColor: "",
        finalTime: "",
        diff: "",
        diffColor: ""
      })
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"],
  computed: {
    transformCoef() {
      if (!this.isScaled) return {};
      let e = this.scaleCoef;
      return this.isWeb && (e *= 0.8), {
        transform: `scale(${e})`,
        "transform-origin": "0 0"
      };
    },
    isWeb() {
      return !this.isMobile();
    }
  }
}), eb = {
  key: 0,
  class: "position"
}, tb = { class: "pos-number" }, ib = { class: "row-i" }, sb = { class: "sider" }, nb = { class: "country" }, ob = { class: "country-name" }, rb = ["src", "alt"];
function ab(e, t, i, s, n, o) {
  var a, u;
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: _(["time-keeper-laps", ((a = e.player.finalTime) == null ? void 0 : a.length) > 0 ? "longer" : ""]),
    style: b([e.style, e.transformCoef])
  }, [
    e.player.position.length > 0 ? (p(), h("div", eb, [
      l("span", tb, $(e.player.position), 1)
    ])) : w("", !0),
    l("div", ib, [
      l("div", sb, [
        l("div", nb, [
          l("div", ob, " (" + $(e.player.countryString) + ") ", 1),
          l("img", {
            class: "image",
            src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${e.player.country.toLowerCase()}.png`,
            alt: e.player.country
          }, null, 8, rb)
        ]),
        M(r, {
          text: e.player.name,
          "font-size": 32,
          width: 220,
          height: 70,
          class: "player-name"
        }, null, 8, ["text"])
      ]),
      l("div", {
        class: _(["final-time", e.player.timeColor === "yellow" ? "yellow" : ""])
      }, $(e.player.finalTime), 3)
    ]),
    l("div", {
      class: _(["time", [
        e.player.timeColor === "yellow" ? "yellow" : "",
        ((u = e.player.finalTime) == null ? void 0 : u.length) > 0 ? "normal-weight" : ""
      ]])
    }, $(e.player.time), 3),
    l("div", {
      class: _(["diff", [e.player.diffColor, e.showDiff ? "stick-out" : ""]])
    }, $(e.player.diff), 3)
  ], 6);
}
const c$ = /* @__PURE__ */ S(Qv, [["render", ab]]), lb = T({
  name: "TimeKeeperLaps",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    text: {
      type: String,
      default: ""
    },
    time: {
      type: String,
      default: ""
    },
    isScaled: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"],
  computed: {
    transformCoef() {
      if (!this.isScaled) return {};
      let e = this.scaleCoef;
      return this.isWeb && (e *= 0.8), {
        transform: `scale(${e})`,
        "transform-origin": "0 0"
      };
    },
    isWeb() {
      return !this.isMobile();
    }
  }
}), db = { class: "row-i" }, ub = { class: "sider" }, cb = { class: "time" };
function pb(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return p(), h("div", {
    class: "time-keeper-laps-leader",
    style: b([e.style, e.transformCoef])
  }, [
    l("div", db, [
      l("div", ub, [
        M(r, {
          text: e.text,
          "font-size": 38,
          width: 325,
          height: 70,
          class: "player-name"
        }, null, 8, ["text"])
      ])
    ]),
    l("div", cb, $(e.time), 1)
  ], 4);
}
const p$ = /* @__PURE__ */ S(lb, [["render", pb]]), hb = T({
  name: "PowerTableHeader",
  props: {
    headerProps: {
      type: Object,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    isTraining: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      isSsm: !1
    };
  },
  computed: {
    formatedTime() {
      var e, t;
      return this.isTraining && ((e = this.headerProps) != null && e.time) ? Ee(Number(this.headerProps.time)) : (t = this.headerProps) == null ? void 0 : t.time;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
  }
}), fb = { class: "picture" }, mb = ["src", "alt"], gb = { class: "grouper" }, yb = { class: "top-section" }, vb = { class: "base-data" }, bb = { class: "minigame-name" }, $b = {
  key: 0,
  class: "minigame-name-personal-best"
}, kb = {
  key: 0,
  class: "new-pb"
}, _b = { class: "pb" }, wb = { class: "competition-type" }, Tb = { class: "competition-name" }, Sb = {
  key: 0,
  class: "wind"
}, xb = { class: "wind-text" }, Cb = { class: "result" }, zb = { class: "result-type" }, jb = { class: "right-side" }, Bb = { class: "adds" }, Pb = ["src", "alt"], Db = {
  key: 0,
  class: "result-statistics"
}, Lb = { key: 0 }, Ob = {
  key: 1,
  class: "result-time"
}, Ib = {
  key: 0,
  class: "icon-tp"
}, Mb = {
  key: 0,
  class: "table-header-wrapper"
}, Nb = { class: "table-row" }, Ab = { class: "row-i" }, Rb = { class: "right-part" }, Eb = { class: "additional-data" }, Fb = { class: "additional-data" }, Vb = { class: "time" };
function qb(e, t, i, s, n, o) {
  var r, a, u, d, c, g, f, m;
  return p(), h("section", {
    class: _([[{ active: e.active }, { "power-table-head-ssm": e.isSsm }], "power-table-head"])
  }, [
    l("div", fb, [
      l("img", {
        src: e.headerProps.discipline.image,
        alt: e.headerProps.discipline.name
      }, null, 8, mb)
    ]),
    l("div", gb, [
      l("div", yb, [
        l("div", vb, [
          l("div", bb, [
            l("div", null, $(e.headerProps.discipline.name), 1),
            ((a = (r = e.headerProps) == null ? void 0 : r.personalBest) == null ? void 0 : a.value.length) > 0 ? (p(), h("div", $b, [
              e.headerProps.personalBest.showNew ? (p(), h("span", kb, "NEW")) : w("", !0),
              K(" " + $(e.$t("personalBest")) + ": ", 1),
              l("span", _b, $(e.headerProps.personalBest.value), 1)
            ])) : w("", !0)
          ]),
          l("div", wb, [
            l("div", Tb, $(e.headerProps.competitonType), 1),
            e.headerProps.wind && e.headerProps.wind.show ? (p(), h("div", Sb, [
              t[0] || (t[0] = l("div", { class: "wind-image" }, null, -1)),
              l("div", xb, $(e.headerProps.wind.value) + " m/s ", 1)
            ])) : w("", !0)
          ]),
          l("div", Cb, [
            l("div", zb, $(e.headerProps.resultType), 1)
          ])
        ]),
        l("div", jb, [
          l("div", Bb, [
            e.headerProps.add ? (p(), h("img", {
              key: 0,
              src: e.headerProps.add.image,
              alt: e.headerProps.add.alt
            }, null, 8, Pb)) : w("", !0)
          ]),
          !e.active && !e.isSsm ? (p(), h("div", Db, [
            e.headerProps.time ? (p(), h("span", Lb, $(e.$t("utPersonalBestShort")) + ":", 1)) : w("", !0),
            e.headerProps.time ? (p(), h("span", Ob, [
              K($(e.formatedTime) + " ", 1),
              e.isTraining ? (p(), h("span", Ib)) : w("", !0)
            ])) : w("", !0)
          ])) : w("", !0)
        ]),
        e.active ? (p(), h("span", Mb, [
          l("div", Nb, [
            l("div", Ab, [
              t[1] || (t[1] = l("div", { class: "sider" }, null, -1)),
              l("div", Rb, [
                l("div", Eb, $((d = (u = e.headerProps) == null ? void 0 : u.headerTableText) == null ? void 0 : d.col1), 1),
                l("div", Fb, $((g = (c = e.headerProps) == null ? void 0 : c.headerTableText) == null ? void 0 : g.col2), 1)
              ])
            ]),
            l("div", Vb, $((m = (f = e.headerProps) == null ? void 0 : f.headerTableText) == null ? void 0 : m.col3), 1)
          ])
        ])) : w("", !0)
      ])
    ])
  ], 2);
}
const Wb = /* @__PURE__ */ S(hb, [["render", qb]]), Ub = T({
  name: "PowerBadgeTooltip",
  components: { ShrinkingTextBox: pe },
  mixins: [P],
  props: {
    isActive: {
      type: Boolean,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    isTooLow: {
      type: Boolean,
      default: !1
    },
    texts: {
      type: Array,
      default: []
    },
    badge: {
      type: Array,
      required: !0
    }
  },
  computed: {
    customStyle() {
      return this.isTooLow ? { bottom: "-92px" } : { top: "-92px" };
    },
    arrowStyle() {
      return this.isTooLow ? {
        bottom: "92px",
        left: "-30px"
      } : {
        top: "92px",
        left: "-30px"
      };
    },
    iconStyle() {
      var t, i, s;
      const e = this.name;
      return [
        {
          backgroundImage: `url('https://appspowerplaymanager.vshcdn.net/images/winter-sports/icons/badges/${e}/${(t = this.badge[0]) == null ? void 0 : t.type}.webp'`
        },
        {
          backgroundImage: `url('https://appspowerplaymanager.vshcdn.net/images/winter-sports/icons/badges/${e}/${(i = this.badge[1]) == null ? void 0 : i.type}.webp'`
        },
        {
          backgroundImage: `url('https://appspowerplaymanager.vshcdn.net/images/winter-sports/icons/badges/${e}/${(s = this.badge[2]) == null ? void 0 : s.type}.webp'`
        }
      ];
    }
  },
  methods: {
    stringifyCount(e, t = !1) {
      return e > 0 ? `${e}${t ? "x" : ""}` : "-";
    },
    contentStyle(e) {
      return { opacity: e > 0 ? 1 : 0.5 };
    }
  }
}), Hb = { class: "tooltip-wrapper" }, Xb = { class: "tooltip-header" }, Gb = { class: "tooltip-content" }, Yb = { class: "tooltip-count" }, Kb = { class: "tooltip-count" }, Zb = { class: "tooltip-count" }, Jb = { class: "tooltip-footer" };
function Qb(e, t, i, s, n, o) {
  const r = L("shrinking-text-box");
  return Ae((p(), h("div", {
    class: "power-badge-tooltip",
    style: b(e.customStyle)
  }, [
    l("div", {
      class: "arrow",
      style: b(e.arrowStyle)
    }, null, 4),
    l("div", Hb, [
      l("div", Xb, [
        M(r, {
          text: e.texts[0],
          "font-size": 30,
          width: 740,
          height: 50
        }, null, 8, ["text"])
      ]),
      l("div", Gb, [
        e.badge[0] ? (p(), h("div", {
          key: 0,
          class: "tooltip-content-item",
          style: b(e.contentStyle(e.badge[0].value))
        }, [
          l("div", {
            style: b(e.iconStyle[0]),
            class: "tooltip-power-badge"
          }, $(e.stringifyCount(e.badge[0].value)), 5),
          l("span", Yb, $(e.stringifyCount(e.badge[0].value, !0)), 1),
          M(r, {
            text: e.texts[1],
            "font-size": 30,
            width: 600,
            height: 64
          }, null, 8, ["text"])
        ], 4)) : w("", !0),
        e.badge[1] ? (p(), h("div", {
          key: 1,
          class: "tooltip-content-item",
          style: b(e.contentStyle(e.badge[1].value))
        }, [
          l("div", {
            style: b(e.iconStyle[1]),
            class: "tooltip-power-badge"
          }, $(e.stringifyCount(e.badge[1].value)), 5),
          l("span", Kb, $(e.stringifyCount(e.badge[1].value, !0)), 1),
          M(r, {
            text: e.texts[2],
            "font-size": 30,
            width: 600,
            height: 64
          }, null, 8, ["text"])
        ], 4)) : w("", !0),
        e.badge[2] ? (p(), h("div", {
          key: 2,
          class: "tooltip-content-item",
          style: b(e.contentStyle(e.badge[2].value))
        }, [
          l("div", {
            style: b(e.iconStyle[2]),
            class: "tooltip-power-badge"
          }, $(e.stringifyCount(e.badge[2].value)), 5),
          l("span", Zb, $(e.stringifyCount(e.badge[2].value, !0)), 1),
          M(r, {
            text: e.texts[3],
            "font-size": 30,
            width: 600,
            height: 64
          }, null, 8, ["text"])
        ], 4)) : w("", !0)
      ]),
      t[0] || (t[0] = l("div", { class: "underline" }, null, -1)),
      l("div", Jb, [
        M(r, {
          text: e.texts[4],
          "font-size": 30,
          width: 740,
          height: 73
        }, null, 8, ["text"])
      ]),
      t[1] || (t[1] = l("div", { class: "shadow-box" }, null, -1))
    ])
  ], 4)), [
    [Ze, e.isActive]
  ]);
}
const e1 = /* @__PURE__ */ S(Ub, [["render", Qb]]), t1 = T({
  name: "PowerBadge",
  components: { PowerBadgeTooltip: e1 },
  props: {
    badge: {
      type: Array,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    isTooLow: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["setZIndex"],
  data() {
    return {
      badgePlace: {
        type: "",
        value: 0,
        top: !1
      },
      tooltipActive: !1
    };
  },
  computed: {
    iconStyle() {
      const e = this.name, t = this.badgePlace.type;
      return {
        backgroundImage: `url('https://appspowerplaymanager.vshcdn.net/images/winter-sports/icons/badges/${e}/${t}.webp'`
      };
    },
    texts() {
      return [
        this.$t(`${this.name}-header`),
        this.$t(`${this.name}-first`),
        this.$t(`${this.name}-second-third`).replace("[rank]", "2"),
        this.$t(`${this.name}-second-third`).replace("[rank]", "3"),
        this.$t(`${this.name}-footer`)
      ];
    }
  },
  mounted() {
    this.badgePlace = this.badgePlaceCalc();
  },
  methods: {
    badgePlaceCalc() {
      for (let e = 0; e < this.badge.length; e++) {
        const t = this.badge[e];
        if (t.top)
          return {
            type: t.type,
            value: t.value,
            top: t.top
          };
      }
      return {
        type: "",
        value: 0,
        top: !1
      };
    },
    setZIndex(e) {
      this.$emit("setZIndex", e);
    },
    setActive(e) {
      this.tooltipActive = e, this.setZIndex(e ? 1 : 0);
    }
  }
});
function i1(e, t, i, s, n, o) {
  const r = L("power-badge-tooltip");
  return e.badgePlace.top ? (p(), h("div", {
    key: 0,
    class: "power-badge-wrapper",
    style: b({ zIndex: e.tooltipActive ? 1 : 0 })
  }, [
    l("div", {
      style: b(e.iconStyle),
      class: "power-badge",
      onMouseover: t[0] || (t[0] = (a) => e.setActive(!0)),
      onTouchstart: t[1] || (t[1] = (a) => e.setActive(!e.tooltipActive)),
      onMouseleave: t[2] || (t[2] = (a) => e.setActive(!1))
    }, $(e.badgePlace.value), 37),
    M(r, {
      badge: e.badge,
      name: e.name,
      texts: e.texts,
      "is-active": e.tooltipActive,
      "is-too-low": e.isTooLow
    }, null, 8, ["badge", "name", "texts", "is-active", "is-too-low"])
  ], 4)) : w("", !0);
}
const s1 = /* @__PURE__ */ S(t1, [["render", i1]]), n1 = T({
  name: "PowerBadges",
  components: { PowerBadge: s1 },
  props: {
    badges: {
      type: Object,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {
      }
    },
    isTooLow: {
      type: Boolean,
      default: !1
    },
    rowNumber: {
      type: Number,
      default: 0
    }
  },
  emits: ["setZIndex"],
  methods: {
    setZIndex(e) {
      this.$emit("setZIndex", this.rowNumber, e);
    }
  }
}), o1 = { class: "power-badges" };
function r1(e, t, i, s, n, o) {
  const r = L("power-badge");
  return p(), h("div", o1, [
    (p(!0), h(H, null, de(e.badges, (a, u, d) => (p(), V(r, {
      key: d,
      badge: a,
      name: String(u),
      "is-too-low": e.isTooLow,
      onSetZIndex: e.setZIndex
    }, null, 8, ["badge", "name", "is-too-low", "onSetZIndex"]))), 128))
  ]);
}
const a1 = /* @__PURE__ */ S(n1, [["render", r1]]), l1 = T({
  name: "PowerTableRows",
  components: { PowerBadges: a1 },
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    rowData: {
      type: Array,
      required: !0
    },
    shouldPaginate: {
      type: Boolean,
      default: !1
    },
    actualPage: {
      type: Number,
      default: 1
    },
    allPages: {
      type: Number,
      default: 1
    },
    isStartList: {
      type: Boolean,
      default: !1
    },
    showRankingPointsSsm: {
      type: Boolean,
      default: !0
    },
    biatlonType: {
      type: Boolean,
      default: !1
    },
    disciplineIconSrc: {
      type: String,
      default: ""
    },
    showDisciplineIcon: {
      type: Boolean,
      required: !1,
      default: !1
    },
    specialRecord: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      zIndexes: [],
      isSsm: !1
    };
  },
  computed: {
    getPointIcon() {
      return this.showDisciplineIcon && !this.isSsm ? { backgroundImage: `url('${this.disciplineIconSrc}')` } : { backgroundImage: "url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/icons/ICO_POINT_48px.png'" };
    },
    getAttributeIcon() {
      return { backgroundImage: `url('${this.disciplineIconSrc}')` };
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm";
    for (let e = 0; e < this.rowData.length; e++)
      this.zIndexes.push(0);
  },
  methods: {
    formatedRankingPoints(e) {
      return Ee(e);
    },
    setZIndex(e, t) {
      this.zIndexes[e] = t;
    },
    getRowClass(e) {
      return this.isStartList || this.actualPage > 1 ? "" : `row-${e}`;
    },
    getAnimationDelay(e, t) {
      return {
        transitionDelay: e === this.rowData.length - 1 ? "550ms" : `${550 + e * 85}ms`,
        transform: e === this.rowData.length - 1 ? t ? "translateY(0)" : ` translateY(${(e + 1) * -100}%)` : ""
      };
    }
  }
}), d1 = {
  key: 0,
  class: "placeholder"
}, u1 = { class: "position" }, c1 = { class: "pos-number" }, p1 = { class: "row-i" }, h1 = { class: "sider" }, f1 = { class: "country" }, m1 = { class: "country-name" }, g1 = { class: "country-img" }, y1 = ["src", "alt"], v1 = { class: "player-name" }, b1 = { class: "right-part" }, $1 = {
  key: 0,
  class: "wp"
}, k1 = { class: "time" }, _1 = {
  key: 2,
  class: "pb"
}, w1 = {
  key: 0,
  class: "pb"
};
function T1(e, t, i, s, n, o) {
  const r = L("power-badges");
  return p(), h("section", {
    class: _(["table-body", { "table-body-ssm": e.isSsm }])
  }, [
    (p(!0), h(H, null, de(e.rowData, (a, u) => {
      var d, c;
      return p(), h("span", {
        key: a.name,
        class: _(["row", [e.getRowClass(u), { active: e.active }]]),
        style: b([{ zIndex: e.zIndexes[u], position: "relative" }, e.getAnimationDelay(u, e.active)])
      }, [
        "placeholder" in a ? (p(), h("div", d1)) : (p(), h("div", {
          key: 1,
          class: _(["table-row", { isPlayer: a.playable || !1 }])
        }, [
          l("div", u1, [
            l("span", c1, $(a.position), 1)
          ]),
          l("div", p1, [
            l("div", h1, [
              l("div", f1, [
                l("div", m1, $(a.countryString), 1),
                l("div", g1, [
                  l("img", {
                    class: "image",
                    src: `https://appspowerplaymanager.vshcdn.net/images/flags/64x43/${a.country.toLowerCase()}.png`,
                    alt: a.country
                  }, null, 8, y1)
                ])
              ]),
              l("div", v1, $(a.name), 1),
              M(r, {
                badges: a.badges,
                "is-too-low": u > 3,
                "row-number": u,
                onSetZIndex: e.setZIndex
              }, null, 8, ["badges", "is-too-low", "row-number", "onSetZIndex"])
            ]),
            l("div", b1, [
              e.isStartList ? w("", !0) : (p(), h(H, { key: 0 }, [
                (d = a.specialText) != null && d.length && !e.isSsm ? (p(), h("div", $1, $(a.specialText), 1)) : w("", !0),
                a.results[0] ? (p(), h("div", {
                  key: 1,
                  class: _(["additional-data", { isPlayer: a.playable || !1 }])
                }, [
                  l("span", {
                    class: _({ "biatlon-type": e.biatlonType })
                  }, $(a.results[0]), 3)
                ], 2)) : w("", !0),
                a.results[1] ? (p(), h("div", {
                  key: 2,
                  class: _(["additional-data", { isPlayer: a.playable || !1 }])
                }, [
                  l("span", {
                    class: _({ "biatlon-type": e.biatlonType })
                  }, $(a.results[1]), 3)
                ], 2)) : w("", !0)
              ], 64)),
              e.isSsm && e.isStartList && e.showRankingPointsSsm ? (p(), h("div", {
                key: 1,
                class: _(["additional-data", { isPlayer: a.playable || !1 }])
              }, [
                l("span", null, $(e.formatedRankingPoints(a.rankingPoints || 0)), 1),
                l("span", {
                  class: "icon-point",
                  style: b([e.getPointIcon])
                }, null, 4)
              ], 2)) : w("", !0),
              l("div", k1, [
                e.isStartList ? (p(), h(H, { key: 1 }, [
                  !e.isSsm && !e.showDisciplineIcon ? (p(), h(H, { key: 0 }, [
                    K($(e.formatedRankingPoints(a.rankingPoints || 0)), 1)
                  ], 64)) : (p(), h(H, { key: 1 }, [
                    K($(a.attribute), 1)
                  ], 64)),
                  e.isSsm ? (p(), h("span", {
                    key: 3,
                    class: "icon-point",
                    style: b([e.getAttributeIcon])
                  }, null, 4)) : (p(), h("span", {
                    key: 2,
                    class: "icon-point",
                    style: b([e.getPointIcon])
                  }, null, 4))
                ], 64)) : (p(), h(H, { key: 0 }, [
                  K($(a.result), 1)
                ], 64))
              ]),
              a.playable && e.isSsm && e.specialRecord !== "" ? (p(), h("div", _1, $(e.specialRecord), 1)) : w("", !0)
            ]),
            (c = a.specialText) != null && c.length && e.isSsm ? (p(), h("div", w1, $(a.specialText), 1)) : w("", !0)
          ])
        ], 2))
      ], 6);
    }), 128)),
    e.shouldPaginate ? (p(), h("section", {
      key: 0,
      class: _(["table-pagination", e.active ? "active" : "inactive"])
    }, $(e.actualPage) + " / " + $(e.allPages), 3)) : w("", !0)
  ], 2);
}
const S1 = /* @__PURE__ */ S(l1, [["render", T1]]), x1 = T({
  name: "PowerTable",
  components: {
    PowerTableHeader: Wb,
    PowerTableRows: S1
  },
  mixins: [P],
  props: {
    active: {
      type: Boolean,
      default: !1
    },
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      default: () => ({})
    },
    paginationSize: {
      type: Number,
      default: 8
    },
    headerProps: {
      type: Object,
      required: !0
    },
    rowData: {
      type: Array,
      required: !0
    },
    isTraining: {
      type: Boolean,
      default: !1
    },
    isStartList: {
      type: Boolean,
      default: !1
    },
    biatlonType: {
      type: Boolean,
      default: !1
    },
    showDisciplineIcon: {
      type: Boolean,
      required: !1,
      default: !1
    },
    showRankingPointsSsm: {
      type: Boolean,
      default: !0
    },
    specialRecord: {
      type: String,
      default: ""
    }
  },
  emits: ["click"],
  data() {
    return {
      actualPage: 1,
      pathImages: E,
      isSsm: !1
    };
  },
  computed: {
    transformCoef() {
      return `scale(${this.scaleCoef})`;
    },
    shouldPaginate() {
      return this.rowData.length > this.paginationSize;
    },
    allPages() {
      return Math.ceil(this.rowData.length / this.paginationSize);
    },
    remainderPageAmount() {
      return this.paginationSize - this.rowData.length % this.paginationSize;
    },
    paginatedData() {
      if (this.isNoLess) return this.rowData.slice(0, this.actualPage * this.paginationSize);
      if (this.isNoMore) {
        const e = this.rowData.slice(
          this.actualPage * this.paginationSize - this.paginationSize,
          this.actualPage * this.paginationSize
        );
        for (let t = 0; t < this.remainderPageAmount; t++)
          e.push({ placeholder: !0 });
        return e;
      }
      return this.rowData.slice(
        this.actualPage * this.paginationSize - this.paginationSize,
        this.actualPage * this.paginationSize
      );
    },
    isNoLess() {
      return this.actualPage === 1;
    },
    isNoMore() {
      return this.actualPage === this.allPages;
    }
  },
  created() {
    this.isSsm = this.$gameName === "ssm", this.changeToPageWherePlayerIs();
  },
  methods: {
    onClick(e) {
      this.$emit("click", e);
    },
    backward(e) {
      const t = this.actualPage === 1 ? 1 : this.actualPage - 1;
      this.actualPage = t, e.cancelable && e.preventDefault();
    },
    forward(e) {
      const t = this.actualPage === this.allPages ? this.allPages : this.actualPage + 1;
      this.actualPage = t, e.cancelable && e.preventDefault();
    },
    changeToPageWherePlayerIs() {
      const e = this.rowData.findIndex((i) => i.playable);
      if (e === -1)
        return;
      const t = Math.ceil((e + 1) / this.paginationSize);
      this.actualPage = t;
    }
  }
}), C1 = ["src"], z1 = ["src"], j1 = ["src"], B1 = ["src"];
function P1(e, t, i, s, n, o) {
  const r = L("power-table-header"), a = L("power-table-rows");
  return p(), h("section", {
    class: _(["power-table", [{ multiple: e.rowData.length > e.paginationSize }, { "power-table-ssm": e.isSsm }]]),
    style: b([e.style, { transform: e.transformCoef }])
  }, [
    e.shouldPaginate ? (p(), h("div", {
      key: 0,
      class: _(["leftArrow", [{ disabled: e.isNoLess }, e.active ? "active" : "inactive"]]),
      onMousedown: t[0] || (t[0] = A((...u) => e.backward && e.backward(...u), ["stop"])),
      onMouseleave: t[1] || (t[1] = A(() => {
      }, ["stop"])),
      onMouseup: t[2] || (t[2] = A(() => {
      }, ["stop"])),
      onTouchstart: t[3] || (t[3] = A((...u) => e.backward && e.backward(...u), ["stop"])),
      onTouchmove: t[4] || (t[4] = A(() => {
      }, ["stop"])),
      onTouchend: t[5] || (t[5] = A(() => {
      }, ["stop"]))
    }, [
      e.isSsm ? (p(), h("img", {
        key: 0,
        src: `${e.pathImages}/table/btn-back.jpg`
      }, null, 8, C1)) : (p(), h("img", {
        key: 1,
        src: `${e.pathImages}/table/BTN_PREW_ROUNDED.png`
      }, null, 8, z1))
    ], 34)) : w("", !0),
    M(r, {
      active: e.active,
      "header-props": e.headerProps,
      "is-training": e.isTraining
    }, null, 8, ["active", "header-props", "is-training"]),
    M(a, {
      active: e.active,
      "row-data": e.paginatedData,
      "should-paginate": e.shouldPaginate,
      "actual-page": e.actualPage,
      "all-pages": e.allPages,
      "is-start-list": e.isStartList,
      "biatlon-type": e.biatlonType,
      "discipline-icon-src": e.headerProps.discipline.image,
      "show-discipline-icon": e.showDisciplineIcon,
      "show-ranking-points-ssm": e.showRankingPointsSsm,
      "special-record": e.specialRecord
    }, null, 8, ["active", "row-data", "should-paginate", "actual-page", "all-pages", "is-start-list", "biatlon-type", "discipline-icon-src", "show-discipline-icon", "show-ranking-points-ssm", "special-record"]),
    e.shouldPaginate ? (p(), h("div", {
      key: 1,
      class: _(["rightArrow", [{ disabled: e.isNoMore }, e.active ? "active" : "inactive"]]),
      onMousedown: t[6] || (t[6] = A((...u) => e.forward && e.forward(...u), ["stop"])),
      onMouseleave: t[7] || (t[7] = A(() => {
      }, ["stop"])),
      onMouseup: t[8] || (t[8] = A(() => {
      }, ["stop"])),
      onTouchstart: t[9] || (t[9] = A((...u) => e.forward && e.forward(...u), ["stop"])),
      onTouchend: t[10] || (t[10] = A(() => {
      }, ["stop"]))
    }, [
      e.isSsm ? (p(), h("img", {
        key: 0,
        src: `${e.pathImages}/table/btn-forward.jpg`
      }, null, 8, j1)) : (p(), h("img", {
        key: 1,
        src: `${e.pathImages}/table/BTN_NEXT_ROUNDED.png`
      }, null, 8, B1))
    ], 34)) : w("", !0)
  ], 6);
}
const h$ = /* @__PURE__ */ S(x1, [["render", P1]]), f$ = {
  install: (e) => {
    e.config.globalProperties.$setRatio = () => {
      let t;
      window.innerWidth / window.innerHeight <= 1.6 ? t = window.innerWidth / 1920 : t = window.innerHeight / 1080, t = Math.ceil(t * 100) / 100, t > 1 && (t = 1);
      const i = document.getElementById("Viewport");
      if (i) {
        const s = `initial-scale=${t}`, n = `width=${window.innerWidth}, height=${window.innerHeight}`;
        i.setAttribute(
          "content",
          `viewport-fit=cover, ${s}, user-scalable=no, ${n}`
        );
      }
    };
  }
}, D1 = T({
  name: "LungeInfo",
  mixins: [P],
  props: {
    isScaled: {
      type: Boolean,
      default: !0
    },
    fill: {
      type: Number,
      default: 0
    },
    text: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    showInfo: {
      type: Boolean,
      default: !1
    },
    scaleEndEffect: {
      type: Number,
      default: 2.5
    },
    durationOriginal: {
      type: Number,
      default: 0.5
    },
    durationEffect: {
      type: Number,
      default: 1
    },
    showEffect: {
      type: Boolean,
      default: !1
    },
    textTimeLunge: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tweenLayer1: null,
      tweenLayer2: null
    };
  },
  computed: {
    transformCoef() {
      let e = 1;
      return this.isScaled && (e = this.scaleCoef), {
        transform: `scale( ${e} )`
      };
    },
    getStroke() {
      const i = "#1e1e1e";
      return {
        "text-shadow": `0 0 0 transparent, -1px -1px 0 ${i}, 0px -1px 0 ${i}, 1px -1px 0 ${i}, -1px 0px 0 ${i}, 0px 0px 0 ${i}, 1px 0px 0 ${i}, -1px 1px 0 ${i}, 0px 1px 0 ${i}, 1px 1px 0 ${i}, -2px -2px 0 ${i}, -1px -2px 0 ${i}, 0px -2px 0 ${i}, 1px -2px 0 ${i}, 2px -2px 0 ${i}, -2px -1px 0 ${i}, -1px -1px 0 ${i}, 0px -1px 0 ${i}, 1px -1px 0 ${i}, 2px -1px 0 ${i}, -2px 0px 0 ${i}, -1px 0px 0 ${i}, 0px 0px 0 ${i}, 1px 0px 0 ${i}, 2px 0px 0 ${i}, -2px 1px 0 ${i}, -1px 1px 0 ${i}, 0px 1px 0 ${i}, 1px 1px 0 ${i}, 2px 1px 0 ${i}, -2px 2px 0 ${i}, -1px 2px 0 ${i}, 0px 2px 0 ${i}, 1px 2px 0 ${i}, 2px 2px 0 ${i}, 0px 5px 2px rgba(0, 0, 0, 0.96)`
      };
    },
    getTextTimeLunge() {
      return this.textTimeLunge === "" ? this.$t("timeLunge") : this.textTimeLunge;
    }
  },
  watch: {
    showInfo: {
      handler(e) {
        var t, i;
        e && ((t = this.tweenLayer1) == null || t.kill(), (i = this.tweenLayer2) == null || i.kill(), this.tweenLayer1 = U.fromTo(
          ".lunge-message-info.original",
          {
            opacity: 0
          },
          {
            duration: this.durationOriginal,
            opacity: 1
          }
        ), this.tweenLayer2 = U.fromTo(
          ".lunge-message-info.effect",
          {
            opacity: 0.3,
            scale: 1
          },
          {
            duration: this.durationEffect,
            opacity: 0,
            scale: this.scaleCoef * this.scaleEndEffect
          }
        ));
      }
    }
  }
}), L1 = { class: "lunge-info-wrapper" }, O1 = { class: "lunge-message-info-wrapper" }, I1 = { class: "lunge-message-info effect" }, M1 = { class: "text" }, N1 = { class: "lunge-message-info original" }, A1 = { class: "text" }, R1 = { class: "lunge-info" }, E1 = { class: "lunge-info-bar-wrapper" }, F1 = { class: "lunge-info-bar-text" };
function V1(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "lunge-info-container",
    style: b(e.transformCoef)
  }, [
    l("div", L1, [
      l("div", O1, [
        Ae(l("div", I1, [
          l("div", {
            class: "shadow",
            style: b(e.getStroke)
          }, $(e.getTextTimeLunge), 5),
          l("div", M1, $(e.getTextTimeLunge), 1)
        ], 512), [
          [Ze, e.showInfo]
        ]),
        Ae(l("div", N1, [
          l("div", {
            class: "shadow",
            style: b(e.getStroke)
          }, $(e.getTextTimeLunge), 5),
          l("div", A1, $(e.getTextTimeLunge), 1)
        ], 512), [
          [Ze, e.showInfo]
        ]),
        J(e.$slots, "default")
      ]),
      l("div", R1, [
        l("div", E1, [
          l("div", {
            class: _(["lunge-info-bar", e.color]),
            style: b({ width: e.fill + "%" })
          }, null, 6),
          l("span", F1, $(e.text), 1)
        ])
      ])
    ])
  ], 4);
}
const m$ = /* @__PURE__ */ S(D1, [["render", V1]]), q1 = T({
  name: "StartUpText",
  mixins: [P],
  props: {
    /**
     * Sets the styles. To make the native style binding work.
     */
    style: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    type: {
      type: Number,
      required: !0
    },
    isScaled: {
      type: Boolean,
      default: !0
    },
    discipline: {
      type: String,
      default: "100m"
    }
  },
  computed: {
    transformCoef() {
      return this.isScaled ? {
        transform: `scale(${this.scaleCoef}) translate(-50%, 0)`,
        "transform-origin": "0 0"
      } : {};
    },
    typeStyle() {
      const e = `${this.type * -100}px`;
      return {
        background: `url('https://appspowerplaymanager.vshcdn.net/images/minigame/core-ui/messages/${this.discipline}-start-texts-large.png') 0 ${e}`
      };
    }
  }
});
function W1(e, t, i, s, n, o) {
  return p(), h("div", {
    class: "start-up-text",
    style: b([e.style, e.transformCoef, e.typeStyle])
  }, null, 4);
}
const g$ = /* @__PURE__ */ S(q1, [["render", W1]]);
export {
  Sf as AppSvgIcon,
  Gn as ArrowAnimation,
  Zn as ArrowStatic,
  K1 as BiathlonSplitTimes,
  Z1 as BlackOverlay,
  I0 as BlockingEffect,
  O0 as BlockingEffectCenter,
  Mi as BlueBox,
  J1 as BlueBoxSegmented,
  Ts as BlueBoxSolid,
  U0 as BoatStats,
  Q1 as BulletsTargetsBox,
  e0 as CircleBalanceBar,
  t0 as ColorOverlayComponent,
  i0 as CountdownComponent,
  D0 as CountdownShiny,
  k0 as DoubleBox,
  Zy as DownhillSkierTime,
  o$ as DownhillTimes,
  lv as DownhillTimesTable,
  H0 as ErrorModal,
  s0 as ExitDisciplineModal,
  n0 as FpsLooker,
  o0 as FullInfo,
  r0 as GameLoading,
  q0 as GameLoadingSsm,
  a0 as HeartMonitorBox,
  Xl as HighScoreBox,
  l0 as HorizontalBalanceBar,
  d0 as HorizontalBarWithIdeal,
  u0 as ImpactEffect,
  c0 as ImpulseInputComponent,
  kd as InfoBox,
  F0 as InstructionBox,
  yv as InstructionCard,
  r$ as Instructions,
  p0 as LandingBox,
  h0 as LoadingCircleOverlay,
  m$ as LungeInfo,
  dl as MarksInfo,
  m0 as Menu,
  f0 as MenuOverlay,
  V0 as MiniTable,
  nf as MiniTableRow,
  Jd as MissedText,
  au as MobileButton,
  g0 as MovementButtons,
  P0 as MovementButtonsSmooth,
  y0 as MovementSides,
  v0 as PlayerInfoAvatar,
  W0 as PositionBox,
  zt as PowerButton,
  va as PowerCheck,
  ri as PowerIconSlot,
  Cn as PowerModal,
  Uu as PowerRule,
  Ta as PowerSlider,
  b0 as PowerStick,
  Sn as PowerSwitch,
  h$ as PowerTable,
  nc as ProgressBar,
  _0 as PushBar,
  $0 as RecordBox,
  Bm as RewardAnneTable,
  n$ as SettingsModal,
  B0 as ShinyTextAnimated,
  Tc as ShrinkingBlock,
  pe as ShrinkingTextBox,
  ai as ShrinkingTextUniversal,
  w0 as SkijumpLeftTopInfo,
  T0 as SmallActionButton,
  vu as SmallMovementButton,
  x0 as SpeedBarRun,
  A0 as SpeedBarV2,
  Oc as SpeedBox,
  S0 as SpeedControlBar,
  C0 as SplitTimes,
  wp as StartBar,
  M0 as StartCountdownTime,
  g$ as StartUpText,
  j0 as StartgateCounterBig,
  Yc as StartgateCounterSmall,
  Wc as StatsTopBox,
  E0 as TextMessage,
  R0 as TextMessageDynamic,
  _h as TextMessageWithNumber,
  d$ as TimeKeeper,
  u$ as TimeKeeperExpanded,
  c$ as TimeKeeperLaps,
  p$ as TimeKeeperLapsLeader,
  qt as Tooltip,
  z0 as TrafficLightBox,
  Yp as TrafficLightLuge,
  L0 as TrafficLightStartBar,
  eg as TrainingAttribute,
  t$ as TrainingBlueBox,
  i$ as TrainingLeftTopBox,
  s$ as TrainingResult,
  zn as TrainingRewards,
  Xg as TrainingScore,
  kg as TrainingStars,
  hg as TrainingTask,
  gg as TrainingTasks,
  Ef as TutorialAnne,
  G0 as TutorialHandSettings,
  Y0 as TutorialKeyboardKey,
  K0 as TutorialKeyboardKeys,
  Z0 as TutorialMessageBox,
  Wf as TutorialMobile,
  J0 as TutorialOverlay,
  Fm as TutorialRewards,
  Tm as TutorialTask,
  Q0 as TutorialTasks,
  e$ as TutorialTrainingRewards,
  ws as TypeWriterComponent,
  il as UserInfo,
  es as WaitingComponent,
  N0 as WindBox,
  ml as WindInfo,
  P as WindowAspect,
  Ln as blackOverlay,
  X0 as errorHandler,
  yi as errorState,
  ss as fpsLookerState,
  Gt as gameSettingsState,
  X1 as gameState,
  Rn as loadingCircleState,
  _s as loadingState,
  Vn as mobileState,
  f$ as setRatio,
  G1 as testCountdownState,
  a$ as translations,
  l$ as translationsSSM,
  Y1 as tutorialCoreState,
  mt as waitingState
};
